export const de = {
  app: {
    home: 'Home',
    playerScout: 'Spieler Scout',
    playerComparison: 'Spieler Vergleich',
    playerRecruitment: 'Radar',
    collections: 'Kollektionen',
    favoritePlayers: 'Favoriten',
    teamAnalytics: 'Team Analysen',
    gameAnalysis: 'Spiel Analyse',
    seasonStats: 'Saisonstatistiken',
    leagueTable: 'Liga Tabelle',
    scoresAndFixtures: 'Resultate & Spiele',
    notifications: 'Nachrichten',
    administration: 'Administration',
    inbox: 'Posteingang',
    teamStats: 'Team Statistiken',
    blog: 'Blog',
    leagues: 'Ligen',
    squadBuilder: 'Squad Builder',
    playerAlerts: 'Player Alerts',
    searchAlerts: 'Suche Alerts',
    videoUploadTool: 'Video Upload Tool',
    videoPlaylists: 'Playlists',
    uploadedGames: 'Uploaded games',
    favoriteTeams: 'Favorite Teams',
    arrigo: 'Arrigo',
    SeasonStats: 'Saison Statistiken',
    validateEvents: 'Ereignisse validieren'
  },
  playerRecruitment: {
    title: 'Spielerblatt',
    subtitle: 'Gehen Sie näher auf die Eigenschaften und Statistiken des Spielers ein',
    league: 'Liga',
    selectedSeason: 'Ausgewählte Saison',
    year: 'Jahr',
    radar: 'Radar',
    positions: 'Positionen',
    numberOfPlayers: 'Anzahl der Spieler',
    template: 'Format',
    compareWith: 'Vergleichen mit',
    previousPerformance: 'Frühere Leistung',
    xGames: '{0} Spiele',
    average: 'Durchschnitt',
    leagueAverage: 'Liga-Durchschnitt',
    selectSeason: 'Wähle eine Saison',
    positionsPlayed: 'Gespielte Positionen',
    minMax: 'Min & Max',
    top5Leagues: 'Top 5 Ligen',
    infoMessage: 'Eine Saison auswählen, um Min & Max zu aktivieren',
    infoMessage2: 'Spielervergleich entfernen, um Saison-Min & Max zu aktivieren',
    dataPer90MinText: 'Daten pro 90 Minuten',
    adjustToPossessionText: '* An Ballbesitz angepasst',
    text: 'Text',
    lollipop: 'Lollipop',
    polar: 'Polar',
    noGamesBetweenDates: 'Keine Spiele zwischen den ausgewählten Daten gefunden',
    radarTemplates: {
      Goalkeeper: 'Torwart',
      GoalkeeperCustom: 'Torwart-Custom',
      GoalkeeperCustom1: 'Torwart Benutzerdefiniert 1',
      GoalkeeperCustom2: 'Torwart Benutzerdefiniert 2',
      GoalkeeperCustom3: 'Torwart Benutzerdefiniert 3',
      GoalkeeperCustom4: 'Torwart Benutzerdefiniert 4',
      GoalkeeperCustom5: 'Torwart Benutzerdefiniert 5',
      GoalkeeperCustom6: 'Torwart Benutzerdefiniert 6',
      Defender: 'Innenverteidiger',
      DefenderCustom: 'Defender Custom',
      DefenderCustom1: 'Innenverteidiger Benutzerdefiniert 1',
      DefenderCustom2: 'Innenverteidiger Benutzerdefiniert 2',
      DefenderCustom3: 'Innenverteidiger Benutzerdefiniert 3',
      DefenderCustom4: 'Innenverteidiger Benutzerdefiniert 4',
      DefenderCustom5: 'Innenverteidiger Benutzerdefiniert 5',
      DefenderCustom6: 'Innenverteidiger Benutzerdefiniert 6',
      FullBack: 'Außenverteidiger',
      FullBackCustom: 'FullBack Custom',
      FullBackCustom1: 'Außenverteidiger Benutzerdefiniert 1',
      FullBackCustom2: 'Außenverteidiger Benutzerdefiniert 2',
      FullBackCustom3: 'Außenverteidiger Benutzerdefiniert 3',
      FullBackCustom4: 'Außenverteidiger Benutzerdefiniert 4',
      FullBackCustom5: 'Außenverteidiger Benutzerdefiniert 5',
      FullBackCustom6: 'Außenverteidiger Benutzerdefiniert 6',
      FullBackPredictive: 'Vorausschauender Außenverteidiger',
      Midfielder: 'Mittelfeldspieler',
      MidfielderCustom: 'Mittelfeldspieler Custom',
      MidfielderCustom1: 'Mittelfeldspieler Benutzerdefiniert 1',
      MidfielderCustom2: 'Mittelfeldspieler Benutzerdefiniert 2',
      MidfielderCustom3: 'Mittelfeldspieler Benutzerdefiniert 3',
      MidfielderCustom4: 'Mittelfeldspieler Benutzerdefiniert 4',
      MidfielderCustom5: 'Mittelfeldspieler Benutzerdefiniert 5',
      MidfielderCustom6: 'Mittelfeldspieler Benutzerdefiniert 6',
      MidfielderPredictive: 'Vorausschauender Mittelfeldspieler',
      MidfielderDefensive: 'Defensiver Mittelfeldspieler',
      MidfielderOffensive: 'Offensiver Mittelfeldspieler',
      AttackingMidfielder: 'Angreifender Mittelfeldspieler',
      MidfielderWing: 'Zentrums- und Flügelspieler',
      Winger: 'Flügelspieler',
      WingerCustom: 'Winger Custom',
      WingerCustom1: 'Flügelspieler Benutzerdefiniert 1',
      WingerCustom2: 'Flügelspieler Benutzerdefiniert 2',
      WingerCustom3: 'Flügelspieler Benutzerdefiniert 3',
      WingerCustom4: 'Flügelspieler Benutzerdefiniert 4',
      WingerCustom5: 'Flügelspieler Benutzerdefiniert 5',
      WingerCustom6: 'Flügelspieler Benutzerdefiniert 6',
      WingerOffensive: 'Offensiver Flügelspieler',
      Forward: 'Stürmer',
      ForwardCustom: 'Benutzerdefiniert weiterleiten',
      ForwardCustom1: 'Stürmer Benutzerdefiniert 1',
      ForwardCustom2: 'Stürmer Benutzerdefiniert 2',
      ForwardCustom3: 'Stürmer Benutzerdefiniert 3',
      ForwardCustom4: 'Stürmer Benutzerdefiniert 4',
      ForwardCustom5: 'Stürmer Benutzerdefiniert 5',
      ForwardCustom6: 'Stürmer Benutzerdefiniert 6',
      ForwardPredictive: 'Vorausschauender Stürmer',
      WingBack: 'Offensiver Außenverteidiger',
      WingBackCustom: 'WingBack Custom',
      WingBackCustom1: 'Offensiver Außenverteidiger Benutzerdefiniert 1',
      WingBackCustom2: 'Offensiver Außenverteidiger Benutzerdefiniert 2',
      WingBackCustom3: 'Offensiver Außenverteidiger Benutzerdefiniert 3',
      WingBackCustom4: 'Offensiver Außenverteidiger Benutzerdefiniert 4',
      WingBackCustom5: 'Offensiver Außenverteidiger Benutzerdefiniert 5',
      WingBackCustom6: 'Offensiver Außenverteidiger Benutzerdefiniert 6',
      WingBackMedia: 'Offensiver Außenverteidiger (SocialMedia)',
      FullBackMedia: 'Außenverteidiger (SocialMedia)',
      MidfielderMedia: 'Mittelfeldspieler (SocialMedia)',
      WingerMedia: 'Flügelspieler (SocialMedia)',
      ForwardMedia: 'Stürmer (SocialMedia)',
      PhysicalWingBack: 'Physischer Offensiver Außenverteidiger',
      PhysicalForward: 'Physischer Stürmer',
      PhysicalWinger: 'Physischer Flügelspieler',
      PhysicalMidfielder: 'Physischer Mittelfeldspieler',
      PhysicalFullBack: 'Physischer Außenverteidiger',
      PhysicalDefender: 'Physischer Innenverteidiger',
      PhysicalWingBackLMO: 'Physischer Offensiver Außenverteidiger',
      PhysicalForwardLMO: 'Physischer Stürmer',
      PhysicalWingerLMO: 'Physischer Flügelspieler',
      PhysicalMidfielderLMO: 'Physischer Mittelfeldspieler',
      PhysicalFullBackLMO: 'Physischer Außenverteidiger',
      PhysicalDefenderLMO: 'Physischer Innenverteidiger'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Torwart',
      Defender: 'Innenverteidiger',
      FullBack: 'Außenverteidiger',
      FullBackPredictive: 'Vorausschauender Außenverteidiger',
      Midfielder: 'Mittelfeldspieler',
      MidfielderPredictive: 'Vorausschauender Mittelfeldspieler',
      MidfielderDefensive: 'Defensiver Mittelfeldspieler',
      MidfielderOffensive: 'Offensiver Mittelfeldspieler',
      AttackingMidfielder: 'Angreifender Mittelfeldspieler',
      MidfielderWing: 'Zentrums- und Flügelspieler',
      Winger: 'Flügelspieler',
      WingerOffensive: 'Offensiver Flügelspieler',
      Forward: 'Stürmer',
      ForwardPredictive: 'Vorausschauender Stürmer',
      WingBack: 'Offensiver Außenverteidiger',
      WingBackMedia: 'Offensiver Außenverteidiger (SocialMedia)',
      FullBackMedia: 'Außenverteidiger (SocialMedia)',
      MidfielderMedia: 'Mittelfeldspieler (SocialMedia)',
      WingerMedia: 'Flügelspieler (SocialMedia)',
      ForwardMedia: 'Stürmer (SocialMedia)',
      PhysicalWingBack: 'Physischer Offensiver Außenverteidiger',
      PhysicalForward: 'Physischer Stürmer',
      PhysicalWinger: 'Physischer Flügelspieler',
      PhysicalMidfielder: 'Physischer Mittelfeldspieler',
      PhysicalFullBack: 'Physischer Außenverteidiger',
      PhysicalDefender: 'Physischer Innenverteidiger',
      PhysicalWingBackLMO: 'Physischer Offensiver Außenverteidiger',
      PhysicalForwardLMO: 'Physischer Stürmer',
      PhysicalWingerLMO: 'Physischer Flügelspieler',
      PhysicalMidfielderLMO: 'Physischer Mittelfeldspieler',
      PhysicalFullBackLMO: 'Physischer Außenverteidiger',
      PhysicalDefenderLMO: 'Physischer Innenverteidiger'
    },
    radarDescription: {
      basicStatistics: {
        title: 'GRUNDLEGENDE STATISTIKEN',
        minutes: 'Minuten',
        goals: 'Tore',
        assists: 'Vorlagen',
        redCards: 'rote Karten',
        yellowCards: 'gelbe Karten',
        games: 'Spiele',
        goalsReceived: 'Gegentore ohne Elfmeter',
        xGFaced: 'xG kassiert'
      },
      profiles: {
        3: {
          1: 'Am Ball technisch starker Torwart, sowohl bei langen als auch bei kurzen Pässen.',
          2: 'Fähigkeit, mit den Füßen zu spielen und bei der Spielanbahnung eine wichtige Rolle zu spielen, mit guten Passquoten sowohl bei kurzen als auch bei langen Pässen.',
          3: 'Gute Beinarbeit, die dieses Profil aufgrund seiner Passwerte zu einer interessanten Option macht.',
          4: 'Profil, das durch seine Pässe hervorsticht, egal ob im eigenen Feld oder im gegnerischen Feld.',
          5: 'Große Sicherheit mit dem Ball am Fuß und hohe Passfähigkeiten.',
          6: 'Gute Beinarbeit, Sicherheit beim Ballwurf und hoher Anteil kurzer und langer Pässe.',
          7: 'Hoher Prozentsatz an abgeschlossenen Pässen, sowohl kurze als auch lange, sorgt für Qualität im Umlauf.'
        },
        5: {
          1: 'Abwehrspieler, der in vielen Eins-gegen-eins-Situationen erfolgreich ist, mit vielen Zweikämpfen und abgefangenen Bällen.',
          2: 'Sehr effektiver Innenverteidiger in einzelnen Zweikämpfen, sowohl oben als auch im Zweikampf, mit guter Lektüre.',
          3: 'Zentrale Verteidigung mit guter Leistung in einzelnen Abwehrduellen, was sich in einem hohen Nachholvolumen niederschlägt.',
          4: 'Profil mit einem hohen Defensivniveau, das dank Tacklings und Interceptions in der Lage ist, eine große Menge an Bällen zurückzugewinnen.',
          5: 'Sehr effektive Verteidigung im Zweikampf und mit vielen Interceptions, die sich in Einzelkonfrontationen hervorheben.',
          6: 'Innenverteidiger mit einer hohen Anzahl von Erholungsversuchen pro Spiel, geschickt darin, das Spiel des Gegners zu lesen und zu schneiden, mit hoher Präzision und Häufigkeit bei Tacklings.',
          7: 'Defensives Profil mit einer hohen Anzahl an Rückschlägen dank der Effektivität und Häufigkeit von Tacklings und guter Prognosefähigkeit.'
        },
        6: {
          1: 'Abwehrspieler, der viele Chancen kreiert und das Spiel lesen und lenken kann.'
        },
        7: {
          1: 'Spieler mit einem ausgeglichenen Verhältnis zwischen dem Offensivspiel (viele Beiträge in "xG Aufbau") und dem Defensivspiel (hohes Volumen an Balleroberungen).'
        },
        8: {
          1: 'Stark im defensiven Eins gegen Eins, hohes Volumen an Balleroberungen, sowohl an Zweikämpfen als auch an abgefangenen Bällen.'
        },
        9: {
          1: 'Spieler mit vielen Offensivbeiträgen, der viele Chancen und gefährliche Situationen generiert.'
        },
        10: {
          1: 'Ein kompletter Spieler, der in der Lage ist, viel Raum abzudecken, einen Beitrag zur Balleroberung zu leisten und einen relevanten Prozentsatz an "xG Buildup" in Bezug auf die Gesamtleistung des Teams hat.'
        },
        11: {
          1: 'Mittelfeldspieler mit einem guten Defensivspiel und hoher Effizienz im Passspiel, trotz geringem Einfluss im Offensivspiel.'
        },
        12: {
          1: 'Kompletter Mittelfeldspieler, der viele Chancen kreiert, effizient in Luftduellen ist und sowohl Zweikämpfe als auch Bälle erobert.'
        },
        15: {
          1: 'Flügelspieler mit guter Technik im Eins gegen Eins und erfolgreichen Flanken, der mehr Vorlagen als Torschüsse generiert.'
        },
        16: {
          1: 'Spieler mit vielen Durchbrüchen und Ballverlagerungen, der auch Chancen generiert und bei Ballbesitz im Mittelfeld mehr Einfluss hat als ein klassischer Flügelspieler.'
        },
        17: {
          1: 'Spieler mit guten Dribbling-Fähigkeiten, der versucht ins Zentrum zu ziehen, um mehr Torschüsse (xG) als Schlüsselpässe (xA) zu erzeugen.'
        },
        18: {
          1: 'Stürmer, der sich ohne Ball gut bewegt und richtige Entscheidungen trifft, wann er den Abschluss suchen oder passen soll.'
        },
        22: {
          1: 'Stürmer mit guter Beweglichkeit, um Steilpässe zu empfangen, der sich auch nach außen fallen lässt und ein hohes Level an Chancenkreation aufweist. Hoher Prozentsatz an Ballberührungen außerhalb des Strafraums im Verhältnis zu allen Ballaktionen im Spiel.'
        }
      },
      description: 'BESCHREIBUNG',
      conjuction: ' und ',
      conjuction2: ' und ',
      over: 'über',
      under: 'unter',
      respectively: ', entsprechend',
      Defending1: {
        1: 'Seine defensive Leistung ist unter den schlechtesten der Top-5-Ligen.'
      },
      Defending2: {
        1: 'Defensiv spielt er keine wesentliche Rolle, da die Leistungen unter dem Standard liegen.'
      },
      Defending3: {
        1: 'Defensiv spielt er eine gute Rolle, da die Leistungen leicht über dem Durchschnitt liegen.'
      },
      Defending4: {
        1: 'Herausragende Leistung in der defensiven Arbeit mit überdurchschnittlicher Performance.'
      },
      Defending5: {
        1: 'Hervorragend in defensiven Aufgaben, mit einer Leistung, die mit der der besten player_positions der Top-5-Ligen vergleichbar ist.'
      },
      Saving1: {
        1: 'Torwart mit schwachen Leistungen, der Schwierigkeiten hat, den Ball zu halten.'
      },
      Saving2: {
        1: 'Kein guter Torwart, da sein Level unter dem Durchschnitt liegt.'
      },
      Saving3: {
        1: 'Torwart mit einer akzeptablen Leistung, er liegt im Durchschnitt der Top-5-Ligen und müsste seine metric_name verbessern.'
      },
      Saving4: {
        1: 'Torwart mit einer überdurchschnittlichen Leistung im Vergleich zu den Top-5-Ligen, herausragend im Bereich metric_name.'
      },
      Saving5: {
        1: 'Er ist ein sehr kompletter Torwart, all seine Metriken platzieren ihn in den besten 20 % der Torhüter der Top-5-Ligen in Europa.'
      },
      Passing1: {
        1: 'Am Ball sind seine Leistungen ähnlich wie die der schlechtesten Spieler.'
      },
      Passing2: {
        1: 'Was das Passen angeht, sind seine Leistungen unterdurchschnittlich.'
      },
      Passing3: {
        1: 'Sein Passspiel ist akzeptabel, leicht über dem Durchschnitt.'
      },
      Passing4: {
        1: 'Sehr gutes Passspiel, weit über dem Durchschnitt.'
      },
      Passing5: {
        1: 'Sehr effektiv im Passspiel, mit einer besseren Leistung als die meisten Spieler.'
      },
      Aerial1: {
        1: 'Sehr schwacher Spieler im Luftduell, einer der schlechteren auf seiner Position in diesem Aspekt.'
      },
      Aerial2: {
        1: 'Was seine Luftduelle angeht, bringt er keine guten Leistungen, unterdurchschnittlich.'
      },
      Aerial3: {
        1: 'Akzeptable Leistungen in Luftduellen, leicht über dem Durchschnitt.'
      },
      Aerial4: {
        1: 'Überragende Leistungen in seinen Luftduellen, mit einer hohen Effektivität in diesem Aspekt.'
      },
      Aerial5: {
        1: 'Seine Leistungen im Luftduell platzieren ihn unter die Besten im Spiel.'
      },
      Shooting1: {
        1: 'Sehr schwache Leistungen vor dem Tor, vergleichbar mit den schlechtesten Spielern in diesem Aspekt.'
      },
      Shooting2: {
        1: 'Ausbaufähiger Abschluss, unterdurchschnittlich.'
      },
      Shooting3: {
        1: 'Akzeptable Leistungen im Offensivbereich, leicht über dem Durchschnitt.'
      },
      Shooting4: {
        1: 'Er bringt gute Leistungen im Strafraum, er ist besser als 60 % der Spieler.'
      },
      Shooting5: {
        1: 'Überragende Technik im Offensivspiel, mit spektakulären Leistungen, die ihn in diesem Aspekt unter die besten Spieler stellen.'
      },
      Association1: {
        1: 'Seine Leistungen am Ball sind sehr schlecht, er ist einer der schlechtesten Spieler in den Top-5-Ligen.'
      },
      Association2: {
        1: 'Er muss sich am Ball deutlich verbessern, da er unterdurchschnittliche Leistungen bringt.'
      },
      Association3: {
        1: 'Er assoziiert gut mit dem Ball, leicht über dem Durchschnitt.'
      },
      Association4: {
        1: 'Er assoziiert den Ball sehr gut und bringt bemerkenswerte Leistungen.'
      },
      Association5: {
        1: 'Er ist überragend am Ball, einer der besten Spieler in diesem Aspekt.'
      },
      BallHandling1: {
        1: 'Er ist fürchterlich am Ball, gehört zu den Schlechtesten der Top-5-Ligen.'
      },
      BallHandling2: {
        1: 'Was seine Ballkontrolle angeht, sind die Leistungen unter dem Durchschnitt.'
      },
      BallHandling3: {
        1: 'Akzeptable Leistungen am Ball, leicht über dem Durchschnitt.'
      },
      BallHandling4: {
        1: 'Gutes Level in Bezug auf die Ballkontrolle, er zählt nahezu zu den Besten in diesem Aspekt.'
      },
      BallHandling5: {
        1: 'Seine Ballkontrolle ist herausragend, er gehört zu den besten Spielern der Top-5-Ligen.'
      },
      Crosses1: {
        1: 'Schlechte Leistung beim Flanken des Balls in den Strafraum. Einer der schlechtesten Spieler in den Flankenmetriken.'
      },
      Crosses2: {
        1: 'Unterdurchschnittliche Leistung bei der Erzeugung von Gefahr durch seine Flanken.'
      },
      Crosses3: {
        1: 'Annehmbare, aber ausbaufähige Anzahl von Flanken in den Strafraum, leicht über dem Durchschnitt.'
      },
      Crosses4: {
        1: 'Gute Statistik bei Flanken, weit über dem Durchschnitt.'
      },
      Crosses5: {
        1: 'Er gehört zu den besten Spielern, die in den Strafraum flanken, konkret zu den 20 % der effektivsten Profile in dieser Hinsicht.'
      },
      Carries1: {
        1: 'Er gehört zu den schlechtesten 20 % der Spieler, was die Ballbehandlung angeht.'
      },
      Carries2: {
        1: 'Seine Ballbesitzleistung liegt weit unter dem Durchschnitt der Spieler auf seiner Position.'
      },
      Carries3: {
        1: 'Nahezu durchschnittliche Leistung, leicht überdurchschnittlich in Bezug auf die Ballbehandlung.'
      },
      Carries4: {
        1: 'Herausragender Spieler mit sehr guten Werten in Bezug auf Tiefe und Ballbehandlung.'
      },
      Carries5: {
        1: 'Sehr talentierter Ballkünstler, mit einer hohen Leistung in der Kategorie Ballbehandlung.'
      },
      Turnovers1: {
        1: 'Seine Leistung ist sehr negativ, mit einer hohen Anzahl von Ballverlusten, die es dem Gegner erleichtern, Gefahr zu erzeugen. Er gehört zu den schlechtesten in dieser Kategorie.'
      },
      Turnovers2: {
        1: 'Zahlreiche gefährliche Ballverluste begünstigen die Gegner; es ist notwendig, sich deutlich zu verbessern und diese Verluste zu reduzieren.'
      },
      Turnovers3: {
        1: 'Dieser Spieler liegt bei Ballverlusten leicht über dem Durchschnitt, daher gibt es noch Raum für Verbesserungen in seiner Leistung.'
      },
      Turnovers4: {
        1: 'Bemerkenswerte Leistung bei den Ballverlusten, besser als 60 % der Spieler, die die wenigsten Bälle verlieren.'
      },
      Turnovers5: {
        1: 'Hervorzuheben sind seine wenigen Ballverluste, die ihn zu einem der besten Spieler im Ballbesitz seiner Mannschaft machen.'
      },
      SequenceInvolvement1: {
        1: 'Was den Ballbesitz angeht, sind die Zahlen nicht gut; Aktionen enden sehr selten mit einem Schuss.'
      },
      SequenceInvolvement2: {
        1: 'Der Abschluss bei Ballbesitz ist deutlich verbesserungswürdig, Aktionen enden kaum mit einem Schuss, was die Leistung weit unter dem Durchschnitt einordnet.'
      },
      SequenceInvolvement3: {
        1: 'Akzeptables Niveau beim Abschluss von Aktionen vor dem Tor, mit einem Prozentsatz, der leicht über dem Durchschnitt liegt und somit eine große Möglichkeit zur Verbesserung bietet.'
      },
      SequenceInvolvement4: {
        1: 'Gute Fähigkeit, den Ballbesitz seiner Mannschaft mit Schüssen zu beenden, von denen einige zu Toren führen; bemerkenswerte Leistung in dieser Kategorie.'
      },
      SequenceInvolvement5: {
        1: 'Er gehört zu denen, die den Ballbesitz der Mannschaft am effektivsten mit gefährlichen Schüssen abschließen.'
      },
      OutPlay1: {
        1: 'Wir können feststellen, dass der Spieler nur minimalen Einfluss darauf hat, defensive Strukturen zu stören.'
      },
      OutPlay2: {
        1: 'Sein Beitrag zum Spielaufbau und zum Durchbrechen von Abwehrreihen liegt unter dem Positionsstandard.'
      },
      OutPlay3: {
        1: 'Gelegentlich in der Lage, Vorteile zu schaffen, mit Leistungen im Bereich des Positionsdurchschnitts.'
      },
      OutPlay4: {
        1: 'Trägt häufig dazu bei, Abwehrlinien zu durchbrechen und Ungleichgewichte zu erzeugen.'
      },
      OutPlay5: {
        1: 'Gehört zu denen, die auf dieser Position am besten Gegner ausschalten und Vorwärtsbewegung erzeugen.'
      },
      LineBreakingPasses1: {
        1: 'Versucht oder vollendet nur selten Pässe, die Abwehrlinien durchbrechen, mit sehr geringem Beitrag in diesen Aktionen.'
      },
      LineBreakingPasses2: {
        1: 'Hat Schwierigkeiten, regelmäßig Mitspieler zwischen den Linien oder hinter dem Druck zu finden, Beitrag unter Positionsstandard.'
      },
      LineBreakingPasses3: {
        1: 'Der Spieler spielt gelegentlich Pässe, die Linien durchbrechen, und liegt in diesem Bereich im Durchschnitt seiner Position.'
      },
      LineBreakingPasses4: {
        1: 'Wir erkennen, dass der Spieler häufig mit seinen Pässen Linien durchbricht und gegnerische Blöcke aus dem Gleichgewicht bringt.'
      },
      LineBreakingPasses5: {
        1: 'Gehört zu den Besten der Liga, was das Durchbrechen von Linien und das Überwinden von Druck mit Pässen angeht; dies ist eine seiner Hauptstärken.'
      },
      PassUnderPressure1: {
        1: 'Es ist erkennbar, dass es ihm schwerfällt, Ruhe oder Effektivität zu bewahren, wenn Gegner Druck ausüben.'
      },
      PassUnderPressure2: {
        1: 'Bei hohem Druck fällt es ihm schwer, die Passgenauigkeit zu halten.'
      },
      PassUnderPressure3: {
        1: 'Liegt beim Passspiel unter Druck im Bereich des Durchschnitts. Geht vernünftig mit Druck um, jedoch nicht immer mit sauberer Ausführung.'
      },
      PassUnderPressure4: {
        1: 'Er findet trotz Drucks häufig Mitspieler und liegt in dieser Art von Pässen über dem Durchschnitt.'
      },
      PassUnderPressure5: {
        1: 'Hervorragende Ruhe und Präzision beim Passspiel unter starkem Druck. Gehört in diesem Aspekt zu den Besten auf seiner Position.'
      },
      BallReceived1: {
        1: 'Erhält nur sehr wenige Pässe in offensiven Zonen; kein Spieler, der regelmäßig zwischen den Linien agiert.'
      },
      BallReceived2: {
        1: 'Nimmt einige ungestörte Bälle in der gegnerischen Hälfte an, aber ohne große Regelmäßigkeit.'
      },
      BallReceived3: {
        1: 'Verzeichnet ein mittleres Volumen an ungestörten Ballannahmen in Angriffsbereichen.'
      },
      BallReceived4: {
        1: 'Empfängt häufig zwischen den Linien und in druckfreien Zonen.'
      },
      BallReceived5: {
        1: 'Sammelt viele Ballannahmen zwischen den Linien, frei von Gegenspielern und in potenziell wichtigen Zonen.'
      },
      OnBallPressure1: {
        1: 'Presst selten und fast nie in der Nähe des Ballführenden. Kein intensiver Spieler.'
      },
      OnBallPressure2: {
        1: 'Führt einige starke Pressings aus, aber nicht oft. Seine Gesamtintensität ist eher gering.'
      },
      OnBallPressure3: {
        1: 'Verzeichnet ein mittleres Volumen an Pressings in der Nähe des Gegners in Ballbesitz.'
      },
      OnBallPressure4: {
        1: 'Disziplinierter Pressingspieler, der sich regelmäßig dem Ballführenden nähert.'
      },
      OnBallPressure5: {
        1: 'Sehr intensiv ohne Ball, hoch diszipliniert und arbeitet hart, um den Gegner unter Druck zu setzen.'
      },
      SpatialCoverage1: {
        1: 'Der Spieler zeigt nur sehr begrenzten Beitrag zur Raumbesetzung und -kontrolle, mit minimaler Beteiligung an Formation und taktischer Struktur. Seine Raumdeckung ist in Ballbesitz und ohne Ball schwach und hat wenig Einfluss auf die kollektive Organisation.'
      },
      SpatialCoverage2: {
        1: 'Der Spieler bietet unterdurchschnittliche Raumdeckung, beteiligt sich teilweise an der Feldbesetzung, weist jedoch Lücken in der Positionskontinuität und im Zusammenspiel mit dem Team auf. Sein Einfluss auf die taktische Struktur ist unregelmäßig.'
      },
      SpatialCoverage3: {
        1: 'Der Spieler weist durchschnittliche Raumdeckung auf, trägt konstant zur Raumbesetzung und -kontrolle bei. Seine Positionierung ist im Allgemeinen korrekt und funktional, mit mäßigem Einfluss in Offensive und Defensive.'
      },
      SpatialCoverage4: {
        1: 'Der Spieler bietet überdurchschnittliche Raumdeckung, ist stark an der Feldbesetzung und der Positionsstruktur beteiligt. Seine Fähigkeit, die Formation zu halten und sich an Übergänge anzupassen, trägt erheblich zu Kompaktheit und Kontrolle wichtiger Räume bei.'
      },
      SpatialCoverage5: {
        1: 'Der Spieler erreicht ein exzellentes Niveau der Raumdeckung, optimiert seine Positionierung, um entscheidend auf Formation und taktische Struktur einzuwirken. Sein Spielverständnis und die Abstimmung mit dem Block ermöglichen maximale Besetzung strategischer Räume.'
      },
      OffBallPressure1: {
        1: 'Der Spieler übt ohne Ball nur sehr begrenzten Defensivdruck aus, stört selten Gegner oder erzwingt Fehler. Sein Beitrag zum Pressing und zur Defensivstruktur ist minimal.'
      },
      OffBallPressure2: {
        1: 'Der Spieler übt unterdurchschnittlichen Defensivdruck ohne Ball aus, greift Gegner gelegentlich an, jedoch mit inkonstantem Timing oder Stellungsspiel. Sein Einfluss auf Ballgewinne oder Störungen des gegnerischen Aufbaus ist begrenzt.'
      },
      OffBallPressure3: {
        1: 'Der Spieler zeigt durchschnittlichen Off-Ball-Druck, trägt konstant zu den Defensivbemühungen bei. Seine Positionierung und sein Timing sind im Allgemeinen effektiv.'
      },
      OffBallPressure4: {
        1: 'Der Spieler übt überdurchschnittlichen Off-Ball-Druck aus, stört häufig gegnerische Aktionen und reduziert deren Zeit und Raum. Seine Bemühungen sind gut koordiniert.'
      },
      OffBallPressure5: {
        1: 'Der Spieler ist herausragend im Off-Ball-Druck, bedrängt Gegner ständig, erzwingt Ballverluste und schränkt Passwege ein. Intensität, Positionierung und Antizipation steigern die Defensivleistung deutlich.'
      },
      Distance1: {
        1: 'Es wird deutlich weniger Strecke zurückgelegt als der Durchschnitt (die Bewegung auf dem Platz ist sehr begrenzt).'
      },
      Distance2: {
        1: 'Seine pro Spiel gelaufene Distanz liegt unter dem, was im Spitzenfußball üblich ist (weniger aktiv als der Durchschnitt).'
      },
      Distance3: {
        1: 'Er läuft eine angemessene Distanz, Zahlen liegen um den Ligadurchschnitt (sein physischer Einsatz ist ausgewogen).'
      },
      Distance4: {
        1: 'Er legt konstant hohe Distanzen zurück, was auf eine starke Ausdauer hinweist.'
      },
      Distance5: {
        1: 'Sein physisches Volumen ist herausragend. Er gehört in Bezug auf gelaufene Distanz zu den aktivsten Spielern der Top-5-Ligen.'
      },
      Sprint1: {
        1: 'Er macht deutlich weniger Sprints als der Durchschnitt (geringer Sprintaufwand über das Spiel hinweg).'
      },
      Sprint2: {
        1: 'Seine Sprintfrequenz liegt unter dem Durchschnitt für seine Position (begrenzte Explosivität bei schnellen Bewegungen).'
      },
      Sprint3: {
        1: 'Er macht eine moderate Anzahl an Sprints pro Spiel, im erwarteten Durchschnitt.'
      },
      Sprint4: {
        1: 'Fällt durch eine weit überdurchschnittliche Sprintfrequenz auf. Zeigt konstante Explosivität mit schnellen Läufen während des gesamten Spiels.'
      },
      Sprint5: {
        1: 'Er gehört zu den oberen 20 % der Spieler mit dem höchsten Sprintvolumen pro 90 Minuten.'
      },
      Acceleration1: {
        1: 'Seine Fähigkeit, das Tempo zu wechseln, liegt klar unter dem Durchschnitt; er macht nur wenige explosive Beschleunigungen im Spiel.'
      },
      Acceleration2: {
        1: 'Seine Beschleunigungsleistung liegt unter dem Durchschnitt im Vergleich zu ähnlichen Spielern, da er wenige Kurzdistanz-Sprints zeigt.'
      },
      Acceleration3: {
        1: 'Er verzeichnet eine angemessene Anzahl an Beschleunigungen, nahe am Ligadurchschnitt.'
      },
      Acceleration4: {
        1: 'Zeigt eine starke Fähigkeit, schnell und wiederholt zu beschleunigen; seine Beschleunigungsrate liegt klar über dem Durchschnitt.'
      },
      Acceleration5: {
        1: 'Er gehört zu den obersten 20 % der explosivsten Spieler in wiederholten Beschleunigungen.'
      },
      Speed1: {
        1: 'Vermutlich ein physisch langsamer Spieler oder einer, der intensive Läufe im Spiel schont.'
      },
      Speed2: {
        1: 'Seine Spitzengeschwindigkeit liegt leicht unter dem Wettbewerbsdurchschnitt.'
      },
      Speed3: {
        1: 'Hält im Spiel durchschnittliche Spitzengeschwindigkeiten.'
      },
      Speed4: {
        1: 'Erreicht häufig hohe Geschwindigkeiten, was darauf hindeutet, dass er schnell und kräftig ist.'
      },
      Speed5: {
        1: 'Erreicht sehr hohe Spitzengeschwindigkeiten. Wahrscheinlich ein Unterschiedsspieler in puncto Tempo.'
      },
      LineBreakingCarries1: {
        1: 'Durchbricht selten Linien mit Ball am Fuß; zeigt wenig Initiative im Vorwärtsdrang.'
      },
      LineBreakingCarries2: {
        1: 'Führt einige Linien durchbrechende Läufe mit Ball aus, jedoch nicht regelmäßig.'
      },
      LineBreakingCarries3: {
        1: 'Hat eine moderate Anzahl erfolgreicher, Linien durchbrechender Läufe mit Ball.'
      },
      LineBreakingCarries4: {
        1: 'Trägt häufig den Ball über Linien und unterstützt so den Spielaufbau.'
      },
      LineBreakingCarries5: {
        1: 'Ein echter Spezialist im Balltragen, der konstant und mit hohem Volumen Linien durchbricht.'
      },
      LineBreakingActions1: {
        1: 'Verzeichnet nur sehr wenige, Linien durchbrechende Aktionen (Pässe und Läufe) und geht selten Risiko ein.'
      },
      LineBreakingActions2: {
        1: 'Produziert einige progressive Aktionen (Pässe und Läufe), aber selten; spielt eher horizontal.'
      },
      LineBreakingActions3: {
        1: 'Kombiniert regelmäßig Pässe und Läufe, die Linien durchbrechen, und trägt zur Vorwärtsbewegung bei.'
      },
      LineBreakingActions4: {
        1: 'Technisch versiert und intelligent, um viele Linien durchbrechende Aktionen (Pässe und Läufe) zu erzeugen.'
      },
      LineBreakingActions5: {
        1: 'Ein wahrer Spezialist für Progression; er hat großen Einfluss auf sein Team, indem er konstant Linien mit Ball durchbricht.'
      },
      OffBallRuns1: {
        1: 'Der Spieler macht nur sehr wenige gezielte Läufe ohne Ball, bietet in der Offensive wenig Unterstützung.'
      },
      OffBallRuns2: {
        1: 'Der Spieler zeigt unterdurchschnittliche Bewegung ohne Ball, unterstützt gelegentlich den Angriff, jedoch ohne konstantes Timing oder klare Absicht.'
      },
      OffBallRuns3: {
        1: 'Der Spieler zeigt durchschnittliche gezielte Läufe ohne Ball, schafft regelmäßig Raum und unterstützt das Teamspiel moderat.'
      },
      OffBallRuns4: {
        1: 'Der Spieler weist überdurchschnittliche Off-Ball-Aktivität auf, macht häufig gezielte Läufe, die Abwehrstrukturen stören und Räume öffnen.'
      },
      OffBallRuns5: {
        1: 'Der Spieler glänzt mit gezielten Läufen ohne Ball, antizipiert das Spiel konstant und schafft intelligente Laufwege, die offensive Chancen maximieren.'
      },
      OverMaxValue: {
        1: 'Er hat eine extreme Fähigkeit in over_max_metric_name, mit Leistungen auf sehr hohem Niveau, was diesen Spieler zu den Top 10 % der Top-5-Ligen zählen lässt.'
      },
      OverAverageSeason: {
        1: 'Seine Leistungen in over_average_metric_name liegen über dem Ligadurchschnitt in league_name (over_average_metric_value vs average_metric_value).',
        2: 'Vergleicht man seine Zahlen mit denen der Liga league_name, so lässt sich feststellen, dass seine Leistungen in over_average_metric_name über dem Durchschnitt liegen (over_average_metric_value vs average_metric_value).'
      },
      UnderMinValue: {
        1: 'In Bezug auf under_min_metric_name sollte er seine Leistungen deutlich verbessern, da er derzeit zu den niedrigsten percent_metric_name der Top-5-Ligen gehört.'
      },
      Over70Percent: {
        1: ', besonders herausragend in over_70_metric_name mit over_70_metric_value pro 90 Minuten, jeweils.',
        2: ', liegt in over_70_metric_name über 70 % der Spieler mit over_70_metric_value pro 90 Minuten, jeweils.',
        3: ', leistet eine mehr als bemerkenswerte Arbeit in over_70_metric_name mit over_70_metric_value pro 90 Minuten, jeweils.'
      },
      Under30Percent: {
        1: ', muss hart arbeiten in under_30_metric_name, weil seine Leistungen mit under_30_metric_value pro 90 Minuten jeweils schwach ausfallen.',
        2: ', verbesserungswürdig in under_30_metric_name, denn mit under_30_metric_value pro 90 Minuten jeweils sind seine Leistungen schlechter als erwartet.',
        3: ', was under_30_metric_name betrifft, muss er mit under_30_metric_value pro 90 Minuten jeweils härter arbeiten, um bessere Statistiken zu erzielen.'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Es ist gut, seine Leistungen hervorzuheben, die über dem Ligadurchschnitt von league_name liegen.'
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value vs average_metric_value im Durchschnitt).'
      },
      Over70PercentIndividualPressure: {
        1: ', übt einen sehr hohen individuellen Druck auf den Gegner aus, um den Ball zurückzuerobern.',
        2: ', übt hohen Druck auf den Gegner aus, um den Ball zurückzuerobern.'
      },
      Under30PercentIndividualPressure: {
        1: ', muss sein Pressing verstärken, um den Ball zurückzuerobern.',
        2: ', muss sich mehr anstrengen, um den Gegner unter Druck zu setzen.'
      }
    },
    himSelf: 'Er selbst',
    ownSeason: 'Eigene Saison',
    minMaxTooltip: 'Minimale und maximale Werte des Radars anpassen',
    NumberOfPlayers: 'Spieleranzahl',
    top5Ligas: 'Top-5-Ligen',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Login',
    latestBlogPosts: 'Letzter Blog Posts',
    signIn: 'Einloggen',
    username: 'Benutzername',
    password: 'Passwort',
    passwordForgotten: 'Passwort Vergessen',
    signUp: 'Anmelden',
    enter: 'Enter',
    forceTitle: 'Benutzerkonto in Nutzung',
    forceMessage: 'Das Benutzerkonto ist bereits mit einem anderen Gerät verbunden. Wollen Sie es rausschmeißen und mit diesem Gerät verbinden?',
    forgotMyPassword: 'Passwort vergessen',
    firstLogin: 'Erstes Einloggen',
    firstLoginMessage: 'Aus Sicherheitsgründen müssen Sie ein neues Passwort bei Ihrem ersten Login erstellen. Zusätzlich zu einer bevorzugten Sprache in der App',
    firstLoginOverview: 'Hier finden Sie einen Überblick über Ihr Konto, die Ligen und Produkte, zu denen Sie Zugang haben.',
    passwordConfirmation: 'Passwort Bestätigung',
    forgotPasswordMessage: 'Geben Sie Ihre E-Mail ein. Wenn ein gültiges Konto mit der E-Mail verknüpft ist, erhalten Sie in Ihrem Posteingang die nächsten Schritte zum Zurücksetzen Ihres Passworts',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordLinkInvalid: 'Dieser Link ist ungültig oder abgelaufen. Fordern Sie auf der Anmeldeseite ein neues Zurücksetzen des Passworts an.',
    skipSettings: 'Einstellungen überspringen',
    contact: 'Kontakt',
    cookiesText: 'Diese Website verwendet Google-Cookies, um ihre Dienste bereitzustellen und Ihren Datenverkehr zu analysieren, um die Servicequalität zu gewährleisten, Nutzungsstatistiken zu erstellen und Missbrauch zu erkennen und zu beheben.',
    contactUs: 'Kontaktieren Sie uns',
    newsTitle: 'Neu: Physische Scores!',
    newsText: 'Wir haben neben unserem ursprünglichen Eventdaten-Score zwei neue Scores für physische Leistung hinzugefügt: <b>Ausdauer-Score</b> und <b>Geschwindigkeit-&-Power-Score</b>.<br> Ausdauer hebt Spieler hervor, die konstant Raum abdecken und hohe Belastungen aufrechterhalten, während Geschwindigkeit & Power sich auf Höchstgeschwindigkeit, Sprints und explosive Beschleunigungen konzentriert.'
  },
  settings: {
    pageSubtitle: 'Konfigurieren Sie Ihre Erfahrungen in der Anwendung',
    language: 'Sprache',
    availableLeagues: 'Verfügbare Ligen',
    availableSeasons: 'Verfügbare Saisons',
    availableProducts: 'Verfügbare Produkte',
    organization: 'Firma',
    changePassword: 'Passwort ändern',
    seasonTemplates: 'Saison Vorlage',
    seasonTemplatesSubtitle: 'Erstellen Sie Ihre eigenen Saisonvorlagen, die später in der Spieler Leistung und im Spieler Scout zur Auswahl stehen',
    templateName: 'Vorlage Name',
    selectTemplate: 'Vorlage zum Bearbeiten auswählen',
    radarDefault: 'Standard Radar',
    default: 'Standard',
    tabs: {
      options: 'Optionen',
      templates: 'Vorlagen',
      availableLeagues: 'Verfügbare Ligen',
      contactData: 'GBE Kontaktdaten',
      availableLigen: 'Verfügbare Ligen'
    },
    contactData: {
      userDetails: 'Benutzerdaten',
      firstName: 'Name',
      lastName: 'Nachname',
      contactDetails: 'Kontaktdaten für GBE',
      name: 'Name',
      phone: 'Festnetznummer',
      mobile: 'Handynummer',
      email: 'Email',
      representativeDetails: 'Firmendaten für GBE'
    },
    currency: 'Währung',
    fieldPreferences: 'Hintergrundeinstellung',
    visualizationsPreferences: 'Grafik Einstellungen',
    fieldColor: 'Hintergrund Farben',
    fieldColors: {
      green: 'Grün',
      blue: 'Blau',
      white: 'Weiß',
      black: 'Schwarz',
      grey: 'Grey'
    },
    defaultPlayerVisualization: 'Standard-Spieler-Visualisierung',
    appPreferences: 'Anwendungseinstellungen',
    darkMode: 'Dunkel Modus',
    showTour: 'Geführte Tour anzeigen',
    customStats: 'Benutzerdefinierte Statistiken',
    radarTemplates: 'Radar Vorlage',
    radarTemplatesSubtitle: 'Erstellen Sie Ihre eigenen Metrikvorlagen, die später in der Spieler Leistung und im Spieler Ranking ausgewählt werden können',
    radarCategories: {
      Custom1: 'Benutzerdef. 1',
      Custom2: 'Benutzerdef. 2',
      Custom3: 'Benutzerdef. 3',
      Custom4: 'Benutzerdef. 4',
      Custom5: 'Benutzerdef. 5',
      Custom6: 'Benutzerdef. 6',
      Physical: 'Physisch',
      CustomPhysical1: 'Benutzerdef. Physisch 1',
      CustomPhysical2: 'Benutzerdef. Physisch 2',
      CustomPhysical3: 'Benutzerdef. Physisch 3',
      CustomPhysical4: 'Benutzerdef. Physisch 4',
      CustomPhysical5: 'Benutzerdef. Physisch 5',
      CustomPhysical6: 'Benutzerdef. Physisch 6'
    },
    templateRemoveTitle: 'Remove Template',
    templateRemoveMsg: 'Do you want to remove this template?',
    templateEditTitle: 'Vorlage speichern',
    templateEditMsg: 'Es gibt eine ungespeicherte Vorlage. Möchten Sie diese speichern, bevor Sie eine andere Vorlage?',
    category: 'Kategorie',
    playerRadar: 'Spieler Radar',
    teamRadar: 'Team Radar',
    statsAlert: 'Trage mindestens eine Statistik zum Speichern ein',
    recommended: 'Empfohlen',
    warning: 'Es gibt Positionen, die die maximal zulässige Anzahl von Radargeräten erreicht haben. Bitte löschen oder bearbeiten Sie jede Vorlage',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Spanisch',
      numeric: 'Numerisch'
    },
    showMediaMode: 'Medienmodus anzeigen',
    statTemplates: 'Vorlagen für Spielstatistiken',
    statTemplatesSubtitle: 'Erstellen Sie Ihre eigenen Vorlagen, indem Sie aus einer Vielzahl von Metriken wählen',
    ratingFormat: {
      ratingFormat: 'Bewertungsformat',
      numbers: 'Zahlen',
      letters: 'Buchstaben A-F'
    }
  },
  playerDetail: {
    passport: 'Pass',
    secondPassport: 'Zweiter Pass',
    age: 'Alter',
    dateOfBirth: 'Geburtsdatum',
    height: 'Grösse',
    weight: 'Gewicht',
    wage: 'Einkommen',
    history: 'Transfers',
    positions: 'Positionen',
    injuries: 'Verletzungen',
    transfers: 'Transfers',
    nationalTeam: 'Nationalmannschaft',
    addFavorite: 'Zu Favoriten hinzufügen',
    removeFavorite: 'Aus Favoriten entfernen',
    contractEnd: 'Vertragsende',
    yearsOld: 'Jahre alt',
    playerAvailability: 'Verfügbarkeit',
    playerUsage: 'Gespielte Minuten',
    usage: 'Einsatz',
    addToCollection: 'Zur Kollektion hinzufügen',
    performance: 'Leistung',
    info: 'Info',
    career: 'Karriere',
    playerStyle: 'Spielerstil',
    radar: 'Radar',
    finishingMap: 'Abschluss Zone',
    threatMap: 'Gefahren Zone',
    keyPassMap: 'Schlüsselpass Zone',
    beeswarm: 'Platzierung',
    allGames: 'Alle Spiele',
    eventsMap: 'Events Zone',
    lbpMap: 'Zeilenumbruchpässe',
    obpMap: 'Auf Balldruck',
    pupMap: 'Pässe unter Druck',
    obrMap: 'Ballquittungen',
    fullName: 'Vollständiger Name',
    academy: 'Akademie',
    name: 'Name',
    lastName: 'Nachname',
    playerAvailabilityLong: '% von der Saison ohne Verletzungen oder Aussetzungen',
    playerUsageLong: 'Gespielte Minuten',
    playerAvailability1: 'Spiele ohne Verletzungen oder Aussetzungen',
    playerAvailability2: 'Spiele in dieser Saison',
    playerUsage1: 'Gespielte Minuten',
    playerUsage2: 'Mannschaftsminuten gesamt',
    notMinutesThisSeason: 'Hat in dieser Saison noch keine Minuten gespielt',
    seasonPlaceholder: 'Es ist keine aktive Saison',
    inactivePlayer: 'Inaktiver Spieler',
    inactivePlayerMessage: 'Falls Sie mehr Informationen benötigen, können Sie sich bei uns für ein Bericht melden',
    goRequest: 'Gehen Sie zu Anfrage',
    warningMinutes: 'Vorsicht: Weniger als 450 Minuten gespielt, Analyse könnte möglicherweise nicht repräsentativ sein',
    scoreWarningMinutes: 'Spieler mit mindestens 450 insgesamt gespielten Minuten',
    pdScoreWarningMinutes: 'Spieler mit mindestens 450 insgesamt gespielten Minuten (mindestens 60 Minuten pro Spiel)',
    warningSeasonGames: 'Saison hat weniger als 5 Spiele, also Min & Max sind \'Top 5 Ligen\'',
    warningStatsRemoved: 'Einige Statistiken werden nicht angezeigt, da sie für die ausgewählte Saison nicht verfügbar sind',
    warningBeeswarm: 'Spieler nicht angezeigt, da keine Daten für die ausgewählte Saison verfügbar sind',
    warningPlayersZeroValue: '{x} Spieler mit 0 werden nicht angezeigt ',
    onlyPlayersThatFit: 'Nur Spieler die in das Radar Format passen',
    gamesPlayedNotEnough: 'Optionen deaktiviert aufgrund einer unzureichenden Anzahl gespielter Spiele',
    gbe: 'GBE',
    analysis: 'Analyse',
    documents: 'Dokumente',
    rankDefensive: 'Defensive',
    rankBallHandling: 'Ballkontrolle',
    rankGoal: 'Tor Beitrag',
    rankXt: 'Gefahr',
    rankIndex: 'Index',
    visitHistory: 'Historie anschauen',
    placer: 'Spielfeld',
    touchesMap: 'Ballaktionen',
    heatMap: 'Heat Map',
    ageProfile: 'Altersprofil',
    strongFoot: 'starker Fuß',
    player: 'Spieler',
    outOf: 'von',
    in: 'in',
    radius: 'Radius',
    blur: 'Unschärfe',
    careerTable: {
      nationalTeamCareer: 'Karriere in der Nationalmannschaft',
      nationalTeamCompetitions: 'Nationale Mannschaftswettbewerbe'
    },
    physicalProgression: 'Physical Progression',
    gpi: 'Globaler Spielerindex',
    warningGPI: 'Nur verfügbar für Spieler, die in den letzten 30 Tagen in ELO-Ligen aktiv waren',
    diffGPI: 'Änderung seit dem letzten Spiel',
    rankingInTheWorld: '#{0} in der Welt',
    rankingInTheLeague: '#{0} in {1}',
    max: 'Max',
    gpiChart: 'Diagramm basierend auf dem Wert des Globalen Spielerindex der letzten {0} Spiele',
    percentileRange: 'Perzentile {0} bis {1}',
    JahrsOld: ' Jahre alt',
    months: 'Monate',
    month: 'Monat',
    contractExpOver4Years: 'Vertrag läuft in aus',
    contractExpSoon: 'Der Vertrag läuft bald aus',
    contractFinalYear: 'Letztes Vertragsjahr',
    freeAgent: 'Freier Agent',
    gpiDescription: 'Der Global Player Index (GPI) ist ein standardisiertes Spielerbewertungssystem, das Fußballer anhand ihrer Teamstärke, Gegnerstärke, Spielleistungen und Verfügbarkeit bewertet. Inspiriert durch das Elo-Bewertungssystem stellt es sicher, dass die Spielerbewertungen das tatsächliche Wettbewerbsumfeld und nicht willkürliche Basislinien widerspiegeln.',
    turnoversMap: 'Umsatz- und Rückgewinnungskarte',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    }
  },
  finishingMap: {
    typesOfShot: 'Schussart',
    shotStrategy: 'Schussstrategie',
    strategiesCount: '{count} Strategien',
    areas: 'Region',
    bodyPart: 'Körperteil',
    more: 'mehr',
    selectAll: 'Alle auswählen',
    minutes: 'Minuten',
    circles: 'Kreise',
    boxes: 'Heatmap des Strafraums',
    lines: 'Linien',
    games: 'Spiele',
    perShot: 'pro Schuss',
    goal: 'Tor',
    missedShot: 'Verfehlte Schüsse',
    savedShot: 'Gehaltene Schüsse',
    shotOnPost: 'Pfostentreffer',
    missedChance: 'Verpasste Chance',
    openPlay: 'aus dem Spiel heraus',
    regularPlay: 'reguläres Spiel',
    fastBreak: 'Fast Break',
    individualPlay: 'Individuelles Spiel',
    setPiece: 'Standard Situation',
    fromCorner: 'Eckball',
    freeKick: 'Freistoß',
    indirectFreeKick: 'Indirekter Freistoß',
    throwInSetPiece: 'Einwurf',
    inBox: 'Im Strafraum',
    goalArea: '5-Meter Raum',
    boxLeft: 'Linker Strafraum',
    boxCenter: 'Mitte Strafraum',
    boxRight: 'Rechter Strafraum',
    outOfBox: 'Außerhalb des Strafraums',
    outBoxDeepLeft: 'Außerhalb des Strafraums tief Links',
    outBoxDeepRight: 'Außerhalb des Strafraums tief Rechts',
    outBoxLeft: 'Außerhalb des Strafraums Links',
    outBoxCentreLeft: 'Außerhalb des Strafraum Mitte Links',
    outBoxCentre: 'Außerhalb des Strafraums Mitte ',
    outBoxCentreRight: 'Außerhalb des Strafraums Mitte Rechts',
    outBoxRight: 'Außerhalb des Strafraum Rechts ',
    left35: '+35 Links',
    centreLeft35: '+35 Mitte Links',
    centre35: '+35 Mitte',
    centreRight35: '+35 Mitte Rechts',
    right35: '+35 Rechts',
    head: 'Kopf',
    rightFooted: 'Rechter Fuß',
    leftFooted: 'Linker Fuß',
    otherBodyPart: 'Anderer Körperteil',
    chart: {
      shots: 'Schüsse',
      xGPerShot: 'xG pro Schuss',
      exceptionTextPenaltyGoals: '* Elfmeter = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Elfmeter = 0.765 xGOT',
      exceptionTextOwnGoals: '* Eigentore werden nicht mitgezählt',
      og: 'Eigentor',
      penaltiesExcluded: 'Elfmeter werden nicht inkludiert',
      ownGoalsExcluded: 'Ohne Eigentore',
      sumOfxG: 'Summe von xG',
      exceptionShotsOutOfRange: '* Zeigt keine Schüsse außerhalb der Reichweite an'
    },
    inGoal: 'Im Tor',
    outOfGoal: 'Außerhalb des Tores',
    highLeft: 'Oben Links',
    highCenter: 'Oben Mitte',
    highRight: 'Oben Rechts',
    lowLeft: 'Unten Links',
    lowCenter: 'Unten Mitte',
    lowRight: 'Unten Rechts',
    outHighLeft: 'Oben Links daneben',
    high: 'Oben Mitte daneben',
    outHighRight: 'Oben Rechts daneben',
    closeHighLeft: 'Knapp oben Links vorbei',
    closeHigh: 'Knapp oben Mitte vorbei',
    closeHighRight: 'Knapp oben Rechts vorbei',
    closeLeft: 'Knapp unten Links vorbei',
    closeRight: 'Knapp unten Rechts vorbei',
    finishingTable: 'Abschluss Tabelle',
    onGoal: 'Auf das Tor',
    distributionFilters: 'Verteilungsfilter',
    penalty: 'Elfmeter',
    penaltyShootout: 'Elfmeterschießen',
    onlyPercentage: 'Prozentsatz anzeigen',
    showAll: 'Alles anzeigen',
    chanceMissed: 'Chance verpasst'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Schlüsselpass',
      xAPerPass: 'xA pro Pass',
      xAOpenPlay: 'xA Offenem Spiel',
      xASetPiece: 'xA Standard Situation'
    }
  },
  beeswarm: {
    template: 'Vorlage',
    templates: {
      Goalkeeper: 'Torwart',
      Defender: 'Innenverteidiger',
      'Full-Back': 'Außenverteidiger',
      FullBack: 'Außenverteidiger',
      'Wing-Back': 'Offensiver Außenverteidiger',
      WingBack: 'Offensiver Außenverteidiger',
      Midfielder: 'Mittelfeldspieler',
      AttackingMidfielder: 'Offensiver Mittelfeldspieler',
      Winger: 'Flügelspieler',
      Forward: 'Stürmer',
      Physical: 'Physisch'
    },
    compareWith: 'Vergleichen mit',
    highlightPlayersOf: 'Highlight Players of',
    highlightPlayers: 'Highlight Spieler aus',
    per90: 'Daten pro 90 Minuten',
    highlightTeams: 'Teams Hervorheben',
    filterTeams: 'Mannschaften filtern',
    warningZeros: 'Nur für nicht umgekehrte Statistiken'
  },
  collections: {
    newCollection: 'Neue Kollektion',
    editCollection: 'Kollektion Anpassen',
    name: 'Name',
    visibility: 'Ansicht',
    privacity: {
      publicTitle: 'Öffentlich',
      publicDescription: 'Sichtbar für Sie und Ihren Verein',
      privateTitle: 'Privat',
      privateDescription: 'Nur für Sie sichtbar',
      supervisedTitle: 'Beaufsichtigt',
      supervisedDescription: 'Nur für Sie und Ihren Vorgesetzten sichtbar'
    },
    addSuccess: 'Erfolgreich hinzugefügt',
    createAddSuccess: 'Erfolgreich erstellt und hinzugefügt',
    editSuccess: 'Erfolgreich geändert',
    deleteSuccess: 'Erfolgreich gelöscht',
    title: 'Spieler Kollektionen',
    publics: 'Öffentliche',
    privates: 'Privates',
    supervised: 'Beaufsichtigt',
    totalMarketValue: 'Marktwert',
    avgMarketValue: 'Durchschnittlicher Marktwert',
    avgAge: 'Durchschnittliches Alter',
    searchBarPlaceholder: 'Um zur Kollektion hinzuzufügen, suchen und wählen Sie einen Spieler',
    deleteCollection: 'Kollektion löschen',
    deleteCollectionMessage: 'Kollektion wird gelöscht, sind Sie sich sicher?',
    removePlayer: 'Spieler entfernen',
    removePlayerMessage: 'Der Spieler wird von der Kollektion entfernt, sind Sie sich sicher?',
    subtitle: 'Scouting organisieren',
    notExitingTemplate: 'Es gibt noch keine Vorlagen'
  },
  searchbar: {
    placeholder: 'Suche (z.B. `Eric Arsenal´)',
    players: 'Spieler',
    teams: 'Mannschaften',
    games: 'Spiele',
    leagues: 'Ligen',
    explore: 'Mehr Resultate suchen',
    placeholderNoResults: 'Keine Ergebnisse',
    teamPlaceholder: 'Um ein Team zu vergleichen, suchen und wählen Sie es aus'
  },
  favorites: {
    showOnly: 'Nur Anzeigen',
    selfFavorites: 'Meine Favoriten',
    clubFavorites: 'Vereins Favoriten',
    contractExpiration: 'Vertragsablauf',
    groupBy: 'Gruppieren nach',
    noGrouped: 'Keine',
    maxSelection: 'Nur auswählen',
    selectAtleastOne: 'Mindestens einen auswählen',
    comparePlayers: 'Spieler vergleichen',
    selectedPlayers: 'Ausgewählte Spieler',
    subtitle: 'Verwalte deine Favoriten',
    generateXlsx: 'Erstelle XLSX',
    generating: 'wird erstellt...',
    subscribed: 'Subscribed',
    subscribedTooltip: 'Subscribe to recieve a mail when a game have been played',
    deleteSelected: 'Ausgewählte löschen'
  },
  expiration: {
    summer: 'Sommer',
    winter: 'Winter'
  },
  positions: {
    noposition: 'Keine Position',
    goalkeeper: 'Torwart',
    goalkeepers: 'Torhüter',
    defender: 'Abwehr',
    defenders: 'Abwehrspieler',
    defenses: 'Abwehr',
    fullback: 'Außenverteidiger',
    fullbacks: 'Außenverteidiger',
    midfielder: 'Mittelfeld',
    midfielders: 'Mittelfeldspieler',
    winger: 'Flügel',
    wingers: 'Flügelspieler',
    forward: 'Stürmer',
    forwards: 'Sturm',
    wingback: 'Offensiver Außenverteidiger',
    wingbacks: 'Offensive Außenverteidiger'
  },
  dPos: {
    1: {
      name: 'Goalkeeper',
      alias: ''
    },
    2: {
      name: 'Right Full Back',
      alias: 'RFB'
    },
    3: {
      name: 'Right Center Back',
      alias: 'RCB'
    },
    4: {
      name: 'Left Center Back',
      alias: 'LCB'
    },
    5: {
      name: 'Left Full Back',
      alias: 'LFB'
    },
    6: {
      name: 'Defensive Midfielder',
      alias: 'DM'
    },
    7: {
      name: 'Right Winger',
      alias: 'RW'
    },
    8: {
      name: 'Center Midfielder',
      alias: 'CM'
    },
    9: {
      name: 'Striker',
      alias: 'ST'
    },
    10: {
      name: 'Attacking Midfielder',
      alias: 'AM'
    },
    11: {
      name: 'Left Winger',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Vergleichen mit',
    lastSeasonSelectText: 'Letzte Saison',
    lastAndCurrentSeasonSelectText: 'Letzte + Aktuelle Season',
    currentSeasonSelectText: 'Aktuelle Saison',
    lastNgamesSelectText: 'Letzten {x} Spiele',
    npgVsXGTitle: 'Tore (ohne Elfmeter) VS xG',
    totalXGLabel: 'Insgesamte xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Tore Gesamt (ohne Elfmeter)',
    xGAgainstvsNPGAgainstTitle: 'xG kassiert VS Tore (ohne Elfmeter) kassiert',
    totalXGAgainstLabel: 'Insgesamte xG kassiert',
    xGAgainstLabel: 'xG kassiert',
    totalNPGAgainstLabel: 'Insgesamte Tore (ohne Elfmeter) kassiert',
    xGvsxGAgainstTitle: 'xG VS xG kassiert',
    pointsVsXPointsTitle: 'Punkte VS Erwartete Punkte',
    xTTitle: 'Spielfluss',
    totalXPoints: 'Insgesamte xPunkte',
    totalPoints: 'Insgesamte Punkte',
    requestedReports: 'Angeforderte Berichte',
    playersScouted: 'Spieler gescoutet',
    performanceVSAverageChart: 'Performance VS Durchschnitt',
    perPositions: 'Pro Position',
    perLeagues: 'Pro Ligen',
    perMonths: 'Pro Monat',
    perClients: 'Pro Kunde',
    ofPreposition: 'von',
    idJChartTitle: 'Spielinitiative',
    idJChartLabel: 'Index GI',
    vJOChartTitle: 'Offensives Spielvolumen',
    vJOChartLabel: 'Index OGV',
    preJOChartTitle: 'Offensive Spielpräzision',
    preJOChartLabel: 'Index OGPre',
    proJOChartTitle: 'Offensive Spielentwicklung',
    proJOChartLabel: 'Index OGPro',
    chart: 'Diagramm',
    table: 'Tabelle',
    showLeaguesWithAtLeast: 'Zeige Ligen mit mindestens',
    playersScoutedSuffix: 'gescouteten Spielern',
    perLeague: 'Pro Liga'
  },
  table: {
    history: {
      season: 'Saison',
      team: 'Team',
      position: 'Position',
      side: 'Seite',
      games: 'Spiele',
      minutes: 'Minuten',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: 'Fehlende Spiele',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Saison',
      team: 'Team',
      injury: 'Verletzung',
      dateFrom: 'Beginn Datum',
      dateTo: 'End Datum',
      daysLost: 'Verpasste Tage',
      gamesLost: 'Verpasste Spiele',
      allInjuries: 'All Injuries'
    },
    transfers: {
      season: 'Saison',
      date: 'Datum',
      teamFrom: 'Alter Verein',
      teamTo: 'Wechsel nach',
      marketValue: 'Marktwert',
      fee: 'Preis',
      type: 'Typ'
    },
    caps: {
      team: 'Team',
      debut: 'Debüt',
      games: 'Spiele',
      goals: 'Tore',
      coachDuringDebut: 'Trainer beim Debüt',
      debutAge: 'Alter beim Debüt'
    },
    roster: {
      country: 'Land',
      player: 'Spieler',
      positions: 'Positionen',
      minutes: 'Minuten',
      games: 'Spiele',
      goals: 'Tore',
      assists: 'Vorlagen',
      cards: 'Karten',
      gamesExplicit: 'Spiele'
    },
    league: {
      title: 'Liga-Blatt',
      subtitle: 'Vertiefen Sie die Rangliste und Statistiken der Liga',
      team: 'Team',
      games: 'S',
      gamesExplicit: 'Spiele',
      gamesRanking: 'S',
      gamesRankingExplicit: 'Spiele',
      points: 'Pts',
      pointsExplicit: 'Punkte',
      expectedPoints: 'VP',
      expectedPointsExplicit: 'Voraussichtliche Punkte',
      goalsScored: 'NPG',
      goalsScoredExplicit: 'Non-Penalty Goals - Tor (ohne Elfmeter)',
      xG: 'xT',
      xGExplicit: 'Voraussichtliche Tore',
      goalsAgainst: 'NPGA',
      goalsAgainstExplicit: 'Non-Penalty Gegentore kassiert',
      xGAgainst: 'xGA',
      xGAgainstExplicit: 'Voraussichtliche Gegentore kassiert',
      xGAgainstDiff: 'xGA Diff',
      xGAgainstDiffExplicit: 'Differenz erwartete Gegentore',
      form: 'Form',
      sos: 'SoS',
      sosExplicit: 'Strength of Schedule',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'Home Field Advantage',
      difficultyAboveAvg: 'Difficulty above average',
      differentGames: '* Unterschiedliche Anzahl an gespielten Spielen',
      berth: 'Bewertung'
    },
    usersOfClient: {
      userName: 'Name',
      userRole: 'User',
      devRole: 'Dev',
      adminRole: 'Admin',
      servicesRole: 'Dienstleistungen',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Ranking',
      elevenRole: 'Elevens',
      similarityRole: 'Ähnlichkeit',
      gameAnalysisRole: 'Spielanalysen',
      clientStatsRole: 'Klienten Statistik',
      created: 'Erstellt',
      type: 'Schreiben',
      logins: 'Logins',
      lastLogin: 'Letztes mal eingeloggt',
      trialDate: 'Testdatum'
    },
    clientLeagues: {
      league: 'Liga',
      area: 'Zone',
      tier: 'Stufe',
      seasons: 'Saisons',
      currentMatchDay: 'Spieltag',
      regular: 'Regulär',
      youthLeague: 'Jugend',
      clientActive: 'Aktiv',
      visibleLeagues: 'Sichtbare Ligen',
      male: 'Herrenliga',
      female: 'Frauenliga'
    },
    connections: {
      title: 'Häufige Kombinationen',
      playerFrom: 'Von Spieler',
      playerTo: 'Zu Spieler',
      passes: 'Pässe',
      passesTooltip: 'Anzahl an erfolgreichen Pässen',
      passesFinalThird: 'P ⅓',
      passesFinalThirdTooltip: 'Pässe im letzten Drittel'
    },
    playerPassMapData: {
      title: 'Passspiel Statistiken',
      player: 'Spieler',
      passes: 'Pässe',
      passesPct: '% Pässe',
      xA: 'xA',
      xG: 'xG',
      xT: 'xGefahr',
      playerTooltip: 'Spielername',
      passesTooltip: 'Insgesammte Anzahl an Pässen',
      passesPctTooltip: '% Erfolgreichen Pässen',
      xATooltip: 'Erwartete Vorlagen',
      xGTooltip: 'Erwartete Tore',
      xTTooltip: 'Erwartete Gefahr'
    },
    playerAllGames: {
      gameDate: 'Datum',
      game: 'Spiel',
      team: 'Mannschaft',
      positionsPlayed: 'Positionen',
      minsPlayed: 'Minuten',
      gameActions: 'Aktionen',
      gameDateTooltip: 'Spiel Datum',
      gameTooltip: 'Spiel',
      positionsPlayedTooltip: 'Gespielte Positionen',
      minsPlayedTooltip: 'Gespielte Minuten',
      gameActionsTooltip: 'Tore, Vorlagen, Karten',
      from: 'Begyndelse',
      to: 'Ende',
      goalText: 'Tor in',
      assistText: 'Vorlage in',
      penaltyText: 'Strafstoß in',
      ownGoalText: 'Eigentor in',
      yellowCardText: 'Gelbe Karte in',
      secondYellowCardText: 'Zweite Gelbe Karte in',
      redCardText: 'Rote Karte in',
      substitutionIN: 'Eingewechselt in',
      substitutionOUT: 'Ausgewechselt in',
      suspendedText: 'Suspendierung',
      Team: 'Ausrüstung'
    },
    gameFlow: {
      phase: 'Phase',
      mins: 'Minuten',
      team: 'Team',
      period: 'Dauer',
      possession: '%Bes.',
      possessionTooltip: '% Ballbesitz',
      xT: 'xGefahr',
      xTTooltip: 'Voraussichtliche Gefahr',
      pft: 'P ⅓',
      pftTooltip: 'Pässe in dem letzten Drittel',
      xG: 'xG',
      xGTooltip: 'Voraussichtliche Tore'
    }
  },
  game: {
    title: 'Spielblatt',
    subtitle: 'Vertiefung der Merkmale und Statistiken des Spiels',
    header: {
      gameDetails: 'Spiel Info',
      gameStats: 'Stats',
      gameFinishingMap: 'Abschluss-Zone',
      gameKeyPassMap: 'Schlüsselpass-Zone',
      gamePassMap: 'Pass-Zone',
      gameThreat: 'Spiel Gefahr',
      gameFlow: 'Spielfluss',
      gameAnalysis: 'Spielanalyse',
      gamePhysicalStats: 'Physische Statistiken',
      possessions: 'Ballbesitz',
      bench: 'Bank',
      video: 'Video highlights',
      preGame: 'Vor dem Spiel',
      postGame: 'Nach dem Spiel',
      areaCoverage: 'Flächendeckung'
    },
    passMap: {
      typeOfPlay: 'Spielart:',
      passes: 'Pässe:',
      team: 'Team',
      minutes: 'Minuten:',
      select: 'Auswählen',
      all: 'Alle',
      attacking: 'Sturm',
      defending: 'Abwehr',
      forwards: 'Vorwärts',
      backwards: 'Rückwärts',
      sideways: 'Seitlich',
      longBall: 'Langer Ball',
      successfullPasses: 'Erfolgreiche Pässe',
      homeTeam: 'Heim Mannschaft',
      awayTeam: 'Auswärts Mannschaft',
      passingMatrix: 'Passen Matrix',
      passer: 'Passgeber',
      receiver: 'Empfänger',
      passOutcome: 'Passergebnis',
      passDirection: 'Passrichtung',
      half: 'Hälfte',
      offensive: 'Offensiv',
      defensive: 'Defensiv',
      passingConnections: 'Passverbindungen',
      pitchView: 'Spielfeld',
      passSingular: 'Pass',
      passPlural: 'Pässe',
      playerLocation: 'Standort des Spielers',
      passLegend: 'Durchschnittliche Berührungsposition',
      minuteRange: 'Minutenbereich'
    },
    stats: {
      summary: 'Summary',
      attacking: 'Attacking',
      defending: 'Defending',
      contribution: 'Contribution',
      possession: 'Ballbesitz',
      expectedPoints: 'Voraussichtliche Punkte',
      directness: 'Genauigkeit',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG Standards',
      xA: 'xA',
      xASetPiece: 'xA Standards',
      xT: 'xT',
      xTSetPiece: 'xT Standards',
      touchesInOppBox: 'Touches in Opponent Box',
      passesFinalThird: 'Pässe im letzten Drittel',
      interceptions: 'Balleroberungen',
      recoveries: 'Ballgewinn',
      recoveriesOppHalf: 'Ballgewinn Gegnerischen Hälfte',
      tackles: 'Zweikämpfe',
      tacklesWasDribbled: 'Gewonnene defensive Eins-gegen-Eins-Duelle',
      fouls: 'Fouls',
      yellowCards: 'Gelbe Karten',
      redCards: 'Rote Karten',
      passes: 'Pässe',
      passing: 'Pässe %',
      crosses: 'Flanken',
      crossing: 'Flanken %',
      shots: 'Schüsse',
      shotsOnTarget: 'Schüsse aufs Tor',
      ppdaExplicit: 'Pässe pro Defensive Aktion',
      xgExplicit: 'Voraussichtliche Tore',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Wettbewerbsdurchschn.',
      winChanceTooltip: 'Siegwahrscheinlichkeit basierend auf erzielten und zugelassenen xG',
      drawChance: 'Unentschieden',
      xgAgainst: 'xG gegen',
      averagePossession: 'Ballbesitz',
      averageShots: 'Schüsse',
      averagexG: 'Voraussichtliche Tore',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt',
      SeasonAvg: 'Wettbewerb Durchschn.',
      recoveriesRate: 'Wiederherstellungsrate',
      turnoversRate: 'Fluktuationsrate'
    },
    detail: {
      halfTime: 'Halbzeit',
      overTime: 'Nachspielzeit',
      showStats: 'Statistiken zeigen',
      hideStats: 'Statistiken Ausblenden',
      bench: 'Bank',
      showShotOptions: 'Schuss Optionen anzeigen',
      hideShotOptions: 'Schuss Optionen ausblenden',
      showPassOptions: 'Pass Optionen anzeigen',
      hidePassOptions: 'Pass Optionen ausblenden',
      endGame: 'Spielende',
      penalties: 'Strafstoß'
    },
    timeline: {
      events: {
        goal: 'Tor',
        goal_ownGoal: 'Eigentor',
        goal_penalty: 'Elfmetertor',
        card: 'Karte',
        card_yellowCard: 'Gelbe Karte',
        card_secondYellowCard: 'Zweite Gelbe Karte',
        card_redCard: 'Rote Karte',
        formationChange: 'Formationsänderung',
        substitution: 'Auswechslung',
        saveShot: 'Gehaltener Schuss',
        saveShot_penalty: 'Gehaltener Strafstoß',
        missedShot: 'Verfehlter Schuss',
        missedShot_penalty: 'Verfehlter Strafstoß',
        shotOnPost: 'Pfostenschuss',
        shotOnPost_penalty: 'Pfostenschuss vom Strafstoß',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'Tor durch ',
      redCardTo: 'Rote Karte für ',
      missedPenalty: 'Versäumte strafe'
    },
    gameThreat: {
      typeOfPlay: 'Art der Aktion',
      regularPlay: 'Reguläres Spiel',
      setPiece: 'Standard Situation',
      setPiecePlay: 'Standard Situation',
      throwInSetPiecePlay: 'Einwurf',
      throwInPlay: 'Einwurf',
      gkThrow: 'Torwartstoß',
      gkKick: 'Abstoß',
      kickOff: 'Beginnen',
      actionEnding: 'Spielende',
      pass: 'Pass',
      shot: 'Schuss',
      foul: 'Foul',
      other: 'Anderes',
      threat: 'Gefahr',
      legendSumOfXT: 'Summe von xT',
      legendPass: 'Pass',
      legendShot: 'Schuss',
      legendCarryAndAction: 'Ballmitnahme und Aktion',
      legendCarryAndPass: 'Ballmitnahme und Pass',
      legendOnlyShowing: 'Zeigt nur individuelle Aktionen mit xT > ',
      legendOnlyShowingPart1: 'Zeigt nur individuelle Aktionen',
      legendOnlyShowingPart2: 'Aktionen mit xT > ',
      legendOnlyShowingSetPiece: 'Zeigt nur Standard Situation mit xT > ',
      legendOnlyShowingOpenPlay: 'Zeigt nur Aktionen aus dem Spiel heraus mit xT > ',
      legendPlays: 'Aktionen',
      legendPerPlay: 'pro Aktion',
      legendCarry: 'Ballmitnahme',
      penaltyPlay: 'Strafstoß',
      freeKickTakenPlay: 'Freistoß Situation',
      cornerTakenPlay: 'Eckball',
      fromCornerPlay: 'Eckball Situation',
      keeperThrowPlay: 'Torwart Abwurf Situation',
      fastBreakPlay: 'Schnelles Umschaltspiel Spiel',
      indirectPlay: 'Indirektes Spiel',
      minutes: 'Minuten',
      games: 'Spiele',
      xT: 'xT',
      xTPer90: 'xT pro 90\''
    },
    gameAnalysis: {
      next: 'Nächstes',
      previous: 'Vorheriges',
      phaseLabel: 'Phase',
      phasesLabel: 'Phasen',
      dot: '. ',
      comma: ', ',
      from: 'Von',
      to: 'Zu',
      and: ' und ',
      steps: {
        finishingMapFullGame: 'Abschluss Zone',
        keyPassMapFullGame: 'Schlüsselpass Zone',
        gameFlow: 'Spielfluss',
        finishingMapPerPhases: 'Abschluss Zone pro Phase',
        keyPassMapPerPhases: 'Schlüsselpass Zone pro Phase',
        passMapPerPhases: 'Pass Zone pro Phase'
      },
      step1: {
        table: {
          draw: 'Unentschieden',
          win: 'Sieg',
          lose: 'Niederlage',
          possession: 'Ballbesitz',
          xP: 'Erwartete Punkte',
          directness: 'Genausigkeit',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG aus dem Spiel heraus',
          xGSetPiece: 'xG Standard Situation',
          xA: 'xA',
          xAOpenPlay: 'xA aus dem Spiel heraus'
        },
        text: {
          firstParagraph: {
            1: 'Die Zone auf der rechten Seite zeigt die voraussichtlichen Tore an, die durch home_team_name und away_team_name generiert wurden. Die gefüllten Kreise sind die Schüsse die im Tor gelandet sind. Die Größe der Kreise hängen von dem xG Wert von jedem Schuss ab.'
          },
          lastParagraph: {
            1: 'Die Wahrscheinlichkeit von einem Ergebnis und die Anzahl an voraussichtlichen Punkten werden durch Schuss Simulationen (100,000 Schüsse werden simuliert) berechnet.'
          },
          targetHighTeamXG: {
            1: 'target_team_name, sowie als auch rival_team_name, haben es geschafft eine hohe Wahrscheinlichkeit an voraussichtlichen Toren zu generieren'
          },
          targetHighTeamOpenPlayXG: {
            1: 'In diesem Spiel, kamen die meisten Chancen von target_team_name aus dem Spiel heraus'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'In diesem Spiel, kamen die meisten Chancen von target_team_name aus dem Spiel heraus (im Gegensatz zu rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'In diesem Spiel, kamen die meisten Chancen von target_team_name durch Standard Situationen'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'In diesem Spiel, kamen die meisten Chancen von target_team_name durch Standard Situationen (im Gegensatz zu rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'In diesem Spiel, kamen die meisten Chancen von target_team_name durch Eckbälle'
          },
          targetLowTeamGoalConversion: {
            1: ' jedoch war die Torwahrscheinlichkeit niedrig '
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name machte eine hohe Anzahl sowohl an erwarteten Toren aus dem freien Spiel heraus, als auch aus Standard Situationen'
          },
          targetHighTeamGoalConversion: {
            1: ' auch mit einer hohen Torwahrscheinlichkeit. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', waren nicht in der Lage ein Tor zu schießen, trotz ihrer Chancen'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' aber produzierte Gefahr um mehrere Tore zu machen'
          },
          targetHighTeamXGvsGameRival: {
            1: 'In diesem Spiel produzierte target_team_name mehr Gefahr als rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' und hätte mehr Tore schießen können. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' jedoch waren sie nicht in der Lage Tore zu schießen, trotz ihrer Chancen. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' Vergleich der Gewinnchance mit team_winning_chance, gemäß unserer Pre-Spieltags Simulation.'
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' Die meisten Chancen von target_team_name entstanden aus dem Spiel heraus. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' Die meisten Chancen von target_team_name entstanden aus Standard Situationen. '
          },
          startTargetHighTeamCornerXG: {
            1: ' Die meisten Chancen stammen von Eckbällen. '
          },
          targetSimilarTeamXG: {
            1: 'In diesem Spiel haben beide Mannschaften ähnliche Gefahren produziert - gemessen an den xG, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'jedoch hat target_team_name bessere Leistungen in der Chancenverwertung gezeigt. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Trotz des Resultats, hat target_team_name nicht viel Gefahr produziert - gemessen an den xG. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name hat nicht genug Gefahr produziert gemessen an den xG um das Spiel zu gewinnen '
          },
          rivalHighTeamXG: {
            1: 'und haben rival_team_name erlaubt zu viel Gefahr zu verursachen. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' Mit dieser Zusammensetzung, kann target_team_name nur gegen team_winning_chance gewinnen, entsprechend unserer Pre-Spieltags Simulation. '
          },
          targetHighTeamGoalConversion2: {
            1: ' mit einer hoher Torwahrscheinlichkeit '
          },
          winningChance: {
            1: 'Angesichts der Anzahl der Schüsse und xG von beiden Mannschaften, hätte target_team_name das Spiel gewinnen müssen mit team_winning_chance. '
          },
          highPlayerXGManyShots: {
            1: 'Es ist interessant zu sehen, dass player_name xg_value xG und shots_value Schüsse generierte'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' um ein Tor zu erzielen, wird xg_value xG benötigt. '
          },
          highPlayerXGOneGoal: {
            1: ' um ein Tor zu schießen. '
          },
          highPlayerXGAnyGoal: {
            1: ', obwohl er kein Tor erzielen konnte. '
          },
          highPlayerXGNotManyShots: {
            1: 'Es ist Erwähnenswert dass player_name mit wenig Schüssen xg_value xG generiert hat'
          },
          highManyPlayerXG: {
            1: 'Es ist interesant zu sehen, dass player_name and player_name2 jeweils xg_value und xg_value2 <b>xG</b> produzierten. '
          },
          highTeamXGPerShot: {
            1: 'Hinsichtlich der Abschlüsse von target_team_name, war die Wahrscheinlichkeit, dass diese zu einem Tor führen bei xg_per_shot_value. pro Schuss'
          },
          highTeamXGPerShotVSGameRival: {
            1: 'Die Abschlüsse von target_team_name war viel besser als rival_team_name, mit einem Durchschnitt von xg_per_shot_value xG pro Schuss. '
          },
          xGTimesNotAfter70xG: {
            1: 'Trotz der hohen xG, hatte target_team_name Probleme damit, Gefahr am Ende des Spiels zu generieren. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name hat viel Gefahr produziert, insbesondere am Anfang beider Hälften. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name hat viel Gefahr produziert, insbesondere am Ende beider Hälften. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name hat viel Gefahr produziert, insbesondere am Anfang der ersten Hälfte. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name hat viel Gefahr produziert, insbesondere am Ende der ersten Hälfte. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name hat viel Gefahr produziert, insbesondere am Anfang der zweiten Hälfte. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name hat viel Gefahr produziert, insbesondere am Ende der zweiten Hälfte. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name fing mit einer soliden Partie an, welche dabei mit ihren Chancen xg_value erwartete Tore generiert haben.'
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name endete die erste Hälfte mit Chancen die xg_value voraussichtliche Tore produziert haben. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name kam in der zweiten Hälfte raus mit Chancen die xg_value voraussichtliche Tore produziert haben. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name endete die zweite Hälfte mit Chancen die xg_value voraussichtliche Tore produziert haben. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name produzierte sehr viel Gefahr am Ende der zweiten Hälfte. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name produzierte sehr viel Gefahr am Anfang der zweiten Hälfte. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name produzierte sehr viel Gefahr am Ende der ersten Hälfte. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name produzierte sehr viel Gefahr am Anfang der ersten Hälfte. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name produzierte die meiste Gefahr in der ersten Hälfte, während rival_team_name in der zweiten Hälfte gefährlicher wurde. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name produzierte die meiste Gefahr in der zweiten Hälfte, während rival_team_name in der ersten Hälfte gefährlicher war. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'Es war ein Spiel wo die meiste Gefahr im Sinne von voraussichtlichen Toren während der ersten Hälfte produziert wurde. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'Es war ein Spiel wo die meiste Gefahr im Sinne von voraussichtlichen Toren während der zweiten Hälfte produziert wurde.. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name produzierte die meiste Gefahr in der ersten Hälfte. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name produzierte die meiste Gefahr in der zweiten Hälfte. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name ließ die meisten Gefahren in Bezug auf voraussichtliche Tore in der ersten Hälfte zu. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name ließ die meisten Gefahren in Bezug auf voraussichtliche Tore in der zweiten Hälfte zu. '
          },
          highInBoxXG: {
            1: 'Die Abschluss Zone zeigt an, dass die meisten Schüsse von innerhalb des Strafraumes kamen. '
          },
          highOutOfBoxXG: {
            1: 'In der Abschluss Zone kann man erkennen, dass in diesem Spiel, target_team_name generated viel Gefahr von außerhalb des Strafraums produziert hat. '
          },
          highInBoxXGRival: {
            1: 'Wir möchten darauf hinweisen, dass die meisten Gefahren durch target_team_name von Schüssen innerhalb des Strafraums entstanden. '
          },
          highInBoxXGRival2: {
            1: ' Wir möchten darauf hinweisen, dass die meisten Gefahren für target_team_name von Schüssen innerhalb des Strafraums entstanden. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name hat sehr stark verteidigt, um Gefahren innerhalb des Strafraums zu vermeiden. '
          },
          highTeamChancesHighPPDARival: {
            1: 'Der Mangel an Druck von target_team_name, erlaubte ppda_value Pässe pro Defensive Aktionen, was eines der Hauptfaktoren war für rival_team_name eine hohe Anzahl an Chancen zu produzieren. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name erlaubte nur ppda_value Pässe pro Defensive Aktionen, was eine Hauptrolle spielte für ihren Sieg. '
          },
          lowPPDA: {
            1: 'target_team_name hat hervorragende Arbeit geleistet im Spielaufbauunterbrechen von rival_team_name und erlaubten nur eine Durchschnittliche ppda_value Pässe pro Defensive Aktionen. '
          },
          highPossession: {
            1: 'target_team_name hatte die Kontrolle des Balls mit possession_value Ballbesitz'
          },
          highPPDARival: {
            1: ' sowie eine flüssige Verteilung des Balles'
          },
          chancesCreated: {
            1: ', was ihnen erlaubt hat, eine hohe Anzahl an Chancen im freien Spiel zu haben (chances_value). '
          },
          chancesCreatedRival: {
            1: ', jedoch konnte rival_team_name eine hohe Anzahl an Chancen aus dem Spiel heraus generieren (chances_value). '
          },
          xGPerShotRival: {
            1: ', jedoch konnte rival_team_name gefährlichere Chancen aus dem Spiel heraus produzieren mit einem xg_per_shot_value xG pro Schuss. '
          },
          winGame: {
            1: ' was eine Hauptrolle zum Sieg spielt. '
          },
          notEnoughWinGame: {
            1: ' was nicht genug ist um das Spiel zu gewinnen. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'Das erste Tor entstand durch einen Fehler von player_error_name ausgenutzt von player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'Das erste und einzige Tor entstand durch einen Fehler von player_error_name ausgenutzt von player_name'
          },
          lastPhaseOfGame: {
            1: ' in der letzten Phase des Spiels. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'Das letzte Tor um das Spiel zu gewinnen entstand durch einen Fehler von player_error_name was zum Tor von player_name führte. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'Das letzte Tor um das Spiel auszugleichen entstand durch einen Fehler von player_error_name was zum Tor von player_name führte '
          },
          goalsFromErrorsGoalToTie: {
            1: 'Ein Fehler von player_error_name führte zu einer Chance um das Spiel auszugleichen für target_team_name. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name ging in Führung durch einen Fehler von player_error_name'
          },
          xGChance: {
            1: ' mit einer Chance von xg_value xG. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'Das letzte Tor von rival_team_name um das Spiel zu gewinnen entstand durch einen Fehler von player_error_name was zum Tor von player_name führte. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'Ein Fehler von player_error_name führte zu einer Chance zum Ausgleich von rival_team_name. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name kam in Führung durch das Nutzen eines Fehlers von player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name haben die einzige große Chance vom Spiel genutzt um zu treffen, der Torschütze player_name sieht man in dem xG Feld mit einem xG von xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name hat während des Spiels alle großen Chancen verwandelt'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name hatte die einzige große Chance von target_team_name um zu treffen, mit einem xG von xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name war nicht in der Lage irgendeine Chance der chances_value zu nutzen, auch wenn die Wahrscheinlichkeit bei 40% zum Tor lag. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name hatte eine große Chance von xg_value xG um in Führung zu gehen. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name hatte chances_value Chancen mit xG über 40% um in Führung zu gehen. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name hatte Chancen von chances_value mit hohem xG um in Führung zu gehen. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name hatte Chancen um in Führung zu gehen mit einer Quote xg_value xG mit dem er den Pfosten traf. '
          },
          beforeEndOfGame: {
            1: 'Vor dem Spielende, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name hatte eine Chance von xg_value xG um das Spiel zu gewinnen. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name hatte chances_value Chancen mit einem xG über 40% um das Spiel zu gewinnen. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name hatte chances_value Chancen mit hohem xG um das Spiel zu gewinnen. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name hatte eine große Chance von xg_value xG um im Spiel in Führung zu gehen. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name hatte chances_value Chancen mit xG über 40% um in Führung zu gehen. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name hatte chances_value Chance mit hohem xG um in Führung zu gehen. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name hatte eine Chance um in Führung zu gehen mit xg_value xG was den Pfosten getroffen hat. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name hatte eine Chance von xg_value xG um den Ausgleich zu machen, blieb aber ohne Glück. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name hatte chances_value Chancen zum Ausgleich mit einer Trefferwahrscheinlichkeit von über 30%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name hatte eine Chance von xg_value xG um den Ausgleich zu machen, was mit einem Pfosten Schuss endete. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Unentschieden',
          win: 'Sieg',
          possession: 'Ballbesitz',
          xP: 'Erwartete Punkte',
          directness: 'Genauigkeit',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA aus dem Spiel heraus',
          xASetPiece: 'xA Standard Situationen',
          chancesCreated: 'Produzierte Chancen',
          shotsOnTarget: 'Schüsse aufs Tor'
        },
        text: {
          firstParagraph: {
            1: 'Dieses Bild zeigt die voraussichtlichen Vorlagen <b style=\'color:home_color\'>home_team_name</b> und <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA je Schlüsselpass. '
          },
          keyPassesGeneratedFrom: {
            1: ', insbesondere Schlüsselpässe produziert von '
          },
          highTeamXAvsXG: {
            1: 'Wie die xA Zone zeigt, geht die meiste Gefahr von target_team_name aus und stammt eher aus der Kombination der Spieler, als durch individuelle Aktionen'
          },
          openPlay: {
            1: 'aus dem Spiel heraus'
          },
          setPiece: {
            1: 'Standard Situationen'
          },
          cornerKicks: {
            1: 'Eckbälle'
          },
          combinationPlays: {
            1: 'Kombinationsspiel'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'In diesem Spiel produzierte target_team_name Gefahr aus beiden Kombinationsspielen'
          },
          individualActions: {
            1: ' und individuellen Aktionen. '
          },
          dangerFromIndividualActions: {
            1: 'In diesem Spiel kam die meiste Gefahr von target_team_name durch individuelle Aktionen.'
          },
          highTeamXAvsXGRival: {
            1: 'Die Chancen die target_team_name zugelassen haben, kamen aus dem Kombinationsspiel, wie in xA Zone anzeigt.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name hat gute Schlüsselpässe gespielt '
          },
          manyPlayerKeyPasses: {
            1: 'Es ist auffallend, dass player_name, xa_value xA in key_passes Schlüsselpässe gespielt hat'
          },
          playerAssists: {
            1: ' benötigend xa_per_assist xA pro Vorlage.'
          },
          giveAssist: {
            1: ' um eine Vorlage zu geben.'
          },
          noAssists: {
            1: ', obwohl keiner seiner Pässe zu einer Vorlage wurde.'
          },
          highXANotManyShots: {
            1: 'Es ist wichtig zu notieren, dass player_name, xa_value xA in ein paar Pässe produziert hat'
          },
          manyPlayersHighXA: {
            1: 'Es ist wichtig zu notieren, dass player_name und player_name2 jeweils xa_value und xa_value2 xA produziert haben.'
          },
          xATimes: {
            1: 'target_team_name produzierte die meiste Gefahr in der ersten Hälfte, während rival_team_name diese in der '
          },
          firstHalf: {
            1: ' ersten Hälfte. '
          },
          secondHalf: {
            1: ' zweiten Hälfte. '
          },
          left: {
            1: 'linken Seite '
          },
          center: {
            1: 'Mitte '
          },
          right: {
            1: 'rechten Seite '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'Es ist ein Spiel, in dem die meiste Gefahr in Form von erwarteten Toren während des Spiels erzeugt wurde '
          },
          xAFirstHalf: {
            1: 'target_team_name hat es geschafft die Mehrheit an Gefahr zu produzieren '
          },
          xATimesXARival: {
            1: 'target_team_name zu viel Gefahr in Form von erwarteten Toren in der'
          },
          xASides: {
            1: ' Die Mehrheit der Gefahr von target_team_name stammte von der the side_name (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: 'während rival_team_name produzierte die Mehrheit von der side_name (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'Die Gefahr die produziert wurde von rival_team_name, kam insbesondere von der side_name (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name war insbesondere effektiv in '
          },
          xAPerChanceCreated: {
            1: ' mit einem Durchschnitt von xa_value'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name war insbesondere effektiv in '
          }
        }
      },
      step3: {
        text: {
          chance: ' Chance',
          chances: ' Chancen',
          goal: ' Tor',
          goals: ' Tore',
          home: 'heim',
          away: 'auswärts',
          last: 'letztes',
          first: 'erstes',
          goalScorer: 'Torschütze',
          goalScorers: 'Torschützen',
          lastPhase: 'Letzte Phase des Spiels, ',
          phase: {
            1: 'In dieser phase_position Phase vom Spiel, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> produziert mehr voraussichtliche Gefahr (<b style=\'color:more_color\'>more_xt_team_value xT</b>) als <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'und es in diesem Zeitraum mehr Minuten lang getan hat (<b style=\'color:more_color\'>more_time_xt_minutes Min.</b> vs. <b style=\'color:less_color\'>less_time_xt_minutes Min.</b> des Gegners)'
          },
          rivalTeamMoreMinutes: {
            1: 'Doch es war sein Rivale, der länger für Gefahr sorgte (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> von dem Gegner) in diesem Zeitspann vom Spiel'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> war das Team, dass am meisten Gefahr produziert hat (<b style=\'color:max_color\'>max_xt_team_value xT</b>) in <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', während der <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> ihre meiste Gefahr produzierten (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) in <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Vom Spiel haben beide Teams es geschafft, den gegnerischen Torwart zu überwinden in <b>Nummer_of_goals_each_team</b> jeder. Die Heimmannschaft durch <b style=\'color:#3366FF\'>home_player_name_goals</b> und die Auswärtsmannschaft <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'Im Bezug auf die Tore, <b style=\'color:replace_color\'>goal_scored_team_name</b> übertrafen die Gegner mit <b style=\'color:replace_color\'>difference_Nummer_of_goals</b> der Differenz, da sie den Torwart überwunden haben mit <b style=\'color:replace_color\'>home_player_name_goals</b> als goal_scorer_word'
          },
          sameTeamMoreMinuten: {
            1: 'und tat es in diesem Zeitraum für mehr Minuten (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> als der Gegner)'
          }
        }
      },
      step4: {
        table: {
          team: 'Mannschaft',
          period: 'Zeitraum',
          possession: 'Ballbesitz',
          ppda: 'PPDA',
          xGOpenPlay: 'xG OP',
          tooltip: {
            team: 'Mannschaft',
            period: 'Zeitraum',
            possession: 'Ballbesitz',
            ppda: 'Pässe pro Defensiv Aktion',
            xGOpenPlay: 'xG aus dem Spiel heraus'
          }
        },
        text: {
          clearly: 'deutlich',
          very: 'sehr ',
          haveGotText1: 'hat nur',
          haveGotText2: 'hätten mehr haben sollen',
          gaveUpPoss: 'haben Ballbesitz verloren',
          lostPoss: 'Ballverlust',
          too: 'auch ',
          possession: {
            1: 'In dieser Phase des Spiels hatte <b style=\'color:team_color\'>Teamname</b> eindeutig_text den Ballbesitz'
          },
          equalPossession: {
            1: 'In dieser Phase des Spiels dominierte niemand den anderen, da der Ballbesitz ziemlich ausgeglichen war, auch wenn man sich die Zahlen ansieht, <b style=\'color:team_color\'>team_name</b> haben leicht ihre Gegner überspielt mit einem <b style=\'color:team_color\'>possession_value%</b> an Ballbesitz'
          },
          lowPossessionHighPPDA: {
            1: ', aber <b style=\'color:target_team_color\'>target_team_name</b> haben gut gegen den Ball gepresst, als rival_team_name im Ballbesitz war, mit einer <b>PPDA</b> of <b>ppda_value</b>'
          },
          lowPossessionLowPPDA: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> erlaubten das Pressing <b style=\'color:rival_team_color\'>rival_team_name</b> um <b style=\'color:target_team_color\'>ppda_value Pässe je Defensive Aktionen</b>'
          },
          highPossessionLowPPDA: {
            1: ' und konnten wegen dem very_textlow intensiven Pressing von rival_team_name spielen'
          },
          highPossessionHighPPDA: {
            1: ' selbst wenn die Intensität des Pressings vom Gegner rival_team_name, very_texthigh war'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> hatten eine hohe Ballbesitzstatistik von <b>pft_value</b> <b>Pässe im letzten Drittel</b> des Spielfeldes. '
          },
          highPossessionMidLowPFT: {
            1: 'Ohne Rücksicht auf den hohen Ballbesitz, <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>Pässe im letzten Drittel</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Obwohl <b style=\'color:target_team_color\'>target_team_name</b> possession_text während dieser Phsae, war es möglich <b>pft_value</b> <b>Pässe im letzten Drittel zu geben</b>. '
          },
          midPossessionHighPFT: {
            1: 'Ein regelmäßiger Ballbesitz während dieser Phase hat <b style=\'color:target_team_color\'>target_team_name</b> nicht gestoppt <b>pft_value</b> <b>Pässe im letzten Drittel zu machen</b>. '
          },
          highPFTHighTouchesIOB: {
            1: '  Der <b style=\'color:target_team_color\'>target_team_name</b> kontrollierte das Spiel nicht nur im letzten Drittel, sondern war auch im gegnerischen Strafraum sehr präsent. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> haben den Ball im letzten Drittel kontrolliert, jedoch konnten sie nicht viele Bälle in den gegnerischen Strafraum reinbringen'
          },
          highPFTMidTouchesIOB: {
            1: 'Mit der gegebenen Anzahl an <b>Pässen im letzten Drittel</b>, <b style=\'color:target_team_color\'>target_team_name</b> hätten sie mehr Gefahr im gegnerischen Strafraum ausüben sollen'
          },
          lowPFTHighTouchesIOB: {
            1: 'Obwohl <b style=\'color:target_team_color\'>target_team_name</b> nicht viele Pässe im letzten Drittel gemacht haben, waren sie oft im gegnerischen Strafraum. '
          },
          midPFTHighTouchesIOB: {
            1: 'Angesichts der Anzahl an Pässen im letzten Drittel von <b style=\'color:target_team_color\'>target_team_name</b> haben sie es oft geschafft in den Strafraum zu gelangen. '
          },
          maxDirectness: {
            1: 'Es ist bemerkenswert, dass das die Phase vom Spiel ist wo <b style=\'color:max_dir_color\'>target_team_name</b> mehr offensive gespielt hat mit einer <b>Direktheit</b> von <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> haben mehr xG  produziert als in anderen Phasen des Spiels  '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> ein hohes Volumen an zu erwartenden Toren generieren konnte'
          },
          highXG: {
            1: 'haben eine gute Menge an voraussichtlichen Toren produziert'
          },
          highXGLowPossession: {
            1: ' trotz fehlender Ballkontrolle'
          },
          highXGLowShots: {
            1: ' nur wenige Schüsse, mit einer <b>xG per Shot</b> von <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' obwohl die xG je Schuss war too_textlow. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> waren unfähig Gefahr zu produzieren'
          },
          lowXGMinXG: {
            1: 'Im Bezug auf das produzieren von voraussichtlichen Toren, war es eine sehr schwache Phase für <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> hat sehr niedrige Volumen an voraussichtlichen Toren generiert'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> waren nicht in der Lage ein gutes Volumen an voraussichtlichen Toren zu produzieren'
          },
          lowXGHighPossession: {
            1: ' obwohl sie Ballbesitz hatten. '
          },
          lowXGHighShots: {
            1: ' trotz den vielen Schüssen'
          },
          lowXGHighPFT: {
            1: ' trotz der Vervollständigung von <b>pft_value</b> <b>Pässe im letzten Drittel </b> des Spielfeldes. '
          },
          midXGQuintileMinXG: {
            1: 'Obwohl die Generierung von xG nicht schlecht war, war dies die schwächste Phase des Spiels für <b style=\'color:target_team_color\'>target_team_name</b> in diesem Aspekt'
          },
          midXGQuintileMaxXG: {
            1: 'Das war die Phase in der es <b style=\'color:target_team_color\'>target_team_name</b> geschafft hat die höchsten <b>xG (xg_value) zu produzieren </b>'
          }
        }
      },
      step5: {
        table: {
          team: 'Team',
          period: 'Phase',
          possession: 'Ballbesitz.',
          directness: 'Genauigkeit',
          passesFinalThird: 'P ⅓',
          tooltip: {
            team: 'Team',
            period: 'Phase',
            possession: 'Ballbesitz',
            directness: 'Genauigkeite',
            passesFinalThird: 'Pässe im letzten Drittel'
          }
        },
        text: {
          last: 'letzte',
          goal: 'Tor',
          goals: 'Tore',
          chance: 'Chance',
          chances: 'Chancen',
          first: 'erste',
          homeTeam: 'Heimmannschaft',
          awayTeam: 'Auswärtsmannschaft',
          home: 'heim',
          away: 'auswärts',
          clearly: 'deutlich',
          slightly: 'etwas',
          firstOrLastPhase: {
            1: 'In dieser phase_position Phase vom Spiel, ',
            2: 'In diesem phase_position Zeitraum vom Spiel, '
          },
          phase: {
            1: 'Während dieser Phase des Spiels, '
          },
          bothZeroGoalsScored: {
            1: 'ohne, dass eines der Teams die Anzeigetafel verändern kann.'
          },
          equalGoalsScored: {
            1: 'schafften es <b>Nummer_goals</b> zu schießen'
          },
          differentGoalsScored: {
            1: 'schafften es <b>Nummer_goals</b> zu schießen'
          },
          equalPossesion: {
            1: 'beide Mannschaften hatten genau <b>poss_value%</b> der Zeit'
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b> hatten Ballbesitz für mehr Minuten  (<b style=\'color:more_color\'>more_poss_team_value%</b> der Zeit) als der Gegner <b style=\'color:less_color\'>less_poss_team_name</b> (<b style=\'color:less_color\'>less_poss_team_value%</b> der Zeit)'
          },
          equalDirectness: {
            1: 'beide Mannschaften haben jeweils mit der selben Genauigkeit (<b>directness_value</b> gespielt)'
          },
          moreDirectnessSameTeam: {
            1: 'sie waren vertikaler als ihre Gegner, und haben mit einer Genauigkeit von <b style=\'color:more_color\'>more_dir_team_value</b> vs <b style=\'color:less_color\'>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: 'jedoch, war es die home_away Mannschaft die mit mehr Genauigkeit gespielt hat, von (<b style=\'color:more_color\'>more_dir_team_value</b>) als die gegnerische Mannschaft (<b style=\'color:less_color\'>less_dir_team_value</b>)'
          },
          equalChancesCreated: {
            1: 'Beide Mannschaften haben die gleiche Anzahl an Chancen produziert von <b>chances_created_value</b> chance_text.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b> hat nur <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b> produziert, und wurde adverb_text vom Gegner übertroffen (<b style=\'color:more_color\'>more_cc_team_value more_chance_text created</b>). '
          },
          equalXA: {
            1: 'Beide Teams hatten die gleichen Chancen, wie der <b>xa_value of Expected Assists</b> zeigt '
          },
          moreXA: {
            1: 'Die home_away Manschafft hat <b>diff_xa_team_value an voraussichtlichen Vorlagen produziert</b> (<b style=\'color:more_color\'>more_xa_team_value</b> vs <b style=\'color:less_color\'>less_xa_team_value</b>) was mehr als der Gegner war, '
          },
          xAOpenPlay: {
            1: 'jeweils produzierend <b style=\'color:more_color\'>more_xa_op_value</b> und <b style=\'color:less_color\'>less_xa_op_value xA von dem Spiel heraus</b>.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' jedes ',
          respectively: ', jeweils',
          with: ' (mit <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'Spieler war',
          playerWere: 'Spieler waren',
          firstPhase: {
            1: 'In der ersten Phase des Spiels, war der wichtigste player_text ',
            2: 'Was der ersten Phase angeht, wer herausragte war '
          },
          otherPhase: {
            1: 'Zwischen <b style=\'color:replace_color\'>min_from\'</b> und <b style=\'color:replace_color\'>min_to\'</b> sollte erwähnt werden '
          },
          lastPhase: {
            1: 'Im letzten Teil des Spiels ist zu erwähnen',
            2: 'Was die letzten Phase angeht, '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>Spielername</b>, da er die meisten erfolgreichen Pässe seiner Mannschaft gespielt hat, genau <b style=\'color:replace_color\'>Erfolgreiche_Pässe</b> '
          },
          playerMaxTotalPasses: {
            1: 'was noch wertvoller wird, wenn die Zahlen zeigen, dass er auch'
          },
          playerMaxTotalPasses2: {
            1: 'with_text der Spieler mit den meisten versuchten Pässen von (<b style=\'color:replace_color\'>total_passes_value Pässe</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'obwohl er nicht die meisten Pässe gespielt hat, (<b style=\'color:replace_color\'>player_name</b> mit <b style=\'color:replace_color\'>total_passes_value Pässen</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'versuchte während dieser Phase <b style=\'color:replace_color\'>total_passes_value Pässe</b> jeweils. '
          },
          playerMaxPctPasses: {
            1: 'Im Bezug auf <b style=\'color:replace_color\'>% an erfolgreichen Pässen</b>, <b style=\'color:replace_color\'>player_name</b> hat eine hohe <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'Im Bezug auf angekommene Pässe, ist es erwähnenswert <b style=\'color:replace_color\'>player_name</b> mit einer <b style=\'color:replace_color\'>max_pct_passes_value%</b> Pass Erfolgquote</b>. '
          },
          playerSumTotalXG: {
            1: 'In diesem Zeitfenster erzielte das Team insgesamt <b style=\'color:replace_color\'>sum_xg_value xG produziert</b>, ',
            2: 'In diesem Zeitfenster, <b style=\'color:replace_color\'>team_name</b> produzierte einen <b style=\'color:replace_color\'>xG</b> von <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'Trotz der insgesamt <b style=\'color:replace_color\'>all_team_total_passes</b> der gesamten Mannschaft war es vergeblich, da sie keine einzige Chance herausspielen konnten. ',
            2: 'Die <b style=\'color:replace_color\'>all_team_total_passes</b> die produziert wurden, machten keine einzige Torchance. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 'mit <b style=\'color:replace_color\'>player_xg_name</b> mit <b style=\'color:replace_color\'>xg_value xG</b> und <b style=\'color:replace_color\'>player_xa_name</b> mit <b style=\'color:replace_color\'>xa_value xA</b> war der gefährlichste Spieler im Bezug auf erspielten Chancen. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: 'er ist <b style=\'color:replace_color\'>player_name</b> mit <b style=\'color:replace_color\'>xg_value xG</b> und <b style=\'color:replace_color\'>xa_value xA</b> der, der am meisten Chancen für seine Mannschaft herausspielte. '
          },
          playersMaxXGMaxXA: {
            1: 'dank unter anderem an <b style=\'color:replace_color\'>Spieler_name</b>, die mit ihren Schlüsselpässen jeweils <b style=\'color:replace_color\'>xa_value xA</b> auslösten. '
          },
          playerMaxXGZeroXA: {
            1: 'als <b style=\'color:replace_color\'>Spieler_xg_name</b> mit <b style=\'color:replace_color\'>xg_value xG</b>, der die meisten Chancen hatte und sie selbst kreieren musste, da er keine Schlüsselpässe erhielt. '
          },
          playersMaxXGZeroXA: {
            1: '1: der <b style=\'color:replace_color\'>Spieler_xg_name</b> mit <b style=\'color:replace_color\'>xg_value xG</b>, der die Chancen hatte und sie selbst schaffen musste, da er keine Schlüsselpässe erhielt'
          },
          oneMaxConnections: {
            1: 'Das Duo was die meisten Pässe während des Spiels mit einander gemacht haben waren <b style=\'color:replace_color\'>couple_name</b>, mit insgesamt <b style=\'color:replace_color\'>connections_value an Pässen</b>. ',
            2: 'Das Duo aus <b style=\'color:replace_color\'>couple_name</b> spielte <b style=\'color:replace_color\'>connections_value</b> mal den Ball miteinander hin und her. ',
            3: 'Das Duo war es, das in diesem Spielabschnitt die meisten Pässe spielte, auch bei <b style=\'color:replace_color\'>connections_value</b>. '
          },
          twoMaxConnections: {
            1: 'Die beiden Duos geformt durch <b style=\'color:replace_color\'>couple_name</b> und <b style=\'color:replace_color\'>couple_name2</b> waren die am häufigsten miteinander kombinierten in diesem Zeitraum, <b style=\'color:replace_color\'>connections_value</b> . '
          },
          moreThanTwoMaxConnections: {
            1: 'Die Duos <b style=\'color:replace_color\'>couple_name</b>, machten <b style=\'color:replace_color\'>connections_value passes</b> miteinander. '
          },
          oneMinConnections: {
            1: 'Auf der anderen Seite war es <b style=\'color:replace_color\'>couple_name</b> die am wenigsten miteinander passten, mit nur <b style=\'color:replace_color\'>connections_value Pässen</b>. ',
            2: 'Anderseits, das Duo zusammengesetzt aus <b style=\'color:replace_color\'>couple_name</b> haben nur <b style=\'color:replace_color\'>connections_value</b> mal miteinander kombiniert. '
          },
          twoMinConnections: {
            1: 'Auf der anderen Seite, <b style=\'color:replace_color\'>couple_name</b> und <b style=\'color:replace_color\'>couple_name2</b> haben kaum miteinander kombiniert mit nur (<b style=\'color:replace_color\'>connections_value Pässen</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Einige Kombinationen haben nicht genügend Verbindung zueinander hergestellt, wie z. B. das Duo <b style=\'color:replace_color\'>couple_name</b>, das mit <b style=\'color:replace_color\'>connections_value passes</b> zu den seltensten Kombinationen gehört. '
          }
        }
      },
      step7: {
        ballPossession: 'Ballbesitz',
        gamePossessionDist: 'Ballbesitzverteilung'
      }
    },
    gamePossessionMap: {
      of: 'von',
      to: 'nach',
      and: 'und',
      endsWith: 'endet mit',
      time: 'Zeit',
      touches: 'Ballberührungen',
      passes: 'Pässe',
      threat: 'Gefahr',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minuten',
      duration: 'Dauer',
      endsGoal: 'endet in Tor',
      endsInBox: 'endet im Strafraum',
      withShot: 'mit Schuss',
      withCross: 'mit Flanke',
      possession: 'Ballbesitz',
      events: 'Events',
      filters: 'Filter',
      filtersWarning: 'Die Gefahr gilt nur für Ballbesitz ohne Torschuss',
      sumWarning: 'Der Filter gilt für die Summe der xG aller Schüsse in der Sequenz, daher kann sie größer als 1 sein',
      show: 'zeigen',
      sequenceNumbers: 'Laufende Nummer',
      jerseyNumbers: 'Nummern zurück',
      pass: 'Pass',
      carryAndPass: 'Ballmitnahme und Pass',
      carryAndAction: 'Ballmitnahme und Aktion',
      carryAndShot: 'Ballmitnahme und Schuss',
      shotFailed: 'Verfehlte Schüsse',
      goal: 'Tor',
      savedShot: 'Gehaltene Schüsse',
      missedShot: 'Verfehlte Schüsse',
      shotOnPost: 'Pfostentreffer',
      headerGoal: 'Kopfballtore',
      headerFailed: 'missglückter Kopfball',
      failed: 'misslungen',
      with: 'mit'
    },
    report: {
      title: 'Spielbericht',
      maps: 'Karten',
      xGRace: 'xG Rennen',
      lineups: 'Aufstellungen',
      button: 'Generieren eines vollständigen PDF-Berichts über das Spiel',
      mobileButton: 'PDF-Bericht',
      most: 'Meist',
      topXPlayers: 'Top {x} Spieler',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Bericht über physische Spieldaten'
    },
    avgScoreTooltip: 'Durchschnittliche Punktzahl pro Minute',
    status: {
      scheduled: 'Geplant',
      postponed: 'Verschoben',
      cancelled: 'Abgesagt',
      inPlay: 'Live',
      finished: 'Fertig',
      awarded: 'Ausgezeichnet',
      dataAvailable: 'Die Daten werden in den nächsten Stunden verfügbar sein'
    },
    preGameAnalysis: {
      showExpectations: 'Erwartungen zeigen',
      hideExpectations: 'Erwartungen verbergen',
      goalsPeriods: 'Zielperioden',
      synergyIndex: 'Synergieindex',
      synergyIndexSubtitle: 'Gesamtstärke der Passer-Abschluss-Verbindung'
    }
  },
  general: {
    1: 'Eins',
    2: 'Zwei',
    3: 'Drei',
    4: 'Vier',
    5: 'Fünf',
    8: 'Links',
    9: 'Beide',
    10: 'Rechts',
    create: 'Produzieren',
    save: 'Speichern',
    cancel: 'Annullieren',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    reset: 'Zurücksetzen',
    go: 'Los',
    formErrors: {
      required: 'Zone ist erforderlich',
      passwordMatch: 'Passwort stimmt nicht mit überein',
      minLength: 'Mindestlänge',
      maxLength: 'Maximale Länge',
      emailValid: 'E-mail muss gültig sein',
      youthAge: 'Das Alter muss zwischen 10 und 23 liegen',
      seasonYear: 'Das Jahr muss zwischen 2016 und 2050 liegen',
      integer: 'Dezimalzahlen sind nicht erlaubt'
    },
    confirmationTitle: 'Sind Sie sicher?',
    confirmationMessage: 'Bitte bestätigen Sie falls sie die Aktion ausführen wollen',
    yes: 'Ja',
    no: 'Nein',
    search: 'Suchen',
    clearFilters: 'Filter löschen',
    minimum: 'Minimum',
    maximum: 'Maximum',
    minimumPercent: '(%)Minimum Prozent',
    period: 'Phase',
    exclude: 'Ausschließen',
    team: 'Mannschaft',
    clear: 'Löschen',
    all: 'Alle',
    ground1: 'Alle',
    ground2: 'Heim',
    ground3: 'Auswärts',
    filter: 'Filter',
    noData: 'Keine Resultate gefunden',
    noDataGivenFilters: 'No results found with given filters',
    similarityMinutesWarning: 'Keine Daten aufgrund von weniger als 450 Minuten Spielzeit',
    templateOnlyEditable: 'Vorlage nur bearbeitbar von ',
    close: 'Schließen',
    load: 'laden',
    filters: 'Filter',
    players: 'Spieler',
    teams: 'Teams',
    compare: 'Vergleichen',
    seeMore: 'Mehr sehen',
    seeLess: 'Weniger sehen',
    request: 'Anfordern',
    notes: 'Anmerkungen',
    closeSession: 'Verlassen',
    settings: 'Einstellungen',
    player: 'Spieler',
    state: 'Zustand',
    updated: 'Aktualisiert',
    file: 'Datei',
    uploadFile: 'Datei hochladen',
    reports: 'Berichte',
    download: 'Runterladen',
    new: 'Neu',
    comparison: 'Vergleichen',
    scout: 'Scout',
    favorites: 'Favoriten',
    moreOptions: 'Weitere Optionen',
    lessOptions: 'Weniger Optionen',
    today: 'Heute',
    home: 'Zuhause',
    away: 'Auswärts',
    until: 'bis',
    firstHalf: 'Erste Hälfte',
    secondHalf: 'Zweite Hälfte',
    firstPeriodOT: 'Erste Hälfte der Verlängerung',
    secondPeriodOT: 'Zweite Hälfte der Verlängerung',
    postponed: 'Verschoben',
    stats: 'Statistiken',
    yesterday: 'Gestern',
    last: 'Letztes',
    startDate: 'Begin Datum',
    active: 'Aktiv',
    playerLimit: 'Spieler Limit',
    type: 'Typ',
    successMessage: 'Die Operation war ein Erfolg',
    failMessage: 'Die Operation war nicht erfolgreich',
    by: 'Von',
    checkYourInbox: 'Inbox überprüfen',
    faq: 'Dokumentation',
    globalSearch: 'Globale Suche',
    gamesLost: 'Niederlagen',
    outOf: 'aus',
    avgSeason: 'Saison Durchschnitt',
    leftDays: 'Verbleibende Tage',
    notifyError: 'Fehler benachrichtigen',
    notify: 'Benachrichtigen',
    comments: 'Kommentare',
    searches: 'Suche',
    now: 'Jetzt',
    twoHoursAgo: 'Vor Zwei Stunden',
    incomings: 'Ankünfte',
    departures: 'Abgänge',
    transferLoans: 'Verleihungen',
    transfers: 'Transfers',
    movements: 'Bewegungen',
    incomes: 'Einkommen',
    expenditures: 'Ausgaben',
    action: 'Aktion',
    target: 'Ziel',
    uses: 'Verwendungszweck',
    users: 'Benutzer',
    since: 'seit',
    mediaMode: 'Media Mode',
    white: 'Weiß',
    enabled: 'Aktiviert',
    disabled: 'Gesperrt',
    left: 'Links',
    right: 'Rechts',
    both: 'Beide',
    'left-both': 'Links Beide',
    'right-both': 'Rechts Beide',
    'left foot': 'Links',
    'right foot': 'Rechts',
    files: 'Datei',
    confirm: 'Bestätigen',
    currentStep: 'Aktueller Schritt',
    phases: 'Phasen',
    entries: 'Einträge',
    none: 'Keine',
    times: 'Zeiten',
    darkMode: 'Dark Mode',
    client: 'Kunde',
    visits: 'Besuche',
    lastVisit: 'Letzte Besuche',
    strong: 'Stark',
    medium: 'Mittel',
    weak: 'Schwach',
    goal: 'Ziel',
    list: 'Liste',
    map: 'Karte',
    copiedToClipboard: 'In die Ablage kopiert',
    division: 'Abteilung',
    many: 'Viele',
    few: 'Wenige',
    median: 'Mittelwert',
    topRight: 'Oben Rechts',
    topLeft: 'Oben Links',
    bottomRight: 'Unten Rechts',
    bottomLeft: 'Unten Links',
    library: 'Bibliothek',
    mediaLibrary: 'Mediathek',
    for: 'Für',
    stat: 'Statistik',
    position: 'Position',
    order: 'Reihenfolge',
    add: 'Hinzufügen',
    visualization: 'Visualisierung',
    basic: 'Grundlage',
    selectAll: 'Alle auswählen',
    unselectAll: 'Unselect All',
    distribution: 'Vertrieb',
    end: 'End',
    accuracy: 'Genauigkeit',
    opponent: 'Gegner',
    ownTeam: 'Eigenes Team',
    center: 'Zentrum',
    line: 'Linie',
    live: 'Live',
    unavailable: 'nicht Verfügbar',
    calendar: 'Calendar',
    activeLeague: 'League in Progress',
    similarity: 'Similarity',
    emptyForSelectAll: 'Empty select all',
    size: 'Size',
    selectPlayersRestriction: 'Wählen Sie zwischen 1 und {x} Spielern',
    group: 'Group',
    alerts: 'Alerts',
    shortcuts: 'Shortcuts',
    share: 'Share',
    dataAvailable: 'Daten werden bald verfügbar sein',
    someStatsAvailableSoon: 'Einige Statistiken werden bald verfügbar sein',
    monthGamesWarning: 'Spiele des ausgewählten Monats werden bald verfügbar sein',
    metrics: 'Metriken',
    competition: 'Competition',
    code: 'Code',
    alias: 'Alias',
    never: 'Nie',
    unlimited: 'Unbegrenzt',
    user: 'Benutzer',
    warning: 'Warnung',
    requests: 'Anfragen',
    contactSales: 'Kontakt Vertrieb',
    comingSoon: 'Demnächst verfügbar!',
    firstPost: '1. Beitrag',
    secondPost: '2. Beitrag',
    dZone: 'D-Zone',
    penaltySpot: 'Elfmeterpunkt',
    secondPlay: '2. Spiel',
    otherZone: 'Andere Zone',
    baseline: 'Grundlinie',
    youth: 'Youth',
    male: 'Male',
    direct: 'Direkt',
    indirect: 'Indirekt',
    processing: 'Processing',
    addNew: 'Neu Hinzufügen',
    createdBy: 'Erstellt von',
    downloading: 'Downloading',
    displayType: 'Präsentationstyp',
    alreadyExists: 'bereits vorhanden',
    aggregation: 'Aggregation',
    unavailableLeagues: 'Sie haben keinen Zugang zu einer der Ligen, in denen der Spieler gespielt hat',
    meters: 'Meters',
    quantity: 'Quantity',
    allTime: 'All Times',
    games: 'Games',
    unit: 'Einheit',
    categories: 'Kategorien',
    maintenanceWarning: 'Wartung läuft',
    maintenanceMessage: 'Wir führen gerade Updates durch. Änderungen, die Sie jetzt vornehmen, werden nicht gespeichert. Vielen Dank für Ihre Geduld!',
    seeAll: 'Alle ansehen',
    from: 'Von',
    to: 'zu',
    showFilters: 'Filter anzeigen',
    hideFilters: 'Filter ausblenden',
    horizontal: 'Horizontal',
    vertical: 'Vertikal',
    drop: 'Fallen',
    orientation: 'Orientierung',
    goalProbability: 'Zielwahrscheinlichkeit',
    assistProbability: 'Assist-Wahrscheinlichkeit',
    attackingDirection: 'Angriffsrichtung',
    currentTeam: 'Aktuelles Team',
    expectations: 'Erwartungen',
    sideBySide: 'Nebeneinander',
    teamValue: 'Teamwert',
    fieldLayout: 'Feldlayout',
    searchPlaceholder: 'Type {x} letters at least to search'
  },
  playerScout: {
    dlabDatabase: 'Driblab Datenbank',
    league: 'Liga',
    top5: 'Top 5',
    topCountries: 'Länder',
    tier: 'Stufe',
    division1: 'Erste Liga',
    division2: 'Zweite Liga',
    division3: 'Dritte Liga',
    division4: 'Vierte Liga',
    division5: 'Fünfte Liga',
    division6: 'Sechste Division',
    summary: 'Überblick',
    offensive: 'Off',
    defensive: 'Def',
    gk: 'GK',
    all: 'Alle',
    physical: 'Phys',
    arrigo: 'Arrigo',
    yearTooltip: 'Nur ein Jahr erlaubt',
    expectedThreat: 'xThreat (Gefahr)',
    expectedThreatTooltip: 'Threat added to all possessions',
    expectedThreatOP: 'xThreat OP',
    expectedThreatOPTooltip: 'Threat added to Open Play possessions',
    expectedThreatInTeam: 'xThreat (Gefahr) in Mannschaft %',
    expectedThreatInTeamTooltip: 'Pct. of Threat added by player to the team',
    ballProgression: 'Ballbesitz',
    ballProgressionTooltip: 'Progressions of +10 meters',
    deepProgression: 'Ballbesitz in die Tiefe',
    deepProgressionTooltip: 'Ball Progressions to Last Fifth',
    ballRetention: '% Ballbesitzquote',
    ballRetentionTooltip: 'Pct. of Actions where Ball was Successfully Retained',
    ballRetentionOppHalf: '% Ballbesitzquote GH',
    ballRetentionOppHalfExplicit: 'Ballbesitzquote in der gegnerischen Hälfte',
    finishing: 'Abschluss',
    finishingTooltip: 'Pct. of Shots Ending in a Goal',
    scoringContribution: 'Scoring-Beitrag',
    scoringContributionTooltip: 'Assists + Goals',
    xgPerShot: 'xG pro Schuss',
    xgPerGoal: 'xG pro Tor',
    headerPerCross: 'Kopfball pro Flanke',
    completedCrosses: 'Erfolgreiche Flanken',
    crossingPct: 'Flanken %',
    crossingEfficiency: 'Flanken Effizienz',
    crossingEfficiencyTooltip: 'Crossing Efficiency (Measures Quality and Quantity)',
    longBalls: 'Lange Bälle',
    longPassing: 'Langer Ball %',
    dribblingPct: 'Dribbling %',
    throughBalls: 'Steilpässe',
    oppBoxTouches: 'Ballberührungen in der Gegnerischen Hälfte',
    oppBoxTouchesTooltip: 'Touches in Opponent Box',
    openPlayKeyPasses: 'Schlüsselpässe aus dem Spiel heraus',
    openPlayKeyPassesTooltip: 'Open Play Passes ending in Shot',
    xGBuildup: 'xG Aufbau',
    xGBuildupTooltip: 'xG  der Sequenzen, die mit einem Schuss enden, an dem der Spieler beteiligt war (mit der Ausnahme von xG der Schüsse und an Schlüsselpässe)',
    Assists: 'Vorlagen',
    passPercentage: 'Passen %',
    passPerLongBall: 'Pass per LB',
    passPerLongBallExplicit: 'Pass via langem Ball',
    nonPenaltyGoals: 'Tor (ohne Elfmeter)',
    xG: 'xG',
    xGExplicit: 'Voraussichtliche Tore',
    shots: 'Schüsse',
    xGShot: 'xG Schuss',
    xGChain: 'xG Kette',
    xGChainTooltip: 'xG der Sequenzen, die mit einem Schuss enden, an dem der Spieler beteiligt war',
    chancesCreated: 'Produzierte Chancen',
    chances: 'Chance',
    dribbles: 'Dribblings',
    dribblesSuccessfull: 'Erfolgreiche Dribblings',
    touches: 'Ballberührungen in gegnerischen Hälfte',
    xA: 'xA',
    xAExplicit: 'Voraussichtliche Vorlagen',
    xAOpenPlay: 'xA OP',
    xAOpenPlayExplicit: 'Voraussichtliche Vorlagen aus dem freien Spiel heraus',
    passesOpponentBox: 'Pässe im Gegnerischen Strafraum',
    passesOB: 'Pässe im GS',
    passesFinalThirdTooltip: 'Pässe im letzten drittel',
    passesSuccessful: 'Erfolgreiche Pässe',
    passesSuccessfulTooltip: 'Erfolgreich abgeschlossene Pässe',
    ballProgressionPassing: 'Spiel. Passen',
    ballProgressionPassingTooltip: 'Spielentwicklung durch Passen',
    ballProgressionDribbling: 'Spiel. Dribbling',
    ballProgressionDribblingTooltip: 'Spielentwicklung durch Dribbling',
    passesTotal: 'Pässe',
    passesTotalTooltip: 'Versuchte Pässe insgesamt',
    shortPassesSuccessful: 'Erfolgreiche kurze Pässe',
    shortPassesSuccessfulTooltip: 'Erfolgreich abgeschlossene Kurzpässe',
    shortPassesTotal: 'Kurze Pässe',
    shortPassesTotalTooltip: 'Versuchte Kurzpässe insgesamt',
    tackles: 'Zweikämpfe *',
    adjustedTackles: 'Angepasste Zweikämpfe',
    interceptions: 'Balleroberungen *',
    adjustedInterceptions: 'Angepasste Balleroberungen',
    aerials: 'Luftduelle',
    aerialsPercent: 'Luftduelle %',
    aerialEfficiency: 'Luftduelle Effizienz',
    aerialEfficiencyTooltip: 'Luftduell-Effizienz (Misst Qualität und Quantität)',
    twd: 'ZwA',
    tacklesWasDribbled: 'Gewonnene defensive Eins-gegen-Eins-Duelle',
    fouls: 'Fouls',
    indPressure: 'Individuelles Pressing',
    pressure: 'Pressing',
    dispossessed: 'Ballverlust',
    recoveries: 'Balleroberungen',
    primary: 'Primar',
    secondary: 'Sekundär',
    position: 'Positionen',
    nationality: 'Nationalität',
    height: 'Größe (cm)',
    minHeight: 'Min. Größe',
    maxHeight: 'Max. Größe',
    age: 'Alter',
    minAge: 'Min. Alter',
    maxAge: 'Max. Alter',
    games: 'Spiele',
    minGames: 'Min. Spiele',
    maxGames: 'Max. Spiele',
    minutes: 'Minuten',
    minMinutes: 'Min. Minuten',
    maxMinutes: 'Max. Minuten',
    minPercentMinutes: 'Min. Prozent Minuten',
    dates: 'Termine',
    marketValue: '(€) Marktwert',
    teams: 'Mannschaften',
    contractEnd: 'Vertragsende',
    minValue: 'Min. Wert',
    maxValue: 'Max. Wert',
    excludeTeams: 'Mannschaften ausschließen',
    recentSearches: 'Letzte Suchanfragen',
    saveSearch: 'Suchanfrage speichern',
    loadSearch: 'Suchanfragen laden',
    loadCollection: 'Sammlung laden',
    collection: 'Sammlung',
    search: 'Suche',
    searchesList: 'Suchanfragen Liste',
    mySearches: 'Meine Suchanfragen',
    mySearchesDescription: 'Sie haben dies bereits gespeichert',
    recentSearchesDescription: 'Die letzten 10 Suchanfragen die Sie gemacht haben',
    searchToLoad: 'Suchen um zu speichern',
    recentSearch: 'Letzte Suchanfrage',
    saveSearchSuccess: 'Suchanfrage erfolgreich gespeichert',
    removeSearch: 'Suchanfrage löschen',
    removeSearchMessage: 'Sind sie sicher dass sie die Suchanfrage löschen wollen?',
    updateSearch: 'Suche aktualisieren',
    updateSearchMessage: 'Sind Sie sicher, dass Sie die Suche aktualisieren möchten?',
    deleteSearchSuccess: 'Suchanfrage wurde gelöscht',
    playersFound: 'Spieler gefunden',
    addToCollection: 'Zur Sammlung hinzufügen',
    npg: 'NPG',
    goals: 'Tore',
    value: 'Wert',
    nationalTeams: 'Nationalmannschaften',
    gbeScore: 'GBE',
    dlIndex: 'Ergebnis',
    minGbe: 'Min. GBE',
    goalsConceded: 'Kassierte Tore',
    npgConceded: 'NPG kassiert',
    npgConcededTooltip: 'Non-Penalty Goals kassiert',
    xGOTConceded: 'xG Aufs Tor kassiert',
    xGOTConcededTooltip: 'xG an Schüssen aufs Tor bekommen',
    goalsPrevented: 'Verhinderte Tore',
    xGFacedPerShotOnTarget: 'xGOT pro Schuss',
    xGFacedPerShotOnTargetTooltip: 'xG pro abgegebenem Schuss',
    xGSavedPerxGFacedOnTarget: 'xG gehalten',
    xGSavedPerxGFacedOnTargetTooltip: 'Prozentsatz an Paraden im Bezug auf xG',
    savesPct: '% Paraden',
    savesOutOfBoxPct: '% Außerhalb der Box gehalten',
    savesInBoxPct: '% Innerhalb der Box gehalten',
    xGFacedPerGoal: 'xG Pro Tor gesehen',
    xGFacedPerGoalTooltip: 'xG gebraucht um ein Tor zu schießen',
    catchingPct: '% Fangen',
    catchingTooltip: 'Prozentsatz der Paraden die gefangen wurden',
    passingOwnHalfPct: '% Pässe in der eigenen Hälfte',
    passingOwnHalfPctTooltip: 'Prozentsatz an erfolgreichen Pässen in der eigenen Hälfte',
    passingOppHalfPct: '% Pässe in der gegnerischen Hälfte',
    passingOppHalfPctTooltip: 'Prozentsatz an erfolgreichen Pässen in der gegnerischen Hälfte',
    passingContribution: '% Passing Cont.',
    passingContributionTooltip: 'Percentage of Passing Contribution',
    shotsPerGoal: 'Schüsse pro Tor',
    passesFinalThird: 'Pässe im letzten Drittel',
    passingFinalThird: '% an Pässen im letzten Drittel',
    claimAccuracy: 'Anspruchsgenauigkeit',
    claimAccuracyTooltip: 'Überdurchschnittlich viele gewonnene Bälle',
    highTurnovers: 'Viele Ballverluste (B)',
    highTurnoversTooltip: 'Ballverluste näher als 40 Meter zum eigenen Tor',
    shotEndingHighTurnovers: 'B gefoglt von Schuss',
    shotEndingHighTurnoversTooltip: 'Viele B die mit einem Schuss enden',
    goalEndingHighTurnovers: 'B die mit einem Tor enden',
    goalEndingHighTurnoversTooltip: ' Viele B die mit einem Tor enden',
    avgCarriesProgress: 'Durchschnittliche Fortschritte',
    avgCarriesProgressTooltip: 'Durchschnittliche Entfernung beim vertikalen Bewegen des Balls (Meter)',
    carriesChance: 'Mit einer Chance endend',
    carriesChanceTooltip: 'Dribblings gefolgt von einem Schlüsselpass',
    carriesAssist: 'Endend in einer Vorlage',
    carriesAssistTooltip: 'Dribblings gefolgt von einer Vorlage',
    carriesShot: 'Endend in einem Schuss',
    carriesShotTooltip: 'Dribblings gefolgt von einem Schuss',
    carriesGoal: 'Endend mit einem Tor',
    carriesGoalTooltip: 'Dribblings gefolgt von einem Tor',
    shotEndingSequence: 'Endend mit einem Schuss',
    shotEndingSequenceTooltip: 'Sequenzen die mit einem Schuss enden, wo der Spieler involviert war',
    goalEndingSequence: 'Endend mit einem Schuss',
    goalEndingSequenceTooltip: 'Sequenzen die mit einem Tor enden, wo der Spieler involviert war',
    gbeScoreTooltip: 'FA Football\'s Governing Body Endorsement',
    goalsPreventedTooltip: 'Vom Torhüter gehaltene Tore (ohne Strafstoß) (xG abbekommen - NPG Kassiert)',
    freePlayers: 'Ablösefreie Spieler',
    index: 'Index',
    playerName: 'Name',
    teamName: 'Mannschaft',
    secondPos: 'Zweite Pos.',
    side: 'Mannschaft',
    onlyOnLoan: 'Nur ausgeliehen',
    dob: 'Geburtsdatum',
    countryName: 'Land',
    secondCountryName: 'Zweites Land',
    seasonYear: 'Saison',
    assists: 'Vorlagen',
    placeholder: 'Sie können mit dem Hinzufügen einiger Filter beginnen',
    placeholder2: 'Klicken Sie auf die Schaltfläche Suchen, um die Ergebnisse anzuzeigen',
    passesPct: 'Pässe %',
    passingPct: 'Pässe %',
    oppBoxPasses: 'Pässe im gegner. Strafraum',
    adjustedClearances: 'Angepasste Klärungen',
    aerialsPct: 'Luftduelle %',
    leagueCountryCode: 'Liga Land Code',
    shooting: 'Schüsse aufs Tor %',
    xtPassing: 'xT Passen',
    xtPassingTooltip: 'Threat added by passing',
    xtDribbling: 'xT Dribbling',
    xtDribblingTooltip: 'Threat added by carrying',
    foot: 'Strong Foot',
    aggressiveActions: 'Aggressive Actions',
    aggressiveActionsTooltip: 'Number of tackles attempted in the next two seconds after losing the possession',
    tacklesAttempted: 'Tackles Attempted',
    highDefensiveActionPct: '% HD Actions',
    highDefensiveActionPctTooltip: 'Percentage of Defensive Actions made 40 meters close to the opponent goal',
    individualPressureOppHalf: 'Pressure Opp. Half',
    individualPressureOppHalfTooltip: 'Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent in the opponent half',
    xGBuildUp5Pass: 'xG Buildup 5P',
    xGBuildUp5PassTooltip: 'Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)',
    chancesCreatedOpenPlay: 'Chances Created OP',
    chancesCreatedOpenPlayTooltip: 'Number of passes leading to a shot during open play',
    fmf: {
      Defender: 'Innenverteidiger',
      aerial: 'Luftduelle',
      goodDefender: 'Guter Abwehrspieler',
      goodPresence: 'Gute Präsenz',
      playmaking: 'Spielmacher',
      Fullback: 'Außenverteidiger',
      defensiveness: 'Defensivität',
      offensiveness: 'Offensivität',
      fast: 'Schnell',
      Forward: 'Stürmer',
      goalChances: 'Torchancen',
      goodDecissions: 'Gute Entscheidungen',
      individualTechnique: 'Individuelle Technik',
      Goalkeeper: 'Torwart',
      footWork: 'Fußtechnik',
      leadership: 'Führungsrolle',
      Midfielder: 'Defensiver Mittelfeldspieler',
      balance: 'Balance',
      ballRetention: '% Ballabsicherung',
      offensivePasses: 'Offensive Pässe',
      recoveries: 'Balleroberungen',
      shotToGoal: 'Schuss aufs Tor',
      'Attacking-Midfielder': 'Offensiver Mittelfeldspieler',
      defensiveGame: 'Defensives Spiel',
      offensiveGame: 'Offensives Spiel',
      Winger: 'Flügelspieler',
      crossing: 'Flanken',
      deepProgressions: 'Tiefer Ballbesitz',
      defendingEffort: 'Defensiveinsatz',
      facing: 'gegenüberstellen'
    },
    yellowCards: 'Gelbe Karten',
    redCards: 'Rote Karten',
    alert: 'Alert',
    yearOfBirth: 'Geburtsjahr',
    minYearOfBirth: 'minimales Geburtsjahr',
    maxYearOfBirth: 'maximales Geburtsjahr',
    women: 'Frauen',
    continental: 'Kontinental',
    countryCup: 'Landespokal',
    statsName: 'Statistikname',
    abbreviation: 'Abkürzung',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Zeigt nur die letzte gespielte reguläre Saison',
    gamesWith60PlusMinsTooltip: 'Mindestanzahl gespielter Spiele mit mehr als 60 Minuten',
    starts: 'Beginnt',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Mit bis zu 5 Spielern vergleichen',
    requestReport: 'Bericht anfordern',
    searchBarPlaceholder: 'Spieler oder Team suchen',
    allStats: 'Alle Statistiken',
    placeholder: 'Sie können beginnen, Spieler hinzuzufügen'
  },
  reports: {
    detailedInsights: 'Detaillierte Einblicke erhalten',
    features: 'Eigenschaften des Berichts',
    performance: 'Leistung',
    evolution: 'Entwicklung',
    compareWithMyTeam: 'Vergleichen mit meinem Team',
    similarPlayers: 'Ähnliche Spieler',
    potentialTeams: 'Potenzielle Teams',
    requestSuccess: 'Anfrage erfolgreich gesendet',
    requestAt: 'Angefragt',
    reportConversation: 'Konversation melden',
    writeYourMessage: 'Nachricht schreiben...',
    you: 'Sie'
  },
  state: {
    requested: 'Angefordert',
    inProgress: 'Im Prozess',
    delivered: 'Geliefert'
  },
  langs: {
    es: 'Spanisch',
    en: 'Englisch',
    fr: 'Französisch',
    de: 'Deutsch',
    it: 'Italienisch',
    pt: 'Portugiesisch',
    tr: 'Türkisch',
    jp: 'Japanisch',
    cn: 'Chinesisch',
    sa: 'Arabisch',
    nl: 'Niederländisch',
    pl: 'Polnisch',
    sv: 'Schwedisch',
    cs: 'Tschechisch',
    ko: 'Koreanisch',
    hu: 'Ungarisch',
    ru: 'Russisch'
  },
  langsArea: {
    europe: 'Europa',
    asia: 'Asien',
    arabic: 'Arabisch'
  },
  inbox: {
    subtitle: 'Auf dem Laufenden bleiben',
    new_injury_alert: 'Neue Verletzungsmeldung',
    new_contract_alert: 'Neue Vertragsmeldung',
    new_team_alert: 'Benachrichtigung über neue Signaturen.',
    new_marketValue_alert: 'Neue Marktwertmeldung',
    new_game_alert: 'Benachrichtigung über neue gespielte Spiele',
    receive_mail: 'E-Mail empfangen',
    receive_mail_subtitle: 'Erhalten Sie Daily Mail mit Spielern, die die Filter erfüllen',
    receive_notifications: 'Benachrichtigungen',
    receive_notifications_subtitle: 'Erhalten Sie Benachrichtigungen in der Anwendung mit den Spielern, die den Filter passieren',
    changedTo: 'Geändert zu',
    alerts: 'Meldung',
    includedIn: 'Eingeplant in',
    noContract: 'Ohne Vertrag',
    newMessages: 'Neue Nachrichten',
    reply: {
      reply: 'Reply',
      replyTitle: 'Give feedback to the client:',
      replyPlaceholder: 'The user will receive the reply along with the status update'
    }
  },
  gameAnalysis: {
    subtitle: 'Erhalten Sie Einblicke in die letzten Spiele',
    subtitle2: 'Zeigt Spiele in den nächsten sieben Tagen',
    subtitle3: 'Erhalten Sie Einblicke in die letzten Spiele und erkunden Sie die nächsten Spiele',
    seeDetail: 'Details ansehen'
  },
  statsNaming: {
    Possession: 'Ballbesitz',
    TimePossession: 'Ballbesitzzeit',
    PassesPerShots: 'Pässe pro Schuss',
    PPDA: 'PPDA',
    ExpectedPoints: 'Voraussichtliche Punkte',
    Points: 'Points',
    Directness: 'Genauigkeit',
    PassesPerLongBall: 'Pässe pro Langer Ball',
    CrossingPerXG: 'Flanken pro xG',
    PenaltySavedPenaltyFaced: 'Strafstoss gehalten/Strafstoss konfrontiert',
    Goals: 'Goals',
    PenaltyShots: 'Elfmeterschüsse',
    PenaltyGoals: 'Elfmetertore',
    NonPenaltyGoals: 'Non-Penalty Tore',
    NPGOpenPlay: 'TOE aus dem Spiel heraus',
    NPGSetPiece: 'TOE Standardsituationen',
    Shooting: 'Schiessen',
    Finishing: 'Abschluss',
    xGEfficiency: 'xG Effizienz',
    HeaderPerShot: 'Kopfball pro Schuss',
    HeaderPerCross: 'Kopfball pro Flanke',
    HeadedGoals: 'Angeführte Ziele',
    GoalsConceded: 'Gegentore',
    SavesInBox: 'Wird im Karton gespeichert',
    SavesOutBox: 'Spart sofort nach dem Auspacken',
    Assists: 'Vorlagen',
    ThroughBalls: 'Steilpässe',
    CrossEfficiency: 'Effizienz der Flanken',
    ScoringContribution: 'Treffbeitrag',
    xAssistsOpenPlay: 'xVorlagen aus dem Spiel heraus',
    xAssistsSetPiece: 'xVorlagen durch Standard Situationen',
    xAssistsOpenPlayInTeam: 'xVorlagen aus dem Spiel heraus im Team',
    xAssistsSetPieceInTeam: 'xVorlagen durch Standard Situationen im Team',
    xGBuildupFinalThird: 'xG Aufbau im Letzten ⅓',
    xGChainFinalThird: 'xG Chain Letzten ⅓',
    BallProgressionPassing: 'Spielentwicklung durch Passen',
    BallProgressionDribbling: 'Spielentwicklung durch dribbling',
    TacklesWasDribbled: 'Gewonnene defensive Eins-gegen-Eins-Duelle',
    TacklesSuccessful: 'Erfolgreiche Tackles',
    Interceptions: 'Ballabfangungen',
    Clearances: 'Klärungen',
    Fouls: 'Fouls',
    Recoveries: 'Balleroberungen',
    Shots: 'Schüsse',
    ShotsPerGoal: 'Schüsse pro Tor',
    ShortPassesSuccessful: 'Erfolgreiche kurzpässe',
    PassingSuccessForwardPct: '% an Erfolg beim Vorwärts Passen',
    PassingSuccessBackwardPct: '% Erfolg beim rückwärts Passen',
    PassingForwardBackwardPct: '% Vorwärts Passen pro rückwärts',
    LongBallPerPassesPct: '% Langer Ball pro Pass',
    LongBallReceived: 'Lange Bälle angenommen',
    LongBallReceivedOppHalf: 'Lange Bälle in gegnerischen Hälfte zugespielt bekommen',
    OffensiveActions: 'Offensive Aktionen',
    DribblesAttempted: 'Dribblingsversuche',
    SuccessfulDribblesPct: '% Erfolgreiche Dribblings',
    OffensiveTouchesOutBoxPct: '% Offensivberührungen außerhalb des Bereichs',
    BallRetention: '% Ballabsicherung',
    PassingPct: '% Passen',
    PassingOwnHalfPct: '% Pässe in die eigene Hälfte',
    PassingOppHalfPct: '% Pässe in die gegnerische Hälfte',
    PassingFinalThird: 'Pässe in den Letzten ⅓',
    PassesFinalThirdTotal: 'Gesamtzahl der Pässe im Finale ⅓',
    PassingFinalThirdPct: '% Pässe in den Letzten ⅓',
    LongBallSuccessful: 'Erfolgreiche lange Bälle',
    LongBallPct: '% lange Bälle',
    LongBallTotal: 'Insgesamt lange Bälle',
    SavesPct: '% an gehaltene Schüsse',
    SavesInBoxPct: '% gehaltene Schüsse im Strafraum',
    SavesOutOfBoxPct: '% gehaltene Schüsse von ausserhalb des Strafraums',
    xGSavedPerXGFacedOnTarget: 'xG gehalten/xG Schüsse Abbekommen',
    xGFacedOnTargetPerGoalReceived: 'xG kassiert pro Tor',
    xGFacedOnTargetEfficiency: 'Verhinderte Tore',
    xGFacedOnTarget: 'xG Schüsse Abbekommen',
    IndividualPressure: 'Individuelles Pressing',
    AerialEfficiency: 'Effizienz der Luftduelle',
    AerialWins: 'Gewonnene Luftduelle',
    AerialWinsPct: '% gewonnene Luftduelle',
    xG: 'Voraussichtliche Tore',
    xGDiff: 'xG-Differenz',
    xGOpenPlay: 'xG Open Play',
    xGSetPiece: 'xG durch Standard Situationen',
    xGPerShot: 'xG pro Schuss',
    ChancesCreated: 'Produzierte Chancen',
    CompletedCrosses: 'Erfolgreiche Flanken',
    Crossing: '% Flanken',
    OpenPlayKeyPasses: 'Schlüsselpässe vom Spiel heraus',
    OpenPlayKeyPassesInTeam: 'Schlüsselpässe vom Spiel heraus im Team',
    OpenPlayPassesIntoOpponentBox: 'Pässe Gesamt in den gegnerischen Strafraum vom Spiel heraus',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'Pässe in den gegnerischen Strafraum vom Spiel heraus',
    xAssists: 'Voraussichtliche Vorlagen',
    xGChain: 'xG Kette',
    xGBuildup: 'xG Aufbau',
    xGBuildupInTeam: 'xG Aufbau in Team',
    BallProgression: 'Ballbesitz',
    SuccessfulDribbles: 'Erfolgreiche Dribblings',
    Dispossessed: 'Ballverlust',
    TouchesInOpponentBox: 'Ballkontrolle im gegnerischen Strafraum',
    xGSavedPerShot: 'xG gehalten pro Schuss',
    BallRetentionOppHalf: '% Ballkontrolle in der gegnerischen Hälfte',
    DeepProgression: 'Ballbesitz in die Tiefe',
    DeepProgressionFinalThird: 'Ballbesitz im letzten Drittel',
    FoulsTaken: 'gefoult worden',
    PenaltiesTaken: 'Strafstöße geschossen',
    BlockedCrosses: 'Geblockte Flanken',
    BlockedShots: 'Geblockte Schüsse',
    Blocks: 'Blocks',
    NonPenaltyGoalsAgainst: 'Tore (kein Elfmeter) kassiert',
    Headers: 'Kopfbälle',
    AveragePassDistance: 'Durchschnittliche Passlänge',
    ProgressiveRuns: 'Progressive Läufe',
    xT: 'Voraussichtliche Gefahr',
    xTOpenPlay: 'xT aus dem Spiel Heraus',
    xTSetPiece: 'xT durch Standard Situationen',
    xGOT: 'Voraussichtliche Tore aufs Tor',
    BadActions: 'Schlechte Aktionen',
    BadActionsOwnHalf: 'Schlechte Aktionen in der eigenen Hälfte',
    AerialsWonOwnBox: 'Gewonnene Luftduelle im eigenen Strafraum',
    AerialsWonOppBox: 'Aerials Won Opp Box',
    AerialsTotalOppBox: 'Aerials Total Opp Box',
    AerialsTotalOwnBox: 'Aerials Total Own Box',
    FoulsOwnHalfPct: '% Fouls in eigener Hälfte',
    RecoveriesOppHalf: 'Ballgewinn in der Gegnerischen Hälfte',
    DuelsPct: '% Erfolgreiche Duelle',
    TacklesUnsuccessful: 'Erfolglose Tackles',
    TacklesWasDribbledFirstThird: 'Gewonnene defensive Eins-gegen-Eins-Duelle im ersten Drittel',
    TacklesWasDribbledSecondThird: 'Gewonnene defensive Eins-gegen-Eins-Duelle ⅔',
    TacklesWasDribbledFinalThird: 'Gewonnene defensive Eins-gegen-Eins-Duelle Ende ⅓',
    BallProgressionFinalThird: 'Ballbesitz im letzten Drittel',
    DuelsTotal: 'Duelle',
    QuickRecoveries: 'Schnelle Balleroberungen',
    ShotsPerNPG: 'Schüsse pro NPG',
    ShotsOutBox: 'Schüsse außerhalb des gegnerischen Strafraums',
    GoalsOutBox: 'Tore außerhalb des gegnerischen Strafraums',
    ShootingOutBox: '% Schüsse von außerhalb des gegnerischen Strafraums',
    HandPassing: '% Abwurf',
    Catching: '% Fangen',
    Caught: 'Gefangene Saves',
    ClaimAccuracy: 'Anspruchsgenauigkeit',
    HighTurnovers: 'Viele Ballverluste',
    ShotEndingHighTurnovers: 'Viele Ballverluste die mit einem Schuss enden',
    GoalEndingHighTurnovers: 'Viele Ballverluste die mit einem Tor enden',
    AverageCarriesProgress: 'Durchschnittliche Fortschritte',
    ChanceEndingCarries: 'Dribblings die mit einem Schuss-gefolgtem Pass enden',
    AssistEndingCarries: 'Dribblings die mit einer Vorlage enden',
    ShotEndingCarries: 'Dribblings die mit einem Schuss enden',
    GoalEndingCarries: 'Dribblings die mit einem Tor enden',
    ShotEndingSequence: 'Sequenzen die mit einem Schuss enden',
    GoalEndingSequence: 'Sequenzen die mit einem Tor enden',
    xGPerNPG: 'xG pro kein Straftstoß Tor',
    AerialWonOffensive: 'Gewonnene Offensiv-Luftduelle',
    AerialWonDefensive: 'Gewonnene Defensiv-Luftduelle',
    xGAgainst: 'Erwartete Gegentore',
    xGDiffAgainst: 'Erwartete Gegentore Diff',
    xGPerNPGAgainst: 'xG kassiert pro kein Strafstoß Tor',
    xGSetPieceAgainst: 'xG Kassiert aus Standard Situationen',
    xGOpenPlayAgainst: 'xG Kassiert aus dem Spiel Heraus',
    xGPerShotAgainst: 'xG Kassiert pro Schuss',
    ShotsAgainst: 'Schüsse Kassiert',
    ShotsOnTargetAgainst: 'Schüsse aufs Tor werden kassiert',
    ShotsOnTargetInBoxAgainst: 'Schüsse aufs Tor im Strafraum kassiert',
    ShotsOnTargetOutBoxAgainst: 'Schüsse aufs Tor außerhalb des Strafraums kassiert',
    RivalPossession: 'Ballbesitz des Gegners',
    AerialDefensivePct: '% Defensive Gewonnene Luftduelle',
    HighRecoveries: 'Viele Balleroberungen',
    HighDefensiveActions: 'Viele Defensiv-Aktionen',
    HighDefensiveActionPct: '% Viele Defensiv-Aktionen',
    HighDefensiveDistance: 'Hohe defensive Distanz',
    PassesPerPossession: 'Pässe pro Ballbesitz',
    LengthPerPossession: 'Entfernung pro Ballbesitz',
    xTNet: 'Net xT',
    AvgCarriesDistance: 'Dursch. Distanz der Ballmitnahme',
    PassesForwardPct: '% Vorwärtspässe',
    PassesForwardSuccessful: 'Erfolgreiche Vorwärtspässe',
    PassesForwardTotal: 'Gesamtzahl der Vorwärtspässe',
    TacklesAttempted: 'Versuchte Zweikämpfe',
    DuelsLost: 'Verlorene Zweikämpfe',
    Carries: 'Ballmitnahmen',
    CarriesPct: '% Ballmitnahmen',
    Aerials: 'Luftduelle',
    ProgressivePassesReceivedIntoBox: 'Progressive Pässe im Strafraum angenommen',
    PassesOppHalf: 'Pässe in die Gegnerische Hälfte',
    ShotsOnTarget: 'Schüsse aufs Tor',
    AggressiveActions: 'Aggressive Aktionen',
    Crosses: 'Flanken',
    xGBuildup5pass: 'xGAufbau 5 Pässe',
    SpeedSequence: 'Geschwindigkeit der Sequenz',
    Touches: 'Ballberührungen',
    AerialsTotalOppHalf: 'Luftduelle Gesamt in Gegnerischer Hälfte',
    AerialsWonOppHalf: 'Die Luftaufnahmen haben den Gegner gewonnen. Hälfte',
    AerialsWonOppHalfPct: '% Gewonnene Luftduelle in der gegnerischen Hälfte',
    AerialsPctOppBox: '% Luftduelle im gegnerischen Strafraum gewonnen',
    AerialsPctOwnBox: '% Luftduelle im eigenen Strafraum gewonnen',
    AerialDefensive: 'Luftduelle Defensiv',
    AerialOffensive: 'Luftduelle Offensiv',
    AerialOffensivePct: '% Luftduelle Offensiv',
    IndividualPressureOppHalf: 'Individuelles Pressing in der gegnerischen Hälfte',
    ChancesCreatedOP: 'Generierte Chancen aus dem Spiel heraus',
    TouchesPerShot: 'Ballberührungen pro Schuss',
    PassesFinalThirdTotalPct: '% Pässe im letzten Drittel',
    xACrosses: 'xA von Flanken',
    Passes: 'Pässe',
    PassesSuccessful: 'Erfolgreiche Pässe',
    TacklesWasDribbledFouls: '% Ground Duels',
    OffsidesCaught: 'im Abseits',
    ProgressivePassesReceivedFinalThird: 'Progressive Pässe Angenommen in dem letzten Drittel',
    ProgressivePassesReceived: 'Progressive Pässe Angenommen',
    Breadth: 'Breite',
    DuelsDefTotal: 'Defensive Duelle',
    DefensiveActions: 'Defensive Aktionen',
    ProgressivePassesReceivedOppHalf: 'Fortschreitende Pässe in der gegnerische Hälfte erhalten',
    CompletedCrossesOP: 'Angekommene Flanken aus dem freien Spiel heraus',
    CrossingOP: '% Flanken aus dem freien Spiel heraus',
    CrossesOP: 'Gesamtzahl der Kreuze im offenen Spiel',
    PassingContribution: '% Passing Contribution',
    BallProgressionOppHalfInTeam: '% Ball Progression Opp. Half in Team',
    PassesOPIntoBoxInTeam: '% Passes Open Play into Box in Team',
    TouchesOppBoxInTeam: '% Touches Opp. Box in Team',
    xGOPInTeam: '% xG Open Play in Team',
    DeepPasses: 'Deep Passes',
    DeepPassesTotal: 'Tiefe Pässe',
    DefensiveDuelsPct: '% Defensive Duels',
    DefensiveDistance: 'Defensive Distance',
    QuickRecoveriesPct: '% Quick Recoveries',
    DiffDefensiveDistanceTeam: 'Diff. Defensive Distance Team',
    xTPassing: 'xT Passing',
    xTPassing100Passes: 'xT Passing 100 Passes',
    ProgressivePassesAccurate: 'Progressive Passes',
    PassAbility: 'Pass Ability',
    OPPassesIntoOppBoxPct: '% Open Play Passes Into Opp. Box',
    EntriesOppBox: 'Entries Opp. Box',
    Crosses6yardBox: 'Crosses Six-Yard Box',
    Cutbacks: 'Cutbacks',
    xTDribbling: 'xT Dribbling',
    AvgShotDistance: 'Avg Shot Distance',
    xGOnTarget: 'xG on Target',
    FinishingxGOT: 'Finishing xGOT',
    DribblesWonOwnHalf: 'Dribbles Won Own Half',
    DribblesOwnHalf: 'Dribbles Own Half',
    DribblesOwnHalfPct: '% Dribbles Own Half',
    DribblesWonOppHalf: 'Dribbles Won Opp Half',
    DribblesOppHalf: 'Dribbles Opp Half',
    DribblesOppHalfPct: '% Dribbles Opp Half',
    DribblesWonFinalThird: 'Dribbles Won Final Third',
    DribblesFinalThird: 'Dribbelt im letzten Drittel',
    DribblesFinalThirdPct: '% Dribbles Final Third',
    ShotEndingHighRecoveries: 'Hohe Ballgewinne mit Abschluss',
    PassingFinalThirdAgainst: 'Pässe ins letzte Drittel (gegen uns)',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Offene Spielpässe in den Strafraum (gegen uns)',
    EntriesOppBoxAgainst: 'Eintritte in unseren Strafraum (gegen uns)',
    DeepProgressionAgainst: 'Zugelassene tiefe Progressionen',
    TouchesInOpponentBoxAgainst: 'Ballkontakte des Gegners in unserem Strafraum',
    Score: 'Punktzahl',
    PDScore: 'Physische Punktzahl',
    OrlegiScore: 'Score Orlegi',
    SirScore: 'Sirius Score',
    ExcScore: 'Excelsior Score',
    xTOPInTeam: 'xT aus dem Spiel Heraus in Team',
    YellowCards: 'Gelbe Karten',
    RedCards: 'Rote Karten',
    xTOpenPlayAgainst: 'xT Kassiert aus dem Spiel Heraus',
    xTSetPieceAgainst: 'xT Kassiert durch Standard Situationen',
    NPGOpenPlayAgainst: 'TOE Kassiert aus dem Spiel Heraus',
    NPGSetPieceAgainst: 'TOE Kassiert Standardsituationen',
    PassesOppHalfPerPossession: 'Pässe Gegnerische Hälfte pro Ballbesitz',
    AverageTimeRecovery: 'Durchschnittliche Wiederherstellungszeit',
    ExpectedPassing: '% Erwarteter Durchgang',
    NumPossession10Passes: 'Besitzt 10 Pässe',
    PassesReceived: 'Empfangene Pässe',
    PassesReceivedFinalThird: 'Empfangene Pässe Final ⅓',
    ProgressivePassesTotalPct: '% Progressive Pässe',
    ShortPassesPct: '% Kurzpässe',
    TouchesOppBoxOppTeam: 'Ballkontakte im Eigenen Strafraum Zugelassen mit Ihm auf dem Platz',
    ShotsOnTargetOppTeam: 'Zugelassene Schüsse aufs Tor mit Ihm auf dem Platz',
    NPGOppTeam: 'xG Ohne Elfmeter des Gegners mit Ihm auf dem Platz',
    ShotsOpenPlay: 'Torschüsse aus dem offenen Spiel',
    xGSetPiecePerxG: 'xG Standards pro xG',
    ShotsOpenPlayAgainst: 'Torschüsse aus dem offenen Spiel gegen',
    ShotsFromDribble: 'Schüsse nach Dribbling',
    GoalsFromDribble: 'Tore nach Dribbling',
    PassesIntoFinalThird: 'Pässe ins letzte Drittel',
    PassesIntoFinalThirdTotal: 'Gesamtzahl der Pässe im letzten Drittel',
    PassesInsideFinalThird: 'Pässe im letzten Drittel',
    PassesInsideFinalThirdTotal: 'Gesamtzahl der Pässe im Finale ⅓',
    PassesFinalThirdNoArea: 'Besteht das letzte Drittel (ohne Box)',
    PassesIntoOppBox: 'Pässe in den gegnerischen Strafraum',
    CarriesFinalThird: 'Dribblings ins letzte Drittel',
    CarriesInsideFinalThird: 'Dribblings im letzten Drittel',
    CarriesFinalThirdNoBox: 'Trägt das letzte Drittel (ohne Box)',
    CarriesIntoOppBox: 'Dribblings in den gegnerischen Strafraum',
    TimePossessionAgainst: 'Ballbesitz des Gegners',
    TimePossessionTotal: 'Gesamter Ballbesitz',
    PassesInBox: 'Pässe im eigenen Strafraum',
    LongThrowInSuccessful: 'Erfolgreicher weiter Einwurf',
    LongThrowInTotal: 'Gesamte weite Einwürfe',
    LongThrowInPct: '% erfolgreicher weiter Einwürfe',
    Games: 'Gespielte Spiele',
    PointsPerGame: 'Punkte pro Spiel',
    ExpectedPointsDiff: 'Erwartete Punktedifferenz',
    PassesTotalOwnHalf: 'Gesamtzahl der Pässe in der eigenen Hälfte',
    PassesOwnHalf: 'Passt die eigene Hälfte',
    PassesTotalOppHalf: 'Besteht die Gesamt-Opp-Hälfte',
    ProgressivePassesTotal: 'Insgesamt progressive Pässe',
    DuelsWon: 'Gewonnene Duelle',
    NonPenaltySaves: 'Paraden ohne Strafe',
    BadActionsOppHalf: 'Schlechte Aktionen gegenüber der Hälfte',
    CarriesSuccessful: 'Trägt erfolgreich',
    ShotsOnTargetOutBox: 'Schüsse aufs Ziel aus der Box',
    TotalDistance: 'Gesamtabstand',
    DistanceTIP: 'Gesamtabstand TIP',
    DistanceOTIP: 'Gesamtabstand OTIP',
    SprintsNumber: 'Sprints Anzahl',
    SprintsDistance: 'Sprints Entfernung',
    WalkingDistance: 'Gehstrecke',
    JoggingDistance: 'Joggingdistanz',
    RunningDistance: 'Laufstrecke',
    ExtremeAccelerations: 'Extreme Beschleunigungen',
    NumberOfRuns: 'Anzahl der Läufe',
    HsrNumber: 'HSR Menge',
    HsrDistance: 'HSR Entfernung',
    SprintNumberDeclinePct: '% Rückgang der Anzahl an Sprints',
    SprintDistanceDeclinePct: '% Rückgang der Sprintdistanz',
    SprintNumberDecline: 'Rückgang der Anzahl an Sprints',
    SprintDistanceDecline: 'Rückgang der Sprintdistanz',
    HsrDistancePct: '% HSR Entfernung',
    SprintDistancePct: '% Sprint Distanz',
    Accelerations: 'Anzahl der Beschleunigungen',
    ExplosiveDistance: 'Explosive Entfernung',
    MaxSpeed: 'Max. Geschwindigkeit',
    AvgMaxSpeed: 'Durchschnittliche Höchstgeschwindigkeit',
    MaxAccelerations: 'Maximale Beschleunigungen',
    BypassedPlayersByPasses: 'Umspielte Spieler',
    BypassedDefendersByPasses: 'Umspielte Verteidiger',
    PassesBypassingPlayers: 'Pässe, die Spieler Überspielen',
    PassesBypassingDefenders: 'Pässe, die Verteidiger Überspielen',
    BypassedPlayersPerPass: 'Umspielte Spieler pro Pass',
    BypassedDefendersPerPass: 'Umspielte Verteidiger pro Pass',
    LineBreakingPasses: 'Linienbrechende Pässe',
    LineBreakingPassesMD: 'Linienbrechende Pässe MD',
    LineBreakingPassesM: '',
    LineBreakingThroughBalls: 'Linienbrechende Steilpässe',
    LineBreakingPassesPerPass: '% Linienbrechende Pässe pro Pass',
    TotalPassesUnderStrongPressure: 'Gesamtanzahl Pässe unter Starkem Druck',
    TotalPassesUnderLightPressure: 'Gesamtanzahl Pässe unter Druck',
    SuccessfulPassesUnderStrongPressure: 'Erfolgreiche Pässe unter Starkem Druck',
    SuccessfulPassesUnderLightPressure: 'Erfolgreiche Pässe unter Druck',
    PassingUnderStrongPressure: '% Passspiel unter Starkem Druck',
    PassingUnderLightPressure: '% Passspiel unter Druck',
    PassReceiptsInSpaceCompleted: 'Pässe in Freiräume und Empfangen Erfolgreiche',
    PassReceiptsInSpace: 'Pässe in Freiräume Empfangen',
    PassReceiptsInSpaceCompletedFirstThird: 'Ballannahmen im Raum abgeschlossen erstes Drittel',
    PassReceiptsInSpaceCompletedSecondThird: 'Ballannahmen im Raum abgeschlossen zweites Drittel',
    PassReceiptsInSpaceCompletedFinalThird: 'Ballannahmen im Raum abgeschlossen letztes Drittel',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Ballannahmen im Raum abgeschlossen rechte Seite gegnerische Hälfte',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Ballannahmen im Raum abgeschlossen Zentrum gegnerische Hälfte',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Ballannahmen im Raum abgeschlossen linke Seite gegnerische Hälfte',
    PassReceiptsInSpaceFirstThird: 'Ballannahmen im Raum erstes Drittel',
    PassReceiptsInSpaceSecondThird: 'Ballannahmen im Raum zweites Drittel',
    PassReceiptsInSpaceFinalThird: 'Ballannahmen im Raum letztes Drittel',
    PassReceiptsInSpaceOppHalfRight: 'Ballannahmen im Raum rechte Seite gegnerische Hälfte',
    PassReceiptsInSpaceOppHalfCenter: 'Ballannahmen im Raum Zentrum gegnerische Hälfte',
    PassReceiptsInSpaceOppHalfLeft: 'Ballannahmen im Raum linke Seite gegnerische Hälfte',
    TotalStrongOnBallPressures: 'Gesamtanzahl Starker Ball-Drücke',
    TotalLightOnBallPressures: 'Gesamtanzahl Ball-Drücke',
    SuccessfulStrongOnBallPressures: 'Erfolgreiche Starke Ball-Drücke',
    SuccessfulLightOnBallPressures: 'Erfolgreiche Ball-Drücke',
    StrongOnBallPressuresPct: '% Starke Ball-Drücke',
    LightOnBallPressuresPct: '% Ball-Drücke',
    TimesBypassedByPasses: 'Überspielt durch Pässe',
    TimesBypassedByCarries: 'Überspielt durch Dribblings',
    TimesBypassedByActions: 'Überspielt durch Aktionen',
    BypassedPlayersByCarries: 'Spieler durch Dribblings Überspielt',
    BypassedDefendersByCarries: 'Verteidiger durch Dribblings Überspielt',
    BypassedPlayersByActions: 'Spieler durch Aktionen Überspielt',
    BypassedDefendersByActions: 'Verteidiger durch Aktionen Überspielt',
    CarriesBypassingPlayers: 'Dribblings, die Spieler Überspielen',
    CarriesBypassingDefenders: 'Dribblings, die Verteidiger Überspielen',
    BypassedPlayersPerCarry: 'Überspielte Spieler pro Dribbling',
    BypassedDefendersPerCarry: 'Überspielte Verteidiger pro Dribbling',
    LineBreakingCarries: 'Dribblings zwischen den Linien',
    LineBreakingCarriesMD: 'Dribblings zwischen Abwehr und Mittelfeld',
    LineBreakingCarriesM: 'Dribblings zwischen Mittelfeldlinie',
    LineBreakingCarriesD: 'Dribblings zwischen Abwehrlinie',
    LineBreakingCarriesPerCarry: 'Linienbrechende Dribblings pro Dribbling',
    LineBreakingActions: 'Aktionen zwischen den Linien',
    LineBreakingActionsMD: 'Aktionen zwischen Abwehr und Mittelfeld',
    LineBreakingActionsM: 'Aktionen zwischen Mittelfeldlinie',
    LineBreakingActionsD: 'Aktionen zwischen Abwehrlinie',
    PassesPerLineBreakingPass: 'Pässe pro Linienbrechendem Pass',
    CarriesPerLineBreakingCarry: 'Dribblings pro Linienbrechendem Dribbling',
    LinesBrokenByPasses: 'Durch Pässe Gebrochene Linien',
    LinesBrokenByCarries: 'Durch Dribblings Gebrochene Linien',
    LinesBrokenByActions: 'Durch Aktionen Gebrochene Linien',
    LinesBrokenPerPass: 'Gebrochene Linien pro Pass',
    LinesBrokenPerCarry: 'Gebrochene Linien pro Dribbling',
    AvgLastDefenderDistanceIP: 'Abstand Letzter Verteidiger IP',
    AvgLastDefenderDistanceOOP: 'Abstand Letzter Verteidiger OOP',
    AvgDefensiveLineDistanceIP: 'Abstand Abwehrlinie IP',
    AvgDefensiveLineDistanceOOP: 'Abstand Abwehrlinie OOP',
    AvgRBDistanceIP: 'Abstand Rechter Außenverteidiger IP',
    AvgRBDistanceOOP: 'Abstand Rechter Außenverteidiger OOP',
    AvgLBDistanceIP: 'Abstand Linker Außenverteidiger IP',
    AvgLBDistanceOOP: 'Abstand Linker Außenverteidiger OOP',
    AvgBlockDistanceIP: 'Abstand Block IP',
    AvgBlockDistanceOOP: 'Abstand Block OOP',
    AvgBlockAreaIP: 'Blockfläche IP',
    AvgBlockAreaOOP: 'Blockfläche OOP',
    AvgDefensiveLineWidthOOP: 'Breite Abwehrlinie OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Breite Offensivlinie Letztes Drittel IP',
    AvgLByIP: 'Position Linker Außenverteidiger IP',
    AvgRByIP: 'Position Rechter Außenverteidiger IP',
    AvgOffensiveLineDistanceIP: 'Abstand Offensivlinie IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Abstand Offensivlinie Letztes Drittel IP',
    AvgOffensiveLineWidthIP: 'Breite Offensivlinie IP',
    OffBallRuns: 'Gesamtanzahl der Laufwege ohne Ball',
    OffBallRunsOverlap: 'Überlaufen',
    OffBallRunsUnderlap: 'Einlaufen',
    OffBallRunsRunAhead: 'Läufe Nach Vorne',
    OffBallRunsRunBehind: 'Läufe Hinter Die Abwehr',
    OffBallRunsCrossReceiver: 'Lauf Zum Flankenempfang',
    OffBallRunsSupport: 'Unterstützungslauf',
    OffBallRunsComingShort: 'Entgegenkommen Lauf',
    description: {
      Possession: 'Prozentualer Anteil des Ballbesitzes der Mannschaft',
      TimePossession: 'Ballbesitzzeit der Mannschaft',
      PassesPerShots: 'Durchschnitliche Anzahl an zugelassenen Pässen pro Schuss',
      PPDA: 'Pässe pro defensive Aktion. PPDA misst den Druck den die Mannschaft auf die gegnerischen Spieler ausübt, wenn sie im Ballbesitz sind. Der Wert entspricht der durchschnittlichen Anzahl an aufeinander folgenden Pässen, die der Gegner ausführen konnte, bevor er unterbrochen wurde. Desto höher der Wert, desto mehr Pässe wurden zugelassen für den Gegner.',
      Directness: 'Misst, wie genau eine Mannschaft ist. Ein hoher Wert der Genauigkeit ist mit einer höheren Anzahl von Vorwärtspässen im Verhältnis zu Seitwärtspässen verbunden',
      ExpectedPoints: 'Anzahl der von einer Mannschaft erwarteten Punkte, berechnet auf der Grundlage der erwarteten erzielten und kassierten Tore. Mit dieser Kennzahl lässt sich die Leistung einer Mannschaft während eines Spiels (oder einer Reihe von Spielen) im Vergleich zu den tatsächlich erzielten Punkten besser beurteilen.',
      PassesPerLongBall: 'Prozentualer Anteil der erfolgreichen langen Pässe an der Gesamtzahl der abgeschlossenen Pässe',
      CrossingPerXG: 'Prozentsatz an voraussichtlichen Toren die von Flanken stammen',
      PenaltySavedPenaltyFaced: 'Prozentualer Anteil der abgewehrten Strafstöße an allen abgewehrten Strafstößen',
      Goals: 'Number of goals scored',
      PenaltyShots: 'Gesamtanzahl der Schüsse vom Elfmeterpunkt',
      PenaltyGoals: 'Gesamtanzahl der Tore vom Elfmeterpunkt',
      NonPenaltyGoals: 'Anzahl an Toren erzielt je gespielte Minuten, mit der Ausnahme von Elfmetertoren',
      NPGOpenPlay: 'Number of goals scored by open play actions excluding penalty goals',
      NPGSetPiece: 'Number of goals scored by set piece actions excluding penalty goals',
      Shooting: 'Anzahl der erzielten Tore ohne Elfmetertore',
      Finishing: 'Prozent der Schüsse die im Tor landen',
      xGEfficiency: 'Anzahl der erwarteten Tore, die ein Spieler benötigt, um ein Tor zu erzielen',
      HeaderPerShot: 'Anzahl der Kopfball Tore',
      HeaderPerCross: 'Prozentualer Anteil der vom Spieler geköpften Flanken an der Gesamtzahl der von der Mannschaft ausgeführten Flanken',
      Assists: 'Anzahl an Vorlagen',
      ThroughBalls: 'Anzahl an Steilpässen für einen Spieler der ein offensiven Lauf macht um <br> eine Torchance zu produzieren',
      CrossEfficiency: 'Anzahl an erfolgreichen Flanken aus allen versuchten Flanken',
      ScoringContribution: 'Anzahl an Vorlagen und Toren',
      xAssistsOpenPlay: 'Anzahl an voraussichtlichen Vorlagen die aus dem Spiel entstanden sind',
      xAssistsSetPiece: 'Anzahl an voraussichtlichen Vorlagen die aus Standard Situationen entstanden sind',
      xAssistsOpenPlayInTeam: 'Anzahl an voraussichtlichen Vorlagen die aus dem Spiel entstanden sind im Team',
      xAssistsSetPieceInTeam: 'Anzahl an voraussichtlichen Vorlagen die aus Standard Situationen entstanden sind im Team',
      xGChainFinalThird: 'Anzahl an xG wo ein Spieler im letzten Drittel beteiligt war',
      xGBuildupFinalThird: 'Anzahl an xG wo ein Spieler im letzten Drittel beteiligt war (mit der Ausnahme von Schüssen und Pässen vor einem Schuss)',
      BallProgressionPassing: 'Anzahl der Male, in denen der Spieler den Ball 10 Meter oder mehr mit einem Pass weiterbringt',
      BallProgressionDribbling: 'Gibt an, wie oft der Spieler den Ball durch Tragen des Balls 10 Meter oder mehr weiterbringt',
      TacklesWasDribbled: 'Metrik, die den Prozentsatz der Fälle berücksichtigt, in denen der Spieler den Ball durch Tackling zurückerobert, im Vergleich zu den Fällen, in denen er gepasst/gelaufen ist. Je höher der Indikator, desto besser',
      TacklesSuccessful: 'Anzahl erfolgreicher Tacklings des Spielers',
      Interceptions: 'Anzahl der Fälle, in denen der Spieler einen Pass abfängt, um zu verhindern, dass der Ball sein Ziel erreicht,',
      Clearances: 'Anzahl der Ballkontakte des Spielers außerhalb der Verteidigungszone Spielzeit',
      Fouls: 'Anzahl der vom Spieler begangenen Fouls',
      Recoveries: 'Anzahl an balleroberungen von einem spieler',
      Shots: 'Anzahl an Schüssen insgesamt',
      ShotsPerGoal: 'Anzahl an Schüssen aufs Tor, um einen Tor (kein Elfmeter) zu erzielen',
      ShortPassesSuccessful: 'Anzahl an Kurzpässen (weniger als 12 Meter) vollendet',
      PassingSuccessForwardPct: 'Prozentsatz von erfolgreichen Pässen in die vorwärts Richtung',
      PassingSuccessBackwardPct: 'Prozentsatz von erfolgreichen Pässen in die rückwärts Richtung',
      PassingForwardBackwardPct: 'Quote an Pässen in die vorwärts Richtung vs. in die rückwärts Richtung',
      LongBallPerPassesPct: 'Prozentsatz an erfolgreichen langen Bällen (>32 Meter) von allen erfolgreichen Pässen eines Spielers.',
      LongBallReceived: 'Anzahl der empfangenen langen Pässe (>32 Meter)',
      LongBallReceivedOppHalf: 'Anzahl an langen Bällen (>32 Metern) empfangen von dem Spieler in der gegnerischen Hälfte',
      OffensiveActions: 'Offensive Aktionen',
      DribblesAttempted: 'Anzahl an versuchten Dribblings',
      SuccessfulDribblesPct: 'Prozentsatz an erfolgreichen Dribblings von den gesamten versuchten Dribblings',
      OffensiveTouchesOutBoxPct: '% Offensive Touches außerhalb des Strafraums',
      BallRetention: 'Prozentsatz der Zeit, in der du in Ballbesitz bist und den Ball nicht verlierst',
      PassingPct: 'Prozentsatz der angekommenen Pässe aus allen Pässen des Spielers',
      PassingOwnHalfPct: 'Prozentsatz der angekommenen Pässe aus allen Pässen <br>des Spielers (nur Pässe in der eigene Hälfte)',
      PassingOppHalfPct: 'Prozentsatz der angekommenen Pässe aus allen Pässen <br>des Spielers (nur Pässe in der gegnerische Hälfte)',
      PassingFinalThird: 'Erfolgreiche Pässe, ohne Flanken, Standards, Ecken und Einwürfe, die im letzten Drittel beginnen',
      PassesFinalThirdTotal: 'Gesamtzahl der versuchten Pässe, ohne Flanken, Standardsituationen, Ecken und Einwürfe, die im letzten Drittel enden',
      PassingFinalThirdPct: 'Prozentsatz erfolgreicher Pässe von allen Pässen des Spielers (nur jene, die im letzten Drittel beginnen)',
      LongBallSuccessful: 'Anzahl an erfolgreichen Pässen über 32 Metern',
      LongBallPct: 'Anzahl an erfolgreichen Pässen über 32 Metern/ gesamte Pässe über 32 Metern.',
      LongBallTotal: 'Gesamtzahl der Pässe über 32 Meter',
      SavesPct: 'Prozentsatz an gehaltenen Schüssen von den gesamten Schüssen',
      SavesInBoxPct: 'Prozentsatz an gehaltenen Schüssen von innerhalb des Strafraums',
      SavesOutOfBoxPct: 'Prozentsatz an gehaltenen Schüssen von außerhalb des Strafraums',
      xGSavedPerXGFacedOnTarget: 'Koeffizient der den Prozentsatz anzeigt von den<br> voraussichtlichen xG die der Torwart hält.',
      xGFacedOnTargetPerGoalReceived: 'Messung die anzeigt wie viele voraussichtliche Tore gebraucht werden<br> um ein Tor zu erzielen gegen einen spezifischen Torwart.',
      xGFacedOnTargetEfficiency: 'Anzahl an Toren (ohne Elfmeter) die durch den Torwart verhindert wurden',
      xGFacedOnTarget: 'Gesamtzahl der Gegentreffer (gerettet und erzielt) des Torhüters',
      IndividualPressure: 'Messung die Objektiv den Druck misst, die ein Spieler auf den Gegner ausübt',
      AerialEfficiency: 'Messung, die sowohl den Prozentsatz der gewonnenen Luftduelle<br> als auch die Anzahl der erfolgreichen Luftduelle kombiniert',
      AerialWins: 'Anzahl an Luftduelle die ein Spieler gewinnt',
      AerialWinsPct: 'Anzahl an Luftduelle die ein Spieler gewinnt aus der gesamten Anzahl<br>an Luftduellen in denen der Spieler involviert war',
      xG: 'Voraussichtliche Tore produziert. Diese Metrik misst die Wahrscheinlichkeit, dass ein Schuss in einem Tor endet, basierend auf verschiedenen Variablen (Entfernung, Winkel, Art des Spiels, Körperteil, ...) einer solchen Aktion.',
      xGDiff: 'Unterschied zwischen xG und Zielen',
      xGOpenPlay: 'Erwartete Tore, die durch Open Play generiert werden',
      xGSetPiece: 'xG aus Standard Situationen',
      xGPerShot: 'Durchschnittliche xG der von einem Spieler abgegebenen Schüsse. Diese Metrik misst die durchschnittliche Gefährlichkeit der abgegebenen Schüsse. Je höher, desto wahrscheinlicher ist es, dass Ihre Schüsse im Tor landen. Ein xG pro hohem Schuss bedeutet, dass der Spieler seine Schüsse gut auswählt.',
      ChancesCreated: 'Anzahl an Pässen die von einem Schuss gefolgt werden',
      CompletedCrosses: 'Anzahl an erfolgreichen Flanken',
      Crossing: 'Prozentsatz an erfolgreichen Flanken aus allen versuchten Flanken',
      OpenPlayKeyPasses: 'Anzahl an erfolgreichen Pässen durch einen Spieler von aus dem Spiel heraus',
      OpenPlayKeyPassesInTeam: 'Prozentsatz der anzahl an erfolgreichen pässen durch einen spieler von aus dem spiel heraus im team',
      OpenPlayPassesIntoOpponentBox: 'Anzahl an erfolgreichen Pässen gesamt durch einen Spieler in den Strafraum des Gegners<br> aus dem Spiel heraus',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Anzahl an erfolgreichen Pässen durch einen Spieler in den Strafraum des Gegners<br> aus dem Spiel heraus',
      xAssists: 'Metrik, die die Qualität der in einem Spiel geschaffenen Chancen analysiert. Jeder Schussversuch hat einen Wert, der auf der Wahrscheinlichkeit basiert, dass der Schuss ein Tor erzielt. Dieser Wert wird je nach Ort des Passes, der Art (Flanke, Durchschuss, Einwurf...), dem Zustand des Spiels usw. zugewiesen. Im Gegensatz zu xG ist xA eine Kennzahl, die im Idealfall höher ist als die Anzahl der Assists, da ein Spieler nur die Qualität seiner Pässe (xA) kontrollieren kann, während die Anzahl der Assists vom Torschützen abhängt.',
      xGChain: 'Anzahl an xG in denen ein Spieler involviert war ',
      xGBuildup: 'Ähnlich wie xG Chain, aber ohne Berücksichtigung der letzten 2 Spieler der Sequenz (ohne Schüsse und Pässe, die zu einem Schuss führen)',
      xGBuildupInTeam: 'xG Aufbau in Team',
      BallProgression: 'Anzahl der Vorstöße des Spielers über 10 oder mehr Meter, entweder durch Passen, Tragen oder eine Kombination aus beidem',
      SuccessfulDribbles: 'Anzahl an erfolgreichen Dribblings',
      Dispossessed: 'Anzahl an dem ein Spieler den Ball verloren hat durch einen Zweikampf',
      TouchesInOpponentBox: 'Anzahl der Ballkontakte eines Spielers im gegnerischen Strafraum',
      xGSavedPerShot: 'Durchschnittliche Wahrscheinlichkeit eines kassierten Tores durch Schüsse aufs Tor',
      BallRetentionOppHalf: 'Prozentsatz der Zeit, in der du in Ballbesitz bist und den Ball nicht in der gegnerischen Hälfte verlierst',
      DeepProgression: 'Anzahl der Male, die ein Spieler das letzte Drittel des Spielfelds erreicht, indem er den Ball führt, plus die Anzahl der Male, die der Spieler im letzten Drittel in Ballbesitz ist',
      DeepProgressionFinalThird: 'Anzahl der Male, die ein Spieler das letzte Drittel des Spielfelds erreicht, indem er den Ball trägt, plus die Anzahl der Male, die der Spieler im letzten Drittel in Ballbesitz ist',
      FoulsTaken: 'Anzahl von Fouls die ein Spieler kassiert hat',
      PenaltiesTaken: 'Anzahl von Fouls die ein Spieler in dem gegnerischen Strafraum kassiert hat,',
      BlockedCrosses: 'Anzahl an Flanken blockiert durch den Spieler',
      BlockedShots: 'Anzahl an geblockten Schüssen durch den Spieler',
      NonPenaltyGoalsAgainst: 'Anzahl an Toren (ohne Elfmeter) kassiert',
      GoalsConceded: 'Anzahl der kassierten Tore',
      Headers: 'Kopfbälle',
      HeadedGoals: 'Anzahl der mit dem Kopf erzielten Tore',
      Points: 'Anzahl der vom Team erreichten Punkte',
      SavesInBox: 'Anzahl der Paraden von Schüssen innerhalb des Strafraums',
      SavesOutBox: 'Anzahl der Paraden durch Schüsse außerhalb des Strafraums',
      ShotsOnTargetInBoxAgainst: 'Anzahl der kassierten Torschüsse aus dem Strafraum',
      ShotsOnTargetOutBoxAgainst: 'Anzahl der kassierten Torschüsse von außerhalb des Strafraums',
      AveragePassDistance: 'Durchschnittliche Pass Distanz',
      ProgressiveRuns: 'Progressive Läufe',
      xT: 'Voraussichtliche Gefahr (xT) ist eine Messung die die Gefahr eines Spielers der durch dribbling oder Pässen in gefährliche Zonen spielt und dadurch eine hohe Wahrscheinlichkeit von einem Tor produziert',
      xTOpenPlay: 'Voraussichtliche Gefahr die aus dem Spiel heraus entstanden sind',
      xTSetPiece: 'Voraussichtliche Gefahr die durch standard situationen entstanden sind',
      xGOT: 'Voraussichtliche Tore pro Torschuss. Diese Messung misst nur die Schüsse die ein Torwart halten muss (verfehlte Schüsse und gegen das Aluminium werden ausgelassen)',
      BadActions: 'Summe der schlechten Aktionen',
      BadActionsOwnHalf: 'Summe der schlechten Aktionen in eigener Hälfte',
      AerialsWonOwnBox: 'Luftduelle gewonnen im eigenen Strafraum',
      AerialsWonOppBox: 'Aerials Won Opp Box',
      AerialsTotalOppBox: 'Aerials Total Opp Box',
      AerialsTotalOwnBox: 'Aerials Total Own Box',
      FoulsOwnHalfPct: 'Prozentsatz der Fouls in der eigenen Hälfte',
      RecoveriesOppHalf: 'Anzahl an balleroberungen von einem spieler in der gegnerischen hälfte',
      DuelsPct: 'Prozentsatz an erfolgreichen Duellen',
      TacklesUnsuccessful: 'Häufigkeit, mit der es einem Spieler nicht gelingt, den Ball zu erobern, weil ein Gegner erfolgreich an ihm vorbei dribbelt',
      TacklesWasDribbledFirstThird: 'Prozentsatz der Balleroberungen, wenn der Spieler im letzten Drittel steht',
      TacklesWasDribbledSecondThird: 'Gewonnene defensive Eins-gegen-Eins-Duelle ⅔',
      TacklesWasDribbledFinalThird: 'Gewonnene defensive Eins-gegen-Eins-Duelle Ende ⅓',
      BallProgressionFinalThird: 'Ballbesitz im letzten Drittel',
      DuelsTotal: 'Gesamtzahl der Tackles, Aerials, Ballberührungen, Dribblings und Fouls',
      QuickRecoveries: 'Schnelle Ballzurückeroberung',
      ShotsPerNPG: 'Durchschnittliche Anzahl von Schüssen, um ein Tor (nicht Elfmeter) zu erzielen',
      ShotsOutBox: 'Anzahl der Schüsse von außerhalb des Strafraumss',
      GoalsOutBox: 'Anzahl der Tore von außerhalb des Strafraums',
      ShootingOutBox: 'Prozentsatz der Torschüsse von außerhalb des Strafraums',
      HandPassing: 'Abwurfgenauigkeit',
      Catching: 'Prozentsatz der Paraden, bei denen der Torhüter den Ball fängt',
      Caught: 'Speichert, wo der Torwart den Ball fängt und hält, und verhindert so ein zweites Spiel',
      ClaimAccuracy: 'Misst die Qualität des Torwarts beim Fangen/Abwehren eines Balles. Eine Nummer über 1 bedeutet das der Torwart mehr Bälle fängt als erwartet',
      HighTurnovers: 'Ballverluste näher als 40 Meter vor dem eigenen Tor',
      ShotEndingHighTurnovers: 'Hohe Ballverluste (Ballverluste näher als 40 Meter vor dem eigenen Tor, die mit einem Schuss des gegnerischen Teams enden)',
      GoalEndingHighTurnovers: 'Hohe Ballverluste (Ballverluste näher als 40 Meter vor dem eigenen Tor, die mit einem Tor des gegnerischen Teams enden)',
      AverageCarriesProgress: 'Durchschnittliche Distanz die ein Spieler den Ball vertikal bewegt pro Dribbling (Meter)',
      ChanceEndingCarries: 'Dribblings von mindestens 7 Metern das mit einem Schuss-gefolgtem Pass enden',
      AssistEndingCarries: 'Dribblings von mindestens 7 Metern die mit einer Vorlage enden',
      ShotEndingCarries: 'Dribblings von mindestens 7 Metern die mit einem Schuss enden',
      GoalEndingCarries: 'Dribblings von mindestens 7 Metern die mit einem Tor enden',
      ShotEndingSequence: 'Sequenzen die mit einem Schuss enden',
      GoalEndingSequence: 'Sequenzen die mit einem Tor enden',
      xGPerNPG: 'xG für Tore ohne Strafen',
      AerialWonOffensive: 'Gewonnene Offensiv-Luftduelle',
      AerialWonDefensive: 'Gewonnene Defensiv-Luftduelle',
      xGAgainst: 'Erwartete gegentore',
      xGDiffAgainst: 'Erwartete gegentore diff',
      xGPerNPGAgainst: 'Erwartete Gegentore (ohne Elfmeter)',
      xGSetPieceAgainst: 'Erwartete gegentore aus einer standard situation heraus',
      xGOpenPlayAgainst: 'xG Kassiert aus dem spiel heraus',
      xGPerShotAgainst: 'Erwartete Gegentore aus Schüssen auf das Tor',
      ShotsAgainst: 'Anzahl an Schüssen auf das eigene Tor',
      ShotsOnTargetAgainst: 'Anzahl der kassierten Torschüsse',
      RivalPossession: 'Ballbesitz des Gegners',
      AerialDefensivePct: 'Prozentsatz der gewonnenen defensiven Luftduelle',
      HighRecoveries: 'Balleroberung von 40 Metern vor dem gegnerischen Tor',
      HighDefensiveActions: 'Verteidigungsaktionen (Tackles, Interceptions, Blocks, Fouls und 1vs1) erfolgten 40 Meter über der eigenen Grundlinie',
      HighDefensiveActionPct: 'Prozentsatz der Defensivaktionen (Tackles, Interceptions, Blocks, Fouls und 1vs1), die 40 Meter über die eigene Grundlinie hinausgehen',
      HighDefensiveDistance: 'Durchschnittliche Entfernung vom eigenen Tor bei allen Defensiv-Aktionen',
      PassesPerPossession: 'Pässe pro Ballbesitz',
      LengthPerPossession: 'Laufstrecke pro Ballbesitz',
      xTNet: 'Net xT',
      AvgCarriesDistance: 'Durchschnittliche Distanz pro Ballführung',
      PassesForwardPct: '% Pässe gehen vorwärts',
      PassesForwardSuccessful: 'Erfolgreiche Vorwärtspässe',
      PassesForwardTotal: 'Gesamtzahl der Vorwärtspässe',
      TacklesAttempted: 'versuchte Tacklings',
      DuelsLost: 'verlorene Duelle',
      Carries: 'Ballführung',
      CarriesPct: '% Ballmitnahmen',
      Aerials: 'Luftduelle',
      ProgressivePassesReceivedIntoBox: 'Progressive Pässe werden in den Strafraum gespielt',
      PassesOppHalf: 'Gesamtzahl der erfolgreichen Pässe, die in der gegnerischen Hälfte landen',
      ShotsOnTarget: 'Schüsse auf\'s Tor',
      AggressiveActions: 'Anzahl der Tacklings, die in den nächsten zwei Sekunden nach dem Ballbesitzverlust versucht werden',
      Crosses: 'Gesamtzahl der Flanken',
      xGBuildup5pass: 'Anzahl der xG, an denen ein Spieler beteiligt war, nur die letzten 5 Pässe (ohne Schüsse und Pässe',
      DefensiveDistance: 'Average distance to own goal of defensive duels performed',
      SpeedSequence: 'Durchschnittliche Geschwindigkeit (zurückgelegte Meter pro verbrauchte Zeit) aller Ballbesitzzeiten einer Mannschaft',
      Touches: 'Anzahl der Ballkontakte eines Spielers Spielzeit',
      AerialsTotalOppHalf: 'Luftduelle Gesamt in Gegnerischer Hälfte',
      AerialsWonOppHalf: 'Erfolgreiche Luftduelle in die gegnerische Hälfte',
      AerialsWonOppHalfPct: 'Prozentualer Anteil der gewonnenen Luftduelle in der gegnerischen Hälfte',
      AerialsPctOppBox: 'Prozentsatz der gewonnenen Luftduelle im gegnerischen Strafraum',
      AerialsPctOwnBox: 'Prozentsatz der gewonnenen Luftduelle im eigenen Strafraum',
      AerialDefensive: 'Gesamtzahl der Aerials, wenn das gegnerische Team in Ballbesitz ist',
      AerialOffensive: 'Gesamtzahl der Aerials, wenn die eigene Mannschaft in Ballbesitz ist',
      AerialOffensivePct: 'Prozentualer Anteil der gewonnenen Aerials, wenn die eigene Mannschaft in Ballbesitz ist',
      IndividualPressureOppHalf: 'Metrik, die die Anzahl der erfolgreichen Bemühungen (zurückgewonnener Ballbesitz) eines Spielers beim Pressing des Gegners in der gegnerischen Hälfte misst',
      ChancesCreatedOP: 'Anzahl der Pässe, die zu einem Schuss führen, Spielzeit',
      TouchesPerShot: 'Anzahl der Ballberührungen der Spieler pro Schuss',
      PassesFinalThirdTotalPct: 'Prozentsatz der erfolgreichen Pässe ins letzte Drittel',
      xACrosses: 'Erwartete Assists aus Flanken',
      Passes: 'Gesamtzahl der Pässe Spielzeit',
      PassesSuccessful: 'Anzahl der abgeschlossenen Pässe Spielzeit',
      TacklesWasDribbledFouls: 'Prozentualer Anteil der gewonnenen Zweikämpfe an den insgesamt begangenen Zweikämpfen und Fouls',
      OffsidesCaught: 'Abseits',
      ProgressivePassesReceivedFinalThird: 'Progressive Pässe angenommen im letzten Drittel',
      ProgressivePassesReceived: 'Progressive Pässe angenommen',
      Breadth: 'Sum of Tackles, Challenges, Interceptions and Fouls Committed, on the sides of the field',
      DuelsDefTotal: 'Defensive Duelle',
      DefensiveActions: 'Defensive Aktionen',
      ProgressivePassesReceivedOppHalf: 'Progressive Pässe angekommen in der gegnerischen Hälfte',
      CompletedCrossesOP: 'angekommene Flanken aus dem freien Spiel heraus',
      CrossingOP: '% Flanken aus dem freien Spiel heraus',
      CrossesOP: 'Gesamtzahl der Flanken im offenen Spiel',
      PassingContribution: '% Passing Contribution',
      BallProgressionOppHalfInTeam: '% Ball Progression Opp. Half in Team',
      PassesOPIntoBoxInTeam: '% Passes Open Play into Box in Team',
      TouchesOppBoxInTeam: '% Touches Opp. Box in Team',
      xGOPInTeam: '% xG Open Play in Team',
      DeepPasses: 'Passes from outside a 20-metre radius of the opponent goal that end inside that area',
      DeepPassesTotal: 'Gesamtzahl der versuchten Pässe von außerhalb eines 20-Meter-Radius um das gegnerische Tor, die innerhalb dieses Bereichs enden',
      DefensiveDuelsPct: 'Percentage of defensive duels won out of total defensive duels',
      QuickRecoveriesPct: 'Percentage of quick recoveries to interceptions and attempted tackles',
      DiffDefensiveDistanceTeam: 'Difference between the player\'s defensive distance and his team\'s defensive distance',
      xTPassing: 'Expected threat generated only from passes',
      xTPassing100Passes: 'Expected threat generated only from passes and per 100 passes',
      ProgressivePassesAccurate: 'Completed passes of 10 meters or more in the X-axis',
      PassAbility: 'Ratio of completed passes to expected passes (xP)',
      OPPassesIntoOppBoxPct: 'Percentage of open play completed passes into the opponent box and open play attempted passes into the opponent box',
      EntriesOppBox: 'Number of passes and carries into the opponent box',
      Crosses6yardBox: 'Total number of crosses ending in the six-yard box',
      Cutbacks: 'Passing from baseline to back and inside the opponent box',
      xTDribbling: 'Expected threat generated only from dribbles',
      AvgShotDistance: 'Average distance of the total number of shots taken',
      xGOnTarget: 'Expected goals from shots made on target',
      FinishingxGOT: 'Percentage of shots on target ending in a goal',
      DribblesWonOwnHalf: 'Number of successful dribbles made in own half',
      DribblesOwnHalf: 'Number of attempted dribbles made in own half',
      DribblesOwnHalfPct: 'Percentage of successful dribbles and attempted dribbles made in own half',
      DribblesWonOppHalf: 'Number of successful dribbles made in opponent half',
      DribblesOppHalf: 'Number of attempted dribbles made in opponent half',
      DribblesOppHalfPct: 'Percentage of successful dribbles and attempted dribbles made in opponent half',
      DribblesWonFinalThird: 'Number of successful dribbles made in the final third',
      DribblesFinalThird: 'Number of attempted dribbles made in the final third',
      DribblesFinalThirdPct: 'Percentage of successful dribbles and attempted dribbles made in the final third',
      ShotEndingHighRecoveries: 'Hohe Ballgewinne (innerhalb von 40 Metern zum gegnerischen Tor), die mit einem Schuss enden',
      PassingFinalThirdAgainst: 'Erfolgreiche Pässe des Gegners ins letzte Drittel',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Gesamtzahl der Pässe des Gegners in unseren Strafraum im offenen Spiel',
      EntriesOppBoxAgainst: 'Anzahl der Pässe und Dribblings des Gegners in unseren Strafraum',
      DeepProgressionAgainst: 'Anzahl der Ballführungen des Gegners ins letzte Fünftel plus Ballbesitz im ersten Fünftel des Spielfelds',
      TouchesInOpponentBoxAgainst: 'Anzahl der Ballkontakte des Gegners in unserem Strafraum',
      Score: 'Spielerleistung auf der grundlage verschiedener metriken',
      PDScore: 'Physische Leistung der Spieler auf der Grundlage verschiedener physischer metriken',
      OrlegiScore: 'Spielerleistung auf der grundlage verschiedener metriken',
      SirScore: 'Spielerleistung auf der grundlage verschiedener metriken',
      ExcScore: 'Spielerleistung auf der grundlage verschiedener metriken',
      xTOPInTeam: 'Erwartete Gefahr (xT), die im Spiel erzeugt wird, im Verhältnis zur Gesamtzahl der Spieler Ihres Teams',
      YellowCards: 'Gelbe Karten',
      RedCards: 'Rote Karten',
      xTOpenPlayAgainst: 'Erwartete Bedrohung im offenen Spiel',
      xTSetPieceAgainst: 'Erwartete Bedrohung durch Spielfiguren',
      NPGOpenPlayAgainst: 'TOE Kassiert aus dem Spiel Heraus',
      NPGSetPieceAgainst: 'TOE Kassiert Standardsituationen',
      PassesOppHalfPerPossession: 'Pässe Gegnerische Hälfte pro Ballbesitz',
      AverageTimeRecovery: 'Durchschnittliche Wiederherstellungszeit',
      ExpectedPassing: 'Prozentsatz der Pässe, die hätten abgeschlossen werden sollen',
      NumPossession10Passes: 'Besitzt 10 Pässe',
      PassesReceived: 'Empfangene Pässe',
      PassesReceivedFinalThird: 'Empfangene Pässe Final ⅓',
      ProgressivePassesTotalPct: '% Progressive Pässe',
      ShortPassesPct: '% Kurzpässe',
      TouchesOppBoxOppTeam: 'Anzahl der gegnerischen Aktionen im eigenen Strafraum, während der Spieler auf dem Platz ist',
      ShotsOnTargetOppTeam: 'Schüsse aufs Tor, die zugelassen wurden, während der Spieler auf dem Platz ist',
      NPGOppTeam: 'Gegentore ohne Elfmeter, während der Spieler auf dem Platz ist',
      xGSetPiecePerxG: 'Erwartete Tore aus Standardsituationen pro erwartetem Tor',
      ShotsOpenPlay: 'Anzahl der Torschüsse aus dem offenen Spiel',
      ShotsOpenPlayAgainst: 'Anzahl der gegnerischen Torschüsse aus dem offenen Spiel',
      ShotsFromDribble: 'Schüsse nach dem Dribbling eines Gegenspielers',
      GoalsFromDribble: 'Tore nach dem Dribbling eines Gegenspielers',
      PassesIntoFinalThird: 'Erfolgreiche Pässe aus dem letzten Drittel',
      PassesIntoFinalThirdTotal: 'Gesamtzahl der versuchten Pässe, die außerhalb beginnen und innerhalb des letzten Drittels enden',
      PassesInsideFinalThird: 'Erfolgreiche Pässe innerhalb des letzten Drittels (Start und Ende im letzten Drittel)',
      PassesInsideFinalThirdTotal: 'Gesamtzahl der versuchten Pässe im letzten Drittel (Beginn und Ende im letzten Drittel)',
      PassesFinalThirdNoArea: 'Besteht das letzte Drittel (ohne Box)',
      PassesIntoOppBox: 'Erfolgreiche Pässe, die im gegnerischen Strafraum enden',
      CarriesFinalThird: 'Dribblings von mindestens 7 Metern, die im letzten Drittel enden',
      CarriesInsideFinalThird: 'Dribblings von mindestens 7 Metern innerhalb des letzten Drittels (Start und Ende im letzten Drittel)',
      CarriesFinalThirdNoBox: 'Trägt das letzte Drittel (ohne Box)',
      CarriesIntoOppBox: 'Dribblings von mindestens 7 Metern, die im gegnerischen Strafraum enden',
      TimePossessionAgainst: 'Ballbesitzzeit des gegnerischen Teams',
      TimePossessionTotal: 'Ballbesitzzeit beider Teams',
      PassesInBox: 'Erfolgreiche Pässe, die im gegnerischen Strafraum beginnen',
      LongThrowInSuccessful: 'Erfolgreicher langer Einwurf von der Seitenlinie, über 20 Meter weit',
      LongThrowInTotal: 'Gesamte lange Einwürfe von der Seitenlinie, über 20 Meter weit',
      LongThrowInPct: 'Prozentsatz erfolgreicher langer Einwürfe (über 20 Meter)',
      Games: 'Gespielte Spiele',
      PointsPerGame: 'Punkte pro Spiel',
      ExpectedPointsDiff: 'Erwartete Punktedifferenz',
      PassesTotalOwnHalf: 'Gesamtzahl der Pässe aus der eigenen Hälfte',
      PassesOwnHalf: 'Anzahl erfolgreicher Pässe aus der eigenen Hälfte',
      PassesTotalOppHalf: 'Gesamtzahl der Pässe aus der gegnerischen Hälfte',
      ProgressivePassesTotal: 'Gesamtzahl der Durchgänge von 10 Metern oder mehr auf der X-Achse',
      DuelsWon: 'Erfolgreiche Zweikämpfe (Tackles, Aerials, Ballberührungen, Dribblings und begangene Fouls)',
      NonPenaltySaves: 'Paraden ohne Strafschüsse',
      BadActionsOppHalf: 'Summe aller in der gegnerischen Hälfte begangenen Fehlaktionen (Pass fehlgeschlagen, Annehmen fehlgeschlagen, Besitzenteignung, Abseitspass, Ballberührung erfolglos).',
      CarriesSuccessful: 'Anzahl der Tragevorgänge von mindestens 7 Metern, die mit einem erfolgreichen Event enden',
      ShotsOnTargetOutBox: 'Schüsse aufs Tor von außerhalb des Strafraums',
      TotalDistance: 'Gesamtdistanz, die der Spieler während eines Spiels zurückgelegt hat',
      WalkingDistance: 'Gesamtdistanz, die der Spieler während eines Spiels mit einer Geschwindigkeit unter 2 m/s (7,2 km/h) zurückgelegt hat',
      JoggingDistance: 'Gesamtdistanz, die der Spieler während eines Spiels mit einer Geschwindigkeit zwischen 2 m/s (7,2 km/h) und 4 m/s (14,4 km/h) zurückgelegt hat',
      RunningDistance: 'Gesamtdistanz, die der Spieler während eines Spiels mit einer Geschwindigkeit zwischen 4 m/s (14,4 km/h) und 5,5 m/s (19,8 km/h) zurückgelegt hat',
      ExtremeAccelerations: 'Anzahl der Male, dass der Spieler mehr als 3 m/s² beschleunigt hat',
      NumberOfRuns: 'Anzahl der Läufe, die der Spieler mit einer Geschwindigkeit zwischen 4 m/s (14,4 km/h) und 5,5 m/s (19,8 km/h) abgeschlossen hat',
      DistanceTIP: 'Distanz (Team im Besitz), die der Spieler während eines Spiels im Besitz zurückgelegt hat',
      DistanceOTIP: 'Distanz OTIP (Gegnerisches Team im Besitz), die der Spieler während eines Spiels ohne Besitz zurückgelegt hat',
      HsrNumber: 'Anzahl der Male, dass der Spieler mit einer Geschwindigkeit, die gleich oder höher als 5,5 m/s (19,8 km/h) aber weniger als 7 m/s (25,2 km/h) für eine Zeitspanne von mindestens einer Sekunde ist, sich bewegt hat',
      HsrDistance: 'Gesamtdistanz, die der Spieler während eines Spiels mit einer Geschwindigkeit, die gleich oder höher als 5,5 m/s (19,8 km/h) aber weniger als 7 m/s (25,2 km/h) ist, zurückgelegt hat',
      HsrDistancePct: 'Prozentsatz der HSR (High Speed Run) Distanz bezogen auf die gesamte zurückgelegte Distanz',
      SprintsNumber: 'Anzahl der Male, dass der Spieler mit einer Geschwindigkeit, die gleich oder höher als 7 m/s (25,2 km/h) für eine Zeitspanne von mindestens einer Sekunde ist, sich bewegt hat',
      SprintsDistance: 'Gesamtdistanz, die der Spieler während eines Spiels mit einer Geschwindigkeit, die gleich oder höher als 7 m/s (25,2 km/h) ist, zurückgelegt hat',
      SprintNumberDeclinePct: 'Prozentuale Abnahme der Anzahl der Sprints im Vergleich zur zweiten Halbzeit des Spiels',
      SprintDistanceDeclinePct: 'Prozentuale Abnahme der im Sprint zurückgelegten Distanz im Vergleich zur zweiten Halbzeit des Spiels',
      SprintNumberDecline: 'Abnahme der Anzahl der Sprints im Vergleich zur zweiten Halbzeit des Spiels',
      SprintDistanceDecline: 'Abnahme der im Sprint zurückgelegten Distanz im Vergleich zur zweiten Halbzeit des Spiels',
      SprintDistancePct: 'Prozentsatz der Sprintdistanz bezogen auf die gesamte zurückgelegte Distanz',
      Accelerations: 'Anzahl der Male, dass der Spieler zwischen 1,5 m/s² und 3 m/s² beschleunigt hat',
      ExplosiveDistance: 'Explosive Distanz',
      MaxSpeed: 'Maximal erreichte Geschwindigkeit des Spielers',
      AvgMaxSpeed: 'Durchschnitt der maximal erreichten Geschwindigkeit des Spielers',
      MaxAccelerations: 'Maximale Beschleunigung in Meter/Sekunde², die der Spieler erreicht hat',
      BypassedPlayersByPasses: 'Anzahl der Spieler auf der Torseite des Ballführenden zu Beginn des Ballkontakts minus der Anzahl der Spieler auf der Torseite am Ende des Ballkontakts',
      BypassedDefendersByPasses: 'Anzahl der Verteidiger auf der Torseite des Ballführenden zu Beginn des Ballkontakts minus der Anzahl der Verteidiger auf der Torseite am Ende des Ballkontakts',
      PassesBypassingPlayers: 'Anzahl der Pässe, die Spieler überspielt haben',
      PassesBypassingDefenders: 'Anzahl der Pässe, die Verteidiger überspielt haben',
      BypassedPlayersPerPass: 'Gesamtzahl der überspielten Spieler pro Pass',
      BypassedDefendersPerPass: 'Gesamtzahl der überspielten Verteidiger pro Pass',
      LineBreakingPasses: 'Abgeschlossene Pässe, die den Ball mindestens 10% näher zum gegnerischen Tor bringen und entweder eine Verteidigerpaarung durchkreuzen oder hinter der Verteidigungslinie landen',
      LineBreakingPassesMD: 'Erfolgreiche Pässe, die Mittelfeld- und Abwehrlinien durchbrechen',
      LineBreakingPassesM: 'Erfolgreiche Pässe, die die Mittelfeldlinie durchbrechen',
      LineBreakingThroughBalls: 'Erfolgreiche Pässe, die die Abwehrlinie durchbrechen',
      LineBreakingPassesPerPass: 'Anzahl der durch einen Pass durchbrochenen Linien',
      TotalPassesUnderStrongPressure: 'Gesamtanzahl der Pässe unter starkem Druck (im Bereich von 0-2 Metern zum nächsten Gegner)',
      TotalPassesUnderLightPressure: 'Gesamtanzahl der Pässe unter leichtem Druck (im Bereich von 2-4 Metern zum nächsten Gegner)',
      SuccessfulPassesUnderStrongPressure: 'Anzahl erfolgreicher Pässe unter starkem Druck (im Bereich von 0-2 Metern zum nächsten Gegner)',
      SuccessfulPassesUnderLightPressure: 'Anzahl erfolgreicher Pässe unter leichtem Druck (im Bereich von 2-4 Metern zum nächsten Gegner)',
      PassingUnderStrongPressure: 'Prozentsatz erfolgreicher und aller Pässe unter starkem Druck (im Bereich von 0-2 Metern zum nächsten Gegner)',
      PassingUnderLightPressure: 'Prozentsatz erfolgreicher und aller Pässe unter leichtem Druck (im Bereich von 2-4 Metern zum nächsten Gegner)',
      PassReceiptsInSpaceCompleted: 'Pässe, bei denen der Empfänger in der Angriffszone ist und sich kein Verteidiger in einem Umkreis von 5 Metern in Richtung Tor befindet',
      PassReceiptsInSpace: 'Erhaltene Pässe in der Angriffszone, bei denen sich kein Verteidiger in einem Umkreis von 5 Metern in Richtung Tor befindet',
      PassReceiptsInSpaceCompletedFirstThird: 'Pässe, bei denen der Empfänger im ersten Drittel ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedSecondThird: 'Pässe, bei denen der Empfänger im zweiten Drittel ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedFinalThird: 'Pässe, bei denen der Empfänger im letzten Drittel ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Pässe, bei denen der Empfänger in der gegnerischen Hälfte (rechte Seite) ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Pässe, bei denen der Empfänger in der gegnerischen Hälfte (zentrales Feld) ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Pässe, bei denen der Empfänger in der gegnerischen Hälfte (linke Seite) ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceFirstThird: 'Pässe, die im ersten Drittel empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceSecondThird: 'Pässe, die im zweiten Drittel empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceFinalThird: 'Pässe, die im letzten Drittel empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceOppHalfRight: 'Pässe, die in der gegnerischen Hälfte (rechte Seite) empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceOppHalfCenter: 'Pässe, die in der gegnerischen Hälfte (zentrales Feld) empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceOppHalfLeft: 'Pässe, die in der gegnerischen Hälfte (linke Seite) empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      TotalStrongOnBallPressures: 'Anzahl der starken Drucksituationen auf den Ballführenden (im Bereich von 0-2 Metern)',
      TotalLightOnBallPressures: 'Anzahl der Drucksituationen auf den Ballführenden (im Bereich von 2-4 Metern)',
      SuccessfulStrongOnBallPressures: 'Anzahl erfolgreicher starker Drucksituationen auf den Ballführenden (im Bereich von 0-2 Metern)',
      SuccessfulLightOnBallPressures: 'Anzahl erfolgreicher Drucksituationen auf den Ballführenden (im Bereich von 2-4 Metern)',
      StrongOnBallPressuresPct: 'Prozentsatz erfolgreicher starker Drucksituationen (im Bereich von 0-2 Metern zum nächsten Gegner)',
      LightOnBallPressuresPct: 'Prozentsatz erfolgreicher Drucksituationen (im Bereich von 2-4 Metern zum nächsten Gegner)',
      TimesBypassedByPasses: 'Gesamtzahl der Male, bei denen der Spieler per Pass überspielt wurde',
      TimesBypassedByCarries: 'Gesamtzahl der Male, bei denen der Spieler per Dribbling überspielt wurde',
      TimesBypassedByActions: 'Gesamtzahl der Male, bei denen der Spieler per Pass und Dribbling kombiniert überspielt wurde',
      BypassedPlayersByCarries: 'Gesamtzahl der Gegner (Verteidiger und Mittelfeldspieler), die durch Dribblings überspielt wurden',
      BypassedDefendersByCarries: 'Gesamtzahl der Verteidiger, die durch Dribblings überspielt wurden',
      BypassedPlayersByActions: 'Gesamtzahl der Gegner (Verteidiger und Mittelfeldspieler), die durch Pässe und Dribblings kombiniert überspielt wurden',
      BypassedDefendersByActions: 'Gesamtzahl der Verteidiger, die durch Pässe und Dribblings kombiniert überspielt wurden',
      CarriesBypassingPlayers: 'Anzahl der Dribblings, die Spieler überspielt haben',
      CarriesBypassingDefenders: 'Anzahl der Dribblings, die Verteidiger überspielt haben',
      BypassedPlayersPerCarry: 'Durchschnittlich überspielte Gegner pro Dribbling',
      BypassedDefendersPerCarry: 'Durchschnittlich überspielte Verteidiger pro Dribbling',
      LineBreakingCarries: 'Anzahl der Dribblings, die erfolgreich eine oder mehrere Linien durchbrechen',
      LineBreakingCarriesMD: 'Anzahl der Dribblings, die Mittelfeld- und Abwehrlinien durchbrechen',
      LineBreakingCarriesM: 'Anzahl der Dribblings, die die Mittelfeldlinie durchbrechen',
      LineBreakingCarriesD: 'Anzahl der Dribblings, die die Abwehrlinie durchbrechen',
      LineBreakingCarriesPerCarry: 'Prozentsatz der Linien durchbrechenden Dribblings pro Dribbling',
      LineBreakingActions: 'Anzahl der Pässe und Dribblings kombiniert, die erfolgreich eine oder mehrere Linien durchbrechen',
      LineBreakingActionsMD: 'Anzahl der Pässe und Dribblings kombiniert, die Mittelfeld- und Abwehrlinien durchbrechen',
      LineBreakingActionsM: 'Anzahl der Pässe und Dribblings kombiniert, die die Mittelfeldlinie durchbrechen',
      LineBreakingActionsD: 'Anzahl der Pässe und Dribblings kombiniert, die die Abwehrlinie durchbrechen',
      PassesPerLineBreakingPass: 'Verhältnis von Gesamtpässen pro linienbrechendem Pass',
      CarriesPerLineBreakingCarry: 'Verhältnis von Gesamtdribblings pro linienbrechendem Dribbling',
      LinesBrokenByPasses: 'Gesamtanzahl der durch Pässe gebrochenen Linien',
      LinesBrokenByCarries: 'Gesamtanzahl der durch Dribblings gebrochenen Linien',
      LinesBrokenByActions: 'Gesamtanzahl der durch Pässe und Dribblings gebrochenen Linien',
      LinesBrokenPerPass: 'Durchschnittlich gebrochene Linien pro Pass',
      LinesBrokenPerCarry: 'Durchschnittlich gebrochene Linien pro Dribbling',
      AvgLastDefenderDistanceIP: 'Abstand zwischen dem letzten Verteidiger (nächster zum eigenen Tor) und der Torlinie bei Ballbesitz',
      AvgLastDefenderDistanceOOP: 'Abstand zwischen dem letzten Verteidiger (nächster zum eigenen Tor) und der Torlinie ohne Ballbesitz',
      AvgDefensiveLineDistanceIP: 'Abstand zwischen der tiefsten Abwehrlinie und dem Tor bei Ballbesitz',
      AvgDefensiveLineDistanceOOP: 'Abstand zwischen der tiefsten Abwehrlinie und dem Tor ohne Ballbesitz',
      AvgRBDistanceIP: 'Abstand vom rechten Außenverteidiger zum eigenen Tor bei Ballbesitz',
      AvgRBDistanceOOP: 'Abstand vom rechten Außenverteidiger zum eigenen Tor ohne Ballbesitz',
      AvgLBDistanceIP: 'Abstand vom linken Außenverteidiger zum eigenen Tor bei Ballbesitz',
      AvgLBDistanceOOP: 'Abstand vom linken Außenverteidiger zum eigenen Tor ohne Ballbesitz',
      AvgBlockDistanceIP: 'Abstand zwischen dem tiefsten und dem vordersten Feldspieler bei Ballbesitz',
      AvgBlockDistanceOOP: 'Abstand zwischen dem tiefsten und dem vordersten Feldspieler ohne Ballbesitz',
      AvgBlockAreaIP: 'Fläche des Rechtecks, das alle Feldspieler umfasst (Maß für die genutzte Raumfläche) bei Ballbesitz',
      AvgBlockAreaOOP: 'Fläche des Rechtecks, das alle Feldspieler umfasst (Maß für die genutzte Raumfläche) ohne Ballbesitz',
      AvgDefensiveLineWidthOOP: 'Breite der hintersten Spielerlinie (am weitesten vom eigenen Tor entfernt) ohne Ballbesitz',
      AvgOffensiveLineLastThirdWidthIP: 'Horizontale Breite der Offensivlinie im letzten Drittel bei Ballbesitz',
      AvgLByIP: 'Position des linken Außenverteidigers bei Ballbesitz',
      AvgRByIP: 'Position des rechten Außenverteidigers bei Ballbesitz',
      AvgOffensiveLineDistanceIP: 'Abstand zwischen dem eigenen Tor und der Offensivlinie bei Ballbesitz',
      AvgOffensiveLineLastThirdDistanceIP: 'Abstand zwischen dem eigenen Tor und der Offensivlinie im letzten Drittel bei Ballbesitz',
      AvgOffensiveLineWidthIP: 'Horizontale Breite der Offensivlinie bei Ballbesitz',
      OffBallRuns: 'Gezielte Laufwege ohne Ball zur Unterstützung der Angriffsphase',
      OffBallRunsOverlap: 'Läufe, bei denen der Spieler außen (näher zur Seitenlinie) um einen Mitspieler läuft, der den Ball hat',
      OffBallRunsUnderlap: 'Läufe, bei denen der Spieler auf der Innenseite eines Mitspielers läuft, näher zur Spielfeldmitte',
      OffBallRunsRunAhead: 'Vorstoß, der den Ballträger überholt, aber vor dem letzten Verteidiger bleibt',
      OffBallRunsRunBehind: 'Lauf in die Tiefe hinter die Abwehrkette zwischen Verteidigern und Torwart',
      OffBallRunsCrossReceiver: 'Ein Spieler läuft in den Strafraum, um eine Flanke von einem Mitspieler zu empfangen',
      OffBallRunsSupport: 'Der Spieler läuft auf Höhe des Ballträgers, um eine nahe Passoption zu bieten',
      OffBallRunsComingShort: 'Der Spieler läuft dem Ballträger entgegen, um nahen Support oder Rückpassoption zu bieten',
      AerialsOppHalf: 'Luftzweikämpfe in der gegnerischen Hälfte',
      CarriesIntoFinalThird: 'Rohrleitungen von mindestens 7 Metern von außen nach innen im letzten Drittel',
      SpeedScore: 'Die körperliche Leistung des Spielers basierend auf verschiedenen Geschwindigkeitsmetriken',
      EnduranceScore: 'Die körperliche Ausdauerleistung der Spieler basierend auf verschiedenen Kennzahlen',
      SwitchPlaySuccessful: 'Anzahl der abgeschlossenen Pässe über 32 Meter, bei denen die seitliche Verschiebung des Balls größer ist als seine Verschiebung in Richtung des gegnerischen Tors',
      SwitchPlayTotal: 'Gesamtzahl der versuchten Pässe über 32 Meter, bei denen die seitliche Verschiebung des Balls größer ist als seine Verschiebung in Richtung des gegnerischen Tors',
      PassesInsideOppHalf: 'Gesamtzahl der Pässe, die sowohl in der gegnerischen Hälfte beginnen als auch enden',
      PassesInsideOppHalfSuccessful: 'Anzahl der abgeschlossenen Pässe, die sowohl in der gegnerischen Hälfte beginnen als auch enden',
      TacklesAttemptedFirstThird: 'Gesamtzahl der Tacklingversuche im ersten Spielfelddrittel',
      TacklesAttemptedSecondThird: 'Gesamtzahl der Tacklingversuche im zweiten Spielfelddrittel',
      TacklesFirstThird: 'Anzahl erfolgreicher Tacklings im ersten Spielfelddrittel',
      TacklesSecondThird: 'Anzahl erfolgreicher Tacklings im zweiten Spielfelddrittel',
      FoulsOwnHalf: 'Anzahl der in der eigenen Hälfte des Spielers begangenen Fouls',
      TouchesOppHalf: 'Anzahl der Ballberührungen in der gegnerischen Hälfte',
      TacklesAttemptedNotAdjusted: 'Gesamtzahl der versuchten Tacklings, ohne Ballbesitzanpassung',
      TacklesSuccessfulNotAdjusted: 'Gesamtzahl erfolgreicher Tacklings, ohne Ballbesitzanpassung',
      AvgTop5MaxSpeed: 'Durchschnitt der fünf höchsten Höchstgeschwindigkeiten des Spielers',
      LBPReceived: 'Anzahl der empfangenen Zeilenumbruchdurchgänge. Hierbei handelt es sich um vollendete Pässe, die den Ball mindestens 10 % näher an das gegnerische Tor bringen und dabei ein Paar Verteidiger in unmittelbarer Nähe treffen oder über die Verteidigungslinie hinausgehen',
      LBPMReceived: 'Anzahl der erhaltenen Pässe, die die gegnerische Mittelfeldlinie durchbrechen',
      LBPMDReceived: 'Anzahl der erhaltenen Pässe, die sowohl das gegnerische Mittelfeld als auch die Verteidigungslinien durchbrechen',
      ThroughBallReceived: 'Anzahl der erhaltenen Pässe, die die letzte Verteidigungslinie des Gegners durchbrechen',
      HsrDistanceIP: 'Sprintdistanz >21 km/h im Ballbesitz',
      HsrDistanceOOP: 'Sprintdistanz >21 km/h ohne Ballbesitz',
      JoggingDistanceIP: 'Joggingdistanz im Ballbesitz',
      JoggingDistanceOOP: 'Joggingdistanz ohne Ballbesitz',
      RunningDistanceIP: 'Laufdistanz im Ballbesitz',
      RunningDistanceOOP: 'Laufdistanz ohne Ballbesitz',
      SprintsDistanceIP: 'Sprintdistanz >24 km/h im Ballbesitz',
      SprintsDistanceOOP: 'Sprintdistanz >24 km/h ohne Ballbesitz',
      WalkingDistanceIP: 'Zu Fuß im Besitz',
      WalkingDistanceOOP: 'Zu Fuß ohne Ballbesitz'
    },
    subtitles: {
      Possession: 'Prozentualer Anteil des Ballbesitzes der Mannschaft',
      TimePossession: 'Ballbesitzzeit der Mannschaft',
      PassesPerShots: 'Durchschnitliche Anzahl an zugelassenen Pässen pro Schuss',
      PPDA: 'Pässe pro defensive Aktion',
      Directness: 'Misst, wie genau eine Mannschaft ist',
      ExpectedPoints: 'Anzahl der von einem Team erwarteten Punkte, berechnet auf Grundlage der erwarteten Tore',
      PassesPerLongBall: 'Prozentualer Anteil der erfolgreichen langen Pässe an der Gesamtzahl der abgeschlossenen Pässe',
      CrossingPerXG: 'Prozentsatz an voraussichtlichen Toren die von Flanken stammen',
      PenaltySavedPenaltyFaced: 'Prozentualer Anteil der abgewehrten Strafstöße an allen abgewehrten Strafstößen',
      Goals: 'Number of goals scored',
      PenaltyShots: 'Gesamtanzahl der Schüsse vom Elfmeterpunkt',
      PenaltyGoals: 'Gesamtanzahl der Tore vom Elfmeterpunkt',
      NonPenaltyGoals: 'Tore (mit der Ausnahme von Elfmetertoren)',
      AerialWins: 'Erfolgreiche Luftduelle',
      AerialEfficiency: 'Messung der die gewonnenen luftduelle mit den gesamten luftduellen kombiniert',
      AerialWinsPct: 'Luftduelle gewonnen in %',
      Assists: 'Vorlagen',
      Catching: 'Paraden in %',
      Caught: 'Speichert, wo der Torwart den Ball fängt und hält, und verhindert so ein zweites Spiel',
      ChancesCreated: 'Anzahl von Pässen die einem Schuss vorausgehen',
      ClaimAccuracy: 'Überdurchschnittliche Beanspruchung des Balls',
      CompletedCrosses: 'Anzahl von erfolgreichen Flanken',
      Crossing: 'Erfolgreichen Flanken in %',
      Dispossessed: 'Ballverlust',
      Finishing: 'Erfolgreiche Torabschlüsse in %',
      xGEfficiency: 'Quantity of expected goals needed for a player to score a goal',
      Fouls: 'Fouls begangen',
      DeepProgression: 'Häufigkeit, mit der das letzte Fünftel des Spielfelds durch Tragen des Balls erreicht wird, plus die Häufigkeit, mit der sich der Ballbesitz im letzten Fünftel befindet',
      DeepProgressionFinalThird: 'Anzahl Ballaktionen des Spielers im letzten Drittel',
      FoulsTaken: 'Gefoult worden',
      IndividualPressure: 'Anzahl von erfolgreichen Pressingaktionen',
      Interceptions: 'Abgefangene Bälle',
      LongBallPct: 'Erfolgreiche Pässe von mindestens 32 Meter in %',
      LongBallTotal: 'Gesamtzahl der Pässe über 32 Meter',
      LongBallSuccessful: 'Erfolgreiche Pässe von mindestens 32 Meter',
      NPGOpenPlay: 'Goals (excluding penalties) by open play actions',
      NPGSetPiece: 'Goals (excluding penalties) by set piece actions',
      OpenPlayKeyPasses: 'Pässe die zu einem Torschuss führen (ohne Torvorlagen) aus dem Spiel heraus',
      OpenPlayKeyPassesInTeam: 'Erfolgreiche der pässe die zu einem Torschuss führen (ohne Torvorlagen) aus dem Spiel heraus im team',
      PassingFinalThird: 'Erfolgreiche Pässe, ohne Flanken, Standards, Ecken und Einwürfe, die im letzten Drittel beginnen',
      PassesFinalThirdTotal: 'Gesamtzahl der versuchten Pässe, ohne Flanken, Standardsituationen, Ecken und Einwürfe, die im letzten Drittel enden',
      PassingFinalThirdPct: 'Prozentsatz erfolgreicher Pässe von allen Pässen des Spielers (nur jene, die im letzten Drittel beginnen)',
      PassingOppHalfPct: 'Erfolgreiche Pässe in die gegnerische Hälfte in %',
      PassingOwnHalfPct: 'Erfolgreichen Pässe in die eigene Hälfte in %',
      PassingPct: 'Erfolgreiche Pässe in %',
      Recoveries: 'Anzahl an balleroberungen von einem spieler',
      SavesInBoxPct: 'Gehaltene Schüsse innerhalb des Strafraums in %',
      SavesOutOfBoxPct: 'Gehaltene Schüsse außerhalb des Strafraums in %',
      SavesPct: 'Gehaltene Schüsse in %',
      ScoringContribution: 'Anzahl der Vorlagen und Tore',
      xAssistsOpenPlay: 'Anzahl an voraussichtlichen Vorlagen die aus dem Spiel entstanden sind',
      xAssistsSetPiece: 'Anzahl an voraussichtlichen Vorlagen die aus Standard Situationen entstanden sind',
      xAssistsOpenPlayInTeam: 'Anzahl an voraussichtlichen Vorlagen die aus dem Spiel entstanden sind im Team',
      xAssistsSetPieceInTeam: 'Anzahl an voraussichtlichen Vorlagen die aus Standard Situationen entstanden sind im Team',
      xGChainFinalThird: 'Anzahl an xG wo ein Spieler im letzten Drittel beteiligt war',
      xGBuildupFinalThird: 'Anzahl an xG wo ein Spieler im letzten Drittel beteiligt war (mit der Ausnahme von Schüssen und Pässen vor einem Schuss)',
      BallProgressionPassing: 'Anzahl der Male, in denen der Spieler den Ball mit einem Pass 10 Meter oder weiter spielt',
      BallProgressionDribbling: 'Anzahl der Male, in denen der Spieler den Ball 10 Meter oder mehr weit im Besitz behält',
      Shooting: 'Schüsse (mit Ausnahme von Elfmetern) aufs Tor in %',
      Shots: 'Anzahl der Schüsse',
      ShotsPerGoal: 'Durchschnittliche Anzahl von Schüssen pro Tor',
      SuccessfulDribbles: 'Erfolgreiche Dribblings',
      TacklesSuccessful: 'Gesamtzahl an Zweikämpfen',
      TacklesWasDribbled: 'Erfolgreichen Zweikampfduelle in %',
      ThroughBalls: 'Anzahl der Pässe die die Abwehrkette durchbricht',
      TouchesInOpponentBox: 'Anzahl von Ballaktionen im gegnerischen Strafraum',
      xAssists: 'Erwartete Vorlagen',
      xG: 'Erwartete Tore',
      xGDiff: 'Unterschied zwischen xG und Zielen',
      xGOpenPlay: 'Erwartete Tore, die durch das offene Spiel erzielt werden',
      xGSetPiece: 'xG aus Standard Situationen',
      xGBuildup: 'Beteiligung am Aufbau in xG',
      xGBuildupInTeam: 'xG Aufbau in Team',
      BallProgression: 'Spielentwicklung durch das passen oder die Ballmitnahme von mindestens 10 Meter',
      xGChain: 'Beteiligung an der Kette xG',
      xGPerNPG: 'Durchschnitt xG pro Tor (kein Elfmeter)',
      xGPerShot: 'Durchschnitt xG pro Schuss',
      xGSavedPerShot: 'Durchschnitt xG gehalten pro Schuss aufs Tor',
      xGSavedPerXGFacedOnTarget: 'Durchschnitt xG gehalten pro xG Schuss aufs Tor',
      xGFacedOnTargetPerGoalReceived: 'Erwartete Tore werden benötigt, um ein Tor für einen spezifischen Torwart',
      xGFacedOnTargetEfficiency: 'Anzahl an Toren (ohne Elfmeter) die durch den Torwart verhindert wurden',
      xGFacedOnTarget: 'Gesamtzahl der Gegentreffer (gerettet und erzielt) des Torhüters',
      HighTurnovers: 'Ballgewinne näher als 40 Meter vom eigenen Tor',
      OpenPlayPassesIntoOpponentBox: 'Angekommener freier Pass gesamt vom Spieler im gegnerischen Strafraum',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Angekommener freier Pass vom Spieler im gegnerischen Strafraum',
      ChancesCreatedOP: 'Anzahl der Pässe, die zu einem Schuss führen,',
      PenaltiesTaken: 'Anzahl von Fouls die ein Spieler in dem gegnerischen Strafraum kassiert hat,',
      BlockedCrosses: 'Anzahl an Flanken blockiert durch den Spieler',
      BlockedShots: 'Anzahl an geblockten Schüssen durch den Spieler',
      NonPenaltyGoalsAgainst: 'Anzahl an Toren (ohne Elfmeter) kassiert',
      Headers: 'Kopfbälle',
      AveragePassDistance: 'Durchschnittliche Pass Distanz',
      ProgressiveRuns: 'Progressive Läufe',
      xT: 'Generierte Gefahr durch Spielentwicklung in gefährlichen Zonen',
      xTOpenPlay: 'Voraussichtliche Gefahr die aus dem Spiel heraus entstanden sind',
      xTSetPiece: 'Voraussichtliche Gefahr die durch standard situationen entstanden sind',
      xGOT: 'Voraussichtliche Tore pro Torschuss',
      BadActions: 'Summe der schlechten Aktionen',
      BadActionsOwnHalf: 'Summe der schlechten Aktionen in eigener Hälfte',
      AerialsWonOwnBox: 'Luftduelle gewonnen im eigenen Strafraum',
      AerialsWonOppBox: 'Aerials Won Opp Box',
      AerialsTotalOppBox: 'Aerials Total Opp Box',
      AerialsTotalOwnBox: 'Aerials Total Own Box',
      FoulsOwnHalfPct: 'Prozentsatz der Fouls in der eigenen Hälfte',
      RecoveriesOppHalf: 'Anzahl an balleroberungen von einem spieler in der gegnerischen hälfte',
      DuelsPct: 'Prozentsatz an erfolgreichen Duellen',
      TacklesUnsuccessful: 'Häufigkeit, mit der es einem Spieler nicht gelingt, den Ball zu erobern, weil ein Gegner erfolgreich an ihm vorbei dribbelt',
      TacklesWasDribbledFirstThird: 'Prozentsatz der Balleroberungen, wenn der Spieler im letzten Drittel steht',
      TacklesWasDribbledSecondThird: 'Gewonnene defensive Eins-gegen-Eins-Duelle ⅔',
      TacklesWasDribbledFinalThird: 'Gewonnene defensive Eins-gegen-Eins-Duelle Ende ⅓',
      BallProgressionFinalThird: 'Ballbesitz im letzten Drittel',
      DuelsTotal: 'Gesamtzahl der tackles, aerials, ballberührungen, dribblings und fouls',
      QuickRecoveries: 'Schnelle Ballzurückeroberung',
      ShotsPerNPG: 'Durchschnittliche Anzahl von Schüssen, um ein Tor (nicht Elfmeter) zu erzielen',
      ShotsOutBox: 'Anzahl der Schüsse von außerhalb des Strafraumss',
      GoalsOutBox: 'Anzahl der Tore von außerhalb des Strafraums',
      ShootingOutBox: 'Prozentsatz der Torschüsse von außerhalb des Strafraums',
      HandPassing: 'Abwurfgenauigkeit',
      ShotEndingHighTurnovers: 'Hohe Ballverluste (Ballverluste näher als 40 Meter vor dem eigenen Tor, die mit einem Schuss des gegnerischen Teams enden)',
      GoalEndingHighTurnovers: 'Hohe Ballverluste (Ballverluste näher als 40 Meter vor dem eigenen Tor, die mit einem Tor des gegnerischen Teams enden)',
      AverageCarriesProgress: 'Durchschnittliche Distanz die ein Spieler den Ball vertikal bewegt pro Dribbling (Meter)',
      ChanceEndingCarries: 'Dribblings von mindestens 7 Metern das mit einem Schuss-gefolgtem Pass enden',
      AssistEndingCarries: 'Dribblings von mindestens 7 Metern die mit einer Vorlage enden',
      ShotEndingCarries: 'Dribblings von mindestens 7 Metern die mit einem Schuss enden',
      GoalEndingCarries: 'Dribblings von mindestens 7 Metern die mit einem Tor enden',
      ShotEndingSequence: 'Sequenzen die mit einem Schuss enden',
      GoalEndingSequence: 'Sequenzen die mit einem Tor enden',
      AerialWonOffensive: 'Gewonnene Offensiv-Luftduelle',
      AerialWonDefensive: 'Gewonnene Defensiv-Luftduelle',
      xGAgainst: 'Erwartete gegentore',
      xGDiffAgainst: 'Erwartete gegentore diff',
      xGPerNPGAgainst: 'erwartete Gegentore (ohne Elfmeter)',
      xGOpenPlayAgainst: 'xG Kassiert aus dem spiel heraus',
      xGSetPieceAgainst: 'erwartete Gegentore aus einer Standard Situation heraus',
      xGPerShotAgainst: 'erwartete Gegentore aus Schüssen auf das Tor',
      ShotsAgainst: 'Anzahl an Schüssen auf das eigene Tor',
      ShotsOnTargetAgainst: 'Gegentorschüsse',
      RivalPossession: 'Ballbesitz des Gegners',
      AerialDefensivePct: 'Prozentsatz der gewonnenen defensiven Luftduelle',
      HighRecoveries: 'Balleroberung von 40 Metern vor dem gegnerischen Tor',
      HighDefensiveActions: 'Verteidigungsaktionen (Tackles, Interceptions, Blocks, Fouls und 1vs1) erfolgten 40 Meter über der eigenen Grundlinie',
      HighDefensiveActionPct: 'Prozentsatz der Defensivaktionen (Tackles, Interceptions, Blocks, Fouls und 1vs1), die 40 Meter über die eigene Grundlinie hinausgehen',
      HighDefensiveDistance: 'Durchschnittliche Entfernung vom eigenen Tor bei allen Defensiv-Aktionen',
      PassesPerPossession: 'Pässe pro Ballbesitz',
      LengthPerPossession: 'Laufstrecke pro Ballbesitz',
      xTNet: 'Net xT',
      AvgCarriesDistance: 'Durchschnittliche Distanz pro Ballführung',
      PassesForwardPct: '% Pässe gehen vorwärts',
      PassesForwardSuccessful: 'Erfolgreiche Vorwärtspässe',
      PassesForwardTotal: 'Gesamtzahl der Vorwärtspässe',
      TacklesAttempted: 'versuchte Tacklings',
      DuelsLost: 'verlorene Duelle',
      Carries: 'Ballführung',
      CarriesPct: '% Ballmitnahmen',
      Aerials: 'Luftduelle',
      ProgressivePassesReceivedIntoBox: 'Progressive Pässe werden in den Strafraum gespielt',
      PassesOppHalf: 'Gesamtzahl der erfolgreichen Pässe, die in der gegnerischen Hälfte landen',
      LongBallReceived: 'Anzahl der empfangenen langen Pässe (>32 Meter)',
      ShotsOnTarget: 'Schüsse auf\'s Tor',
      AggressiveActions: 'Anzahl der Tacklings, die in den nächsten zwei Sekunden nach dem Ballbesitzverlust versucht werden',
      Crosses: 'Gesamtzahl der Flanken',
      xGBuildup5pass: 'Anzahl der xG, an denen ein Spieler beteiligt war, nur die letzten 5 Pässe (ohne Schüsse und Pässe',
      DefensiveDistance: 'Average distance to own goal of defensive duels performed',
      SpeedSequence: 'Durchschnittliche Geschwindigkeit (zurückgelegte Meter pro verbrauchte Zeit) aller Ballbesitzzeiten einer Mannschaft',
      Touches: 'Anzahl der Ballkontakte eines Spielers Spielzeit',
      AerialsTotalOppHalf: 'Luftduelle Gesamt in Gegnerischer Hälfte',
      AerialsWonOppHalf: 'Erfolgreiche Luftduelle in die gegnerische Hälfte',
      AerialsWonOppHalfPct: 'Prozentualer Anteil der gewonnenen Luftduelle in der gegnerischen Hälfte',
      AerialsPctOppBox: 'Prozentsatz der gewonnenen Luftduelle im gegnerischen Strafraum',
      AerialsPctOwnBox: 'Prozentsatz der gewonnenen Luftduelle im eigenen Strafraum',
      AerialDefensive: 'Gesamtzahl der Aerials, wenn das gegnerische Team in Ballbesitz ist',
      AerialOffensive: 'Gesamtzahl der Aerials, wenn die eigene Mannschaft in Ballbesitz ist',
      AerialOffensivePct: 'Prozentualer Anteil der gewonnenen Aerials, wenn die eigene Mannschaft in Ballbesitz ist',
      IndividualPressureOppHalf: 'Metrik, die die Anzahl der erfolgreichen Bemühungen (zurückgewonnener Ballbesitz)',
      TouchesPerShot: 'Anzahl der Ballberührungen der Spieler pro Schuss',
      PassesFinalThirdTotalPct: 'Prozentsatz der erfolgreichen Pässe ins letzte Drittel',
      xACrosses: 'Erwartete Assists aus Flanken',
      Passes: 'Gesamtzahl der Pässe Spielzeit',
      PassesSuccessful: 'Anzahl der abgeschlossenen Pässe Spielzeit',
      TacklesWasDribbledFouls: 'Prozentualer Anteil der gewonnenen Zweikämpfe an den insgesamt begangenen Zweikämpfen und Fouls',
      OffsidesCaught: 'Abseits',
      ProgressivePassesReceivedFinalThird: 'Progressive Pässe angenommen im letzten Drittel',
      ProgressivePassesReceived: 'Progressive Pässe angenommen',
      Breadth: 'Sum of tackles, challenges, interceptions and fouls committed, on the sides of the field',
      DuelsDefTotal: 'Defensive Duelle',
      DefensiveActions: 'Defensive Aktionen',
      ProgressivePassesReceivedOppHalf: 'Progressive Pässe angekommen in der gegnerischen Hälfte',
      CompletedCrossesOP: 'angekommene Flanken aus dem freien Spiel heraus',
      CrossingOP: '% Flanken aus dem freien Spiel heraus',
      CrossesOP: 'Gesamtzahl der Flanken im offenen Spiel',
      PassingContribution: 'Percentage of passing contribution',
      BallProgressionOppHalfInTeam: '% Ball progression in opponent half in team',
      PassesOPIntoBoxInTeam: '% Passes open play into box in team',
      TouchesOppBoxInTeam: '% Touches opponent box in team',
      xGOPInTeam: '% xG open play in team',
      DeepPasses: 'Passes from outside a 20-metre radius of the opponent goal that end inside that area',
      DeepPassesTotal: 'Gesamtzahl der versuchten Pässe von außerhalb eines 20-Meter-Radius um das gegnerische Tor, die innerhalb dieses Bereichs enden',
      DefensiveDuelsPct: 'Percentage of defensive duels won out of total defensive duels',
      QuickRecoveriesPct: 'Percentage of quick recoveries to interceptions and attempted tackles',
      DiffDefensiveDistanceTeam: 'Difference between the player\'s defensive distance and his team\'s defensive distance',
      xTPassing: 'Expected threat generated only from passes',
      xTPassing100Passes: 'Expected threat generated only from passes and per 100 passes',
      ProgressivePassesAccurate: 'Completed passes of 10 meters or more in the X-axis',
      PassAbility: 'Ratio of completed passes to expected passes (xP)',
      OPPassesIntoOppBoxPct: 'Percentage of open play completed passes into the opponent box and open play attempted passes into the opponent box',
      EntriesOppBox: 'Number of passes and carries into the opponent box',
      Crosses6yardBox: 'Total number of crosses ending in the six-yard box',
      Cutbacks: 'Passing from baseline to back and inside the opponent box',
      xTDribbling: 'Expected threat generated only from dribbles',
      AvgShotDistance: 'Average distance of the total number of shots taken',
      xGOnTarget: 'Expected goals from shots made on target',
      FinishingxGOT: 'Percentage of shots on target ending in a goal',
      DribblesWonOwnHalf: 'Number of successful dribbles made in own half',
      DribblesOwnHalf: 'Number of attempted dribbles made in own half',
      DribblesOwnHalfPct: 'Percentage of successful dribbles and attempted dribbles made in own half',
      DribblesWonOppHalf: 'Number of successful dribbles made in opponent half',
      DribblesOppHalf: 'Number of attempted dribbles made in opponent half',
      DribblesOppHalfPct: 'Percentage of successful dribbles and attempted dribbles made in opponent half',
      DribblesWonFinalThird: 'Number of successful dribbles made in the final third',
      DribblesFinalThird: 'Number of attempted dribbles made in the final third',
      DribblesFinalThirdPct: 'Percentage of successful dribbles and attempted dribbles made in the final third',
      ShotEndingHighRecoveries: 'Hohe Ballgewinne (innerhalb von 40 Metern zum gegnerischen Tor), die mit einem Schuss enden',
      PassingFinalThirdAgainst: 'Erfolgreiche Pässe des Gegners ins letzte Drittel',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Gesamtzahl der Pässe des Gegners in unseren Strafraum im offenen Spiel',
      EntriesOppBoxAgainst: 'Anzahl der Pässe und Dribblings des Gegners in unseren Strafraum',
      DeepProgressionAgainst: 'Anzahl der Ballführungen des Gegners ins letzte Fünftel plus Ballbesitz im ersten Fünftel des Spielfelds',
      TouchesInOpponentBoxAgainst: 'Anzahl der Ballkontakte des Gegners in unserem Strafraum',
      Score: 'Spielerleistung auf der grundlage verschiedener metriken',
      PDScore: 'Physische Leistung der Spieler auf der Grundlage verschiedener physischer metriken',
      OrlegiScore: 'Spielerleistung auf der grundlage verschiedener metriken',
      SirScore: 'Spielerleistung auf der grundlage verschiedener metriken',
      ExcScore: 'Spielerleistung auf der grundlage verschiedener metriken',
      xTOPInTeam: 'Erwartete Gefahr (xT), die im Spiel erzeugt wird, im Verhältnis zur Gesamtzahl der Spieler Ihres Teams',
      YellowCards: 'Gelbe Karten',
      RedCards: 'Rote Karten',
      xTOpenPlayAgainst: 'Erwarteter Gegentreffer im offenen Spiel Spielzeit',
      xTSetPieceAgainst: 'Erwartete Bedrohung durch Spielfiguren',
      NPGOpenPlayAgainst: 'TOE Kassiert aus dem Spiel Heraus',
      NPGSetPieceAgainst: 'TOE Kassiert Standardsituationen',
      PassesOppHalfPerPossession: 'Pässe Gegnerische Hälfte pro Ballbesitz',
      AverageTimeRecovery: 'Durchschnittliche Wiederherstellungszeit',
      ExpectedPassing: 'Prozentsatz der Pässe, die hätten abgeschlossen werden sollen',
      NumPossession10Passes: 'Besitzt 10 Pässe',
      PassesReceived: 'Empfangene Pässe',
      PassesReceivedFinalThird: 'Empfangene Pässe Final ⅓',
      ProgressivePassesTotalPct: '% Progressive Pässe',
      ShortPassesPct: '% Kurzpässe',
      TouchesOppBoxOppTeam: 'Anzahl der gegnerischen Aktionen im eigenen Strafraum, während der Spieler auf dem Platz ist',
      ShotsOnTargetOppTeam: 'Schüsse aufs Tor, die zugelassen wurden, während der Spieler auf dem Platz ist',
      NPGOppTeam: 'Gegentore ohne Elfmeter, während der Spieler auf dem Platz ist',
      xGSetPiecePerxG: 'Erwartete Tore aus Standardsituationen pro erwartetem Tor',
      ShotsOpenPlay: 'Anzahl der Torschüsse aus dem offenen Spiel',
      ShotsOpenPlayAgainst: 'Anzahl der gegnerischen Torschüsse aus dem offenen Spiel',
      ShotsFromDribble: 'Schüsse nach dem Dribbling eines Gegenspielers',
      GoalsFromDribble: 'Tore nach dem Dribbling eines Gegenspielers',
      PassesIntoFinalThird: 'Erfolgreiche Pässe aus dem letzten Drittel',
      PassesIntoFinalThirdTotal: 'Gesamtzahl der versuchten Pässe, die außerhalb beginnen und innerhalb des letzten Drittels enden',
      PassesInsideFinalThird: 'Erfolgreiche Pässe innerhalb des letzten Drittels (Start und Ende im letzten Drittel)',
      PassesInsideFinalThirdTotal: 'Gesamtzahl der versuchten Pässe im letzten Drittel (Beginn und Ende im letzten Drittel)',
      PassesFinalThirdNoArea: 'Besteht das letzte Drittel (ohne Box)',
      PassesIntoOppBox: 'Erfolgreiche Pässe, die im gegnerischen Strafraum enden',
      CarriesFinalThird: 'Dribblings von mindestens 7 Metern, die im letzten Drittel enden',
      CarriesInsideFinalThird: 'Dribblings von mindestens 7 Metern innerhalb des letzten Drittels (Start und Ende im letzten Drittel)',
      CarriesFinalThirdNoBox: 'Trägt das letzte Drittel (ohne Box)',
      CarriesIntoOppBox: 'Dribblings von mindestens 7 Metern, die im gegnerischen Strafraum enden',
      TimePossessionAgainst: 'Ballbesitzzeit des gegnerischen Teams',
      TimePossessionTotal: 'Ballbesitzzeit beider Teams',
      PassesInBox: 'Erfolgreiche Pässe, die im gegnerischen Strafraum beginnen',
      LongThrowInSuccessful: 'Erfolgreicher langer Einwurf von der Seitenlinie, über 20 Meter weit',
      LongThrowInTotal: 'Gesamte lange Einwürfe von der Seitenlinie, über 20 Meter weit',
      LongThrowInPct: 'Prozentsatz erfolgreicher langer Einwürfe (über 20 Meter)',
      Games: 'Gespielte Spiele',
      PointsPerGame: 'Punkte pro Spiel',
      ExpectedPointsDiff: 'Erwartete Punktedifferenz',
      PassesTotalOwnHalf: 'Gesamtzahl der Pässe aus der eigenen Hälfte',
      PassesOwnHalf: 'Anzahl erfolgreicher Pässe aus der eigenen Hälfte',
      PassesTotalOppHalf: 'Gesamtzahl der Pässe aus der gegnerischen Hälfte',
      ProgressivePassesTotal: 'Gesamtzahl der Durchgänge von 10 Metern oder mehr auf der X-Achse',
      DuelsWon: 'Erfolgreiche Zweikämpfe (Tackles, Aerials, Ballberührungen, Dribblings und begangene Fouls)',
      NonPenaltySaves: 'Paraden ohne Strafschüsse',
      BadActionsOppHalf: 'Summe aller in der gegnerischen Hälfte begangenen Fehlaktionen',
      CarriesSuccessful: 'Anzahl der Tragevorgänge von mindestens 7 Metern, die mit einem erfolgreichen Event enden',
      ShotsOnTargetOutBox: 'Schüsse aufs Tor von außerhalb des Strafraums',
      TotalDistance: 'Laufleistung',
      WalkingDistance: 'Gesamtdistanz, die der Spieler während eines Spiels mit einer Geschwindigkeit von weniger als 2 m/s (7,2 km/h) zurückgelegt hat.',
      JoggingDistance: 'Gesamtdistanz, die der Spieler während eines Spiels mit einer Geschwindigkeit zwischen 2 m/s (7,2 km/h) und 4 m/s (14,4 km/h) zurückgelegt hat.',
      RunningDistance: 'Gesamtdistanz, die der Spieler während eines Spiels mit einer Geschwindigkeit zwischen 4 m/s (14,4 km/h) und 5,5 m/s (19,8 km/h) zurückgelegt hat',
      ExtremeAccelerations: 'Häufigkeit, mit der der Spieler mehr als 3 m/s<sup>2</sup> beschleunigt',
      NumberOfRuns: 'Anzahl der absolvierten Läufe mit einer Geschwindigkeit zwischen 14,4 km/h und 19,8 km/h',
      HsrDistance: 'Sprintdistanz >19.8 km/h',
      HsrNumber: 'Anzahl an Sprints >19.8 km/h',
      HsrDistancePct: '% HSR Distanz',
      SprintsNumber: 'Anzahl an Sprints >25.2 km/h',
      SprintsDistance: 'Sprintdistanz >25.2 km/h',
      SprintNumberDeclinePct: '% Abnahme der Sprints',
      SprintDistanceDeclinePct: '% Abnahme der Sprintdistanz',
      SprintNumberDecline: 'Abnahme der Anzahl der Sprints im Vergleich zur zweiten Halbzeit des Spiels',
      SprintDistanceDecline: 'Abnahme der im Sprint zurückgelegten Distanz im Vergleich zur zweiten Halbzeit des Spiels',
      SprintDistancePct: '% Sprintdistanz',
      Accelerations: 'Beschleunigung',
      MaxSpeed: 'Max. Geschwindigkeit',
      AvgMaxSpeed: 'Durchschnitt der maximal erreichten Geschwindigkeit des Spielers',
      MaxAccelerations: 'Maximale Beschleunigung in Meter/Sekunde², die der Spieler erreicht hat',
      BypassedPlayersByPasses: 'Anzahl der Spieler auf der Torseite des Ballführenden zu Beginn des Ballkontakts minus der Anzahl der Spieler auf der Torseite am Ende des Ballkontakts',
      BypassedDefendersByPasses: 'Anzahl der Verteidiger auf der Torseite des Ballführenden zu Beginn des Ballkontakts minus der Anzahl der Verteidiger auf der Torseite am Ende des Ballkontakts',
      PassesBypassingPlayers: 'Anzahl der Pässe, die Spieler überspielt haben',
      PassesBypassingDefenders: 'Anzahl der Pässe, die Verteidiger überspielt haben',
      BypassedPlayersPerPass: 'Gesamtzahl der überspielten Spieler pro Pass',
      BypassedDefendersPerPass: 'Gesamtzahl der überspielten Verteidiger pro Pass',
      LineBreakingPasses: 'Abgeschlossene Pässe, die den Ball mindestens 10% näher zum gegnerischen Tor bringen und entweder eine Verteidigerpaarung durchkreuzen oder hinter der Verteidigungslinie landen',
      LineBreakingPassesMD: 'Erfolgreiche Pässe, die Mittelfeld- und Abwehrlinien durchbrechen',
      LineBreakingPassesM: 'Erfolgreiche Pässe, die die Mittelfeldlinie durchbrechen',
      LineBreakingThroughBalls: 'Erfolgreiche Pässe, die die Abwehrlinie durchbrechen',
      LineBreakingPassesPerPass: 'Anzahl der durch einen Pass durchbrochenen Linien',
      TotalPassesUnderStrongPressure: 'Gesamtanzahl der Pässe unter starkem Druck (im Bereich von 0-2 Metern zum nächsten Gegner)',
      TotalPassesUnderLightPressure: 'Gesamtanzahl der Pässe unter leichtem Druck (im Bereich von 2-4 Metern zum nächsten Gegner)',
      SuccessfulPassesUnderStrongPressure: 'Anzahl erfolgreicher Pässe unter starkem Druck (im Bereich von 0-2 Metern zum nächsten Gegner)',
      SuccessfulPassesUnderLightPressure: 'Anzahl erfolgreicher Pässe unter leichtem Druck (im Bereich von 2-4 Metern zum nächsten Gegner)',
      PassingUnderStrongPressure: 'Prozentsatz erfolgreicher und aller Pässe unter starkem Druck (im Bereich von 0-2 Metern zum nächsten Gegner)',
      PassingUnderLightPressure: 'Prozentsatz erfolgreicher und aller Pässe unter leichtem Druck (im Bereich von 2-4 Metern zum nächsten Gegner)',
      PassReceiptsInSpaceCompleted: 'Pässe, bei denen der Empfänger in der Angriffszone ist und sich kein Verteidiger in einem Umkreis von 5 Metern in Richtung Tor befindet',
      PassReceiptsInSpace: 'Erhaltene Pässe in der Angriffszone, bei denen sich kein Verteidiger in einem Umkreis von 5 Metern in Richtung Tor befindet',
      PassReceiptsInSpaceCompletedFirstThird: 'Pässe, bei denen der Empfänger im ersten Drittel ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedSecondThird: 'Pässe, bei denen der Empfänger im zweiten Drittel ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedFinalThird: 'Pässe, bei denen der Empfänger im letzten Drittel ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Pässe, bei denen der Empfänger in der gegnerischen Hälfte (rechte Seite) ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Pässe, bei denen der Empfänger in der gegnerischen Hälfte (zentrales Feld) ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Pässe, bei denen der Empfänger in der gegnerischen Hälfte (linke Seite) ohne Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceFirstThird: 'Pässe, die im ersten Drittel empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceSecondThird: 'Pässe, die im zweiten Drittel empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceFinalThird: 'Pässe, die im letzten Drittel empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceOppHalfRight: 'Pässe, die in der gegnerischen Hälfte (rechte Seite) empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceOppHalfCenter: 'Pässe, die in der gegnerischen Hälfte (zentrales Feld) empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      PassReceiptsInSpaceOppHalfLeft: 'Pässe, die in der gegnerischen Hälfte (linke Seite) empfangen wurden, ohne dass ein Verteidiger im Umkreis von 5 Metern zum Tor ist',
      TotalStrongOnBallPressures: 'Anzahl der starken Drucksituationen auf den Ballführenden (im Bereich von 0-2 Metern)',
      TotalLightOnBallPressures: 'Anzahl der Drucksituationen auf den Ballführenden (im Bereich von 2-4 Metern)',
      SuccessfulStrongOnBallPressures: 'Anzahl erfolgreicher starker Drucksituationen auf den Ballführenden (im Bereich von 0-2 Metern)',
      SuccessfulLightOnBallPressures: 'Anzahl erfolgreicher Drucksituationen auf den Ballführenden (im Bereich von 2-4 Metern)',
      StrongOnBallPressuresPct: 'Prozentsatz erfolgreicher starker Drucksituationen (im Bereich von 0-2 Metern zum nächsten Gegner)',
      LightOnBallPressuresPct: 'Prozentsatz erfolgreicher Drucksituationen (im Bereich von 2-4 Metern zum nächsten Gegner)',
      TimesBypassedByPasses: 'Gesamtzahl der Male, bei denen der Spieler per Pass überspielt wurde',
      TimesBypassedByCarries: 'Gesamtzahl der Male, bei denen der Spieler per Dribbling überspielt wurde',
      TimesBypassedByActions: 'Gesamtzahl der Male, bei denen der Spieler per Pass und Dribbling kombiniert überspielt wurde',
      BypassedPlayersByCarries: 'Gesamtzahl der Gegner (Verteidiger und Mittelfeldspieler), die durch Dribblings überspielt wurden',
      BypassedDefendersByCarries: 'Gesamtzahl der Verteidiger, die durch Dribblings überspielt wurden',
      BypassedPlayersByActions: 'Gesamtzahl der Gegner (Verteidiger und Mittelfeldspieler), die durch Pässe und Dribblings kombiniert überspielt wurden',
      BypassedDefendersByActions: 'Gesamtzahl der Verteidiger, die durch Pässe und Dribblings kombiniert überspielt wurden',
      CarriesBypassingPlayers: 'Anzahl der Dribblings, die Spieler überspielt haben',
      CarriesBypassingDefenders: 'Anzahl der Dribblings, die Verteidiger überspielt haben',
      BypassedPlayersPerCarry: 'Durchschnittlich überspielte Gegner pro Dribbling',
      BypassedDefendersPerCarry: 'Durchschnittlich überspielte Verteidiger pro Dribbling',
      LineBreakingCarries: 'Anzahl der Dribblings, die erfolgreich eine oder mehrere Linien durchbrechen',
      LineBreakingCarriesMD: 'Anzahl der Dribblings, die Mittelfeld- und Abwehrlinien durchbrechen',
      LineBreakingCarriesM: 'Anzahl der Dribblings, die die Mittelfeldlinie durchbrechen',
      LineBreakingCarriesD: 'Anzahl der Dribblings, die die Abwehrlinie durchbrechen',
      LineBreakingCarriesPerCarry: 'Prozentsatz der Linien durchbrechenden Dribblings pro Dribbling',
      LineBreakingActions: 'Anzahl der Pässe und Dribblings kombiniert, die erfolgreich eine oder mehrere Linien durchbrechen',
      LineBreakingActionsMD: 'Anzahl der Pässe und Dribblings kombiniert, die Mittelfeld- und Abwehrlinien durchbrechen',
      LineBreakingActionsM: 'Anzahl der Pässe und Dribblings kombiniert, die die Mittelfeldlinie durchbrechen',
      LineBreakingActionsD: 'Anzahl der Pässe und Dribblings kombiniert, die die Abwehrlinie durchbrechen',
      PassesPerLineBreakingPass: 'Verhältnis von Gesamtpässen pro linienbrechendem Pass',
      CarriesPerLineBreakingCarry: 'Verhältnis von Gesamtdribblings pro linienbrechendem Dribbling',
      LinesBrokenByPasses: 'Gesamtanzahl der durch Pässe gebrochenen Linien',
      LinesBrokenByCarries: 'Gesamtanzahl der durch Dribblings gebrochenen Linien',
      LinesBrokenByActions: 'Gesamtanzahl der durch Pässe und Dribblings gebrochenen Linien',
      LinesBrokenPerPass: 'Durchschnittlich gebrochene Linien pro Pass',
      LinesBrokenPerCarry: 'Durchschnittlich gebrochene Linien pro Dribbling',
      AvgLastDefenderDistanceIP: 'Abstand zwischen dem letzten Verteidiger (nächster zum eigenen Tor) und der Torlinie bei Ballbesitz',
      AvgLastDefenderDistanceOOP: 'Abstand zwischen dem letzten Verteidiger (nächster zum eigenen Tor) und der Torlinie ohne Ballbesitz',
      AvgDefensiveLineDistanceIP: 'Abstand zwischen der tiefsten Abwehrlinie und dem Tor bei Ballbesitz',
      AvgDefensiveLineDistanceOOP: 'Abstand zwischen der tiefsten Abwehrlinie und dem Tor ohne Ballbesitz',
      AvgRBDistanceIP: 'Abstand vom rechten Außenverteidiger zum eigenen Tor bei Ballbesitz',
      AvgRBDistanceOOP: 'Abstand vom rechten Außenverteidiger zum eigenen Tor ohne Ballbesitz',
      AvgLBDistanceIP: 'Abstand vom linken Außenverteidiger zum eigenen Tor bei Ballbesitz',
      AvgLBDistanceOOP: 'Abstand vom linken Außenverteidiger zum eigenen Tor ohne Ballbesitz',
      AvgBlockDistanceIP: 'Abstand zwischen dem tiefsten und dem vordersten Feldspieler bei Ballbesitz',
      AvgBlockDistanceOOP: 'Abstand zwischen dem tiefsten und dem vordersten Feldspieler ohne Ballbesitz',
      AvgBlockAreaIP: 'Fläche des Rechtecks, das alle Feldspieler umfasst (Maß für die genutzte Raumfläche) bei Ballbesitz',
      AvgBlockAreaOOP: 'Fläche des Rechtecks, das alle Feldspieler umfasst (Maß für die genutzte Raumfläche) ohne Ballbesitz',
      AvgDefensiveLineWidthOOP: 'Breite der hintersten Spielerlinie (am weitesten vom eigenen Tor entfernt) ohne Ballbesitz',
      AvgOffensiveLineLastThirdWidthIP: 'Horizontale Breite der Offensivlinie im letzten Drittel bei Ballbesitz',
      AvgLByIP: 'Position des linken Außenverteidigers bei Ballbesitz',
      AvgRByIP: 'Position des rechten Außenverteidigers bei Ballbesitz',
      AvgOffensiveLineDistanceIP: 'Abstand zwischen dem eigenen Tor und der Offensivlinie bei Ballbesitz',
      AvgOffensiveLineLastThirdDistanceIP: 'Abstand zwischen dem eigenen Tor und der Offensivlinie im letzten Drittel bei Ballbesitz',
      AvgOffensiveLineWidthIP: 'Horizontale Breite der Offensivlinie bei Ballbesitz',
      OffBallRuns: 'Gezielte Laufwege ohne Ball zur Unterstützung der Angriffsphase',
      OffBallRunsOverlap: 'Läufe, bei denen der Spieler außen (näher zur Seitenlinie) um einen Mitspieler läuft, der den Ball hat',
      OffBallRunsUnderlap: 'Läufe, bei denen der Spieler auf der Innenseite eines Mitspielers läuft, näher zur Spielfeldmitte',
      OffBallRunsRunAhead: 'Vorstoß, der den Ballträger überholt, aber vor dem letzten Verteidiger bleibt',
      OffBallRunsRunBehind: 'Lauf in die Tiefe hinter die Abwehrkette zwischen Verteidigern und Torwart',
      OffBallRunsCrossReceiver: 'Ein Spieler läuft in den Strafraum, um eine Flanke von einem Mitspieler zu empfangen',
      OffBallRunsSupport: 'Der Spieler läuft auf Höhe des Ballträgers, um eine nahe Passoption zu bieten',
      OffBallRunsComingShort: 'Der Spieler läuft dem Ballträger entgegen, um nahen Support oder Rückpassoption zu bieten',
      AerialsOppHalf: 'Luftzweikämpfe in der gegnerischen Hälfte',
      CarriesIntoFinalThird: 'Rohrleitungen von mindestens 7 Metern von außen nach innen im letzten Drittel',
      DribblesAttempted: 'Anzahl der versuchten Dribblings',
      SpeedScore: 'Die körperliche Leistung des Spielers basierend auf verschiedenen Geschwindigkeitsmetriken',
      EnduranceScore: 'Die körperliche Ausdauerleistung der Spieler basierend auf verschiedenen Kennzahlen',
      GoalsConceded: 'Anzahl der kassierten Gegentore',
      HeadedGoals: 'Anzahl der mit dem Kopf erzielten Tore',
      SavesInBox: 'Anzahl der gehaltenen Schüsse innerhalb des Strafraums',
      SavesOutBox: 'Anzahl der Paraden bei Schüssen außerhalb des Strafraums',
      ShotsOnTargetInBoxAgainst: 'Anzahl der kassierten Torschüsse aus dem Strafraum',
      ShotsOnTargetOutBoxAgainst: 'Anzahl der kassierten Schüsse aufs Tor von außerhalb des Strafraums',
      SwitchPlaySuccessful: 'Anzahl der abgeschlossenen Pässe über 32 Meter, bei denen die seitliche Verschiebung des Balls größer ist als seine Verschiebung in Richtung des gegnerischen Tors',
      SwitchPlayTotal: 'Gesamtzahl der versuchten Pässe über 32 Meter, bei denen die seitliche Verschiebung des Balls größer ist als seine Verschiebung in Richtung des gegnerischen Tors',
      PassesInsideOppHalf: 'Gesamtzahl der Pässe, die sowohl in der gegnerischen Hälfte beginnen als auch enden',
      PassesInsideOppHalfSuccessful: 'Anzahl der abgeschlossenen Pässe, die sowohl in der gegnerischen Hälfte beginnen als auch enden',
      TacklesAttemptedFirstThird: 'Gesamtzahl der Tacklingversuche im ersten Spielfelddrittel',
      TacklesAttemptedSecondThird: 'Gesamtzahl der Tacklingversuche im zweiten Spielfelddrittel',
      TacklesFirstThird: 'Anzahl erfolgreicher Tacklings im ersten Spielfelddrittel',
      TacklesSecondThird: 'Anzahl erfolgreicher Tacklings im zweiten Spielfelddrittel',
      FoulsOwnHalf: 'Anzahl der in der eigenen Hälfte des Spielers begangenen Fouls',
      TouchesOppHalf: 'Anzahl der Ballberührungen in der gegnerischen Hälfte',
      TacklesAttemptedNotAdjusted: 'Gesamtzahl der versuchten Tacklings, ohne Ballbesitzanpassung',
      TacklesSuccessfulNotAdjusted: 'Gesamtzahl erfolgreicher Tacklings, ohne Ballbesitzanpassung',
      AvgTop5MaxSpeed: 'Durchschnitt der fünf höchsten Höchstgeschwindigkeiten des Spielers',
      LBPReceived: 'Anzahl der empfangenen Zeilenumbruchdurchgänge',
      LBPMReceived: 'Anzahl der erhaltenen Pässe, die die gegnerische Mittelfeldlinie durchbrechen',
      LBPMDReceived: 'Anzahl der erhaltenen Pässe, die sowohl das gegnerische Mittelfeld als auch die Verteidigungslinien durchbrechen',
      ThroughBallReceived: 'Anzahl der erhaltenen Pässe, die die letzte Verteidigungslinie des Gegners durchbrechen',
      ShortPassesSuccessful: 'Anzahl der abgeschlossenen Kurzpässe (weniger als 12 Meter).',
      PassingSuccessForwardPct: 'Prozentsatz erfolgreicher Vorwärtspässe',
      PassingSuccessBackwardPct: 'Prozentsatz erfolgreicher Rückpässe',
      PassingForwardBackwardPct: 'Verhältnis von Vorwärtspässen zu Rückwärtspässen',
      LongBallPerPassesPct: 'Prozentsatz der langen Bälle im Verhältnis zur Gesamtzahl der Pässe',
      LongBallReceivedOppHalf: 'Anzahl der im gegnerischen Feld erhaltenen langen Bälle',
      OffensiveActions: 'Offensive Aktionen',
      SuccessfulDribblesPct: 'Erfolgreiche Dribblings/insgesamt durchgeführte Dribblingversuche',
      OffensiveTouchesOutBoxPct: '% der offensiven Berührungen außerhalb des Strafraums',
      HsrDistanceIP: 'Sprintdistanz >21 km/h im Ballbesitz',
      HsrDistanceOOP: 'Sprintdistanz >21 km/h ohne Ballbesitz',
      JoggingDistanceIP: 'Joggingdistanz im Ballbesitz',
      JoggingDistanceOOP: 'Joggingdistanz ohne Ballbesitz',
      RunningDistanceIP: 'Laufdistanz im Ballbesitz',
      RunningDistanceOOP: 'Laufdistanz ohne Ballbesitz',
      SprintsDistanceIP: 'Sprintdistanz >24 km/h im Ballbesitz',
      SprintsDistanceOOP: 'Sprintdistanz >24 km/h ohne Ballbesitz',
      WalkingDistanceIP: 'Zu Fuß im Besitz',
      WalkingDistanceOOP: 'Zu Fuß ohne Ballbesitz'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SCHLUCHZEN',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRMS',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      HeadedXG: 'Überschrift xG',
      HeadedSetPieceTooltip: 'Es werden nur Spieler angezeigt, die nach Standardsituationen Kopfbälle haben',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR'
    },
    AerialsOppHalf: 'Luftduelle in Gegnerischer Hälfte',
    CarriesIntoFinalThird: 'Fährt bis zum letzten Drittel',
    scoreDifference: 'Punktedifferenz: Zeigt an, ob die Leistung dieses Spiels über oder unter dem Saisondurchschnitt lag',
    SpeedScore: 'Geschwindigkeits-Power-Score',
    EnduranceScore: 'Ausdauerwert',
    SwitchPlaySuccessful: 'Switch Play erfolgreich',
    SwitchPlayTotal: 'Wechseln Sie die Play-Gesamtsumme',
    PassesInsideOppHalf: 'Pässe innerhalb der Opp-Hälfte',
    PassesInsideOppHalfSuccessful: 'Pässe innerhalb der gegnerischen Hälfte erfolgreich',
    TacklesAttemptedFirstThird: 'Tackles werden zuerst versucht ⅓',
    TacklesAttemptedSecondThird: 'Tacklingsversuche im zweiten Drittel',
    TacklesFirstThird: 'Bewältigt das erste Drittel erfolgreich',
    TacklesSecondThird: 'Bewältigt das zweite Drittel erfolgreich',
    FoulsOwnHalf: 'Fouls in der eigenen Hälfte',
    TouchesOppHalf: 'Berührt die andere Hälfte',
    TacklesAttemptedNotAdjusted: 'Tacklingsversuche, nicht angepasst',
    TacklesSuccessfulNotAdjusted: 'Tackles erfolgreich, nicht angepasst',
    AvgTop5MaxSpeed: 'Durchschnittliche Top5-MaxGeschwindigkeit',
    LBPReceived: 'Erhaltene Line-Break-Pässe',
    LBPMReceived: 'Erhaltene Line-Break-Pässe (M-Line).',
    LBPMDReceived: 'Zeilenumbruchpässe (MD-Linie) erhalten',
    ThroughBallReceived: 'Durch erhaltene Bälle',
    recoveriesRate: 'Wiederherstellungsquote',
    turnoversRate: 'Verlustquote',
    HeadedShots: 'Kopfschüsse',
    HeadedXG: 'Überschrift xG',
    HeadedSetPieceTooltip: 'Es werden nur Spieler angezeigt, die nach Standardsituationen Kopfbälle haben',
    HsrDistanceIP: 'HSR-Distanz-IP',
    HsrDistanceOOP: 'HSR-Distanz OOP',
    JoggingDistanceIP: 'Jogging-Distanz IP',
    JoggingDistanceOOP: 'Jogging-Distanz OOP',
    RunningDistanceIP: 'Laufdistanz-IP',
    RunningDistanceOOP: 'Laufdistanz OOP',
    SprintsDistanceIP: 'Sprints Distanz IP',
    SprintsDistanceOOP: 'Sprintdistanz OOP',
    WalkingDistanceIP: 'IP zu Fuß erreichbar',
    WalkingDistanceOOP: 'OOP zu Fuß erreichbar'
  },
  team: {
    title: 'Teamblatt',
    subtitle: 'Vertiefen Sie die Eigenschaften und Statistiken der Mannschaft',
    averageAge: 'Durchsch. Alter',
    transferBalance: 'Transfer Balance',
    roster: 'Spielerliste',
    stadium: 'Stadion',
    coach: 'Trainer',
    transfers: 'Transfers',
    trends: 'Trends',
    loans: 'Leihen',
    loanFrom: 'Geliehen von',
    loanTo: 'Ausgeliehen nach',
    latestGames: 'Letzte Spiele',
    latestXGames: 'Latest {0} Games',
    playingFor: 'Spielt für',
    overview: 'Überblick',
    visualization: 'Visualisierung',
    location: 'Ort',
    outcome: 'Ergebnis',
    beeswarm: 'Platzierung',
    parentTeam: '1. Mannschaft',
    childTeam: 'Jugendmannschaft',
    preferredFormation: 'Bevorzugte Formation',
    mostFrecuentFormations: 'Häufigste Formationen',
    viewType: 'Ansicht Typ',
    overviewTab: {
      axisXTotal: 'Total',
      axisXper90: 'Pro 90\'',
      dataPerGameText: 'Daten pro Spiel',
      season: 'Saison',
      last: 'Letzte',
      current: 'Aktuelle',
      TeamStyle: 'Style',
      TeamDefensive: 'Defensiv',
      TeamOffensive: 'Offensiv',
      TeamCustom1: 'Custom 1',
      TeamCustom2: 'Custom 2',
      TeamCustom3: 'Custom 3',
      TeamCustom4: 'Custom 4',
      coach: 'Trainer',
      groups: {
        Goals: {
          name: 'Tore',
          desc: 'Es werden alle Tore mit und ohne Elfmeter (aus dem Spiel heraus und Standard Situationen) angezeigt.'
        },
        Assists: {
          name: 'Vorlagen',
          desc: 'Spieler mit den meisten Assists (im Spiel und bei Standardsituationen) in dieser Saison.'
        },
        xG: {
          name: 'Erwartete Tore',
          desc: 'Erwartete Tore aus dem Spiel heraus und aus Standardsituationen, sortiert in absteigender Reihenfolge nach insgesamt erzielten xG.'
        },
        xA: {
          name: 'Erwartete Vorlagen',
          desc: 'Erwartete Assists aus dem freien Spiel und aus Standardsituationen heraus.'
        },
        Finishing: {
          name: 'Abschluss',
          desc: 'Schüsse insgesamt und Ergebnis.'
        },
        ScoringContribution: {
          name: 'Scoring-Beitrag',
          desc: 'Anzahl der Assists und Tore der Mannschaft.'
        },
        xT: {
          name: 'Erwartete Gefahr',
          desc: 'Erwartete Gefahr aus dem Spiel heraus, aus Standardsituationen und negative xT.'
        }
      },
      stats: {
        openPlay: 'aus dem Spiel heraus',
        setPiece: 'Standard Situationen',
        negative: 'Negativ',
        npg: 'Tore (ohne Elfmeter)',
        goalsPenalty: 'Elfmetertore',
        npgOpenPlay: 'TOE aus dem Spiel heraus',
        npgSetPiece: 'TOE Standardsituationen',
        assists: 'Vorlagen',
        assistsConceded: 'Gegenvorlagen',
        assistsOpenPlay: 'Vorlagen aus dem Spiel heraus',
        assistsSetPiece: 'Vorlagen durch Standard Situationen',
        xGOpenPlay: 'xG aus dem Spiel heraus',
        xGSetPiece: 'xG Standard Situation',
        xAOpenPlay: 'xA aus dem Spiel heraus',
        xASetPiece: 'xA Standard Situationen',
        xAConceded: 'xA Gegentore',
        nonPenaltyShots: 'Torschüsse (ohne Elfmeter)',
        penaltyShots: 'Elfmeter Schüsse',
        xT: 'Erwartete Gefahr',
        xTOpenPlay: 'xT aus dem Spiel Heraus',
        xTSetPiece: 'xT Standard Situationen',
        xTNeg: 'xT Negativ',
        totalFinishing: 'Abschluss',
        nonPenaltyFinishing: 'Non Penalty Abschluss',
        goalsPenaltyFinishing: 'Penalty Abschluss',
        goal: 'Ziel',
        notGoal: 'Nicht Ziel',
        chance: 'Chance',
        finished: 'Fertig',
        notFinished: 'Nicht fertig',
        walkingDistance: 'Gehen',
        joggingDistance: 'Joggen',
        runningDistance: 'Laufen',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprinten',
        runningNumber: 'Läufe',
        hsrNumber: 'HSR Sprints',
        sprintsNumber: 'Sprints',
        maxSpeed: 'Max. Geschwindigkeit',
        accelerations: 'Beschleunigungen',
        extremeAccelerations: 'Extreme Beschleunigungen',
        maxAcceleration: 'Maximale Beschleunigung'
      }
    },
    teamAnalysis: 'Teamanalyse',
    agentView: {
      positions: {
        gk: 'GK',
        leftFullback: 'Linker AV',
        centralDefender: 'Zentraler IV',
        rightFullback: 'Rechter AV',
        midfielder: 'Mittelfeldspieler',
        attackingMidfielder: 'Off. Mittelfeldspieler',
        leftWinger: 'Linker Flügel',
        rightWinger: 'Rechter Flügel',
        fw: 'ST'
      },
      groups: {
        contractEnd: 'Monate',
        age: 'Jahre alt',
        availability: 'Verfügbarkeit'
      },
      placer: {
        legend: 'Stärke aufgrund von Alter, Vertrag, Verfügbarkeit und Leistung'
      }
    },
    transfersTab: {
      valueMovements: 'Wechselwert',
      valueTransfers: 'Transferwert',
      valueLoans: 'Leihwert',
      avgAgeMovements: 'Durschn. Wechsel Alter',
      avgAgeTransfers: 'Durchschn. Transfer Alter',
      avgAgeLoans: 'Durchschn. Leihe Alter',
      operations: {
        buys: {
          buy: 'Kaufen',
          loan: 'Leihe',
          'end of loan': 'Leihende',
          'free transfer': 'Ablösefreier Transfer',
          free: 'Ablösefrei',
          'loan transfer': 'Leihe',
          other: 'Andere'
        },
        sells: {
          buy: 'Verkaufen',
          loan: 'Verleihen',
          'end of loan': 'Leihende',
          'free transfer': 'ablösefreier Transfer',
          free: 'Ablösefrei',
          'loan transfer': 'Leihgabe',
          other: 'Andere',
          retired: 'Zurückgezogen'
        }
      }
    },
    trendsTab: {
      streaks: 'Schlieren',
      wins: 'Gewinnt',
      cleanSheets: 'Saubere Laken',
      goalPeriods: 'Zeiträume mit erzielten Toren',
      concededGoalPeriods: 'Zeiträume mit kassierten Toren',
      comebacks: 'Comebacks',
      avgTime: 'Durchschnittliche Zeit',
      kindOfGoals: 'Art der Ziele',
      percentWinning: '% Gewinnen',
      percentDrawing: '% Zeichnung',
      percentLosing: '% Verlieren',
      totalOf: 'Insgesamt von',
      minutes: 'minuten',
      before: 'Vor',
      after: 'Nach',
      playedOn: 'Gespielt am',
      scored: 'Bewertet',
      conceded: 'Zugestanden',
      ownGoals: 'Eigentore',
      phasesOfGame: 'Spielphasen',
      intensityLabel: 'Zonenintensität',
      intensityByTeam: 'Nach Team %',
      intensityByLeagueAvg: 'Nach Ligadurchschnitt %',
      buildup: 'Spielaufbau',
      midfieldProgression: 'Mittelfeld-Progression',
      attackOpposition: 'Angriff auf den Gegner',
      attackingTransition: 'Offensivumschaltspiel',
      highPress: 'Hohes Pressing',
      midBlock: 'Mittlerer Block',
      lowBlock: 'Tiefer Block',
      defensiveTransition: 'Defensivumschaltspiel',
      draws: 'Unentschieden',
      losts: 'Verloren',
      chokes: 'Versagen',
      zoneTooltip: 'Bestimmt die Kriterien, die für den Farbverlauf jedes Blocks verwendet werden:',
      teamPctTooltip: 'Basierend auf dem Prozentsatz der Gesamtzeit, die das Team in jeder Zone gespielt hat.',
      leagueAvgPctTooltip: 'Vergleicht den Prozentsatz des Teams mit dem Ligadurchschnitt für jede Zone.',
      leagueAvgMinsTooltip: 'Wendet die gleichen Vergleichskriterien auf die Liga an, bewertet jedoch die Gesamtzeit in Minuten statt in Prozent.',
      losses: 'Verluste',
      results: 'Ergebnisse',
      kindOfConcededGoals: 'Arten kassierter Tore',
      showMinutes: 'Minuten anzeigen'
    },
    onOff: 'On/Off',
    dragUpToXPlayers: 'Bis zu {x} Spieler hochziehen',
    selectUpToXPlayers: 'Bis zu {x} Spieler auswählen',
    onOffTab: {
      G90: 'Tore 90',
      GA90: 'Kassierte Tore 90',
      diffG90: 'Tor Differenz 90',
      XG90: 'xG 90',
      XGA90: 'xG kassiert 90',
      diffXG90: 'xG Differenz 90',
      playersOn: 'Combo ON',
      playersOff: 'Combo OFF',
      ground: 'Spielfeld',
      playersOnThePitch: 'Spieler auf dem Feld',
      playersOffThePitch: 'Spieler außerhalb des Feldes',
      attackTitle: 'Sturm',
      attackSubTitle: 'Offensive Statistiken',
      defenseTitle: 'Abwehr',
      defenseSubTitle: 'Defensive Statistiken',
      associationTitle: 'Verein',
      associationSubTitle: 'Vereins Statistiken',
      comboOn: 'Aktive Combos',
      comboOff: 'Andere',
      diffGoals90: 'T Diff 90',
      goals90: 'Tore (ohne Elfmeter) 90',
      goalsAgainst90: 'Tore (ohne Elfmeter) kassiert 90',
      xgAgainstPer90: 'xG kassiert 90',
      xgDiffPer90: 'xG Diff 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Schüsse aufs Tor 90',
      touchesOppBox90: 'Ballberührungen im gegnerischen Strafraum 90',
      shotsOnTargetAgainst90: 'Schüsse aufs Tor kassiert 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Genauigkeit 90',
      possession: 'Ballbesitz %',
      pctPasses: 'Pässes %',
      pctPassesFinalThird: 'Pässe im letzten Drittel %',
      placeholder: 'Wählen Sie zunächst ein Team aus',
      subtitle: 'Optimieren Sie die Teammetriken, indem Sie Spieler in die Aufstellung aufnehmen oder entfernen'
    },
    terms: {
      short: 'Kurzfristig',
      mid: 'Mittelfristig',
      long: 'Langfristig'
    },
    report: {
      title: 'Teambericht',
      selectedPeriod: 'Ausgewählter Zeitraum',
      stackedCharts: 'Gestapelte Diagramme',
      radars: 'Radargeräte',
      generalData: 'Allgemeine Daten',
      scoringChances: 'Torchancen',
      areasReport: 'Bereiche Bericht',
      setPieceReport: 'Standard-Situationen Bericht',
      corners: 'Ecken',
      cornersAgainst: 'Ecken Gegen',
      indirectFreeKicks: 'Indirekte Freistöße',
      indirectFreeKicksAgainst: 'Indirekte Freistöße Gegen',
      freeKicks: 'Freistöße',
      freeKicksAgainst: 'Freistöße Gegen',
      penaltys: 'Elfmeter',
      freeKicksContribution: 'Freistoß Beitrag',
      shotsContribution: 'Schuss Beitrag',
      topXPlayersByStats: 'Top {x} Spieler nach Statistiken',
      lastShotZone: 'Letzte Schusszone',
      throwSide: 'Einwurfseite',
      kindOfThrow: 'Art des Einwurfs',
      scored: 'Erzielt',
      against: 'Gegen',
      perGame: 'pro Spiel',
      total: 'Gesamt',
      efficiency: 'Effizienz',
      organizedAttack: 'Organisierter Angriff',
      offTransition: 'Offensive Umschaltmomente',
      chances: 'Chancen',
      chancesScored: 'Verwertete Chancen',
      chancesAgainst: 'Chancen Gegen',
      goalsScored: 'Erzielte Tore',
      goalsAgainst: 'Gegentore',
      goalsOrganizedAttack: 'Tore Organisierter Angriff',
      goalsOffTransition: 'Tore Umschaltmomente',
      goalsSetPiece: 'Tore Standard-Situation',
      goalsOrganizedAttackScored: 'Tore Org. Angriff Erzielt',
      goalsOrganizedAttackAgainst: 'Tore Org. Angriff Gegen',
      goalsOffTransitionScored: 'Tore Umschaltmomente Erzielt',
      goalsOffTransitionAgainst: 'Tore Umschaltmomente Gegen',
      goalsSetPieceScored: 'Tore Standard-Situation Erzielt',
      goalsSetPieceAgainst: 'Tore Standard-Situation Gegen',
      crossSide: 'Flankenseite',
      externalShot: 'Distanzschuss',
      innerPlay: 'Innenangriff',
      throwIn: 'Einwurf',
      box: 'Strafraum',
      zone2: 'Zone 2',
      goalsPerPhases: 'Tore pro Phasen'
    },
    minutesAlert: '*Es werden nur Spieler mit 450 oder mehr Spielminuten angezeigt',
    minutesException: 'Es gibt keine Spieler mit 450 oder mehr gespielten Minuten. Alle Spieler anzeigen',
    analysis: 'Analyse',
    substitutions: 'Auswechslung',
    attackZones: 'Angriffszone',
    formations: 'Formationen',
    shotZones: 'Schusszonen',
    crossings: 'Flanken',
    byTime: 'nach Zeit',
    byPosition: 'nach Position',
    byPlayer: 'nach Spieler',
    W: 'Gewonnen',
    D: 'Untenschieden',
    L: 'Niederlage',
    substitutionsByGame: 'Auswechslung nach Spielen',
    substitutionsShort: 'Ausw.',
    avgSeasonShort: 'Durchschn. Saison',
    startingAt: 'Beginnend bei',
    endingAt: 'Endet bei',
    startingAtInfo: 'Zeigt den Anteil des Ballbesitzes basierend auf der Lokalisierung des ersten Ereignisses',
    endingAtInfo: 'Zeigt den Anteil des Ballbesitzes basierend auf der Lokalisierung des letzten Ereignisses',
    endingWithShot: 'Endet mit einem Schuss',
    endingInBox: 'Endet im Strafraum',
    pfX: 'PF {x}',
    bySide: 'über die Seite',
    cornerKicks: 'Eckbälle',
    included: 'inklusive',
    excluded: 'exklusive',
    onlyCorner: 'nur Ecke',
    sizeByMarketValue: 'Größe nach Marktwert',
    timeInTeam: 'Jahre im Team',
    newSignings: 'Neuverpflichtungen',
    sizeBy: 'Größe nach',
    connections: 'Connections',
    assistant: 'Passer',
    finisher: 'Finisher',
    playersMinutesAlert: 'Es werden nur Spieler mit Einsatzminuten in der ausgewählten Saison angezeigt',
    strategyFilterTooltip: 'Zeigen Sie die Ereignisse an, die während Standardsituationen oder während eines offenen Spiels passiert sind',
    sideFilterTooltip: 'Zeigt nur die Versatzstücke an, die auf der ausgewählten Seite (links oder rechts) beginnen.',
    teamMinutesAlert: '*Zeigt nur Teams mit 450 oder mehr gespielten Minuten',
    homeCoach: 'Heimtrainer',
    awayCoach: 'Auswärtstrainer'
  },
  leagueTable: {
    subtitle: 'Nachschauen wie die Ligen sind'
  },
  leagueMatchdays: {
    byRound: 'Nach Spieltag',
    byDate: 'Nach Datum',
    byTeam: 'Nach Team'
  },
  teamStats: {
    subtitle: 'Leistung der Mannschaften vergleichen',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Difference between Expected Goals and Goals',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Difference between Expected Points and Points',
    games: 'GAM',
    gamesExplicit: 'Games played',
    pointsPerGame: 'PPG',
    pointsPerGameExplicit: 'Points per Game'
  },
  roles: {
    ROLE_USER: 'Benutzer',
    ROLE_ADMIN: 'Admin',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Physikalische Daten',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Extrahieren Sie mühelos Spieler-, Mannschafts-, Spiel- und Ligainformationen im JSON-Format.',
    ROLE_EVENTING_DATA_description: 'Tauchen Sie tief in die Statistiken ein mit Radar-Charts, Spieler-Ranglisten, Karten und mehr, basierend auf +100 Leistungsmetriken.',
    ROLE_PHYSICAL_DATA_description: 'Greifen Sie auf Fitnessdaten zu und filtern Sie Spieler nach verschiedenen Leistungskriterien (Distanz, Geschwindigkeit, Sprints, Beschleunigung...).',
    ROLE_VIDEO_description: 'Stellen Sie Videos und Aufstellungen zur Verfügung und lassen Sie sich Spiele mit Ereignissen und Statistiken für detaillierte Analysen anzeigen.',
    ROLE_DRIBLAB_HUB_description: 'Effizientes Verfolgen und Verwalten von Scouting-Aufgaben mit Kalendern, Notizen, Warnungen und gemeinsamer Nutzung von Dokumenten.',
    ROLE_TRACKING_description: 'Erhalten Sie die Positionsdaten aller Spieler in einem Spiel über unsere API für eine umfassende Analyse.',
    ROLE_ARRIGO_description: 'Kombiniert Eventing und Tracking in innovativen Metriken, die über das Traditionelle hinausgehen und jeder Aktion Mehrwert verleihen.',
    ROLE_REPORTS_description: 'Fordern Sie detaillierte Scouting-Berichte von unserem Analystenteam an, um das perfekte Team oder den perfekten Spieler zu finden.',
    ROLE_RAW_EVENTING: 'Rohes Eventing'
  },
  administration: {
    pageSubtitle: 'Verwalten des Betriebs der Anwendung',
    newClient: 'Neuer Kunde',
    clientDuplicateName: 'Ein Kunde mit diesem Namen existiert bereits. Wählen Sie ihn in der Liste aus und verwenden Sie „Neuer Benutzer“, um Benutzer für diesen Kunden anzulegen.',
    newUser: 'Neuer Benutzer',
    editClient: 'Kunde bearbeiten',
    editUser: 'Benutzer bearbeiten',
    clientName: 'Name',
    permissions: 'Rechte',
    releaseUser: 'Benutzer freigeben',
    connectAsUser: 'Verbinden als Benutzer',
    releaseModalTitle: 'Freigabe Benutzerbestätigung',
    releaseModalMessage: 'Der Benutzer wird eine E-Mail über sein neues Konto erhalten. Sind Sie sicher, dass Sie ihn benachrichtigen wollen?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Team',
      Brand: 'Marke',
      Federation: 'Verband',
      Media: 'Media',
      Agency: 'Agentur',
      Individual: 'Individual'
    },
    userType: {
      Ownership: 'Eigentümer',
      SportingDirector: 'Sport Direktor',
      Brand: 'Marke',
      Federation: 'Verband',
      Media: 'Media',
      Agency: 'Agentur',
      Individual: 'Individuell',
      Scout: 'Scout',
      Coach: 'Trainer',
      supervision: {
        title: 'Aufsichtshierarchie',
        subtitle: 'Die Aufsicht fließt nur nach unten. Eine Aufsicht auf gleicher Ebene ist nicht zulässig.',
        supervisesLowerLevels: 'Überwacht alle unten aufgeführten Rollen',
        ruleNoSameLevel: 'Rollen auf derselben Ebene können sich nicht gegenseitig beaufsichtigen.',
        ruleOnlyDownwards: 'Die Aufsicht ist nur von höheren zu niedrigeren Rollen zulässig.',
        ruleLevel3NoSupervision: 'Die unterste Ebene verfügt über keine Aufsichtsberechtigungen.',
        currentUserType: 'Ihr aktueller Benutzertyp'
      }
    },
    visibleYears: 'Sichtbare Jahre',
    areaModalTitle: 'Aktivieren/Deaktivieren von Ligen Bestätigung',
    areaModalMessage: 'Sind Sie sicher, dass Sie alle Ligen aus dem ausgewählten Bereich aktivieren/deaktivieren wollen?',
    countStats: 'Count Stats',
    userClientModalTitle: 'User already exists in another client',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Vertrag',
    contracts: 'Verträge',
    invoiceName: 'Rechnungsname',
    contractFee: 'Vertragsgebühr',
    renewal: 'Verlängerung',
    consultancy: 'Beratung',
    deleteContract: 'Kundenvertrag löschen',
    deleteContractMessage: 'Der Vertrag wird dauerhaft gelöscht. Sind Sie sicher?',
    activeVsHired: 'Aktiv vs Eingestellt',
    requestedVsHired: 'Angefragt vs Eingestellt',
    activeVsHiredWithPlaceholder: '{0} Aktiv vs. {1} Angestellt',
    requestedVsHiredWithPlaceholder: '{0} angefordert vs. {1} eingestellt',
    salesRepresentative: 'Vertriebsmitarbeiter',
    periodicities: {
      periodicity: 'Periodizität',
      annual: 'Jährlich',
      biannual: 'Halbjährlich',
      quarterly: 'Vierteljährlich',
      monthly: 'Monatlich',
      bimonthly: 'Zweimonatlich',
      onePayment: 'Eine Zahlung',
      fourmonthly: 'Alle vier Monate'
    },
    paymentMethods: {
      payment: 'Zahlung',
      method: 'Methode',
      transfer: 'Überweisung',
      mandate: 'Lastschrift'
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Social Media Anzeige',
      videoWithFeedback: 'Video mit Feedback'
    },
    status: {
      status: 'Status',
      pending: 'Ausstehend',
      active: 'Aktiv',
      expiringSoon: 'Läuft bald ab',
      expired: 'Abgelaufen',
      expiringSoonWithDays: 'Der Vertrag läuft bald ab: Noch {0} Tage'
    },
    updates: {
      roleAdded: '<b>{0}</b> hat die Rolle <b>{1}</b> zu <b>{2}</b> hinzugefügt.',
      roleRemoved: '<b>{0}</b> hat die Rolle <b>{1}</b> von <b>{2}</b> entfernt.',
      leagueAdded: '<b>{0}</b> hat <b>{1}</b> zur Liga <b>{2}</b> hinzugefügt.',
      leagueRemoved: '<b>{0}</b> hat <b>{1}</b> aus der Liga <b>{2}</b> entfernt.',
      seasonAdded: '<b>{0}</b> hat <b>{1}</b> zur Saison <b>{2}</b> hinzugefügt.',
      seasonRemoved: '<b>{0}</b> hat <b>{1}</b> aus der Saison <b>{2}</b> entfernt.',
      updateNotesPlaceholder: 'Bitte gib einen Kontext zur Änderung an oder füge relevante Notizen hinzu...',
      updates: 'Aktualisierungen',
      products: 'Produkte'
    },
    clients: 'Kunden',
    trials: 'Prüfungen',
    activeClients: 'Aktive Kunden',
    activeTrials: 'Aktive Versuche',
    activeTrialUsers: 'Aktive Testbenutzer',
    activeContracts: 'Aktive Verträge',
    expiration: 'Ablauf',
    clientWarnings: {
      activeContractInactiveClient: 'Kunden mit aktiven Verträgen, aber keinen aktivierten Benutzern',
      activeContractTrialUsers: 'Kunden mit Testbenutzern während ein Vertrag aktiv ist',
      activeUsersWithoutContract: 'Kunden mit aktiven Nicht-Testbenutzern, aber keinem aktiven Vertrag',
      upcomingExpirations: 'Bevorstehende Ablauffristen',
      renewedContracts: 'Kunden mit verlängerten Verträgen',
      clientsWithWarnings: 'Kunden, die Aufmerksamkeit erfordern',
      enabledUsersWithoutContract: '„Aktivierte Nicht-Testbenutzer ohne aktiven Vertrag“',
      trialUsersWithContract: 'Nutzer im Testmodus trotz aktivem Vertrag',
      activeContractInactiveUsers: 'Der Kunde hat einen aktiven Vertrag, bei dem alle Benutzer inaktiv sind',
      activeContract: 'Dieser Kunde hat einen aktiven Vertrag',
      noEnabledUsers: 'Dieser Client hat keine aktivierten Benutzer',
      ongoingTrialInactiveUsers: 'Kunden mit einer laufenden Testversion, aber keinen aktivierten Benutzern',
      neverLoggedIn: 'Kunden, die sich noch nie angemeldet haben'
    },
    daysLeft: 'Tage übrig',
    expiringSoon: 'Läuft bald ab',
    loggedThisWeek: 'Diese Woche eingeloggt',
    withWarnings: 'Mit Warnungen',
    ofActiveClients: 'der aktiven Kunden',
    endingIn30Days: 'endet in 30 Tagen',
    neverLogged: 'nie eingeloggt',
    ofActiveTrials: 'aktiver Versuche',
    activeClientsWithoutTrial: 'aktive Kunden (exkl. Testversion)',
    renewals: 'Erneuerungen',
    ofActiveContracts: 'der aktiven Verträge'
  },
  dashboards: {
    lastGame: 'Analyse des letzten Spiels',
    lastGameSimple: 'Letztes Spiel',
    seeAllGameInfo: 'Alle Spielinfos ansehen',
    nextGame: 'Nächste Spielvorschau',
    myTeam: 'Meine Mannschaft',
    lastMatchdayGames: 'Letzter Spieltag',
    lastAdded: 'Zuletzt hinzugefügt',
    myFavorites: 'Meine Favoriten',
    seeAllFavorites: 'Alle Favoriten ansehen',
    placeholderFavorites: 'Sie können Favoriten aus den Spielerdetails hinzufügen',
    placeholderTeamFavorites: 'Sie können Favoriten aus den Mannschaftsdetails hinzufügen',
    placeholderLeagueFavorites: 'Sie können Favoriten aus den Ligadetails hinzufügen',
    myCollections: 'Meine Sammlungen',
    placeholderCollections: 'Sie haben noch keine Sammlungen',
    lastCreated: 'Zuletzt erstellt',
    seeAllCollections: 'Alle Kollektionen ansehen',
    seeRival: 'Gegner ansehen',
    seeMyTeam: 'Meine Mannschaft ansehen',
    title: 'Dashboard-Übersicht',
    subtitle: 'Wilkommen zurück',
    recentPlayers: 'Neuste Spieler',
    lastScouted: 'Zuletzt gescoutet',
    scout: 'Scout',
    reportsRequested: 'Berichte',
    lastRequested: 'Letzte Berichte',
    goInbox: 'Zum Posteingang',
    placeholderLastScouted: 'Sie können in der linken Leiste oder im Scouting-Tool nach Spielern suchen',
    placeholderReports: 'Sie können Berichte von Spielerdetails anfordern',
    nationalPlayers: 'Die wertvollsten Nationalspieler in anderen Ländern',
    lastGames: 'Letzte Spiele',
    nationalPlayersShort: 'Nationalspieler in anderen Länder',
    nextMatchdayGames: 'Nächster Spieltag',
    injuredPlayers: 'Verletzte Spieler',
    atPresent: 'heutzutage',
    seeAllPlayers: 'Alle Spieler ansehen',
    suspendedPlayers: 'Gesperrte Spieler',
    placeholderInjured: 'Es gibt keine verletzten Spieler',
    teamValueImpacted: 'Teamwert beeinträchtigt',
    placeholderSuspended: 'Es gibt keine gesperrten Spieler',
    placeholderNextGame: 'Es ist kein Spiel verfügbar',
    placeholderNoGames: 'Es sind noch keine Spiele verfügbar',
    placeholderLastMatchDayNotFound: 'Letzter Spieltag nicht verfügbar',
    placeholderNextMatchDayNotFound: 'Erster Spieltag nicht verfügbar',
    usersMostSearch: 'Nutzer mit den meisten Suchanfragen',
    lastTwoDays: 'Letzten zwei Tage',
    searchesHistory: 'Suchverlauf',
    dayByDay: 'Täglich',
    activeUsersTitle: 'Aktive Nutzer',
    activeUsersSubtitle: 'Im letzten Monat mindestens einmal angemeldet',
    onlineUsersTitle: 'Online Nutzer',
    onlineUsersSubtitle: 'Suchten etwas in der letzten Stunde',
    searchesPerformed: 'Suchanfragen gemacht',
    onlyClients: 'Nur Kunden',
    activeClientsTitle: 'Aktive Kunden',
    activeClientsSubtitle: 'Mindestens ein aktiven Benutzer',
    last24Hours: 'letzten 24 Stunden',
    activityHistory: 'Aktivitätsverlauf',
    loginHistory: 'Zugriffsverlauf',
    failLogins: 'Zugriff fehlgeschlagen',
    successLogins: 'Zugang erfolgreich',
    clientStats: 'Kunden Statistiken',
    playersMostSearch: 'Spieler mit den meisten Suchanfragen',
    toolsMoreUsed: 'Weitere gebrauchte Werkzeuge',
    hotPlayers: 'Angesagte Spieler',
    last_month: 'Letzter Monat',
    last_week: 'Letze Woche',
    last_day: 'Letzter Tag',
    nClients: 'Nº an Kunden',
    userDashboard: 'Benutzer Dashboard',
    userDashboardSubtitle: 'Zusammenfassung der Kontobewegungen',
    offlineDaysOfClient: 'Offline-Tage für jeden Client',
    hideNoConnected: 'Nicht verbundene ausblenden',
    onlyTrial: 'Nur Testkunden',
    daysWithoutLogin: 'Tage ohne Anmeldung',
    trialDays: 'Testtage',
    myKollektionen: 'Meine Kollektionen',
    placeholderKollektionen: 'Sie haben noch keine Kollektionen',
    seeAllKollektionen: 'Alle Kollektionen ansehen'
  },
  faq: {
    subtitle: 'Erfahren Sie mehr über Driblab PRO',
    categories: {
      playerMetrics: 'Spieler Metrik',
      teamMetrics: 'Mannschafts Metrik',
      positions: 'Mannschaftspositionen',
      tools: 'Werkzeuge',
      api: 'API',
      videos: 'Tutorials',
      playerPositions: 'Spielerpositionen',
      userTypes: 'Benutzertypen'
    },
    positions: {
      GK: 'Torwart',
      DR: 'Rechtsverteidiger / Rechter Außenverteidiger (RB)',
      DC: 'Verteidiger Mitte / Innenverteidiger (CB)',
      DL: 'Verteidiger links / Linker Außenverteidiger (LB)',
      DMR: 'Rechter Offensiver Außenverteidiger (RWB)',
      DMC: 'Defensiver Zentral Mittelfeldspieler (DZM)',
      DML: 'Linker Offensiver Außenverteidiger (LWB)',
      MR: 'Rechter Mittelfeldspieler (RM)',
      MC: 'Zentraler Mittelfeldspieler (ZM)',
      ML: 'Linker Mittelfeldspieler (LM)',
      AMR: 'Mittelfeldspieler Rechts / Rechter Mittelfeldspieler (RM)',
      AMC: 'Offensiver Mittelfeldspieler Zentral / Zentral Offensiver Mittelfeldspieler (ZOM)',
      AML: 'Mittelfeldspieler Links  / Linker Mittelfeldspieler (LM)',
      FWR: 'Flügelstürmer Rechts / Rechter Flügelstürmer (RF)',
      FW: 'Stürmer / Stürmer (ST)',
      FWL: 'Flügelstürmer Links / Linker Flügelstürmer (LF)',
      T: 'Torwart',
      AR: 'Abwehrspieler Rechts / Rechter Außenverteidiger (RV)',
      AZ: 'Abwehrspieler Zentral / Innenverteidiger (IV)',
      AL: 'Abwehrspieler Links / Linker Außenverteidiger (LV)'
    },
    metrics: {
      categories: {
        Association: 'Verein',
        Saving: 'Gehalten',
        Shooting: 'Schiessen',
        Defending: 'Abwehren',
        Passing: 'Passen',
        BallHandling: 'Ballkontrolle',
        Aerial: 'Luftduelle',
        Physical: 'Körperlich',
        Predictive: 'Vorausschauend',
        Arrigo: 'Arrigo',
        Score: 'Score',
        Turnovers: 'Ballverlust',
        Carries: 'Dribblings',
        SequenceInvolvement: 'Anteil an der Sequenz',
        Crosses: 'Flanken',
        Distance: 'Entfernung',
        Sprint: 'Sprint',
        Acceleration: 'Beschleunigungen',
        MaxAcceleration: 'Maximale Beschleunigung',
        Speed: 'Geschwindigkeit',
        OutPlay: 'Outplay',
        LineBreakingPasses: 'Linienbrechende Pässe',
        LineBreakingCarries: 'Linienbrechende Dribblings',
        LineBreakingActions: 'Linienbrechende Aktionen',
        PassUnderPressure: 'Pass unter Druck',
        BallReceived: 'Ball erhalten',
        PassesUnderPressure: 'Pässe Unter Druck',
        OnBallPressureReceived: 'Erhaltene Druck am Ball',
        OnBallPressure: 'Druck auf den Ball',
        BallReceiptsInSpace: 'Ballannahme im Raum',
        SpatialCoverage: 'Spielfeldkontrolle',
        OffBallPressure: 'Druck ohne Ball',
        OffBallRuns: 'Läufe Ohne Ball',
        NoCategory: 'Andere',
        subcategories: {
          Quality: 'Qualität',
          Quantity: 'Quantität',
          TeamComparison: 'Teamvergleich',
          Receptions: 'Ballannahmen',
          LongBalls: 'Lange Bälle',
          Efficiency: 'Effizienz',
          Ratio: 'Verhältnis',
          Defensive: 'Defensiv',
          Offensive: 'Offensiv',
          Foot: 'Fuß',
          Progression: 'Fortschritt',
          TopValue: 'Höchstwert',
          Predictive: 'Vorausschauend',
          Distance: 'Entfernung',
          Aerial: 'Luftduelle',
          Crosses: 'Flanken',
          NoCategory: 'Andere'
        },
        desc: {
          Association: 'Verein',
          Saving: 'Gehalten',
          Shooting: 'Schiessen',
          Defending: 'Abwehren',
          Passing: 'Passen',
          BallHandling: 'Ballkontrolle',
          Aerial: 'Luftduelle',
          Physical: 'Körperlich',
          Predictive: 'Vorausschauend',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'Ballverlust',
          Carries: 'Dribblings',
          SequenceInvolvement: 'Anteil an der Sequenz',
          Crosses: 'Flanken',
          Distance: 'Zurückgelegte Distanz bei verschiedenen Geschwindigkeiten',
          Sprint: 'Läufe bei verschiedenen Geschwindigkeiten',
          Acceleration: 'Beschleunigungen',
          Speed: 'Geschwindigkeit',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Linienbrechende Pässe',
          LineBreakingCarries: 'Linienbrechende Dribblings',
          LineBreakingActions: 'Linienbrechende Aktionen',
          PassUnderPressure: 'Pass unter Druck',
          BallReceived: 'Ball erhalten',
          OnBallPressureReceived: 'Erhaltene Druck am Ball',
          OnBallPressure: 'Druck auf den Ball',
          BallReceiptsInSpace: 'Ballannahme im Raum',
          SpatialCoverage: 'Spielfeldkontrolle',
          OffBallPressure: 'Druck ohne Ball',
          OffBallRuns: 'Läufe Ohne Ball'
        },
        abbr: {
          Association: 'Verein',
          Saving: 'Gehalten',
          Shooting: 'Schiessen',
          Defending: 'Abwehren',
          Passing: 'Passen',
          BallHandling: 'Ballk.',
          Aerial: 'Luftduelle',
          Physical: 'Körperlich',
          Predictive: 'Vorausschauend',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'Umsätze',
          Carries: 'Dribblings',
          SequenceInvolvement: 'Ant. an der Seq.',
          Crosses: 'Flanken',
          Distance: 'Distanz',
          Sprint: 'Läufe',
          Acceleration: 'Beschleunigungen',
          MaxAcceleration: 'Max. Beschleunigung',
          Speed: 'Geschwindigkeit',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Linienbrechende Pässe',
          LineBreakingCarries: 'Linienbrechende Dribblings',
          LineBreakingActions: 'Linienbrechende Aktionen',
          PassUnderPressure: 'Pass unter Druck',
          BallReceived: 'Ball erhalten',
          OnBallPressureReceived: 'Erhaltene Druck am Ball',
          OnBallPressure: 'Druck auf den Ball',
          BallReceiptsInSpace: 'Ballannahme im Raum',
          SpatialCoverage: 'Spielfeldkontrolle',
          OffBallPressure: 'Druck ohne Ball',
          OffBallRuns: 'Läufe Ohne Ball'
        }
      },
      types: {
        1: 'Pro 90',
        2: 'Prozentsatz',
        3: 'Quote',
        4: 'Effizienz',
        5: 'Durchschnitt',
        6: 'Pro Spiel',
        7: 'Differenz',
        8: 'Max'
      },
      moreInfo: 'Mehr dazu lesen Sie hier'
    },
    api: {
      subtitle: 'Daten aus verschiedenen Anfragen abrufen',
      resourcesTitle: 'Ressourcen',
      authentication: 'Authentifizierung',
      authText: 'Um die API aufzurufen, müssen sie in jeder Anfrage die Überschrift `Authentifizierung` mit dem Wert `Bearer {API_TOKEN} angeben`',
      generate: 'Erzeugen',
      tokenPlaceholder: 'Wenn Sie kein Token haben oder es abgelaufen ist, klicken Sie auf \'Generieren\'',
      pathParameters: 'Pfadparameter',
      queryParameters: 'Anfrageparameter',
      responseModel: 'Antwortmodell',
      tokenWarning: '* Generieren Sie einen Token, um die API zu verwenden',
      pathParamsWarning: '* hier sind nicht gefüllte Pfadparameter',
      genericDescription: 'Eine API (Application Programming Interface) ermöglicht es Entwicklern, Daten oder Funktionen in ihre eigenen Anwendungen zu integrieren. Unsere Fußball-Statistik-API bietet umfassenden Zugriff auf eine Vielzahl von Daten zu Ländern, Wettbewerben, Teams, Spielern, Spielen und mehr. Mit dieser API können Sie Anwendungen erstellen, die unsere umfangreichen Fußball-Daten für Analysen, Visualisierungen oder andere innovative Lösungen nutzen.',
      methods: {
        getAllCountries: 'Diese Methode ruft eine vollständige Liste aller in der API verfügbaren Länder ab und liefert wichtige Details wie die eindeutige Kennung und den Namen jedes Landes. Dieser Endpoint ist ideal für Anwendungen, die geografische Fußball-Daten benötigen, und ermöglicht Funktionen wie Länderauswahl, Filterung und Analysen. Er dient auch als grundlegende Ressource für die Interaktion mit anderen Endpoints, die auf den Parameter `countryId` angewiesen sind, und sorgt für eine nahtlose Navigation und Integration mit dem Datensatz der API.',
        getCountryDetail: 'Diese Methode liefert detaillierte Informationen über ein bestimmtes in der API verfügbares Land. Mit diesem Endpoint können Sie Daten wie den Namen, den Code und relevante Metadaten des Landes abrufen. Diese Methode ist besonders nützlich für Anwendungen, die länderspezifische Details benötigen, um die Benutzererfahrung zu verbessern, wie zum Beispiel das Anzeigen von kontextbezogenen Informationen oder das Erstellen maßgeschneiderter Einblicke basierend auf geografischen Daten. Sie ergänzt andere Endpoints, indem sie eine tiefere Erkundung eines ausgewählten Landes ermöglicht.',
        getCountryCompetitions: 'Diese Methode ruft eine Liste aller Wettbewerbe ab, die in einem bestimmten Land verfügbar sind. Sie ist eine wertvolle Ressource für Funktionen, die es Benutzern ermöglichen, Wettbewerbe nach Region zu erkunden, und bietet eine nahtlose Verbindung zwischen Länder-Daten und den zugehörigen Turnieren. Dieser Endpoint ist unverzichtbar für Anwendungen, die sich auf lokalisierten Fußball-Content oder regionale Analysen konzentrieren.',
        getAllCompetitionTypes: 'Diese Methode gibt eine Liste aller in der API verfügbaren Wettbewerbstypen zurück, wie Ligen, Pokale und internationale Turniere. Dieser Endpoint eignet sich ideal, um Wettbewerbe zu kategorisieren und den Benutzern eine organisierte Ansicht der verschiedenen Arten von Veranstaltungen zu bieten. Besonders nützlich ist er für die Entwicklung von Funktionen wie Filtern oder Dropdown-Menüs, die es Benutzern ermöglichen, Fußball-Daten basierend auf der Art des Wettbewerbs zu erkunden.',
        getAllCompetitions: 'Diese Methode ruft eine umfassende Liste aller in der API verfügbaren Wettbewerbe ab, unabhängig von Typ oder Standort. Dieser Endpoint ist nützlich für Anwendungen, die eine breite Palette von Fußballwettbewerben anzeigen oder analysieren müssen, und ermöglicht es Benutzern, interessante Veranstaltungen zu erkunden und auszuwählen.',
        getCompetitionAvailable: 'Diese Methode ruft eine Liste der derzeit in der API als verfügbar markierten Wettbewerbe ab. Dies stellt sicher, dass die zurückgegebenen Daten aktuell und einsatzbereit für Anwendungen sind. Sie ist besonders nützlich für Entwickler, die Funktionen erstellen, die auf aktiven oder zugänglichen Wettbewerben basieren, und ermöglicht es Benutzern, relevante Veranstaltungen zu entdecken, ohne auf veraltete oder unvollständige Daten zu stoßen.',
        getCompetitionDetail: 'Diese Methode liefert detaillierte Informationen über einen bestimmten in der API verfügbaren Wettbewerb. Sie ist besonders nützlich für Anwendungen, die tiefgehende Informationen zu einem Wettbewerb benötigen, und ermöglicht Funktionen wie detaillierte Ansichten, kontextbezogene Einblicke oder Filteroptionen basierend auf Wettbewerbseigenschaften.',
        getCompetitionSeasons: 'Diese Methode ruft eine Liste aller Saisons ab, die einem bestimmten Wettbewerb zugeordnet sind. Dieser Endpoint ist unerlässlich für Anwendungen, die eine umfassende Abdeckung der Geschichte oder des aktuellen Stands eines Wettbewerbs bieten möchten, und ermöglicht es Benutzern, Daten saisonweise zu erkunden.',
        getSeasonAvailable: 'Diese Methode liefert eine Liste der aktuell in der API verfügbaren Saisons. Sie ist besonders nützlich für Anwendungen, die sich auf Live- oder laufende Fußballereignisse konzentrieren, und ermöglicht es den Benutzern, mit relevanten und aktuellen Saisondaten zu interagieren.',
        getSeasonDetail: 'Diese Methode ruft detaillierte Informationen über eine bestimmte Saison ab, einschließlich ihres Zeitplans, der zugehörigen Wettbewerbe und wichtiger Metadaten. Dieser Endpoint ist essenziell für Anwendungen, die tiefgehende Einblicke in eine bestimmte Saison benötigen, und ermöglicht Funktionen wie Saisonübersichten, Filterung nach Wettbewerb oder die Anzeige detaillierter Zeitpläne für die Benutzerinteraktion.',
        getSeasonTeams: 'Diese Methode liefert eine Liste aller Teams, die an einer bestimmten Saison teilnehmen. Sie ist ideal für Funktionen wie Kaderverwaltung, Teamleistungsanalysen oder die Erstellung saisonbezogener Filter für Benutzer.',
        getSeasonPlayer: 'Diese Methode ruft eine Liste aller Spieler ab, die in einer bestimmten Saison registriert sind. Sie ist ideal für Funktionen wie Spielerlisten, Leistungstracking oder das Filtern von Spielern basierend auf der ausgewählten Saison.',
        getSeasonPlayerStats: 'Diese Methode liefert detaillierte Statistiken für alle Spieler in einer bestimmten Saison. Sie ist besonders nützlich für Anwendungen, die sich auf Analysen, Spieler-Vergleiche oder die Erstellung dynamischer Visualisierungen von saisonlangen Spielerleistungen konzentrieren.',
        getSeasonArrigoMetrics: 'Diese Methode liefert kombinierte Statistiken für alle Spieler einer bestimmten Saison. Sie ist besonders nützlich für Anwendungen, die sich auf Analysen, Spielervergleiche oder die Erstellung dynamischer Visualisierungen von Saisonerfolgen konzentrieren.',
        getSeasonTeamStats: 'Diese Methode liefert umfassende Statistiken für alle Teams, die an einer bestimmten Saison teilnehmen. Sie ist besonders nützlich für Anwendungen, die sich auf Teamanalysen, Saisonzusammenfassungen oder den Vergleich von Teamleistungen im Verlauf der Saison konzentrieren.',
        getSeasonCoaches: 'Diese Methode ruft eine Liste aller Trainer ab, die während einer bestimmten Saison Teams betreut haben. Sie ist besonders nützlich für Anwendungen, die sich auf Saisonanalysen, Trainerbewertungen oder die Verfolgung von Veränderungen im Teammanagement während der Saison konzentrieren.',
        getSeasonGames: 'Diese Methode liefert eine Liste aller Spiele, die in einer bestimmten Saison gespielt wurden. Sie ist ideal für Anwendungen, die vollständige Saisonpläne anzeigen, Spielergebnisse analysieren oder Benutzern Zugriff auf umfassende Spieldaten der Saison bieten möchten.',
        getSeasonGamesMatchday: 'Diese Methode ruft alle Spiele eines bestimmten Spieltags innerhalb einer Saison ab. Sie ist besonders nützlich für Anwendungen, die Spieltagpläne anzeigen, bestimmte Runden analysieren oder detaillierte Einblicke in eine bestimmte Gruppe von Spielen während der Saison bieten möchten.',
        getSeasonLeagueTable: 'Diese Methode liefert die Ligatabelle für eine bestimmte Saison, einschließlich Ranglisten, Punkte, Siege, Unentschieden, Niederlagen und anderer relevanter Statistiken für jedes Team. Dieser Endpoint ist essenziell für Anwendungen, die die Teamranglisten verfolgen, den Ligaverlauf analysieren oder den Benutzern aktuelle Ranglisten während der gesamten Saison präsentieren möchten.',
        getTeamDetail: 'Diese Methode liefert detaillierte Informationen über ein bestimmtes Team, einschließlich Name, Gründungsjahr, Stadion und weiterer Metadaten. Dieser Endpoint ist ideal für Anwendungen, die teamspezifische Einblicke benötigen, und ermöglicht Funktionen wie detaillierte Teamprofile, historischen Kontext oder eine verbesserte Nutzererfahrung mit umfassenden Teamdaten.',
        getTeamLoans: 'Diese Methode ruft Informationen über Leihgeschäfte ab, an denen ein bestimmtes Team beteiligt ist. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf Transferanalysen, Kaderverwaltung oder die Nachverfolgung von Spielerbewegungen während einer Saison konzentrieren.',
        getTeamRoster: 'Diese Methode liefert eine vollständige Liste aller Spieler im Kader eines bestimmten Teams. Sie ist ideal für Anwendungen, die Teamaufstellungen anzeigen, Spielerrollen analysieren oder kaderbezogene Funktionen verwalten müssen.',
        getTeamGames: 'Diese Methode ruft eine Liste aller Spiele ab, die von einem bestimmten Team gespielt wurden. Sie ist besonders nützlich für Anwendungen, die sich auf die Teamleistung, die Verfolgung von Spielplänen oder die Bereitstellung des vollständigen Spielverlaufs eines Teams konzentrieren.',
        getTeamGameStats: 'Diese Methode liefert detaillierte Statistiken für ein bestimmtes Team in einem bestimmten Spiel. Sie ist besonders nützlich für Anwendungen, die sich auf Spielanalysen, Leistungsevaluierungen oder detaillierte Aufschlüsselungen der Teamleistungen in einzelnen Spielen konzentrieren.',
        getTeamTransfers: 'Diese Methode ruft Informationen über Transfergeschäfte ab, an denen ein bestimmtes Team beteiligt ist. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf Transfermarktanalysen, Kaderänderungen oder die Nachverfolgung von Spielerbewegungen über einen längeren Zeitraum konzentrieren.',
        getGameStatus: 'Diese Methode liefert eine Liste aller möglichen Spielstatus, die in der API verfügbar sind, wie zum Beispiel geplant, im Gange, abgeschlossen, verschoben oder abgesagt. Dieser Endpoint ist besonders nützlich für Anwendungen, die Echtzeit-Spielverfolgung, Filterung von Spielen nach Status oder klare Updates zum Fortschritt oder Zustand eines Spiels bereitstellen möchten.',
        getPlayerPositions: 'Diese Methode gibt eine Liste aller möglichen Spielerpositionen zurück, wie Torwart, Verteidiger, Mittelfeldspieler und Stürmer. Dieser Endpoint ist besonders nützlich für Anwendungen, die Spieler kategorisieren, Positionsdaten analysieren oder es Nutzern ermöglichen, Spieler basierend auf ihren Rollen auf dem Spielfeld zu filtern.',
        getGameDetail: 'Diese Methode liefert umfassende Informationen über ein bestimmtes Spiel, einschließlich Details wie teilnehmende Teams, Datum und Uhrzeit, Austragungsort, Ergebnis und weitere wichtige Metadaten. Dieser Endpoint ist ideal für Anwendungen, die detaillierte Spielinformationen benötigen, und ermöglicht Funktionen wie detaillierte Spielvorschauen, Berichte oder Analysen.',
        getGameStats: 'Diese Methode liefert detaillierte Statistiken zu einem bestimmten Spiel, einschließlich Metriken wie Tore, Schüsse, Ballbesitzanteile, Pässe und Defensivaktionen. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf Spielanalysen, Nachspielberichte oder Visualisierungen der Teamleistung während eines Spiels konzentrieren.',
        getGamePlayerStats: 'Diese Methode ruft detaillierte Leistungsstatistiken für alle Spieler ab, die an einem bestimmten Spiel teilgenommen haben. Dieser Endpoint ist besonders nützlich für Anwendungen, die individuelle Spielerleistungen analysieren, Spielberichte erstellen oder Spieler innerhalb des Kontexts eines einzelnen Spiels vergleichen möchten.',
        getGamePlayerPhysicalStats: 'Diese Methode liefert detaillierte physische Leistungsmetriken für Spieler in einem bestimmten Spiel. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf die Analyse der Fitness von Spielern, das Tracking physischer Leistungen oder die Erstellung detaillierter Spielberichte für einzelne Spieler konzentrieren.',
        getGameTeamPhysicalStats: 'Diese Methode liefert detaillierte physische Leistungsmetriken für Teams in einem bestimmten Spiel. Dazu gehören Daten wie die insgesamt zurückgelegte Distanz, die Anzahl der Sprints, Läufe mit hoher Intensität und andere physische Attribute. Sie ist besonders nützlich für Anwendungen, die sich auf die Fitnessanalyse von Teams, den Vergleich physischer Anstrengungen zwischen Teams oder die Bewertung der Gesamtleistung in einem Spiel konzentrieren.',
        getGamePlayerArrigoMetrics: 'Diese Methode liefert detaillierte Arrigo-Metriken für Spieler in einem bestimmten Spiel. Sie ist besonders nützlich für Anwendungen, die sich auf Analysen konzentrieren und detaillierte Einblicke in die Spieler in einem Spiel liefern.',
        getGameTeamArrigoMetrics: 'Diese Methode liefert detaillierte Kennzahlen zum Team Arrigo in einem bestimmten Spiel. Dazu gehören Daten wie geschlagene Spieler und andere Attribute. Sie ist besonders nützlich für Anwendungen, die sich auf die Analyse der Gesamtleistung im Spiel konzentrieren.',
        getGameLineup: 'Diese Methode ruft die Aufstellung für ein bestimmtes Spiel ab, einschließlich Startspieler, Ersatzspieler und deren jeweilige Positionen. Dieser Endpoint ist besonders nützlich für Anwendungen, die Vorabinformationen zu Spielen anzeigen, Teamformationen analysieren oder Einblicke in die taktischen Entscheidungen der Teams für ein bestimmtes Spiel geben möchten.',
        getGameTimeline: 'Diese Methode liefert eine chronologische Liste der Ereignisse, die während eines bestimmten Spiels stattgefunden haben. Dieser Endpoint ist besonders nützlich für Anwendungen, die Live-Updates zu Spielen, Nachspielzusammenfassungen oder detaillierte Analysen der Spielereignisse anbieten.',
        getGameTracking: 'Diese Methode stellt einen Link zum Herunterladen der Tracking-Daten-Datei für ein bestimmtes Spiel bereit. Diese Datei enthält detaillierte Bewegungs- und Positionsdaten der Spieler und des Balls während des gesamten Spiels. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf fortgeschrittene Analysen, taktische Analysen oder die Visualisierung der Bewegungen von Spielern und Ball während eines Spiels konzentrieren.',
        getTrackingStatus: 'Diese Methode gibt eine vollständige Liste aller im Tracking verfügbaren Bundesstaaten zurück und liefert wichtige Details wie die eindeutige Kennung und den Namen jedes Bundesstaats. Dieser Endpunkt ist ideal für Anwendungen, die eine Übereinstimmungsverfolgung erfordern und Funktionen wie Statusauswahl, Filterung und Analyse ermöglichen. Es dient auch als wichtige Ressource für die Interaktion mit anderen Endpunkten, die von einem „statusId“-Parameter abhängen, und gewährleistet so eine nahtlose Navigation und Integration mit dem breiteren Datensatz der API.',
        getPlayerTransfersTypes: 'Diese Methode liefert eine Liste der möglichen Transferarten für Spieler, wie permanente Transfers, Leihen, ablösefreie Transfers oder Tauschgeschäfte. Dieser Endpoint ist besonders nützlich für Anwendungen, die Transfermarkt-Trends analysieren, Spielerbewegungen kategorisieren oder detaillierte Einblicke in die Art von Spielertransaktionen bieten.',
        getPlayerDetail: 'Diese Methode liefert detaillierte Informationen zu einem bestimmten Spieler, einschließlich persönlicher Daten, Karriere-Statistiken und aktueller Teamzugehörigkeit. Dieser Endpoint ist ideal für Anwendungen, die Spielerprofile, historische Einblicke oder Analysen zu individuellen Spielerleistungen und Karriereverläufen bieten.',
        getPlayerGames: 'Diese Methode ruft eine Liste aller Spiele ab, an denen ein bestimmter Spieler teilgenommen hat. Dieser Endpoint ist besonders nützlich für Anwendungen, die Spielerleistungen verfolgen, Spielhistorien analysieren oder umfassende Spielprotokolle für einzelne Spieler bereitstellen.',
        getPlayerInjuries: 'Diese Methode liefert eine detaillierte Aufzeichnung der Verletzungen eines bestimmten Spielers. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf die Analyse der Spieler-Gesundheit, die Bewertung von Karriereauswirkungen oder die Verfolgung von Erholungszeiträumen konzentrieren.',
        getPlayerNationalTeam: 'Diese Methode liefert detaillierte Informationen über die Teilnahme eines Spielers an Länderspielen. Dieser Endpoint ist besonders nützlich für Anwendungen, die Spielerleistungen auf nationaler Ebene analysieren, internationale Karrieren verfolgen oder Einblicke in die Beiträge bei Turnieren und Freundschaftsspielen bieten.',
        getPlayerSeasons: 'Diese Methode liefert eine Liste aller Saisons, an denen ein bestimmter Spieler teilgenommen hat. Dieser Endpoint ist besonders nützlich für Anwendungen, die die Karriereentwicklung eines Spielers verfolgen, Leistungen über mehrere Saisons hinweg analysieren oder einen historischen Kontext zu ihren Errungenschaften liefern.',
        getPlayerTransfers: 'Diese Methode liefert eine detaillierte Historie der Transfertransaktionen, an denen ein bestimmter Spieler beteiligt war. Dieser Endpoint ist besonders nützlich für Anwendungen, die Spielerkarrieren analysieren, Einblicke in den Transfermarkt bieten oder die Bewegungen von Spielern zwischen Teams verfolgen.',
        getPlayerSeasonTeamStats: 'Diese Methode liefert detaillierte Leistungsstatistiken für einen bestimmten Spieler während einer bestimmten Saison mit einem Team. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf saisonale Spieleranalysen, Vergleiche zwischen Teams oder Saisons und die Verfolgung individueller Beiträge zum Teamerfolg konzentrieren.',
        getPlayerSeasonPhysicalStats: 'Diese Methode liefert detaillierte physische Leistungsmetriken für einen bestimmten Spieler während einer Saison. Dieser Endpoint ist besonders nützlich für Anwendungen, die die Fitness eines Spielers verfolgen, physische Leistungen analysieren oder die Arbeitsbelastung eines Spielers während einer Saison bewerten.',
        getPlayerSeasonGamePhysicalStats: 'Diese Methode liefert detaillierte physische Leistungsmetriken für einen bestimmten Spieler in jedem Spiel einer Saison. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf spielbezogene Fitnessanalysen, die Verfolgung der Arbeitsbelastung von Spielern oder den Vergleich physischer Leistungen in verschiedenen Spielen konzentrieren.',
        getPlayerSeasonGameStats: 'Diese Methode liefert detaillierte Leistungsstatistiken für einen bestimmten Spieler in jedem Spiel einer Saison. Dieser Endpoint ist besonders nützlich für Anwendungen, die sich auf spielbezogene Spieleranalysen, Leistungstrends oder detaillierte Vergleiche zwischen Spielen innerhalb einer Saison konzentrieren.',
        getCoachDetail: 'Diese Methode liefert detaillierte Informationen über einen bestimmten Trainer, einschließlich seines Namens, seiner Karriere, der Teams, die er betreut hat, und seiner bemerkenswerten Erfolge. Dieser Endpoint ist besonders nützlich für Anwendungen, die Trainerprofile hervorheben, Trainerkarrieren verfolgen oder die Auswirkungen von Trainern auf die Teamleistung analysieren.',
        getCoachHistory: 'Diese Methode liefert eine umfassende Historie der Karriere eines bestimmten Trainers, einschließlich der Teams, die er betreut hat, der Wettbewerbe, an denen er teilgenommen hat, und der Dauer seiner Amtszeiten. Dieser Endpoint ist besonders nützlich für Anwendungen, die Trainerkarrieren analysieren, Managementwechsel verfolgen oder Einblicke in die berufliche Laufbahn und Erfolge eines Trainers bieten.',
        getGameEventing: 'Diese Methode stellt alle Ereignisse bereit',
        getLinkStream: 'Diese Methode ruft den Link zum Ansehen des Spielvideos ab',
        getLinkDownload: 'Diese Methode ruft den Link zum Herunterladen des Spielvideos ab',
        getGameTs: 'Diese Methode stellt den letzten Zeitstempel in einem bestimmten Spiel bereit',
        getGameFileTypes: 'Diese Methode stellt die Dateitypen für den Abgleich bereit',
        deletePlayer: 'This method delete a player'
      },
      responseCodes: 'Reaktioncodes',
      furtherInformation: 'For further information, please read our API documentation',
      clipboard: 'In die Zwischenablage kopiert!',
      limit50: 'Es werden nur die ersten 50 Ergebnisse angezeigt'
    }
  },
  globalSearch: {
    subtitle: 'Detailierte Filterung'
  },
  global: {
    teamElos: {
      title: 'Team-ELOs',
      subtitle: 'Globale Team-Ranglisten und Einblicke',
      team: 'Team',
      teams: 'Teams',
      dates: 'Termine',
      excludeInternational: 'Internationale Teams ausschließen',
      elo: 'ELO',
      selectButton: 'Wählen Sie Oben',
      selectTeamFromTable: 'Wähle ein Team aus der Tabelle aus, um den ELO-Trend anzuzeigen.',
      showingTeamAveragesLastSeason: 'Teamdurchschnitte der letzten Saison anzeigen',
      showingTeamStatsLastSeason: 'Nur Teamstatistiken für deren letzte aktive Saison werden angezeigt',
      searchToolTip: 'Tipp: Drücken Sie Strg + B, um direkt auf die Suchleiste zuzugreifen',
      selectTopTooltip: 'Zeigen Sie zum Vergleich weitere Teams im Diagramm an',
      loadingPage: 'Daten vorbereiten...'
    },
    leagueElos: {
      title: 'LIGA-ELO\'S',
      subtitle: 'Globale Liga-Ranglisten und Analysen',
      rankings: 'RANGLISTEN',
      insights: 'EINBLICKE',
      filters: 'FILTER',
      leagues: 'Wettbewerbe',
      from: 'Von',
      to: 'Bis',
      elo: 'ELO',
      change: 'Veränderung',
      league: 'Wettbewerb',
      excludeContinental: 'Kontinentale Wettbewerbe ausschließen',
      eloTrend: 'ELO-Trend',
      eloRanking: 'ELO-Ranking',
      currentELOLabel: '(Aktuelle ELO)',
      allTime: 'Alle Zeiten',
      average: 'Durchschnitt',
      noChartData: 'Keine Daten verfügbar für die ausgewählten Filter.',
      selectLeagueFromTable: 'Wähle eine Liga aus der Tabelle aus, um den ELO-Trend anzuzeigen.',
      noInsightsData: 'Keine Analysedaten für die ausgewählten Wettbewerbe verfügbar. Bitte stelle sicher, dass die Wettbewerbe verfügbare Saisons und Teamanalysedaten haben.',
      showingLeagueAveragesLastSeason: 'Nur Liga-Durchschnitte für deren letztes aktives Saison angezeigt',
      selectTopTooltip: 'Zeigen Sie zum Vergleich weitere Ligen in der Tabelle an',
      confederations: {
        world: 'Welt',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Anzahl der Ligen',
      minimumElo: 'Mindest-ELO'
    },
    players: {
      title: 'GPI des Spielers',
      subtitle: 'Rankings und Einblicke von Global Playern',
      gpiRanking: 'GPI-Ranking',
      rankTooltip: 'Bewegen Sie den Mauszeiger, um das globale Ranking anzuzeigen',
      globalRanking: 'Globales Ranking',
      player: 'Spieler',
      players: 'Spieler',
      gpiTrend: 'GPI-Trend',
      currentGPILabel: '(Aktueller GPI)',
      nationality: 'Geburtsland',
      position: 'Position',
      marketValue: 'Marktwert',
      apply: 'Anwenden',
      marketValueAndAgeTooltip: 'Geben Sie einen Bereich ein und klicken Sie auf „Anwenden“ oder drücken Sie die Eingabetaste.',
      searchPlaceholder: 'Einen Spieler suchen...',
      selectTopTooltip: 'Zeigen Sie zum Vergleich weitere Spieler in der Tabelle an',
      gpi: 'GPI',
      numberOfPlayers: 'Anzahl der Spieler',
      showingPlayerStatsLastSeason: 'Es werden nur die Durchschnittsstatistiken der Spieler für ihre letzte aktive Saison angezeigt',
      date: 'DATUM',
      showChartLabels: 'Beschriftungen anzeigen',
      marketValueTooltip: 'Geben Sie einen Bereich ein und klicken Sie auf „Anwenden“ oder drücken Sie die Eingabetaste.',
      freeAgents: 'Freie Agenten',
      selectPlayerFromTable: 'Wählen Sie einen Spieler aus der Tabelle aus, um den GPI-Trend anzuzeigen.'
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algerien',
    AO: 'Angola',
    AR: 'Argentinien',
    AU: 'Australien',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Belgien',
    BJ: 'Benin',
    BO: 'Bolivien',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Kambodscha',
    CA: 'Kanada',
    CF: 'Zentralafrikanische Rep.',
    CL: 'Chile',
    CO: 'Kolumbien',
    CD: 'Kongo DR',
    CG: 'Kongo',
    CI: 'Elfenbeinküste',
    CU: 'Kuba',
    CZ: 'Tschechien',
    DJ: 'Dschibuti',
    DO: 'Dominikanische Republik',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Äthiopien',
    FI: 'Finnland',
    PF: 'Französisch-Polynesien',
    GM: 'Gambia',
    DE: 'Deutschland',
    GI: 'Gibraltar',
    GL: 'Grönland',
    GP: 'Guadeloupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Ungarn',
    IN: 'Indien',
    IR: 'Iran',
    IE: 'Irland',
    IT: 'Italien',
    JP: 'Japan',
    KZ: 'Kasachstan',
    KI: 'Kiribati',
    KR: 'Süd Korea',
    KG: 'Kirgisistan',
    LV: 'Lettland',
    LS: 'Lesotho',
    LY: 'Libyen',
    LT: 'Litauen',
    MO: 'Macau SAR',
    MG: 'Madagaskar',
    MY: 'Malaysia',
    ML: 'Mali',
    MH: 'Marshall Islands',
    MR: 'Mauritanien',
    MX: 'Mexiko',
    MD: 'Republik Moldau',
    MN: 'Mongolien',
    MA: 'Marokko',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Niederlande',
    NZ: 'Neuseeland',
    NE: 'Niger',
    MP: 'Nördliche Marianen',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Philippinen',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Rumänien',
    RW: 'Rwanda',
    LC: 'Saint Lucia',
    SM: 'San Marino',
    SA: 'Saudi Arabien',
    RS: 'Serbien',
    SL: 'Sierra Leone',
    SK: 'Slowakei',
    SB: 'Salomonen',
    ZA: 'Süd Afrika',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Swasiland',
    CH: 'Schweiz',
    TW: 'Taiwan',
    TZ: 'Tansania',
    TG: 'Togo',
    TT: 'Trinidad und Tobago',
    TR: 'Türkei',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    GB: 'Vereinigtes Königreich',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Britische Jungferninseln',
    EH: 'Westsahara',
    ZM: 'Sambia',
    AL: 'Albanien',
    AD: 'Andorra',
    AG: 'Antigua und Barbuda',
    AM: 'Armenien',
    AT: 'Österreich',
    BS: 'Bahamas',
    BD: 'Bangladesch',
    BY: 'Weißrussland',
    BZ: 'Belize',
    BT: 'Bhutan',
    BA: 'Bosnien und Herz.',
    BR: 'Brasilien',
    BG: 'Bulgarien',
    BI: 'Burundi',
    CM: 'Kamerun',
    CV: 'Kap Verde',
    TD: 'Tschad',
    CN: 'China',
    KM: 'Komoren	',
    CR: 'Costa Rica',
    HR: 'Kroatien',
    CY: 'Zypern',
    DK: 'Dänemark',
    DM: 'Dominica',
    TL: 'Osttimor',
    EG: 'Ägypten',
    GQ: 'Äquatorialguinea',
    EE: 'Estland',
    FJ: 'Fiji',
    FR: 'Frankreich',
    GA: 'Gabun',
    GE: 'Georgien',
    GH: 'Ghana',
    GR: 'Griechenland',
    GD: 'Grenada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong SAR',
    IS: 'Island',
    ID: 'Indonesien',
    IQ: 'Irak',
    IL: 'Israel',
    JM: 'Jamaika',
    JO: 'Jordanien',
    KE: 'Kenia',
    KP: 'Nord Korea',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Libanon',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxemburg',
    MK: 'Nord-Mazedonien',
    MW: 'Malawi',
    MV: 'Malediven',
    MT: 'Malta',
    MQ: 'Martinique',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Monaco',
    ME: 'Montenegro',
    MZ: 'Mosambik',
    NA: 'Namibia',
    NP: 'Nepal',
    NC: 'Neukaledonien',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norwegen',
    PK: 'Pakistan',
    PS: 'Palästina',
    PG: 'Papua-Neuguinea',
    PE: 'Peru',
    PL: 'Polen',
    PR: 'Puerto Rico',
    RE: 'Réunion',
    RU: 'Russland',
    KN: 'St. Kitts und Nevis',
    WS: 'Samoa',
    ST: 'Sao Tome und Princ.',
    SN: 'Senegal',
    SC: 'Seychellen',
    SG: 'Singapur',
    SI: 'Slowenien',
    SO: 'Somalia',
    ES: 'Spanien',
    VC: 'St. Vincent und die Grenadinen',
    SR: 'Suriname',
    SE: 'Schweden',
    SY: 'Syrien',
    TJ: 'Tadjikistan',
    TH: 'Thailand',
    TO: 'Tonga',
    TN: 'Tunesien',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'Vereinigte Arabische Emirate',
    US: 'Vereinigte Staten',
    UZ: 'Usbekistan',
    VA: 'Vatikanstadt',
    VN: 'Vietnam',
    VI: 'Amerikanische Jungferninseln',
    YE: 'Jemen',
    ZW: 'Simbabwe',
    EU: 'Europa',
    INT: 'International',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'England',
    'GB-WLS': 'Wales',
    'GB-SCT': 'Schottland',
    LATAM: 'Süd Amerika',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten'
  },
  loadingMessages: {
    players: 'Spieler werden vorbereitet',
    teams: 'Mannschaften werden vorbereitet',
    games: 'Spiele werden fertiggestellt',
    stats: 'Die Messungen werden fertiggestellt',
    graphs: 'Diagramme werden fertiggestellt',
    gettingReady: 'Wird vorbereitet',
    placeholder: 'Bereit machen'
  },
  requestReport: {
    subtitle: 'Erhalten Sie einen ausführlichen Bericht mit allem, was Sie brauchen',
    categories: {
      scouting: {
        title: 'Scouting',
        subtitle: 'Wer sind die besten Spieler einer bestimmten Liga? Und von verschiedenen Ligen kombiniert? Fordern Sie einen maßgeschneiderten Bericht mit jedem gewünschten Filter an (Alter, Größe, Vertragslaufzeit, etc..) und finde heraus, welche Spieler am besten passen'
      },
      coaches: {
        title: 'Trainer',
        subtitle: 'Wie würde ein Trainer in das System Ihrer Mannschaft passen? Holen Sie sich detaillierte Informationen oder erfahren Sie bei einem bestimmten Profil, welche Trainer am besten passen'
      },
      'team analysis': {
        title: 'Mannschaft',
        subtitle: 'Geben Sie ein Team an und erhalten Sie die Saisonzusammenfassung mit wertvollen Erkenntnissen über Stil, Defensiv- und Offensivleistung, Schwachstellen, beste Spieler, etc...'
      },
      'game analysis': {
        title: 'Spielanalyse',
        subtitle: 'Erhalten Sie bei einem Spiel eine gründliche Analyse vor und nach dem Spiel mit detaillierten Informationen'
      },
      'special projects': {
        title: 'Spezielle Projekte',
        subtitle: 'Wie verhält sich ein Spieler in Auswärtsspielen? Wie wechseln Spieler von Liga zu Liga? Welche Spieler stehen zur Leihe zur Verfügung? Frag alles, was dir einfällt'
      },
      conversation: {
        title: 'Conversation',
        subtitle: 'Beginnen Sie ein Gespräch mit unserem Team'
      }
    },
    notesPlaceholder: 'Teilen Sie uns die Liga, das Profil, die Statistiken, den Trainer, das Team oder das Spiel mit, über das Sie mehr erfahren möchten',
    chooseType: 'Wählen Sie einen Berichtstyp aus',
    requestSummary: 'Zusammenfassung anfordern',
    reportType: 'Berichtstyp',
    reportLanguage: 'Berichtssprache',
    detailTitle: 'Nachbereitung des Berichts',
    detailSubtitle: 'Alle Informationen über den von Ihnen angeforderten Bericht'
  },
  bugReport: {
    modalSubtitle: 'Helfen Sie uns, uns zu verbessern',
    about: 'Über',
    sendSuccess: 'Erfolgreich benachrichtigt. Überprüfen Sie für Updates Ihren Posteingang',
    bugs: 'Fehler'
  },
  gbe: {
    autopass: 'Autopass',
    bandX: 'Band {0}',
    bandXCont: 'Band {0} Kontinentaler Wettbewerb',
    points: 'Punkte',
    titleWinner: 'Titelgewinner',
    qualifiedGroupsBandX: 'Qualifiziert für die Gruppenphase eines Verbandes {0} Kontinentalwettbewerbs',
    qualifiedQualifiersBandX: 'Qualifiziert für die Qualifikationsspiele eines Verbandes {0} Kontinentaler Wettbewerb',
    midTable: 'Mitte der Tabelle',
    relegation: 'Relegation',
    promotion: 'Aufstieg',
    final: 'Finale',
    semifinal: 'Halbfinale',
    quarterfinal: 'Viertelfinale',
    round16: 'Achtelfinale',
    round32: 'Erste K.O. Phase',
    groupstage: 'Gruppen Phase',
    firstRound: '1st Round',
    secondRound: '2nd Round',
    thirdRound: '3rd Round',
    fourthRound: '4th Round',
    preliminaryRound: 'Preliminary Round',
    other: 'Andere',
    score: 'Ergebnisse',
    totalSummary: 'Gesamtzusammenfassung',
    currentlyPlayingInUK: 'Der Spieler ist ein Bürger des Vereinigten Königreichs oder Irlands, oder der Spieler hat einen ständigen Wohnsitz im Vereinigten Königreich',
    bandsAlert: 'Es werden Minuten in zwei verschiedenen Dateien zusammengstellt, insgesamt ist der Maximalwert',
    bandsAlertMax: 'Es gibt Minuten, die in mehr als einer Datei zusammegestellt werden, die Summe ist der Maximalwert',
    bandsAlertAvg: 'Es gibt Minuten, die in mehr als einer Datei zusammengestellt werden, die Summe ist der Durchschnittswert.',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: 'Debut for Youth Player',
    table1: {
      name: 'Internationale Auftritte des Spielers',
      title1: 'Addierte FIFA-Weltrangliste des Nationalverbandes des Spielers',
      title2: 'Internationale Auftritte des Spielers'
    },
    table2: {
      name: 'Inlandsminuten des Spielers',
      title1: 'Inlandsminuten des Spielers'
    },
    table3: {
      name: 'Kontinentale Minuten des Spielers',
      title1: 'Kontinentale Minuten des Spielers'
    },
    table4: {
      name: 'Endgültige Ligaposition des letzten Klubs des Spielers',
      title1: 'Endgültige Ligaposition des letzten Vereins'
    },
    table5: {
      name: 'Kontinentale Entwicklung vom letzten Klub des Spielers',
      title1: 'Kontinentale Entwicklung'
    },
    table6: {
      name: 'Ligaqualität des aktuellen Vereins des Spielers',
      title1: 'Verband des aktuellen Clubs des Spielers'
    },
    table7: {
      name: 'Jugend - Debüt',
      title1: 'Verband'
    },
    table8: {
      name: 'Jugend - Endgültige Ligaposition',
      title1: 'Endgültige Ligaposition des letzten Vereins'
    },
    table9: {
      name: 'Jugend - Kontinentale Entwicklung',
      title1: 'Kontinentale Entwicklung'
    },
    table10: {
      name: 'Jugend - Ligaqualität des aktuellen Clubs des Spielers',
      title1: 'Verband des aktuellen Clubs des Spielers'
    },
    table11: {
      name: 'Jugend - Ligaqualität des aktuellen Clubs des Spielers',
      title1: 'Verband des aktuellen Clubs des Spielers'
    },
    table12: {
      name: 'Jugend - Internationale Auftritte',
      title1: 'Internationale Auftritte des Spielers'
    }
  },
  mediaMode: {
    borderColor: 'Randfarbe',
    fillColor: 'Füllfarbe',
    bgColor: 'Hintegrundfarbe',
    upperText: 'Oberer Text',
    lowerText: 'Unterer Text',
    socialMedia: 'Social Media',
    textColor: 'Textfarbe',
    axisColor: 'Achsenfarben',
    logo: 'Logo',
    comparisonBorderColor: 'Randfarbe vergleichen',
    comparisonFillColor: 'Füllfarbe vergleichen',
    comparisonUpperText: 'Oberer Text vergleichen',
    comparisonLowerText: 'Unterer Text vergleichen',
    homeFillColor: 'Heim Füllfarbe',
    homeBorderColor: 'Heim Randfarben',
    awayFillColor: 'Auswärts Füllfarben',
    awayBorderColor: 'Auswärts Randfarben',
    face: 'Gesicht',
    nationalTeam: 'Nationalmannschaft',
    comparisonFace: 'Gesicht vergleichen',
    upperTextX: 'Oberer Text {0}',
    lowerTextX: 'Unterer Text {0}',
    borderColorX: 'Randfarbe {0}',
    fillColorX: 'Füllfarbe {0}',
    homeFillColorX: 'Füllfarbe (Home) {0}',
    homeBorderColorX: 'Randfarbe  (Home) {0}',
    awayFillColorX: 'Füllfarbe (away) {0}',
    awayBorderColorX: 'Randfarbe (away) {0}',
    faceX: 'Gesicht {0}',
    selectField: 'Wählen Sie eine Eigenschaft aus',
    orientationX: 'Orientierung {0}',
    searchBarPlaceholder: 'Spieler und/oder Spiele suchen...',
    title: 'Medien-Dashboard',
    pageSubtitle: 'Karten und Grafiken durchsuchen und herunterladen',
    chooseChart: 'Diagramm auswählen...',
    headerTextX: 'Überschrift {0}',
    avatarLineLength: 'Avatar-Zeilenlänge',
    avatarLineWeight: 'Avatar-Linienstärke',
    avatarSize: 'Avatar Größe',
    chartX: 'Diagramm {0}',
    chartHeaderFontSize: 'Schriftgröße der Diagrammkopfzeile',
    chartHeaderFontWeight: 'Fontgröße der Diagrammkopfzeile',
    upperTextFontSize: 'Schriftgröße des oberen Textes',
    upperTextFontWeight: 'Fontgröße des oberen Textes',
    lowerTextFontSize: 'Niedrigere Textgröße',
    lowerTextFontWeight: 'Niedrigere Fontgröße',
    socialMediaFontSize: 'Schriftgröße für soziale Medien',
    socialMediaFontWeight: 'Fontgröße in sozialen Medien',
    subtitle: 'Untertitel',
    subtitleFontSize: 'Untertitel-Schriftgröße',
    subtitleFontWeight: 'Untertitel Fontgröße',
    subtitleX: 'Untertitel {0}',
    subtitleFontSizeX: 'Untertitel ${0} Fontgröße',
    subtitleFontWeightX: 'Untertitel ${0} Fontgröße',
    titleX: 'Titel {0}',
    titleFontSize: 'Titel Fontgröße',
    titleFontWeight: 'Titel Fontgröße',
    sponsor: 'Sponsor',
    fontFamily: 'Font family'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Scoutingbericht',
      GAME_REPORT: 'Spielbericht',
      MEDICAL_REPORT: 'Medizinischer Bericht',
      PHYSICAL_REPORT: 'Physicher Bericht',
      PSYCHOLOGICAL_REPORT: 'Psychologischer Bericht ',
      OTHER: 'Andere',
      QUICK_NOTES: 'Kurze Notizen',
      PLAYER_REPORT: 'Spieler Report',
      GENERAL_COMMENTS: 'Allgemeine Kommentare',
      PLAYER_ANALYSIS: 'Spieler-Analyse'
    },
    uploadDocument: 'Dokument hochladen',
    notesPlaceholder: 'Geben Sie beschreibende Anmerkungen oder Kommentare zum Dokument ein',
    notesPlaceholderAlt: 'Geben Sie beschreibende Notizen oder Kommentare zum Spieler ein',
    uploadedBy: 'Hochgeladen von',
    updatedBy: 'Aktualisiert von',
    seeNotes: 'Siehe Notizen',
    addNote: 'Notizen hinzufügen',
    rating: 'Rating',
    position: 'Beste Position',
    physical: 'Physical',
    onBall: 'On Ball',
    offBall: 'Off Ball',
    mental: 'Mental',
    potential: 'Potential',
    conclusion: 'Conclusion',
    recommendation: {
      1: 'Verpflichten',
      2: 'Beobachten',
      3: 'Verwerfen',
      4: 'Interessant',
      label: 'Empfehlung'
    },
    match: 'Spiel',
    deleteQuickNote: 'Notiz löschen',
    deleteQuickNoteMessage: 'Die Notiz wird dauerhaft gelöscht. Sind Sie sicher?',
    noQuickNotes: 'Keine Daten. Beginnen Sie damit, einige Notizen hinzuzufügen!',
    deleteDocument: 'Dokument löschen',
    deleteDocumentMessage: 'Das Dokument wird dauerhaft gelöscht. Sind Sie sicher?',
    noDocuments: 'Keine Daten. Beginnen Sie damit, einige Dokumente hinzuzufügen!'
  },
  notifications: {
    newReportMessage: 'Es gibt eine neue Nachricht in einem Bericht'
  },
  blog: {
    subtitle: 'Neueste Artikel, Updates und Neuigkeiten',
    newEntry: 'Neuer Eintrag',
    title: 'Titel',
    text: 'Text',
    link: 'Link',
    image: 'Bild',
    author: 'Autor',
    date: 'Veröffentlichungsdatum',
    deleteEntry: 'Eintrag löschen',
    deleteEntryMessage: 'Möchten Sie diesen Eintrag wirklich löschen?',
    readMore: 'Mehr lesen'
  },
  positionsOrlegi: {
    GK: 'Torwart',
    DC: 'Innenverteidiger',
    DR: 'Außenverteidiger',
    MC: 'Mittelfeldspieler',
    AMC: 'Offensiver Mittelfeldspieler',
    FW: 'Stürmer',
    FWR: 'Flügelspieler'
  },
  library: {
    subtitle: 'Anzeigen und Freigeben von hochgeladenen Dokumenten',
    mediaSubtitle: 'Exportierte Diagramme anzeigen und weitergeben',
    charts: 'Diagramme',
    goToLibrary: 'Zur Bibliothek gehen'
  },
  scatterPlot: {
    bubbleSize: 'Blasengröße',
    byMinutes: 'Nach Minuten',
    byAge: 'Nach Alter',
    byMarketValue: 'Nach Marktwert'
  },
  eventChart: {
    successfulEvent: 'Erfolgreich',
    unsuccessfulEvent: 'Erfolglos',
    possessionLost: 'Erfolgreich, nicht wiederhergestellt',
    successfulPass: 'Erfolgreicher Pass',
    unsuccessfulPass: 'Erfolgloser Pass',
    successfulCarry: 'Erfolgreiche Ballmitnahme',
    unsuccessfulCarry: 'Erfolglose Ballmitnahme',
    carryAndKeyPass: 'Ballmitnahme & Schlüsselpass',
    carryAndAssist: 'Ballmitnahme & Vorlage',
    carryAndShot: 'Ballmitnahme & Schuss',
    ballProgressionAndPass: 'Ballbesitz & Pass',
    ballProgression: 'Ballbesitz',
    ballProgressionAndKeyPass: 'Ballbesitz & Schlüsselpass',
    ballProgressionAndAssist: 'Ballbesitz & Vorlage',
    ballProgressionAndShot: 'Ballbesitz & Schuss',
    ballProgressionAndGoal: 'Ballbesitz & Tor',
    pass: 'Pass',
    carryAndPass: 'Ballmitnahme & Pass',
    carryAndGoal: 'Ballmitnahme & Tor',
    totalTouches: 'Ballberührungen',
    totalPasses: 'Gesamtpässe',
    successful: 'Erfolgreich',
    unsuccessful: 'Erfolglos',
    tacklePossessionLost: 'Erfolgreich – Besitz verloren',
    gamesSelected: '{count} Spiele ausgewählt',
    allGamesOfSeason: 'Alle Spiele der Saison',
    allGamesOfSeasons: 'Alle Spiele der Saisons',
    allEvents: 'Alle Ereignisse',
    eventTypesCount: '{count} Ereignistypen',
    totalEvents: 'Gesamtzahl der Ereignisse'
  },
  event: {
    Pass: 'Pass',
    TakeOn: 'Dribbling',
    Takeon: 'Dribbling',
    Foul: 'Foul',
    Error: 'Fehler',
    Tackle: 'Zweikampf',
    Interception: 'Ballabfangung',
    Clearance: 'Klärungen',
    MissedShot: 'Verfehlte Schüsse',
    ShotOnPost: 'Pfostentreffer',
    SavedShot: 'Gehaltene Schüsse',
    Goal: 'Tor',
    Aerial: 'Luftduelle',
    BallRecovery: 'Balleroberung',
    Dispossessed: 'Ballverlust',
    ChanceMissed: 'Verpasste Chance',
    BallTouch: 'Ballberührung',
    BlockedPass: 'Geblockter Pass',
    Challenge: 'Herausforderung',
    lossPossession: 'Ballverlust',
    OffsidePass: 'Abseits-Pass',
    groundDuelsLost: 'Verlorene Bodenzweikämpfe',
    'Ball touch': 'Ballkontrolle',
    Smother: 'Abdämpfung',
    'Keeper pickup': 'Ballaufnehmen vom Torwart',
    'Good skill': 'gutes Geschicklichkeitsvermögen',
    Punch: 'Fäusten',
    'Saved shot': 'Gehaltener Schuss',
    'Shot on post': 'Pfostentreffer',
    'Missed shot': 'Verfehlter Schuss',
    Save: 'Parade',
    'Take on': 'Antreten',
    'Offside pass': 'Abseits Pass',
    Claim: 'Anspruch',
    'Blocked pass': 'Geblockter Pass',
    KeeperPickup: 'Abholung durch den Halter',
    'Ball recovery': 'Balleroberung',
    'Ball Recovery': 'Balleroberung',
    'Chance missed': 'Verpasste Chance',
    'Loss possession': 'Ballverlust',
    Carries: 'Ballführung',
    BallProgression: 'Ballfortschritt',
    MissedChance: 'Verpasste Chance',
    Event: 'Ereignis',
    Shot: 'Schuss',
    Assist: 'Vorlage',
    KeyPass: 'Schlüsselpass',
    'Foul taken': 'Foul erhalten'
  },
  leagueTab: {
    leagueTable: 'League Table',
    matchdays: 'Matchdays',
    playerInsights: 'Player Insights',
    onlyLocalPlayers: 'Nur lokale Spieler',
    teamInsights: 'Team Insights',
    head2head: 'Head To Head',
    addNewChart: 'Add new chart',
    rounds: {
      16: 'Round of 16',
      32: 'Round of 32',
      W: 'Winner',
      F: 'Final',
      SF: 'Semi-Finals',
      QF: 'Quarter-Finals',
      GR: 'Group Stage',
      '4R': 'Fourth Round',
      '3R': 'Third Round',
      '2R': 'Second Round',
      '1R': 'First Round',
      PR: 'Preliminary Round',
      QPO1: 'Make Round of 32 Tier Below',
      QPO2: 'Qualifier Round of 16',
      QPO3: 'Qualifikationsrunde der letzten 32'
    },
    positions: 'Positions',
    prediction: 'Predictions',
    predicted: 'Vorhersage',
    groups: 'Groups',
    ranking: 'Ranking',
    numberOfTeams: 'Anzahl der Teams',
    statsWithMinimum: {
      message: 'Es werden nur Spieler mit mehr als {0} {1} in der ausgewählten Saison angezeigt',
      dribblesTotal90: 'dribblings pro 90 Minuten',
      crosses90: 'flanken pro 90 Minuten',
      tacklesAttempted90: 'versuchte Tacklings pro 90 Minuten',
      aerialsTotal90: 'Luftzweikämpfe pro 90 Minuten'
    },
    numberOfLeagues: 'Anzahl der Ligen',
    position: {
      titleWinner: 'Titelgewinner',
      championsLeague: 'Champions League',
      qualifierChampionsLeague: 'Qualifikation Champions League',
      europeLeague: 'Europaliga',
      qualifierEuropeLeague: 'Qualifikation Europa League',
      conferenceLeague: 'Konferenzliga',
      qualifierConferenceLeague: 'Qualifikations-Conference-League',
      midTable: 'Mitteltisch',
      relegation: 'Abstieg',
      promotion: 'Förderung',
      relegationPlayoff: 'Abstiegs-Play-off',
      promotionPlayoff: 'Aufstiegs-Play-off',
      championshipGroup: 'Meisterschaftsgruppe',
      relegationGroup: 'Abstiegsgruppe',
      championshipPlayoffs: 'Meisterschafts-Playoffs',
      preChampionshipPlayoffs2: 'Playoffs vor der Meisterschaft 2',
      preChampionshipPlayoffs3: 'Playoffs vor der Meisterschaft 3',
      playoffsQualifierBand3: 'Playoffs-Qualifikationsband 3',
      continentalGroup: 'Continental-Gruppe'
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'ICH',
      10: 'J',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: 'Find similar players',
    searchBarPlaceholder: 'Search and select a player to find similar',
    radarFilters: 'Radar filters',
    similarityFilters: 'Similarity filters',
    playersFilters: 'Players filters',
    similarPlayers: 'Similar Players',
    seasonWarning: 'Nur Saisons im Similarity Tool, in denen mindestens 450 Einsatzminuten absolviert wurden, stehen zur Verfügung'
  },
  squadBuilder: {
    subtitle: 'Sketch your unique elevens',
    playerSelector: 'Player selector',
    loadSquad: 'Load squad',
    yearsOld: 'yo.',
    playersPerPosition: 'Players per position',
    custom: 'Custom',
    removeSquad: 'Kader löschen',
    removeSquadMessage: 'Sind Sie sicher, dass Sie den Kader löschen wollen?',
    deleteSquadSuccess: 'Kader wurde erfolgreich gelöscht',
    playerDetails: 'Sichtbarkeit der Details',
    ageFormat: 'Altersformat',
    mainPlayer: 'Hauptspieler',
    showDetails: 'Details anzeigen',
    all: 'Alle',
    squadPosition: 'Position im Kader',
    noData: 'Keine Daten. Fügen Sie zunächst einige Spieler auf dem Spielfeld hinzu!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Nicht mehr auftauchen',
      skipTour: 'Geführte Tour überspringen',
      previous: 'Zurück',
      next: 'Weiter',
      finish: 'Beenden'
    },
    playerRadar: {
      step1: {
        title: 'PERSÖNLICHE DATEN',
        message: 'Überprüfen der grundlegenden Spielerdaten: Alter, Größe oder Vertragsdaten'
      },
      step2: {
        title: 'GBE-FILTER',
        message: 'Funktion, die es ermöglicht, festzustellen, ob ein Spieler genug GBE-Punkte hat, um in Großbritannien zu spielen'
      },
      step3: {
        title: 'VERFÜGBARKEIT',
        message: 'Prozentsatz der verfügbaren Minuten und Prozentsatz der gespielten Minuten'
      },
      step4: {
        title: 'POSITIONEN',
        message: 'Finden Sie heraus, auf welchen Positionen der Spieler gespielt hat und wie viele Minuten er auf jeder Position gespielt hat'
      },
      step5: {
        title: 'ANZEIGEFORMATE',
        message: 'Messen Sie die Leistung mit 4 verschiedenen Visualisierungen, Radar, Polar, Lollipop und Text, um sie mit den Spielern auf seiner Position zu vergleichen'
      },
      step6: {
        title: 'LEISTUNGSRADAR',
        message: 'Hier wird die Leistung visuell dargestellt. Das Panel ist interaktiv, Sie können mit dem Mauszeiger über jede Kennzahl fahren und erhalten ihre Definition'
      },
      step7: {
        title: 'SAISONAUSWAHL',
        message: 'Wählen Sie Saisons aus oder fügen Sie welche hinzu, um Ihre Leistung zu messen'
      },
      step8: {
        title: 'AUSWAHL DER BENUTZERDEFINIERTEN VORLAGE',
        message: 'Verwenden Sie die benutzerdefinierten Vorlagen, die Sie erstellt haben, um den Spieler mit anderen Metriken als dem Standardradar zu messen'
      },
      step9: {
        title: 'AUSWAHL DER GESPIELTEN POSITIONEN',
        message: 'Aktivieren und deaktivieren Sie die verschiedenen Positionen, um den Spieler auf der Position zu messen, auf der Sie ihn messen möchten'
      },
      step10: {
        title: 'AUSWAHL DER MINIMA UND MAXIMA',
        message: 'Messen Sie den Spieler mit den Höchst- und Tiefstwerten seiner Saison, der fünf besten Ligen oder der eigenen und der Standardsaison des Benutzerkontos'
      },
      step11: {
        title: 'SPIELERVERGLEICH',
        message: 'Vergleicht den Spieler mit seiner vorherigen Leistung, mit anderen'
      },
      step12: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Es stehen drei Download-Formate zur Verfügung: png, svg und embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'SAISON, KADER UND POSITION',
        message: 'Wählen Sie die Saison, den Kader und die Position aus, mit der der Spieler verglichen werden soll'
      },
      step2: {
        title: 'GRUNDLEGENDE FILTER',
        message: 'Filtern Sie die Spielereigenschaften nach Alter, Minuten und Größe'
      },
      step3: {
        title: 'MARKIEREN UND AUSSCHLIESSEN',
        message: 'Markieren Sie die gewünschten Kreise (Spieler) und schließen Sie Teams aus der Anzeige aus'
      },
      step4: {
        title: 'FILTERN NACH SPIELSITUATIONEN',
        message: 'Wählen Sie die Statistik nach Gruppen: Verband, Verteidigung, Passspiel, Ballbehandlung, usw'
      },
      step5: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Es stehen drei Download-Formate zur Verfügung: png, svg und embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'ANZEIGE AUSWÄHLEN',
        message: 'Sie können die Abschlusskarte in der Hauptansicht, in der Toransicht und in einer Verteilungstabelle sehen'
      },
      step2: {
        title: 'AUSWAHL SAISONS',
        message: 'Fügen Sie Saisons hinzu, um Ihre Schusseffizienz zu messen'
      },
      step3: {
        title: 'ABSCHLUSSPOSTITION',
        message: 'Wählen Sie die Möglichkeit, die genaue Position des Schusses (Kreise) oder nach Bereichen des Kastens und des Spielfelds (Bereiche) zu sehen'
      },
      step4: {
        title: 'xG AUF DAS TOR',
        message: 'Aktivieren Sie die Kästchen für xG to Goal und xG Completion, um zu sehen, welchen Mehrwert der Spieler nach dem Schuss erzielt hat'
      },
      step5: {
        title: 'SCHUSSART',
        message: 'Filter nach Schussart, Strategie, Bereich oder Körperteil'
      },
      step6: {
        title: 'FILTER MINUTEN',
        message: 'Es stehen drei Download-Formate zur Verfügung: png, svg und embed'
      },
      step7: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Es stehen drei Download-Formate zur Verfügung: png, svg und embed'
      },
      step8: {
        title: 'SCHUSSKARTE',
        message: 'Die Karte ist interaktiv. Überprüfen Sie jeden Kreis mit der Maus, um die xG für jeden Schuss zu erfahren'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'SAISONAUSWAHL',
        message: 'Fügen Sie Saisons hinzu, um Ihre Schusseffizienz zu messen'
      },
      step2: {
        title: 'ORT DES SCHLÜSSELPASSES',
        message: 'Wählen Sie die Möglichkeit, den genauen Ort des Schlüsselpasses (Kreis) oder nach Bereichen des Bereichs und des Feldes (Bereiche) anzuzeigen'
      },
      step3: {
        title: 'ART DES ABSCHLUSSES NACH KEY PASS',
        message: 'Filtern Sie nach der Art des Schusses, der Strategie, dem Bereich oder dem Körperteil, der nach dem Steilpass ausgeführt wurde'
      },
      step4: {
        title: 'FILTER MINUTEN',
        message: 'Minutenleiste zur Auswahl von Schüssen und Toren, die in bestimmten Spielperioden erzielt wurden'
      },
      step5: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Es stehen drei Download-Formate zur Verfügung: png, svg und embed'
      },
      step6: {
        title: 'SCHLÜSSELPASS-KARTE',
        message: 'Die Karte ist interaktiv. Konsultieren Sie jeden Kreis mit der Maus, um xA eines jeden Passes zu erfahren'
      }
    },
    playerThreat: {
      step1: {
        title: 'SAISONAUSWAHL',
        message: 'Fügen Sie Saisons hinzu, um Ihren Threat zu messen'
      },
      step2: {
        title: 'THREAT POSITION',
        message: 'Wählen Sie die Möglichkeit, die genaue Position des Schlüsselpasses (Kreis) oder nach Bereich und Feldzonen (Bereiche) anzuzeigen'
      },
      step3: {
        title: 'AKTION UND ABSCHLUSS',
        message: 'Aktivieren oder deaktivieren Sie diese Option je nach Art der Aktion und des Abschlusses, die Sie auf der Karte anzeigen möchten'
      },
      step4: {
        title: 'MINUTEN UND THREAT',
        message: 'Filtern Sie nach Zeitraum, nach Minuten und nach dem Threat der Aktionen'
      },
      step5: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Es stehen drei Download-Formate zur Verfügung: png, svg und embed'
      },
      step6: {
        title: 'THREAT ZONEN',
        message: 'Die Karte ist interaktiv. Konsultieren Sie jeden Kreis mit der Maus, um herauszufinden, welche Bedrohung in jedem xT-Spiel jedes Durchgangs erzeugt wurde'
      }
    },
    playerTouches: {
      step1: {
        title: 'SPIEL- UND EREIGNISAUSWAHL',
        message: 'Wählen Sie das Spiel und die Ereignisse aus, die Sie auf der Karte anzeigen möchten'
      },
      step2: {
        title: 'EREIGNISTYP',
        message: 'Aktivieren oder deaktivieren Sie diese Option, je nachdem, ob das Ereignis des Spielers während des Spiels defensiv oder offensiv ist'
      },
      step3: {
        title: 'ANZEIGEFILTER',
        message: 'Filtern der Karte nach Grundaktionen, Heatmap, Kreisen oder Boxen'
      },
      step4: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Es stehen drei Download-Formate zur Verfügung: png, svg und embed'
      },
      step5: {
        title: 'KARTE DER BALLBERÜHRUNGEN',
        message: 'Die Karte ist interaktiv. Sie können sich jedes Ereignis ansehen, indem Sie auf das Ereignis klicken'
      }
    },
    playerAllGames: {
      step1: {
        title: 'VERFÜGBARKEIT',
        message: 'Prüfen Sie die Verfügbarkeit und die gespielten Minuten für jedes einzelne Spiel'
      },
      step2: {
        title: 'POSITIONEN',
        message: 'Konsultieren Sie die Positionen, auf denen er in jedem Spiel gespielt hat'
      }
    },
    playerInjuries: {
      step1: {
        title: 'VORGESCHICHTE UND AUSFALLTAGE',
        message: 'Konsultieren Sie die Verletzungen des letzten Jahres oder die gesamte Geschichte und den Bereich der Verletzungen nach ihrer Dauer'
      },
      step2: {
        title: 'VERLETZUNGEN NACH VEREIN',
        message: 'Konsultieren Sie die Verletzungen getrennt nach Saison und/oder Verein seiner Laufbahn'
      }
    },
    playerInfo: {
      step1: {
        title: 'KARRIERE UND TRANSFERS',
        message: 'Sie können die Minuten, die Position oder die Verfügbarkeit in seinem Verein, in seiner Nationalmannschaft und die Transfers des Spielers während seiner Karriere einsehen'
      }
    },
    teamOverview: {
      step1: {
        title: 'TEAMBLATT',
        message: 'Grunddaten der Mannschaft abfragen: Durchschnittsalter, Grundformation, ELO oder Transferbilanz'
      },
      step2: {
        title: 'GRUNDLEGENDE STATISTIKEN',
        message: 'Konsultieren Sie Besitz, xG, Schüsse, PPDA oder Vertikalität'
      },
      step3: {
        title: 'RADAR UND JAHRESZEIT',
        message: 'Wählen Sie Radar, Saison und Heim- oder Auswärtsspiele, um die Leistung der Mannschaft zu messen'
      },
      step4: {
        title: 'NACH TRAINER UND SPIELEN FILTERN',
        message: 'Wählen Sie für jeden Trainer die Leistung nach Stufe aus'
      },
      step5: {
        title: 'LEISTUNGSRADAR',
        message: 'Das Panel ist interaktiv, Sie können mit dem Mauszeiger über jede Kennzahl fahren und deren Definition abrufen'
      },
      step6: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Zwei Download-Formate sind verfügbar: png und svg'
      },
      step7: {
        title: 'KALENDER',
        message: 'Sehen Sie sich den Spielplan der Mannschaft an'
      },
      step8: {
        title: 'BESTE SPIELER NACH METRIKEN',
        message: 'In diesem Bereich können Sie verschiedene Metriken auswählen und sehen, welche Spieler am wichtigsten sind'
      },
      step9: {
        title: 'NÄCHSTES SPIEL UND VERLETZUNGEN',
        message: 'Überprüfen Sie den nächsten Gegner und die verletzten und gesperrten Spieler der Mannschaft'
      },
      step10: {
        title: 'DIAGRAMME UND TRENDS',
        message: 'Verschiedene Diagramme für die letzten 10 oder 20 Spiele anzeigen'
      }
    },
    teamRoster: {
      step1: {
        title: 'ANSICHTSTYP',
        message: 'Sehen Sie sich den Kader in 6 verschiedenen Kategorien an: nach Position, Vertragsende, Alter, Verfügbarkeit, Altersprofil und Spielfeld'
      }
    },
    teamLoans: {
      step1: {
        title: 'ANLEIHENDE SPIELER',
        message: 'Konsultieren Sie die Spieler, die an andere Mannschaften ausgeliehen wurden, und die Position, auf der sie spielen'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'SAISON UND KADER',
        message: 'Filtern Sie nach Saison, Radarkader und vergleichen Sie mit Ligen Ihrer Wahl'
      },
      step2: {
        title: 'LEISTUNG NACH MASSSTÄBEN',
        message: 'Sehen Sie, wo das Team in jeder Metrik im Vergleich zu allen Teams in den zuvor ausgewählten Ligen steht'
      },
      step3: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Drei Download-Formate sind verfügbar: png, svg und embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SAISONAUSWAHL',
        message: 'Jahreszeiten zur Messung der Schusseffizienz hinzufügen'
      },
      step2: {
        title: 'EIGENES ODER GEGNERISCHES FINISHING',
        message: 'Wählen Sie aus, ob Sie den Abschluss des Teams oder aller Gegner sehen möchten.'
      },
      step3: {
        title: 'SCHUSSPLAZIERUNG',
        message: 'Wählen Sie aus, wie Sie die Schüsse der Mannschaft sehen möchten, durch Kreise oder durch Zonen (Boxen)'
      },
      step4: {
        title: 'SCHUSS-TYP',
        message: 'Filtern nach Art der Aufnahme, Strategie, Bereich oder Körperteil'
      },
      step5: {
        title: 'FILTER-MINUTEN',
        message: 'Minutenleiste zur Auswahl von Schüssen und Toren, die in bestimmten Spielperioden erzielt wurden'
      },
      step6: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Drei Download-Formate sind verfügbar: png, svg und embed'
      },
      step7: {
        title: 'SCHÜSSE KARTE',
        message: 'Die Karte ist interaktiv. Überprüfen Sie jeden Kreis mit der Maus, um xG jedes Schusses herauszufinden'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SAISONAUSWAHL',
        message: 'Jahreszeiten zur Messung der Schusseffizienz hinzufügen'
      },
      step2: {
        title: 'EIGENE ODER KONKURRIERENDE SCHLÜSSELPÄSSE',
        message: 'Wählen Sie, ob Sie eine Karte mit den wichtigsten Pässen der Mannschaft oder aller Gegner sehen möchten'
      },
      step3: {
        title: 'STANDORT DES SCHLÜSSELPASSES',
        message: 'Wählen Sie aus, ob Sie die genaue Position des Schlüsselpasses (Kreis) oder nach Bereich und Feld (Kästchen) sehen möchten'
      },
      step4: {
        title: 'ART DES FINISHS NACH DEM DURCHGANG',
        message: 'Filter nach Art des Schusses, Strategie, Bereich oder Körperteil nach Schlüsselpass'
      },
      step5: {
        title: 'FILTER-MINUTEN',
        message: 'Minutenleiste zur Auswahl von Schüssen und Toren, die in bestimmten Spielperioden erzielt wurden'
      },
      step6: {
        title: 'BILD-DOWNLOAD-FORMATE',
        message: 'Drei Download-Formate sind verfügbar: png, svg und embed'
      },
      step7: {
        title: 'SCHÜSSE KARTE',
        message: 'Die Karte ist interaktiv. Konsultieren Sie jeden Kreis mit der Maus, um die xA eines jeden Durchgangs zu erfahren'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'NEUESTE SPIELE',
        message: 'Konsultieren Sie Ergebnisse, Ballbesitz, xG und Gewinnprozente aller Spiele der Mannschaft'
      }
    },
    teamTransfers: {
      step1: {
        title: 'ANKOMMEN',
        message: 'Abfrage aller Eingänge (Käufe + Überweisungen) pro Kalenderjahr'
      },
      step2: {
        title: 'ABFAHRTEN',
        message: 'Abfrage aller Abgänge (Verkäufe + Überweisungen) nach Kalenderjahr'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TRENDS',
        message: 'Abfrage der Mannschaftsform durch Serien, Siege, Unentschieden, Comebacks, Perioden mit Toren oder Arten von Toren'
      },
      step2: {
        title: 'STANDARD SITUATION',
        message: 'Vergleichen Sie die Leistung des Teams zwischen Standardspielen und offenen Spielen und erhalten Sie einen detaillierten Überblick über verschiedene Arten von Standardspielen.'
      },
      step3: {
        title: 'SUBSTITUATIONEN',
        message: 'Sehen Sie, wann das Team Auswechslungen vornimmt und welche Spieler am häufigsten ausgewechselt werden'
      },
      step4: {
        title: 'VERBINDUNGEN',
        message: 'Konsultieren Sie die häufigsten Verbindungen zwischen Spielern. Filtern Sie nach Saison und Art des Spiels'
      },
      step5: {
        title: 'ANGRIFFSZONEN',
        message: 'Entdecken Sie die Angriffsbereiche der Mannschaft und filtern Sie nach Saison oder Angriffstyp'
      },
      step6: {
        title: 'FORMATIONEN',
        message: 'Prüfen Sie die am häufigsten verwendeten Formationen und den Prozentsatz der Siege, Unentschieden und Niederlagen mit jeder dieser Formationen'
      },
      step7: {
        title: 'SCHUSSZONEN',
        message: 'Filter nach Saison, Mannschaft oder Gegner, Art der Darstellung der Karte, Schussarten oder Minuten'
      },
      step8: {
        title: 'CROSSINGS',
        message: 'Abfrage und Filterung nach Saison, Art der Anzeige, erfolgreich oder erfolglos, Start- und Zielort oder einschließlich Eckstöße'
      },
      step9: {
        title: 'SPIELER',
        message: 'Filtern Sie nach Saison, Art der Anzeige, erfolgreich oder erfolglos, Start- und Zielort oder einschließlich Eckstößen'
      }
    },
    teamOnOff: {
      step1: {
        title: 'JAHRESZEITEN UND SPIELE',
        message: 'Filter nach Saison, Spielen oder nach Heim- oder Auswärtsspielen'
      },
      step2: {
        title: 'SPIELER',
        message: 'Betrachten Sie die Leistung aller Spieler im Kader anhand zahlreicher Metriken'
      }
    }
  },
  alerts: {
    numPlayers: 'Number of players',
    newPlayersLastWeek: 'New players last week',
    subtitle: 'Get alerts when new players meet your search criteria',
    generalSubtitle: 'Benachrichtigungen über neue Spieler, die Ihren Kriterien entsprechen und Nachrichten über Ihre Lieblingsspieler',
    subtitlePlayer: 'Erhalten Sie Benachrichtigungen, wenn wir Neuigkeiten über Ihre Lieblingsspieler haben',
    subtitleSearch: 'Erhalten Sie Benachrichtigungen, wenn neue Spieler Ihren Suchkriterien entsprechen',
    favorite: 'Favorit',
    newEventCalendar: 'Neues Ereignis',
    updatedEventCalendar: 'Aktualisiertes Ereignis',
    newShareFrom: 'Neue Freigabe von ana@gmail.com',
    injuryAlert: 'Verletzungswarnung',
    contractAlert: 'Vertragswarnung',
    teamAlert: 'Verpflichtungswarnung',
    marketValueAlert: 'Marktwertwarnung',
    gameAlert: 'Spielwarnung'
  },
  videoEvents: {
    highlights: 'Highlights',
    fullGame: 'Full game',
    autoplay: 'Autoplay',
    searchBarPlaceholder: 'Search player, game or team...',
    subtitle: 'Analyze events through video',
    successful: 'Success',
    unsuccessful: 'Fail',
    playing: 'Playing',
    games: 'Games',
    moreFilters: 'More filters...',
    startArea: 'Start area',
    endArea: 'End area',
    select: 'Select',
    selectLastXGames: 'Select last {0} games',
    advancedFilters: 'Advanced Filters',
    freeKicks: 'Free Kicks',
    cornerKicks: 'Corner Kicks',
    allShots: 'All Shots',
    generateZip: 'Generate ZIP',
    zippedModalMessage: 'ZIP process has been started, could take some minutes. You would receive an email when is finished',
    clickToSeeVideo: 'Click to see video'
  },
  videoUpload: {
    subtitle: 'Upload video and create new game',
    uploadVideo: 'Upload video',
    selectPeriod: 'Select period',
    gameData: 'Game Data',
    venue: 'Venue',
    matchType: 'Match type',
    matchGroup: 'Match group',
    roundType: 'Round type',
    roundNumber: 'Round number',
    offsetFh: 'Offset First Half',
    offsetSh: 'Offset Second Half',
    offsetFhOT: 'Offset Overtime First Half',
    offsetShOT: 'Offset Overtime Second Half',
    homeLineup: 'Home Lineup',
    awayLineup: 'Away Lineup',
    existingPlayer: 'Existing player',
    newPlayer: 'New player',
    startingTeam: 'Starting',
    saveAndUpload: 'Save and upload',
    existingGame: 'Game exists already',
    sendToKora: 'Send',
    invalidForm: 'Invalid form',
    warningModalTitle: 'Anomalies have been detected',
    noScoreSheetWarning: 'No scoresheet attached',
    onlyOnePartUploadedWarning: 'Only one half time attached',
    continueQuestion: 'continue?',
    slaLimit: 'Sie haben {0} Spiele mit {1} hochgeladen. Ihr Limit beträgt {2}',
    requestedGames: 'Angeforderte Spiele',
    limitClose: 'Nur noch {0} Spiele anforderbar',
    limitReached: 'Sie haben Ihr Video-Upload-Limit erreicht. Das Hochladen weiterer Spiele kann zusätzliche Kosten verursachen.',
    seasonFinishedWarning: 'Dadurch wird ein Spiel in einer bereits beendeten Saison erstellt. Bitte überprüfen Sie, ob dies korrekt ist.',
    teamCountryWarning: 'Dieses Team stammt aus einem anderen Land als die gewählte Liga. Bitte überprüfen Sie, ob dies korrekt ist.',
    uploading: 'Hochladen',
    doNotNavigateAway: 'Bitte schließen Sie diesen Tab nicht, aktualisieren Sie die Seite nicht und navigieren Sie nicht weg, während der Upload läuft.',
    severalMinutes: 'Dieser Vorgang kann mehrere Minuten dauern.'
  },
  videoPlaylists: {
    subtitle: 'Collections of video highlights filters',
    savePlaylist: 'Save Playlist',
    seeAllPlaylists: 'Alle Listen anzeigen'
  },
  videoHighlights: {
    recap: 'Rekapitulieren',
    homeCondensed: 'Verdichtetes Heimspiel',
    awayCondensed: 'Verdichtetes Auswärtsspiel',
    selectedActions: 'Ausgewählte Aktionen',
    noActions: 'Keine Aktionen entsprechen den angegebenen Filterkriterien',
    noGames: 'Noch keine Spiele hochgeladen',
    attackingActions: 'Offensivaktionen',
    defensiveActions: 'Defensivaktionen',
    groundDuels: 'Boden-Zweikämpfe',
    penaltiesProvoked: 'Provozierte Elfmeter',
    goalkeeperActions: 'Aktionen des Torwarts',
    addSomeGames: 'Füge einige Spiele hinzu, um zu starten!',
    goToVideoUploadTool: 'Gehe zu Video-Upload',
    ballInPlay: 'Im Spiel',
    filterSeasons: 'Saisons filtern',
    streaming: 'Streaming',
    clips: 'Clips',
    qualifiers: {
      Pass: 'Pass',
      Save: 'Parade',
      'Saved Shot': 'Gehaltener Schuss',
      Shot: 'Schuss',
      Goal: 'Tor',
      'Missed Shot': 'Verfehlter Schuss',
      'Shot on Post': 'Schuss an den Pfosten',
      Error: 'Fehler',
      Clearance: 'Klärung',
      Aerial: 'Luftzweikampf',
      Challenge: 'Verlorenes Duell',
      Dispossessed: 'Ballverlust',
      Foul: 'Foul',
      Card: 'Karte',
      'Offside Pass': 'Abseits-Pass',
      Claim: 'Ball gefangen',
      'Keeper Pickup': 'Torwartaufnahme',
      'Ball Touch': 'Ballberührung',
      Dribble: 'Dribbling',
      Interception: 'Abfangen',
      Tackle: 'Zweikampf',
      'Ball Recovery': 'Ballrückeroberung',
      Takeon: 'Dribbling'
    },
    qualifierIds: {
      1: 'Langer Pass',
      2: 'Flanke',
      5: 'Direkter Freistoß',
      6: 'Ecke',
      9: 'Elfmeter',
      15: 'Kopfball',
      20: 'Rechter Fuß',
      21: 'Anderer Körperteil',
      22: 'Offenes Spiel',
      23: 'Konter',
      24: 'Standardsituation',
      25: 'Aus einer Ecke',
      26: 'Freistoß',
      28: 'Eigentor',
      29: 'Vorlage',
      31: 'Gelbe Karte',
      32: 'Zweite gelbe Karte',
      33: 'Rote Karte',
      72: 'Linker Fuß',
      73: 'Links',
      82: 'Gehaltener Schuss (ohne Torwart)',
      94: 'Abwehrblock',
      123: 'Torwartabwurf',
      124: 'Abstoß',
      160: 'Einwurf',
      170: 'Führt zum Tor',
      173: 'Sichere Klärung',
      174: 'Gefährliche Klärung',
      177: 'Gefangen',
      178: 'Stehend',
      179: 'Hechtend',
      182: 'Hände',
      183: 'Füße',
      185: 'Blockierte Flanke',
      210: 'Assist',
      215: 'Individuelle Aktion',
      279: 'Anstoß',
      285: 'Defensiv',
      286: 'Offensiv'
    },
    areas: {
      goalArea: 'Fünfmeterraum',
      boxLeft: 'Linker Strafraum',
      boxCenter: 'Zentraler Strafraum',
      boxRight: 'Rechter Strafraum',
      outBoxDeepLeft: 'Außerhalb Strafraum Links Tief',
      outBoxDeepRight: 'Außerhalb Strafraum Rechts Tief',
      outBoxLeft: 'Außerhalb Strafraum Links',
      outBoxCentreLeft: 'Außerhalb Strafraum Zentral Links',
      outBoxCentre: 'Außerhalb Strafraum Zentral',
      outBoxCentreRight: 'Außerhalb Strafraum Zentral Rechts',
      outBoxRight: 'Außerhalb Strafraum Rechts',
      midfieldLeft35: 'Linkes Mittelfeld',
      midfieldCentreLeft35: 'Zentral Links Mittelfeld',
      midfieldCentre35: 'Zentrales Mittelfeld',
      midfieldCentreRight35: 'Zentral Rechts Mittelfeld',
      midfieldRight35: 'Rechtes Mittelfeld',
      ownGoalArea: 'Eigener Fünfmeterraum',
      ownBoxLeft: 'Eigener Linker Strafraum',
      ownBoxCenter: 'Eigener Zentraler Strafraum',
      ownBoxRight: 'Eigener Rechter Strafraum',
      ownFieldOutOfBoxDeepLeft: 'Eigenes Feld Außerhalb Strafraum Links Tief',
      ownFieldOutOfBoxDeepRight: 'Eigenes Feld Außerhalb Strafraum Rechts Tief',
      ownFieldOutOfBoxLeft: 'Eigenes Feld Außerhalb Strafraum Links',
      ownFieldOutOfBoxCentreLeft: 'Eigenes Feld Außerhalb Strafraum Zentral Links',
      ownFieldOutOfBoxCentre: 'Eigenes Feld Außerhalb Strafraum Zentral',
      ownFieldOutOfBoxCentreRight: 'Eigenes Feld Außerhalb Strafraum Zentral Rechts',
      ownFieldOutOfBoxRight: 'Eigenes Feld Außerhalb Strafraum Rechts',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Erfolg',
      fail: 'Fehlschlag',
      possessionWon: 'Ballbesitz Gewonnen',
      possessionNotWon: 'Ballbesitz Nicht Gewonnen',
      received: 'Erhalten',
      provoked: 'Erzwungen'
    },
    homePlayerHighlights: 'Highlights der Heimspieler',
    awayPlayerHighlights: 'Highlights der Auswärtsspieler'
  },
  share: {
    shareTo: 'Send to',
    viaApp: 'App (Driblab Message)',
    viaEmail: 'Email',
    description: 'Description',
    titleTab: 'Shares',
    toMe: 'Empfangen',
    fromMe: 'Gesendet',
    typeInternal: 'Internal',
    typeExternal: 'External',
    title: 'Geteilte',
    subtitle: 'Übersicht über die Elemente in Ihrer Freigabeliste',
    selectUser: 'Benutzer auswählen',
    expired: 'Abgelaufen',
    limitReached: 'Der Link hat das Nutzungslimit erreicht'
  },
  homeStats: {
    data: 'Verfügbare Daten',
    players: 'Spieler',
    totalPlayers: 'Spieler insgesamt',
    teams: 'Ausrüstung',
    totalTeams: 'Teams insgesamt',
    leagues: 'Ligen',
    totalLeagues: 'Ligen insgesamt',
    seasons: 'Jahreszeiten',
    totalSeasons: 'Saisons insgesamt',
    games: 'Spiele',
    totalGames: 'Spiele insgesamt'
  },
  scoutingCalendar: {
    subtitle: 'Erstellen und organisieren Sie Ihre scouting-Aufgaben',
    myCalendars: 'Privater Kalender',
    publicCalendars: 'Öffentliche Kalender',
    otherCalendars: 'Andere Kalender',
    calendarSettings: 'Kalendereinstellungen',
    moreInfo: 'Mehr Infos',
    individualScouting: 'Individuelles Scouting',
    matchScouting: 'Spiel Scouting',
    calendarView: {
      type: 'Kalendertyp',
      month: 'Monat',
      week: 'Woche',
      day: 'Tag'
    },
    weekView: {
      type: 'Wochentyp',
      monSun: 'Montag - Sonntag',
      sunSat: 'Sonntag - Samstag',
      monFri: 'Montag - Freitag'
    },
    tasks: {
      addNew: 'Neue Aufgabe hinzufügen',
      myTasks: 'Meine Aufgaben',
      filterTasks: 'Aufgaben filtern',
      sharedWithMe: 'Mit mir geteilt',
      createTask: 'Aufgabe erstellen',
      newTask: 'Neue Aufgabe',
      taskName: 'Aufgabenname',
      allDay: 'Ganztägig',
      startDate: 'Anfangsdatum',
      endDate: 'Enddatum',
      startHour: 'Startzeit',
      endHour: 'Endzeit',
      assignedTo: 'Zugewiesen zu',
      assignedToMe: 'Mir zugewiesen',
      color: 'Farbe',
      scoutingType: 'Scouting-Typ',
      taskLocation: 'Aufgabenort',
      selectLeague: 'Liga auswählen',
      selectMatch: 'Spiel auswählen',
      useMatchdate: 'Verwenden Sie das Spiel-Datum als Datum',
      stadium: 'Stadion',
      travel: 'Reise',
      hotel: 'Hotel',
      tickets: 'Tickets',
      taskNotes: 'Beschreibende Notizen oder Kommentare zur Aufgabe eingeben',
      states: {
        toDo: 'Zu erledigen',
        inProgress: 'In Bearbeitung',
        done: 'Erledigt'
      },
      type: {
        player: 'Spielerbewertung',
        team: 'Teambewertung',
        other: 'Andere'
      },
      location: {
        stadium: 'Im Stadion',
        video: 'Video'
      },
      accommodation: {
        accommodationDetails: 'Unterkunftsdetails',
        ownArrangement: 'Eigene Anordnung',
        required: 'Erforderlich',
        notRequired: 'Nicht erforderlich',
        booked: 'Gebucht'
      },
      assignToMe: 'Mir zuweisen',
      addOther: 'Weitere hinzufügen',
      deleteTask: 'Aufgabe löschen',
      deleteTaskMessage: 'Aufgabe wird entfernt, sind Sie sicher?',
      cancelUpdate: 'Update abbrechen',
      cancelUpdateMessage: 'Änderungen werden nicht gespeichert, sind Sie sicher?',
      selectGame: 'Bitte wählen Sie ein Spiel aus, um Dateien hinzuzufügen',
      noData: 'Keine Daten. Fügen Sie zunächst einige Aufgaben hinzu!',
      widgetSubtitle: 'Überprüfen Sie Ihre nächsten Aufgaben',
      scoutingDetails: 'Scouting-Details',
      taskDetails: 'Aufgabendetails',
      playerDocuments: 'Spielerdokumente',
      teamDocuments: 'Teamdokumente',
      gameDocuments: 'Spieldokumente',
      taskDocuments: 'Aufgabendokumente',
      task: 'Aufgabe'
    },
    nextGames: 'Nächste Spiele'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Diese Woche',
      month: 'Diesen Monat',
      year: 'Dieses Jahr'
    },
    noTasks: 'Erstellen Sie neue Aufgaben oder ziehen Sie eine hierher!',
    goToBoard: 'Zum Board gehen'
  },
  profile: {
    title: 'Profil',
    subtitle: 'Passen Sie Ihre Konto- und Abonnementdetails an'
  },
  hub: {
    onlyHub: 'Nur in Driblab Hub verfügbar',
    blue: 'Blau',
    purple: 'lila',
    orange: 'orange',
    grey: 'grau',
    indigo: 'Indigo',
    teal: 'blaugrün',
    lightBlue: 'hellblau',
    brown: 'braun'
  },
  uploadedGames: {
    subtitle: 'All uploaded games',
    timeRequested: 'Time it was requested',
    timeReceived: 'When it was received',
    diffHours: 'Difference in hours',
    collectionCompleted: 'Collection completed',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    goToUploadedGames: 'Zu Hochgeladenen Spielen Gehen',
    sla: 'Service-Level-Vereinbarung',
    matchDate: 'Spieltermin',
    rejectedGame: 'Abgelehnt',
    reviewed: 'Überprüft',
    requested: 'Angefordert',
    koraStatus: 'Kora-Status',
    aws: 'AWS',
    fullVideo: 'Vollständiges Video',
    offset: 'Offset',
    updateFullVideo: 'Vollständiges Video aktualisieren?'
  },
  gameMap: {
    title: 'Spielplan',
    subtitle: 'Erkunden Sie die Spiele der nächsten Tage',
    warning: 'Zeit und Ort könnten nicht korrekt sein. Bitte bestätigen Sie diese Informationen.',
    taskAdded: 'Aufgabe erfolgreich erstellt. Sieh dir den Scouting Calendar an.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Erfolgreich benachrichtigt',
    notPermissions: 'Sie haben keine Berechtigung zum Ansehen',
    notPermissionsLeague: 'Sie haben keine Berechtigung, diese Liga anzusehen',
    notPermissionsGame: 'Sie haben keine Berechtigung, dieses Spiel anzusehen',
    requestAccessTo: 'Zugriff anfordern auf',
    sendRequest: 'Anfrage senden'
  },
  videoTeams: {
    subtitle: 'Finden Sie die neuesten Spiele, sortiert nach Teams',
    noGamesUploaded: 'Noch keine Spiele hochgeladen'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Scouting-Analyse',
    scoutingAnalyses: 'Scouting-Analysen',
    playerScoutingAnalyses: 'Spieler-Scouting-Analysen',
    gameScoutingAnalyses: 'Spiel-Scouting-Analysen',
    analyses: 'Analysen',
    addReport: 'Analyse hinzufügen',
    technical: 'Technisch',
    tactical: 'Taktisch',
    physical: 'Physisch',
    mental: 'Psychologisch',
    technicalNotes: 'Technische Notizen',
    tacticalNotes: 'Taktische Notizen',
    physicalNotes: 'Physische Notizen',
    mentalNotes: 'Notizen zum psychologischen Profil',
    conclusion: 'Fazit',
    charactersMax: 'Maximal 1000 Zeichen',
    globalRating: 'Gesamtbewertung',
    noData: 'Keine Daten vorhanden. Beginnen Sie damit, einige Scouting-Analysen hinzuzufügen!',
    deleteAnalysis: 'Scouting-Analyse löschen',
    deleteAnalysisMessage: 'Die Analyse wird dauerhaft entfernt. Sind Sie sicher?',
    avgTooltip: 'Durchschnitt basierend auf den Endbewertungen der für Sie sichtbaren Analysen',
    avgOverallScoreTooltip: 'Durchschnitt basierend auf den Ihnen sichtbaren Gesamtpunktzahlen des Spielers',
    scouter: 'Scouter',
    lastEdited: 'Zuletzt bearbeitet',
    analysisFilters: 'Analyse-Filter',
    generalFilters: 'Allgemeine Filter',
    widgetSubtitle: 'Neueste hinzugefügte Analysen',
    addPlayerReport: 'Spieler-Scouting-Analyse hinzufügen',
    seeReports: 'Berichte ansehen',
    addGameReport: 'Spielanalyse hinzufügen',
    keyPlayers: 'Schlüsselspieler',
    formation: 'Formation',
    inPossession: 'Im Ballbesitz',
    notesIP: 'Notizen im Ballbesitz',
    outOfPossession: 'Ohne Ballbesitz',
    notesOP: 'Notizen ohne Ballbesitz',
    transitions: 'Umschaltmomente',
    notesTransitions: 'Notizen zu Umschaltmomenten',
    notesSP: 'Notizen zu Standardsituationen',
    finalRating: 'Endbewertung',
    gameNotesPlaceholder: 'Gib beschreibende Notizen oder Kommentare zum Spiel ein',
    avgPotentialTooltip: 'Durchschnitt basierend auf dem Potenzial der für Sie sichtbaren Analysen',
    potential: 'Potenzial',
    tags: 'Schlagworte',
    tagsPlaceholder: 'Fügen Sie einige Tags hinzu',
    tagsHint: 'Geben Sie ein und drücken Sie die Eingabetaste, um ein Tag hinzuzufügen',
    exampleTags: {
      leadership: 'Führung',
      resilience: 'Widerstandsfähigkeit',
      competitiveMindset: 'Wettbewerbsorientierte Denkweise',
      calmUnderPressure: 'Unter Druck ruhig bleiben',
      focus: 'Fokus',
      discipline: 'Disziplin',
      coachability: 'Trainerfähigkeit',
      poorBodyLanguage: 'Schlechte Körpersprache',
      lowConfidence: 'Geringes Vertrauen',
      easilyFrustrated: 'Leicht frustriert'
    }
  },
  addPlayerForm: {
    noLeague: 'Ein Team ohne Liga zu erstellen kann sich negativ auf dessen Indexierung und spätere Suche in der Anwendung auswirken.'
  },
  expenses: {
    expense: 'Ausgabe',
    expenses: 'Ausgaben',
    addExpense: 'Ausgabe hinzufügen',
    transportation: 'Transport',
    accommodation: 'Unterkunft',
    dietary: 'Verpflegung',
    eventTicket: 'Veranstaltungsticket',
    expenseType: 'Ausgabenart',
    amount: 'Betrag',
    expenseDate: 'Ausgabedatum',
    expenseFilters: 'Ausgabenfilter',
    noData: 'Keine Daten. Fügen Sie einige Ausgaben hinzu, um zu beginnen!',
    deleteExpense: 'Ausgabe löschen',
    deleteExpenseMessage: 'Die Ausgabe wird dauerhaft entfernt. Sind Sie sicher?'
  },
  disabledTooltips: {
    general: 'Diese Funktion ist derzeit deaktiviert',
    youth: 'Es muss ein Jugendspieler sein, um ein Alter festzulegen',
    unit: 'Die Statistik muss Runs, HSR oder SPR sein',
    seasonsWithout60MinsGames: 'Der Spieler hat in der/den ausgewählten Saison/en kein Spiel über 60 Minuten gespielt',
    notEditable: 'Dies kann nicht bearbeitet werden',
    noMatchdate: 'Spieldatum nicht verfügbar',
    selectGame: 'Bitte zuerst ein Spiel auswählen',
    selectPlayer: 'Bitte zuerst einen Spieler auswählen',
    selectTeam: 'Bitte zuerst ein Team auswählen',
    selectBoxes: 'Die Boxen-Visualisierung muss ausgewählt werden',
    selectYear: 'Bitte zuerst ein Jahr auswählen',
    pdScoreNotAvailable: 'Bewertung nicht verfügbar für Spieler, die in einem Spiel keine 60 Minuten gespielt haben',
    pdSeasonNotAvailable: 'Physische Daten für diese Saison sind nicht verfügbar',
    pdGameNotAvailable: 'Physische Daten für dieses Spiel sind nicht verfügbar'
  },
  leagueTypes: {
    regular: 'Regulär',
    continental: 'Kontinental',
    nationalTeam: 'Nationalmannschaft',
    countryCup: 'Landespokal',
    qualifier: 'Qualifikation',
    playOff: 'Play-Off',
    regionalLeague: 'Regionalliga',
    friendly: 'Freundschaftsspiel',
    nationalFriendly: 'Nationales Freundschaftsspiel',
    nationaQualifier: 'Nationale Qualifikation'
  },
  playerSides: {
    'Left/Right': 'Links/Rechts',
    'Left/Centre/Right': 'Links/Mitte/Rechts',
    Right: 'Rechts',
    Centre: 'Mitte',
    'Centre/Right': 'Mitte/Rechts',
    Left: 'Links',
    'Left/Centre': 'Links/Mitte'
  },
  areaSelector: {
    selectAreas: 'Bereiche auswählen',
    filterAreas: 'Bereiche filtern'
  },
  spatialCoverage: {
    lastDefenderDist: 'Entfernung zum letzten Verteidiger',
    defensiveLineDist: 'Abstand der Verteidigungslinie',
    fullBackAvgDist: 'Durchschnittlicher seitlicher Abstand',
    offensiveLineDist: 'Offensive Liniendistanz',
    distanceToGoal: 'Entfernung zum Ziel',
    avgLineWidth: 'Durchschn. Linienbreite',
    leagueAvgDistanceToGoal: 'Durchschn. Ligadistanz zum Tor',
    leagueAvgLineWidth: 'Durchschn. Ligalinienbreite',
    avgShort: 'Durchschn.',
    meters: 'Meter',
    leagueAvgDist: 'Durchschn. Ligadistanz',
    distance: 'Distanz',
    avgPositionYAxis: 'Durchschn. Distanz auf dem Spielfeld (Y)',
    leagueAvgPositionYAxis: 'Durchschn. Liga-Distanz auf dem Spielfeld (Y)',
    lbRbDistanceSeparation: 'LB–RB-Distanz',
    leagueAvgLbRbDistanceSeparation: 'Durchschn. Liga LB–RB-Distanz',
    legendTeam: 'Team',
    legendLeagueAvg: 'Ligadurchschn.',
    maxLength: 'Maximale Länge',
    maxWidth: 'Maximale Breite',
    avgBlockDistance: 'Durchschn. Blockabstand'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Intelligente Daten',
    passesUnderPressureSubtitle: 'Analysieren Sie die Erfolgsquote von Pässen, die unter defensivem Druck ausgeführt werden',
    onBallPressureSubtitle: 'Analysieren Sie Verteidigungsdruckereignisse und ihre Erfolgsquote nach Feldzonen',
    ballReceiptsInSpaceSubtitle: 'Analysieren Sie im Weltraum empfangene Pässe nach Feldzone',
    ballReceipts: 'Quittungen',
    totalBallReceipts: 'Ballannahmen gesamt',
    totalBallReceiptsCompleted: 'Gesamte Ballannahmen abgeschlossen',
    completed: 'Abgeschlossen',
    lineBreakingPassesSubtitle: 'Analysiere die Pässe, die Linien durchbrechen und Vorteile schaffen',
    bypassed: 'Umgangen',
    oppsBypassed: 'Gegner unterlegen',
    passer: 'Igangsætter',
    passedTo: 'Pass zu',
    receivedFrom: 'Empfangen von',
    distanceToNearestDefender: 'Entfernung zum nächsten Verteidiger',
    lineBreaking: 'Zeilenumbruch {0}',
    keyPass: 'Schlüsselpass',
    receiver: 'Empfänger',
    dynamicTracking: 'Dynamische Verfolgung',
    eventLockTooltip: 'Einige Spieler sind im Spiel nicht sichtbar',
    bypassedPlayers: '{0} überspielte Spieler',
    playersCount: '{0} Spieler',
    bothTeams: 'Beide Mannschaften',
    matchesCount: '{0} Spiele',
    lbpType: {
      F: 'Angriffslinie',
      M: 'Mittelfeldlinie',
      B: 'Abwehrlinie',
      MF: 'Mittelfeld- und Angriffslinie',
      BM: 'Abwehr- und Mittelfeldlinie',
      BF: 'Abwehr- und Angriffslinie',
      BMF: 'Abwehr-, Mittelfeld- und Angriffslinie'
    },
    lbpCategory: {
      'G-IN-T': 'Flach Innen (bricht die Abwehrlinie)',
      'G-IN-NT': 'Flach Innen (bricht die Abwehrlinie nicht)',
      'G-OUT-T': 'Flach Außen (bricht die Abwehrlinie)',
      'G-OUT-NT': 'Flach Außen (bricht die Abwehrlinie nicht)',
      'O-IN-T': 'Hoch Innen (bricht die Abwehrlinie)',
      'O-IN-NT': 'Hoch Innen (bricht die Abwehrlinie nicht)',
      'O-OUT-T': 'Hoch Außen (bricht die Abwehrlinie)',
      'O-OUT-NT': 'Hoch Außen (bricht die Abwehrlinie nicht)',
      ground: 'Flach',
      over: 'Hoch',
      inside: 'Innen',
      outside: 'Außen',
      through: 'Bricht die Abwehrlinie',
      notThrough: 'Bricht die Abwehrlinie nicht',
      throughAbbr: 'Def. brechen. Linie',
      notThroughAbbr: 'Def nicht brechen. Linie'
    },
    lbpCategorySplit: {
      G: 'Der Pass war flach',
      O: 'Der Pass war hoch',
      OUT: 'Der Pass ging nach außen',
      IN: 'Der Pass ging nach innen',
      T: 'Bricht die Abwehrlinie: Der Pass bricht die Abwehrlinie von innen',
      NT: 'Bricht die Abwehrlinie nicht: Der Pass bricht sie nicht von innen; er umgeht sie von außen'
    },
    obrType: {
      OL: 'Überlappung',
      UL: 'Unterlappung',
      RA: 'Vorlauf',
      RB: 'Hinterlauf',
      CR: 'Cross Receiver',
      SP: 'Unterstützung',
      CS: 'Zurückkommen'
    },
    visualization: 'Visualisierung',
    points: 'Kreise',
    zones: 'Varmekort',
    pressureIntensity: 'Druckintensität',
    pressureOutcome: 'Druckausgang',
    passesOutcome: 'Ergebnis der Pässe',
    strong: 'Stark',
    light: 'Leicht',
    normal: 'Normal',
    successful: 'Erfolgreich',
    unsuccessful: 'Unerfolgreich',
    presses: 'Drucke',
    passes: 'Pässe',
    passUnder: 'Unterfahren',
    successRate: 'Erfolgsquote',
    pressureOn: 'Druck auf',
    pressureOf: 'Presion af',
    pressure: 'Druck',
    totalLabel: 'gesamt',
    totalPasses: 'Gesamtzahl der Pässe',
    unknown: 'unbekannt',
    selectGameToViewMap: 'Spiel auswählen, um Druckkarte anzuzeigen',
    noEventsFoundForGame: 'Keine Druckereignisse für dieses Spiel gefunden',
    noEventsFoundForTeamAndSeason: 'Keine Druckereignisse für dieses Team und Saison gefunden',
    noEventsFoundForPlayerAndSeason: 'Keine Druckereignisse für diesen Spieler und Saison gefunden',
    noEventsMatchFilters: 'Keine Ereignisse passen zu den aktuellen Filtern',
    totalEventsAvailable: 'gesamte Ereignisse verfügbar',
    passType: {
      P: 'Passieren',
      A: 'Helfen',
      KP: 'Schlüsselpass',
      PiOB: 'Pass in Opp. Kasten',
      PiFT: 'Pass ins letzte Drittel',
      SoPP: 'Wechsel des Play Pass'
    },
    minFrom: 'Min. Von',
    minTo: 'Min. bis',
    secondFrom: 'Seg Von',
    secondTo: 'Segen',
    positionPlayed: 'Gespielte Position',
    highlight: 'Hervorheben',
    passTypeLabel: 'Passtyp',
    offBallRunSubtitle: 'Analysieren Sie Off-Ball-Läufe',
    insights: 'Einblicke',
    insightsSubtitle: 'Ranking der Besten mit Advanced Arrigo Analytics',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Wie kann ich Ihnen heute helfen?',
    chatSubtext: 'Fragen Sie alles zu Fußballdaten!',
    thinking: 'Denken...',
    giveFeedback: 'Geben Sie Feedback',
    disclaimer: 'DriblabAI kann Fehler machen. Bitte überprüfen Sie unbedingt die Informationen.',
    recent: 'Jüngste',
    noConversations: 'Hier sehen Sie Ihre letzten Gespräche!',
    rename: 'Umbenennen',
    deleteConversation: 'Konversation löschen',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Konversation löschen möchten?',
    feedback: 'Rückmeldung',
    feedbackQuestion: 'War diese Antwort hilfreich?',
    feedbackComments: 'Zusätzliche Kommentare',
    feedbackPlaceholder: 'Sagen Sie uns, was hilfreich war oder was verbessert werden könnte ...',
    errorMessage: 'Die Nachricht konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
    newConversation: 'Neuer Chat',
    write: 'Nachricht schreiben...'
  },
  periodId: {
    1: 'Erste Hälfte',
    2: 'Zweite Hälfte',
    3: 'Verlängerung - 1º',
    4: 'Verlängerung - 2º',
    5: 'Elfmeterschießen',
    6: 'Vollzeit',
    7: 'Vor dem Spiel',
    8: 'Verlassen',
    9: 'Live',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Andere'
  }
};



// WEBPACK FOOTER //
// ./src/utils/translations/de.js